var eo = Object.defineProperty;
var to = (e, t, i) => t in e ? eo(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i;
var ot = (e, t, i) => (to(e, typeof t != "symbol" ? t + "" : t, i), i);
import { defineComponent as fe, h as bn, getCurrentInstance as wn, inject as io, onMounted as pt, onUnmounted as Ra, shallowRef as Fa, ref as J, computed as H, onBeforeMount as no, watch as vi, Fragment as Tt, createVNode as F, Text as ao, openBlock as K, createElementBlock as Q, createElementVNode as N, toDisplayString as V, unref as p, withModifiers as Qe, createBlock as xe, createCommentVNode as ve, withCtx as re, createTextVNode as Pe, withDirectives as so, vShow as oo, normalizeClass as et, Comment as ro, cloneVNode as lo, renderSlot as hi, Transition as Fn, renderList as Va, createSlots as Bi } from "vue";
import { DcfTextInput as ct, DcfNotification as Si, DcfButton as Be, DcfCheckbox as $e, DcfModal as co, DcfIcon as uo, DcfTile as mo } from "@miele/dcf-components-vue";
/*!
  * shared v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const Ye = typeof window < "u";
let De, St;
if (process.env.NODE_ENV !== "production") {
  const e = Ye && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (De = (t) => {
    e.mark(t);
  }, St = (t, i, n) => {
    e.measure(t, i, n), e.clearMarks(i), e.clearMarks(n);
  });
}
const po = /\{([0-9a-zA-Z]+)\}/g;
function yn(e, ...t) {
  return t.length === 1 && ie(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(po, (i, n) => t.hasOwnProperty(n) ? t[n] : "");
}
const tt = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), ho = (e, t, i) => go({ l: e, k: t, s: i }), go = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), _e = (e) => typeof e == "number" && isFinite(e), vo = (e) => Ga(e) === "[object Date]", $t = (e) => Ga(e) === "[object RegExp]", Ci = (e) => Y(e) && Object.keys(e).length === 0, Se = Object.assign;
let Vn;
const Ze = () => Vn || (Vn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function qn(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const fo = Object.prototype.hasOwnProperty;
function fi(e, t) {
  return fo.call(e, t);
}
const we = Array.isArray, ce = (e) => typeof e == "function", U = (e) => typeof e == "string", le = (e) => typeof e == "boolean", ie = (e) => e !== null && typeof e == "object", ko = (e) => ie(e) && ce(e.then) && ce(e.catch), qa = Object.prototype.toString, Ga = (e) => qa.call(e), Y = (e) => {
  if (!ie(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, bo = (e) => e == null ? "" : we(e) || Y(e) && e.toString === qa ? JSON.stringify(e, null, 2) : String(e);
function wo(e, t = "") {
  return e.reduce((i, n, a) => a === 0 ? i + n : i + t + n, "");
}
const Gn = 2;
function yo(e, t = 0, i = e.length) {
  const n = e.split(/\r?\n/);
  let a = 0;
  const s = [];
  for (let o = 0; o < n.length; o++)
    if (a += n[o].length + 1, a >= t) {
      for (let r = o - Gn; r <= o + Gn || i > a; r++) {
        if (r < 0 || r >= n.length)
          continue;
        const l = r + 1;
        s.push(`${l}${" ".repeat(3 - String(l).length)}|  ${n[r]}`);
        const u = n[r].length;
        if (r === o) {
          const c = t - (a - u) + 1, m = Math.max(1, i > a ? u - c : i - t);
          s.push("   |  " + " ".repeat(c) + "^".repeat(m));
        } else if (r > o) {
          if (i > a) {
            const c = Math.max(Math.min(i - a, u), 1);
            s.push("   |  " + "^".repeat(c));
          }
          a += u + 1;
        }
      }
      break;
    }
  return s.join(`
`);
}
function Li(e) {
  let t = e;
  return () => ++t;
}
function it(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Kn = {};
function Ka(e) {
  Kn[e] || (Kn[e] = !0, it(e));
}
function Mo() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(i, n) {
      const a = e.get(i);
      a && a.push(n) || e.set(i, [n]);
    },
    off(i, n) {
      const a = e.get(i);
      a && a.splice(a.indexOf(n) >>> 0, 1);
    },
    emit(i, n) {
      (e.get(i) || []).slice().map((a) => a(n)), (e.get("*") || []).slice().map((a) => a(i, n));
    }
  };
}
const ri = (e) => !ie(e) || we(e);
function gi(e, t) {
  if (ri(e) || ri(t))
    throw new Error("Invalid value");
  const i = [{ src: e, des: t }];
  for (; i.length; ) {
    const { src: n, des: a } = i.pop();
    Object.keys(n).forEach((s) => {
      ri(n[s]) || ri(a[s]) ? a[s] = n[s] : i.push({ src: n[s], des: a[s] });
    });
  }
}
/*!
  * message-compiler v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function zo(e, t, i) {
  return { line: e, column: t, offset: i };
}
function ki(e, t, i) {
  const n = { start: e, end: t };
  return i != null && (n.source = i), n;
}
const jo = /\{([0-9a-zA-Z]+)\}/g;
function Ha(e, ...t) {
  return t.length === 1 && _o(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(jo, (i, n) => t.hasOwnProperty(n) ? t[n] : "");
}
const Wa = Object.assign, Hn = (e) => typeof e == "string", _o = (e) => e !== null && typeof e == "object";
function Ja(e, t = "") {
  return e.reduce((i, n, a) => a === 0 ? i + n : i + t + n, "");
}
const Ei = {
  USE_MODULO_SYNTAX: 1,
  __EXTEND_POINT__: 2
}, So = {
  [Ei.USE_MODULO_SYNTAX]: "Use modulo before '{{0}}'."
};
function Co(e, t, ...i) {
  const n = Ha(So[e] || "", ...i || []), a = { message: String(n), code: e };
  return t && (a.location = t), a;
}
const G = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, Lo = {
  // tokenizer error messages
  [G.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [G.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [G.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [G.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [G.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [G.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [G.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [G.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [G.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [G.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [G.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [G.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [G.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [G.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [G.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [G.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Vt(e, t, i = {}) {
  const { domain: n, messages: a, args: s } = i, o = Ha((a || Lo)[e] || "", ...s || []), r = new SyntaxError(String(o));
  return r.code = e, t && (r.location = t), r.domain = n, r;
}
function Eo(e) {
  throw e;
}
const Po = /<\/?[\w\s="/.':;#-\/]+>/, To = (e) => Po.test(e), He = " ", Ao = "\r", Le = `
`, xo = String.fromCharCode(8232), Io = String.fromCharCode(8233);
function Do(e) {
  const t = e;
  let i = 0, n = 1, a = 1, s = 0;
  const o = (E) => t[E] === Ao && t[E + 1] === Le, r = (E) => t[E] === Le, l = (E) => t[E] === Io, u = (E) => t[E] === xo, c = (E) => o(E) || r(E) || l(E) || u(E), m = () => i, d = () => n, b = () => a, f = () => s, k = (E) => o(E) || l(E) || u(E) ? Le : t[E], M = () => k(i), j = () => k(i + s);
  function y() {
    return s = 0, c(i) && (n++, a = 0), o(i) && i++, i++, a++, t[i];
  }
  function g() {
    return o(i + s) && s++, s++, t[i + s];
  }
  function w() {
    i = 0, n = 1, a = 1, s = 0;
  }
  function L(E = 0) {
    s = E;
  }
  function _() {
    const E = i + s;
    for (; E !== i; )
      y();
    s = 0;
  }
  return {
    index: m,
    line: d,
    column: b,
    peekOffset: f,
    charAt: k,
    currentChar: M,
    currentPeek: j,
    next: y,
    peek: g,
    reset: w,
    resetPeek: L,
    skipToPeek: _
  };
}
const rt = void 0, No = ".", Wn = "'", Oo = "tokenizer";
function Uo(e, t = {}) {
  const i = t.location !== !1, n = Do(e), a = () => n.index(), s = () => zo(n.line(), n.column(), n.index()), o = s(), r = a(), l = {
    currentType: 14,
    offset: r,
    startLoc: o,
    endLoc: o,
    lastType: 14,
    lastOffset: r,
    lastStartLoc: o,
    lastEndLoc: o,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, u = () => l, { onError: c } = t;
  function m(h, v, P, ...R) {
    const ue = u();
    if (v.column += P, v.offset += P, c) {
      const oe = i ? ki(ue.startLoc, v) : null, ne = Vt(h, oe, {
        domain: Oo,
        args: R
      });
      c(ne);
    }
  }
  function d(h, v, P) {
    h.endLoc = s(), h.currentType = v;
    const R = { type: v };
    return i && (R.loc = ki(h.startLoc, h.endLoc)), P != null && (R.value = P), R;
  }
  const b = (h) => d(
    h,
    14
    /* TokenTypes.EOF */
  );
  function f(h, v) {
    return h.currentChar() === v ? (h.next(), v) : (m(G.EXPECTED_TOKEN, s(), 0, v), "");
  }
  function k(h) {
    let v = "";
    for (; h.currentPeek() === He || h.currentPeek() === Le; )
      v += h.currentPeek(), h.peek();
    return v;
  }
  function M(h) {
    const v = k(h);
    return h.skipToPeek(), v;
  }
  function j(h) {
    if (h === rt)
      return !1;
    const v = h.charCodeAt(0);
    return v >= 97 && v <= 122 || // a-z
    v >= 65 && v <= 90 || // A-Z
    v === 95;
  }
  function y(h) {
    if (h === rt)
      return !1;
    const v = h.charCodeAt(0);
    return v >= 48 && v <= 57;
  }
  function g(h, v) {
    const { currentType: P } = v;
    if (P !== 2)
      return !1;
    k(h);
    const R = j(h.currentPeek());
    return h.resetPeek(), R;
  }
  function w(h, v) {
    const { currentType: P } = v;
    if (P !== 2)
      return !1;
    k(h);
    const R = h.currentPeek() === "-" ? h.peek() : h.currentPeek(), ue = y(R);
    return h.resetPeek(), ue;
  }
  function L(h, v) {
    const { currentType: P } = v;
    if (P !== 2)
      return !1;
    k(h);
    const R = h.currentPeek() === Wn;
    return h.resetPeek(), R;
  }
  function _(h, v) {
    const { currentType: P } = v;
    if (P !== 8)
      return !1;
    k(h);
    const R = h.currentPeek() === ".";
    return h.resetPeek(), R;
  }
  function E(h, v) {
    const { currentType: P } = v;
    if (P !== 9)
      return !1;
    k(h);
    const R = j(h.currentPeek());
    return h.resetPeek(), R;
  }
  function T(h, v) {
    const { currentType: P } = v;
    if (!(P === 8 || P === 12))
      return !1;
    k(h);
    const R = h.currentPeek() === ":";
    return h.resetPeek(), R;
  }
  function C(h, v) {
    const { currentType: P } = v;
    if (P !== 10)
      return !1;
    const R = () => {
      const oe = h.currentPeek();
      return oe === "{" ? j(h.peek()) : oe === "@" || oe === "%" || oe === "|" || oe === ":" || oe === "." || oe === He || !oe ? !1 : oe === Le ? (h.peek(), R()) : x(h, !1);
    }, ue = R();
    return h.resetPeek(), ue;
  }
  function O(h) {
    k(h);
    const v = h.currentPeek() === "|";
    return h.resetPeek(), v;
  }
  function B(h) {
    const v = k(h), P = h.currentPeek() === "%" && h.peek() === "{";
    return h.resetPeek(), {
      isModulo: P,
      hasSpace: v.length > 0
    };
  }
  function x(h, v = !0) {
    const P = (ue = !1, oe = "", ne = !1) => {
      const S = h.currentPeek();
      return S === "{" ? oe === "%" ? !1 : ue : S === "@" || !S ? oe === "%" ? !0 : ue : S === "%" ? (h.peek(), P(ue, "%", !0)) : S === "|" ? oe === "%" || ne ? !0 : !(oe === He || oe === Le) : S === He ? (h.peek(), P(!0, He, ne)) : S === Le ? (h.peek(), P(!0, Le, ne)) : !0;
    }, R = P();
    return v && h.resetPeek(), R;
  }
  function z(h, v) {
    const P = h.currentChar();
    return P === rt ? rt : v(P) ? (h.next(), P) : null;
  }
  function A(h) {
    const v = h.charCodeAt(0);
    return v >= 97 && v <= 122 || // a-z
    v >= 65 && v <= 90 || // A-Z
    v >= 48 && v <= 57 || // 0-9
    v === 95 || // _
    v === 36;
  }
  function $(h) {
    return z(h, A);
  }
  function q(h) {
    const v = h.charCodeAt(0);
    return v >= 97 && v <= 122 || // a-z
    v >= 65 && v <= 90 || // A-Z
    v >= 48 && v <= 57 || // 0-9
    v === 95 || // _
    v === 36 || // $
    v === 45;
  }
  function Z(h) {
    return z(h, q);
  }
  function X(h) {
    const v = h.charCodeAt(0);
    return v >= 48 && v <= 57;
  }
  function W(h) {
    return z(h, X);
  }
  function ae(h) {
    const v = h.charCodeAt(0);
    return v >= 48 && v <= 57 || // 0-9
    v >= 65 && v <= 70 || // A-F
    v >= 97 && v <= 102;
  }
  function se(h) {
    return z(h, ae);
  }
  function he(h) {
    let v = "", P = "";
    for (; v = W(h); )
      P += v;
    return P;
  }
  function Oe(h) {
    M(h);
    const v = h.currentChar();
    return v !== "%" && m(G.EXPECTED_TOKEN, s(), 0, v), h.next(), "%";
  }
  function Ce(h) {
    let v = "";
    for (; ; ) {
      const P = h.currentChar();
      if (P === "{" || P === "}" || P === "@" || P === "|" || !P)
        break;
      if (P === "%")
        if (x(h))
          v += P, h.next();
        else
          break;
      else if (P === He || P === Le)
        if (x(h))
          v += P, h.next();
        else {
          if (O(h))
            break;
          v += P, h.next();
        }
      else
        v += P, h.next();
    }
    return v;
  }
  function Ve(h) {
    M(h);
    let v = "", P = "";
    for (; v = Z(h); )
      P += v;
    return h.currentChar() === rt && m(G.UNTERMINATED_CLOSING_BRACE, s(), 0), P;
  }
  function nt(h) {
    M(h);
    let v = "";
    return h.currentChar() === "-" ? (h.next(), v += `-${he(h)}`) : v += he(h), h.currentChar() === rt && m(G.UNTERMINATED_CLOSING_BRACE, s(), 0), v;
  }
  function Ke(h) {
    return h !== Wn && h !== Le;
  }
  function at(h) {
    M(h), f(h, "'");
    let v = "", P = "";
    for (; v = z(h, Ke); )
      v === "\\" ? P += Gt(h) : P += v;
    const R = h.currentChar();
    return R === Le || R === rt ? (m(G.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, s(), 0), R === Le && (h.next(), f(h, "'")), P) : (f(h, "'"), P);
  }
  function Gt(h) {
    const v = h.currentChar();
    switch (v) {
      case "\\":
      case "'":
        return h.next(), `\\${v}`;
      case "u":
        return xt(h, v, 4);
      case "U":
        return xt(h, v, 6);
      default:
        return m(G.UNKNOWN_ESCAPE_SEQUENCE, s(), 0, v), "";
    }
  }
  function xt(h, v, P) {
    f(h, v);
    let R = "";
    for (let ue = 0; ue < P; ue++) {
      const oe = se(h);
      if (!oe) {
        m(G.INVALID_UNICODE_ESCAPE_SEQUENCE, s(), 0, `\\${v}${R}${h.currentChar()}`);
        break;
      }
      R += oe;
    }
    return `\\${v}${R}`;
  }
  function Kt(h) {
    return h !== "{" && h !== "}" && h !== He && h !== Le;
  }
  function Ht(h) {
    M(h);
    let v = "", P = "";
    for (; v = z(h, Kt); )
      P += v;
    return P;
  }
  function Wt(h) {
    let v = "", P = "";
    for (; v = $(h); )
      P += v;
    return P;
  }
  function D(h) {
    const v = (P) => {
      const R = h.currentChar();
      return R === "{" || R === "%" || R === "@" || R === "|" || R === "(" || R === ")" || !R || R === He ? P : (P += R, h.next(), v(P));
    };
    return v("");
  }
  function ee(h) {
    M(h);
    const v = f(
      h,
      "|"
      /* TokenChars.Pipe */
    );
    return M(h), v;
  }
  function Jt(h, v) {
    let P = null;
    switch (h.currentChar()) {
      case "{":
        return v.braceNest >= 1 && m(G.NOT_ALLOW_NEST_PLACEHOLDER, s(), 0), h.next(), P = d(
          v,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), M(h), v.braceNest++, P;
      case "}":
        return v.braceNest > 0 && v.currentType === 2 && m(G.EMPTY_PLACEHOLDER, s(), 0), h.next(), P = d(
          v,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), v.braceNest--, v.braceNest > 0 && M(h), v.inLinked && v.braceNest === 0 && (v.inLinked = !1), P;
      case "@":
        return v.braceNest > 0 && m(G.UNTERMINATED_CLOSING_BRACE, s(), 0), P = wt(h, v) || b(v), v.braceNest = 0, P;
      default: {
        let ue = !0, oe = !0, ne = !0;
        if (O(h))
          return v.braceNest > 0 && m(G.UNTERMINATED_CLOSING_BRACE, s(), 0), P = d(v, 1, ee(h)), v.braceNest = 0, v.inLinked = !1, P;
        if (v.braceNest > 0 && (v.currentType === 5 || v.currentType === 6 || v.currentType === 7))
          return m(G.UNTERMINATED_CLOSING_BRACE, s(), 0), v.braceNest = 0, Zt(h, v);
        if (ue = g(h, v))
          return P = d(v, 5, Ve(h)), M(h), P;
        if (oe = w(h, v))
          return P = d(v, 6, nt(h)), M(h), P;
        if (ne = L(h, v))
          return P = d(v, 7, at(h)), M(h), P;
        if (!ue && !oe && !ne)
          return P = d(v, 13, Ht(h)), m(G.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, P.value), M(h), P;
        break;
      }
    }
    return P;
  }
  function wt(h, v) {
    const { currentType: P } = v;
    let R = null;
    const ue = h.currentChar();
    switch ((P === 8 || P === 9 || P === 12 || P === 10) && (ue === Le || ue === He) && m(G.INVALID_LINKED_FORMAT, s(), 0), ue) {
      case "@":
        return h.next(), R = d(
          v,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), v.inLinked = !0, R;
      case ".":
        return M(h), h.next(), d(
          v,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return M(h), h.next(), d(
          v,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return O(h) ? (R = d(v, 1, ee(h)), v.braceNest = 0, v.inLinked = !1, R) : _(h, v) || T(h, v) ? (M(h), wt(h, v)) : E(h, v) ? (M(h), d(v, 12, Wt(h))) : C(h, v) ? (M(h), ue === "{" ? Jt(h, v) || R : d(v, 11, D(h))) : (P === 8 && m(G.INVALID_LINKED_FORMAT, s(), 0), v.braceNest = 0, v.inLinked = !1, Zt(h, v));
    }
  }
  function Zt(h, v) {
    let P = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (v.braceNest > 0)
      return Jt(h, v) || b(v);
    if (v.inLinked)
      return wt(h, v) || b(v);
    switch (h.currentChar()) {
      case "{":
        return Jt(h, v) || b(v);
      case "}":
        return m(G.UNBALANCED_CLOSING_BRACE, s(), 0), h.next(), d(
          v,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return wt(h, v) || b(v);
      default: {
        if (O(h))
          return P = d(v, 1, ee(h)), v.braceNest = 0, v.inLinked = !1, P;
        const { isModulo: ue, hasSpace: oe } = B(h);
        if (ue)
          return oe ? d(v, 0, Ce(h)) : d(v, 4, Oe(h));
        if (x(h))
          return d(v, 0, Ce(h));
        break;
      }
    }
    return P;
  }
  function $i() {
    const { currentType: h, offset: v, startLoc: P, endLoc: R } = l;
    return l.lastType = h, l.lastOffset = v, l.lastStartLoc = P, l.lastEndLoc = R, l.offset = a(), l.startLoc = s(), n.currentChar() === rt ? d(
      l,
      14
      /* TokenTypes.EOF */
    ) : Zt(n, l);
  }
  return {
    nextToken: $i,
    currentOffset: a,
    currentPosition: s,
    context: u
  };
}
const $o = "parser", Bo = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Ro(e, t, i) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const n = parseInt(t || i, 16);
      return n <= 55295 || n >= 57344 ? String.fromCodePoint(n) : "�";
    }
  }
}
function Fo(e = {}) {
  const t = e.location !== !1, { onError: i, onWarn: n } = e;
  function a(g, w, L, _, ...E) {
    const T = g.currentPosition();
    if (T.offset += _, T.column += _, i) {
      const C = t ? ki(L, T) : null, O = Vt(w, C, {
        domain: $o,
        args: E
      });
      i(O);
    }
  }
  function s(g, w, L, _, ...E) {
    const T = g.currentPosition();
    if (T.offset += _, T.column += _, n) {
      const C = t ? ki(L, T) : null;
      n(Co(w, C, E));
    }
  }
  function o(g, w, L) {
    const _ = { type: g };
    return t && (_.start = w, _.end = w, _.loc = { start: L, end: L }), _;
  }
  function r(g, w, L, _) {
    _ && (g.type = _), t && (g.end = w, g.loc && (g.loc.end = L));
  }
  function l(g, w) {
    const L = g.context(), _ = o(3, L.offset, L.startLoc);
    return _.value = w, r(_, g.currentOffset(), g.currentPosition()), _;
  }
  function u(g, w) {
    const L = g.context(), { lastOffset: _, lastStartLoc: E } = L, T = o(5, _, E);
    return T.index = parseInt(w, 10), g.nextToken(), r(T, g.currentOffset(), g.currentPosition()), T;
  }
  function c(g, w, L) {
    const _ = g.context(), { lastOffset: E, lastStartLoc: T } = _, C = o(4, E, T);
    return C.key = w, L === !0 && (C.modulo = !0), g.nextToken(), r(C, g.currentOffset(), g.currentPosition()), C;
  }
  function m(g, w) {
    const L = g.context(), { lastOffset: _, lastStartLoc: E } = L, T = o(9, _, E);
    return T.value = w.replace(Bo, Ro), g.nextToken(), r(T, g.currentOffset(), g.currentPosition()), T;
  }
  function d(g) {
    const w = g.nextToken(), L = g.context(), { lastOffset: _, lastStartLoc: E } = L, T = o(8, _, E);
    return w.type !== 12 ? (a(g, G.UNEXPECTED_EMPTY_LINKED_MODIFIER, L.lastStartLoc, 0), T.value = "", r(T, _, E), {
      nextConsumeToken: w,
      node: T
    }) : (w.value == null && a(g, G.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, qe(w)), T.value = w.value || "", r(T, g.currentOffset(), g.currentPosition()), {
      node: T
    });
  }
  function b(g, w) {
    const L = g.context(), _ = o(7, L.offset, L.startLoc);
    return _.value = w, r(_, g.currentOffset(), g.currentPosition()), _;
  }
  function f(g) {
    const w = g.context(), L = o(6, w.offset, w.startLoc);
    let _ = g.nextToken();
    if (_.type === 9) {
      const E = d(g);
      L.modifier = E.node, _ = E.nextConsumeToken || g.nextToken();
    }
    switch (_.type !== 10 && a(g, G.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, qe(_)), _ = g.nextToken(), _.type === 2 && (_ = g.nextToken()), _.type) {
      case 11:
        _.value == null && a(g, G.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, qe(_)), L.key = b(g, _.value || "");
        break;
      case 5:
        _.value == null && a(g, G.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, qe(_)), L.key = c(g, _.value || "");
        break;
      case 6:
        _.value == null && a(g, G.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, qe(_)), L.key = u(g, _.value || "");
        break;
      case 7:
        _.value == null && a(g, G.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, qe(_)), L.key = m(g, _.value || "");
        break;
      default: {
        a(g, G.UNEXPECTED_EMPTY_LINKED_KEY, w.lastStartLoc, 0);
        const E = g.context(), T = o(7, E.offset, E.startLoc);
        return T.value = "", r(T, E.offset, E.startLoc), L.key = T, r(L, E.offset, E.startLoc), {
          nextConsumeToken: _,
          node: L
        };
      }
    }
    return r(L, g.currentOffset(), g.currentPosition()), {
      node: L
    };
  }
  function k(g) {
    const w = g.context(), L = w.currentType === 1 ? g.currentOffset() : w.offset, _ = w.currentType === 1 ? w.endLoc : w.startLoc, E = o(2, L, _);
    E.items = [];
    let T = null, C = null;
    do {
      const x = T || g.nextToken();
      switch (T = null, x.type) {
        case 0:
          x.value == null && a(g, G.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, qe(x)), E.items.push(l(g, x.value || ""));
          break;
        case 6:
          x.value == null && a(g, G.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, qe(x)), E.items.push(u(g, x.value || ""));
          break;
        case 4:
          C = !0;
          break;
        case 5:
          x.value == null && a(g, G.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, qe(x)), E.items.push(c(g, x.value || "", !!C)), C && (s(g, Ei.USE_MODULO_SYNTAX, w.lastStartLoc, 0, qe(x)), C = null);
          break;
        case 7:
          x.value == null && a(g, G.UNEXPECTED_LEXICAL_ANALYSIS, w.lastStartLoc, 0, qe(x)), E.items.push(m(g, x.value || ""));
          break;
        case 8: {
          const z = f(g);
          E.items.push(z.node), T = z.nextConsumeToken || null;
          break;
        }
      }
    } while (w.currentType !== 14 && w.currentType !== 1);
    const O = w.currentType === 1 ? w.lastOffset : g.currentOffset(), B = w.currentType === 1 ? w.lastEndLoc : g.currentPosition();
    return r(E, O, B), E;
  }
  function M(g, w, L, _) {
    const E = g.context();
    let T = _.items.length === 0;
    const C = o(1, w, L);
    C.cases = [], C.cases.push(_);
    do {
      const O = k(g);
      T || (T = O.items.length === 0), C.cases.push(O);
    } while (E.currentType !== 14);
    return T && a(g, G.MUST_HAVE_MESSAGES_IN_PLURAL, L, 0), r(C, g.currentOffset(), g.currentPosition()), C;
  }
  function j(g) {
    const w = g.context(), { offset: L, startLoc: _ } = w, E = k(g);
    return w.currentType === 14 ? E : M(g, L, _, E);
  }
  function y(g) {
    const w = Uo(g, Wa({}, e)), L = w.context(), _ = o(0, L.offset, L.startLoc);
    return t && _.loc && (_.loc.source = g), _.body = j(w), e.onCacheKey && (_.cacheKey = e.onCacheKey(g)), L.currentType !== 14 && a(w, G.UNEXPECTED_LEXICAL_ANALYSIS, L.lastStartLoc, 0, g[L.offset] || ""), r(_, w.currentOffset(), w.currentPosition()), _;
  }
  return { parse: y };
}
function qe(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Vo(e, t = {}) {
  const i = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => i, helper: (s) => (i.helpers.add(s), s) };
}
function Jn(e, t) {
  for (let i = 0; i < e.length; i++)
    Mn(e[i], t);
}
function Mn(e, t) {
  switch (e.type) {
    case 1:
      Jn(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      Jn(e.items, t);
      break;
    case 6: {
      Mn(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function qo(e, t = {}) {
  const i = Vo(e);
  i.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && Mn(e.body, i);
  const n = i.context();
  e.helpers = Array.from(n.helpers);
}
function Go(e) {
  const t = e.body;
  return t.type === 2 ? Zn(t) : t.cases.forEach((i) => Zn(i)), e;
}
function Zn(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let i = 0; i < e.items.length; i++) {
      const n = e.items[i];
      if (!(n.type === 3 || n.type === 9) || n.value == null)
        break;
      t.push(n.value);
    }
    if (t.length === e.items.length) {
      e.static = Ja(t);
      for (let i = 0; i < e.items.length; i++) {
        const n = e.items[i];
        (n.type === 3 || n.type === 9) && delete n.value;
      }
    }
  }
}
const Ko = "minifier";
function Nt(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Nt(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, i = t.cases;
      for (let n = 0; n < i.length; n++)
        Nt(i[n]);
      t.c = i, delete t.cases;
      break;
    }
    case 2: {
      const t = e, i = t.items;
      for (let n = 0; n < i.length; n++)
        Nt(i[n]);
      t.i = i, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Nt(t.key), t.k = t.key, delete t.key, t.modifier && (Nt(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      throw Vt(G.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: Ko,
        args: [e.type]
      });
  }
  delete e.type;
}
const Ho = "parser";
function Wo(e, t) {
  const { sourceMap: i, filename: n, breakLineCode: a, needIndent: s } = t, o = t.location !== !1, r = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: a,
    needIndent: s,
    indentLevel: 0
  };
  o && e.loc && (r.source = e.loc.source);
  const l = () => r;
  function u(M, j) {
    r.code += M;
  }
  function c(M, j = !0) {
    const y = j ? a : "";
    u(s ? y + "  ".repeat(M) : y);
  }
  function m(M = !0) {
    const j = ++r.indentLevel;
    M && c(j);
  }
  function d(M = !0) {
    const j = --r.indentLevel;
    M && c(j);
  }
  function b() {
    c(r.indentLevel);
  }
  return {
    context: l,
    push: u,
    indent: m,
    deindent: d,
    newline: b,
    helper: (M) => `_${M}`,
    needIndent: () => r.needIndent
  };
}
function Jo(e, t) {
  const { helper: i } = e;
  e.push(`${i(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Bt(e, t.key), t.modifier ? (e.push(", "), Bt(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Zo(e, t) {
  const { helper: i, needIndent: n } = e;
  e.push(`${i(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(n());
  const a = t.items.length;
  for (let s = 0; s < a && (Bt(e, t.items[s]), s !== a - 1); s++)
    e.push(", ");
  e.deindent(n()), e.push("])");
}
function Yo(e, t) {
  const { helper: i, needIndent: n } = e;
  if (t.cases.length > 1) {
    e.push(`${i(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(n());
    const a = t.cases.length;
    for (let s = 0; s < a && (Bt(e, t.cases[s]), s !== a - 1); s++)
      e.push(", ");
    e.deindent(n()), e.push("])");
  }
}
function Xo(e, t) {
  t.body ? Bt(e, t.body) : e.push("null");
}
function Bt(e, t) {
  const { helper: i } = e;
  switch (t.type) {
    case 0:
      Xo(e, t);
      break;
    case 1:
      Yo(e, t);
      break;
    case 2:
      Zo(e, t);
      break;
    case 6:
      Jo(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${i(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${i(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${i(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${i(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      throw Vt(G.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: Ho,
        args: [t.type]
      });
  }
}
const Qo = (e, t = {}) => {
  const i = Hn(t.mode) ? t.mode : "normal", n = Hn(t.filename) ? t.filename : "message.intl", a = !!t.sourceMap, s = t.breakLineCode != null ? t.breakLineCode : i === "arrow" ? ";" : `
`, o = t.needIndent ? t.needIndent : i !== "arrow", r = e.helpers || [], l = Wo(e, {
    mode: i,
    filename: n,
    sourceMap: a,
    breakLineCode: s,
    needIndent: o
  });
  l.push(i === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), l.indent(o), r.length > 0 && (l.push(`const { ${Ja(r.map((m) => `${m}: _${m}`), ", ")} } = ctx`), l.newline()), l.push("return "), Bt(l, e), l.deindent(o), l.push("}"), delete e.helpers;
  const { code: u, map: c } = l.context();
  return {
    ast: e,
    code: u,
    map: c ? c.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function er(e, t = {}) {
  const i = Wa({}, t), n = !!i.jit, a = !!i.minify, s = i.optimize == null ? !0 : i.optimize, r = Fo(i).parse(e);
  return n ? (s && Go(r), a && Nt(r), { ast: r, code: "" }) : (qo(r, i), Qo(r, i));
}
/*!
  * core-base v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
function tr() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ze().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Ze().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ze().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
const ht = [];
ht[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ht[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
ht[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
ht[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
ht[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
ht[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
ht[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const ir = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function nr(e) {
  return ir.test(e);
}
function ar(e) {
  const t = e.charCodeAt(0), i = e.charCodeAt(e.length - 1);
  return t === i && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function sr(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function or(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : nr(t) ? ar(t) : "*" + t;
}
function rr(e) {
  const t = [];
  let i = -1, n = 0, a = 0, s, o, r, l, u, c, m;
  const d = [];
  d[
    0
    /* Actions.APPEND */
  ] = () => {
    o === void 0 ? o = r : o += r;
  }, d[
    1
    /* Actions.PUSH */
  ] = () => {
    o !== void 0 && (t.push(o), o = void 0);
  }, d[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    d[
      0
      /* Actions.APPEND */
    ](), a++;
  }, d[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (a > 0)
      a--, n = 4, d[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (a = 0, o === void 0 || (o = or(o), o === !1))
        return !1;
      d[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function b() {
    const f = e[i + 1];
    if (n === 5 && f === "'" || n === 6 && f === '"')
      return i++, r = "\\" + f, d[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; n !== null; )
    if (i++, s = e[i], !(s === "\\" && b())) {
      if (l = sr(s), m = ht[n], u = m[l] || m.l || 8, u === 8 || (n = u[0], u[1] !== void 0 && (c = d[u[1]], c && (r = s, c() === !1))))
        return;
      if (n === 7)
        return t;
    }
}
const Yn = /* @__PURE__ */ new Map();
function lr(e, t) {
  return ie(e) ? e[t] : null;
}
function cr(e, t) {
  if (!ie(e))
    return null;
  let i = Yn.get(t);
  if (i || (i = rr(t), i && Yn.set(t, i)), !i)
    return null;
  const n = i.length;
  let a = e, s = 0;
  for (; s < n; ) {
    const o = a[i[s]];
    if (o === void 0 || ce(a))
      return null;
    a = o, s++;
  }
  return a;
}
const dr = (e) => e, ur = (e) => "", mr = "text", pr = (e) => e.length === 0 ? "" : wo(e), hr = bo;
function Xn(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function gr(e) {
  const t = _e(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (_e(e.named.count) || _e(e.named.n)) ? _e(e.named.count) ? e.named.count : _e(e.named.n) ? e.named.n : t : t;
}
function vr(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function fr(e = {}) {
  const t = e.locale, i = gr(e), n = ie(e.pluralRules) && U(t) && ce(e.pluralRules[t]) ? e.pluralRules[t] : Xn, a = ie(e.pluralRules) && U(t) && ce(e.pluralRules[t]) ? Xn : void 0, s = (j) => j[n(i, j.length, a)], o = e.list || [], r = (j) => o[j], l = e.named || {};
  _e(e.pluralIndex) && vr(i, l);
  const u = (j) => l[j];
  function c(j) {
    const y = ce(e.messages) ? e.messages(j) : ie(e.messages) ? e.messages[j] : !1;
    return y || (e.parent ? e.parent.message(j) : ur);
  }
  const m = (j) => e.modifiers ? e.modifiers[j] : dr, d = Y(e.processor) && ce(e.processor.normalize) ? e.processor.normalize : pr, b = Y(e.processor) && ce(e.processor.interpolate) ? e.processor.interpolate : hr, f = Y(e.processor) && U(e.processor.type) ? e.processor.type : mr, M = {
    list: r,
    named: u,
    plural: s,
    linked: (j, ...y) => {
      const [g, w] = y;
      let L = "text", _ = "";
      y.length === 1 ? ie(g) ? (_ = g.modifier || _, L = g.type || L) : U(g) && (_ = g || _) : y.length === 2 && (U(g) && (_ = g || _), U(w) && (L = w || L));
      const E = c(j)(M), T = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        L === "vnode" && we(E) && _ ? E[0] : E
      );
      return _ ? m(_)(T, L) : T;
    },
    message: c,
    type: f,
    interpolate: b,
    normalize: d,
    values: Se({}, o, l)
  };
  return M;
}
let ti = null;
function kr(e) {
  ti = e;
}
function br(e, t, i) {
  ti && ti.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: i
  });
}
const wr = /* @__PURE__ */ yr(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function yr(e) {
  return (t) => ti && ti.emit(e, t);
}
const Za = Ei.__EXTEND_POINT__, Mt = Li(Za), Ee = {
  NOT_FOUND_KEY: Za,
  // 2
  FALLBACK_TO_TRANSLATE: Mt(),
  // 3
  CANNOT_FORMAT_NUMBER: Mt(),
  // 4
  FALLBACK_TO_NUMBER_FORMAT: Mt(),
  // 5
  CANNOT_FORMAT_DATE: Mt(),
  // 6
  FALLBACK_TO_DATE_FORMAT: Mt(),
  // 7
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: Mt(),
  // 8
  __EXTEND_POINT__: Mt()
  // 9
}, Mr = {
  [Ee.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Ee.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Ee.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Ee.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Ee.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Ee.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Ee.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Ct(e, ...t) {
  return yn(Mr[e], ...t);
}
const Ya = G.__EXTEND_POINT__, zt = Li(Ya), Me = {
  INVALID_ARGUMENT: Ya,
  // 17
  INVALID_DATE_ARGUMENT: zt(),
  // 18
  INVALID_ISO_DATE_ARGUMENT: zt(),
  // 19
  NOT_SUPPORT_NON_STRING_MESSAGE: zt(),
  // 20
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: zt(),
  // 21
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: zt(),
  // 22
  NOT_SUPPORT_LOCALE_TYPE: zt(),
  // 23
  __EXTEND_POINT__: zt()
  // 24
};
function Ge(e) {
  return Vt(e, null, process.env.NODE_ENV !== "production" ? { messages: zr } : void 0);
}
const zr = {
  [Me.INVALID_ARGUMENT]: "Invalid arguments",
  [Me.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Me.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Me.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Me.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Me.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Me.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function zn(e, t) {
  return t.locale != null ? Qn(t.locale) : Qn(e.locale);
}
let Ri;
function Qn(e) {
  if (U(e))
    return e;
  if (ce(e)) {
    if (e.resolvedOnce && Ri != null)
      return Ri;
    if (e.constructor.name === "Function") {
      const t = e();
      if (ko(t))
        throw Ge(Me.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Ri = t;
    } else
      throw Ge(Me.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw Ge(Me.NOT_SUPPORT_LOCALE_TYPE);
}
function jr(e, t, i) {
  return [.../* @__PURE__ */ new Set([
    i,
    ...we(t) ? t : ie(t) ? Object.keys(t) : U(t) ? [t] : [i]
  ])];
}
function Xa(e, t, i) {
  const n = U(i) ? i : ii, a = e;
  a.__localeChainCache || (a.__localeChainCache = /* @__PURE__ */ new Map());
  let s = a.__localeChainCache.get(n);
  if (!s) {
    s = [];
    let o = [i];
    for (; we(o); )
      o = ea(s, o, t);
    const r = we(t) || !Y(t) ? t : t.default ? t.default : null;
    o = U(r) ? [r] : r, we(o) && ea(s, o, !1), a.__localeChainCache.set(n, s);
  }
  return s;
}
function ea(e, t, i) {
  let n = !0;
  for (let a = 0; a < t.length && le(n); a++) {
    const s = t[a];
    U(s) && (n = _r(e, t[a], i));
  }
  return n;
}
function _r(e, t, i) {
  let n;
  const a = t.split("-");
  do {
    const s = a.join("-");
    n = Sr(e, s, i), a.splice(-1, 1);
  } while (a.length && n === !0);
  return n;
}
function Sr(e, t, i) {
  let n = !1;
  if (!e.includes(t) && (n = !0, t)) {
    n = t[t.length - 1] !== "!";
    const a = t.replace(/!/g, "");
    e.push(a), (we(i) || Y(i)) && i[a] && (n = i[a]);
  }
  return n;
}
const Cr = "9.13.1", Pi = -1, ii = "en-US", bi = "", ta = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function Lr() {
  return {
    upper: (e, t) => t === "text" && U(e) ? e.toUpperCase() : t === "vnode" && ie(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && U(e) ? e.toLowerCase() : t === "vnode" && ie(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && U(e) ? ta(e) : t === "vnode" && ie(e) && "__v_isVNode" in e ? ta(e.children) : e
  };
}
let Qa;
function ia(e) {
  Qa = e;
}
let es;
function Er(e) {
  es = e;
}
let ts;
function Pr(e) {
  ts = e;
}
let is = null;
const Tr = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  is = e;
}, Ar = /* @__NO_SIDE_EFFECTS__ */ () => is;
let ns = null;
const na = (e) => {
  ns = e;
}, xr = () => ns;
let aa = 0;
function Ir(e = {}) {
  const t = ce(e.onWarn) ? e.onWarn : it, i = U(e.version) ? e.version : Cr, n = U(e.locale) || ce(e.locale) ? e.locale : ii, a = ce(n) ? ii : n, s = we(e.fallbackLocale) || Y(e.fallbackLocale) || U(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : a, o = Y(e.messages) ? e.messages : { [a]: {} }, r = Y(e.datetimeFormats) ? e.datetimeFormats : { [a]: {} }, l = Y(e.numberFormats) ? e.numberFormats : { [a]: {} }, u = Se({}, e.modifiers || {}, Lr()), c = e.pluralRules || {}, m = ce(e.missing) ? e.missing : null, d = le(e.missingWarn) || $t(e.missingWarn) ? e.missingWarn : !0, b = le(e.fallbackWarn) || $t(e.fallbackWarn) ? e.fallbackWarn : !0, f = !!e.fallbackFormat, k = !!e.unresolving, M = ce(e.postTranslation) ? e.postTranslation : null, j = Y(e.processor) ? e.processor : null, y = le(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, g = !!e.escapeParameter, w = ce(e.messageCompiler) ? e.messageCompiler : Qa;
  process.env.NODE_ENV !== "production" && ce(e.messageCompiler) && Ka(Ct(Ee.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const L = ce(e.messageResolver) ? e.messageResolver : es || lr, _ = ce(e.localeFallbacker) ? e.localeFallbacker : ts || jr, E = ie(e.fallbackContext) ? e.fallbackContext : void 0, T = e, C = ie(T.__datetimeFormatters) ? T.__datetimeFormatters : /* @__PURE__ */ new Map(), O = ie(T.__numberFormatters) ? T.__numberFormatters : /* @__PURE__ */ new Map(), B = ie(T.__meta) ? T.__meta : {};
  aa++;
  const x = {
    version: i,
    cid: aa,
    locale: n,
    fallbackLocale: s,
    messages: o,
    modifiers: u,
    pluralRules: c,
    missing: m,
    missingWarn: d,
    fallbackWarn: b,
    fallbackFormat: f,
    unresolving: k,
    postTranslation: M,
    processor: j,
    warnHtmlMessage: y,
    escapeParameter: g,
    messageCompiler: w,
    messageResolver: L,
    localeFallbacker: _,
    fallbackContext: E,
    onWarn: t,
    __meta: B
  };
  return x.datetimeFormats = r, x.numberFormats = l, x.__datetimeFormatters = C, x.__numberFormatters = O, process.env.NODE_ENV !== "production" && (x.__v_emitter = T.__v_emitter != null ? T.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && br(x, i, B), x;
}
function Ti(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function as(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function jn(e, t, i, n, a) {
  const { missing: s, onWarn: o } = e;
  if (process.env.NODE_ENV !== "production") {
    const r = e.__v_emitter;
    r && r.emit("missing", {
      locale: i,
      key: t,
      type: a,
      groupId: `${a}:${t}`
    });
  }
  if (s !== null) {
    const r = s(e, i, t, a);
    return U(r) ? r : t;
  } else
    return process.env.NODE_ENV !== "production" && as(n, t) && o(Ct(Ee.NOT_FOUND_KEY, { key: t, locale: i })), t;
}
function Yt(e, t, i) {
  const n = e;
  n.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, i, t);
}
function ss(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function Dr(e, t) {
  const i = t.indexOf(e);
  if (i === -1)
    return !1;
  for (let n = i + 1; n < t.length; n++)
    if (ss(e, t[n]))
      return !0;
  return !1;
}
function Fi(e) {
  return (i) => Nr(i, e);
}
function Nr(e, t) {
  const i = t.b || t.body;
  if ((i.t || i.type) === 1) {
    const n = i, a = n.c || n.cases;
    return e.plural(a.reduce((s, o) => [
      ...s,
      sa(e, o)
    ], []));
  } else
    return sa(e, i);
}
function sa(e, t) {
  const i = t.s || t.static;
  if (i)
    return e.type === "text" ? i : e.normalize([i]);
  {
    const n = (t.i || t.items).reduce((a, s) => [...a, en(e, s)], []);
    return e.normalize(n);
  }
}
function en(e, t) {
  const i = t.t || t.type;
  switch (i) {
    case 3: {
      const n = t;
      return n.v || n.value;
    }
    case 9: {
      const n = t;
      return n.v || n.value;
    }
    case 4: {
      const n = t;
      return e.interpolate(e.named(n.k || n.key));
    }
    case 5: {
      const n = t;
      return e.interpolate(e.list(n.i != null ? n.i : n.index));
    }
    case 6: {
      const n = t, a = n.m || n.modifier;
      return e.linked(en(e, n.k || n.key), a ? en(e, a) : void 0, e.type);
    }
    case 7: {
      const n = t;
      return n.v || n.value;
    }
    case 8: {
      const n = t;
      return n.v || n.value;
    }
    default:
      throw new Error(`unhandled node type on format message part: ${i}`);
  }
}
const Or = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function os(e, t) {
  t && To(e) && it(yn(Or, { source: e }));
}
const rs = (e) => e;
let Ot = /* @__PURE__ */ Object.create(null);
function ls(e) {
  e.code === Ei.USE_MODULO_SYNTAX && it(`The use of named interpolation with modulo syntax is deprecated. It will be removed in v10.
reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format 
(message compiler warning message: ${e.message})`);
}
const Lt = (e) => ie(e) && (e.t === 0 || e.type === 0) && ("b" in e || "body" in e);
function cs(e, t = {}) {
  let i = !1;
  const n = t.onError || Eo;
  return t.onError = (a) => {
    i = !0, n(a);
  }, { ...er(e, t), detectError: i };
}
const Ur = /* @__NO_SIDE_EFFECTS__ */ (e, t) => {
  if (!U(e))
    throw Ge(Me.NOT_SUPPORT_NON_STRING_MESSAGE);
  process.env.NODE_ENV !== "production" && (t.onWarn = ls);
  {
    const i = le(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && os(e, i);
    const a = (t.onCacheKey || rs)(e), s = Ot[a];
    if (s)
      return s;
    const { code: o, detectError: r } = cs(e, t), l = new Function(`return ${o}`)();
    return r ? l : Ot[a] = l;
  }
};
function $r(e, t) {
  if (process.env.NODE_ENV !== "production" && (t.onWarn = ls), __INTLIFY_JIT_COMPILATION__ && !__INTLIFY_DROP_MESSAGE_COMPILER__ && U(e)) {
    const i = le(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && os(e, i);
    const a = (t.onCacheKey || rs)(e), s = Ot[a];
    if (s)
      return s;
    const { ast: o, detectError: r } = cs(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = Fi(o);
    return r ? l : Ot[a] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !Lt(e))
      return it(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const i = e.cacheKey;
    if (i) {
      const n = Ot[i];
      return n || (Ot[i] = Fi(e));
    } else
      return Fi(e);
  }
}
const oa = () => "", Ue = (e) => ce(e);
function ra(e, ...t) {
  const { fallbackFormat: i, postTranslation: n, unresolving: a, messageCompiler: s, fallbackLocale: o, messages: r } = e, [l, u] = tn(...t), c = le(u.missingWarn) ? u.missingWarn : e.missingWarn, m = le(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn, d = le(u.escapeParameter) ? u.escapeParameter : e.escapeParameter, b = !!u.resolvedMessage, f = U(u.default) || le(u.default) ? le(u.default) ? s ? l : () => l : u.default : i ? s ? l : () => l : "", k = i || f !== "", M = zn(e, u);
  d && Br(u);
  let [j, y, g] = b ? [
    l,
    M,
    r[M] || {}
  ] : ds(e, l, M, o, m, c), w = j, L = l;
  if (!b && !(U(w) || Lt(w) || Ue(w)) && k && (w = f, L = w), !b && (!(U(w) || Lt(w) || Ue(w)) || !U(y)))
    return a ? Pi : l;
  if (process.env.NODE_ENV !== "production" && U(w) && e.messageCompiler == null)
    return it(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let _ = !1;
  const E = () => {
    _ = !0;
  }, T = Ue(w) ? w : us(e, l, y, w, L, E);
  if (_)
    return w;
  const C = qr(e, y, g, u), O = fr(C), B = Rr(e, T, O), x = n ? n(B, l) : B;
  if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const z = {
      timestamp: Date.now(),
      key: U(l) ? l : Ue(w) ? w.key : "",
      locale: y || (Ue(w) ? w.locale : ""),
      format: U(w) ? w : Ue(w) ? w.source : "",
      message: x
    };
    z.meta = Se({}, e.__meta, /* @__PURE__ */ Ar() || {}), wr(z);
  }
  return x;
}
function Br(e) {
  we(e.list) ? e.list = e.list.map((t) => U(t) ? qn(t) : t) : ie(e.named) && Object.keys(e.named).forEach((t) => {
    U(e.named[t]) && (e.named[t] = qn(e.named[t]));
  });
}
function ds(e, t, i, n, a, s) {
  const { messages: o, onWarn: r, messageResolver: l, localeFallbacker: u } = e, c = u(e, n, i);
  let m = {}, d, b = null, f = i, k = null;
  const M = "translate";
  for (let j = 0; j < c.length; j++) {
    if (d = k = c[j], process.env.NODE_ENV !== "production" && i !== d && !ss(i, d) && Ti(a, t) && r(Ct(Ee.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: d
    })), process.env.NODE_ENV !== "production" && i !== d) {
      const L = e.__v_emitter;
      L && L.emit("fallback", {
        type: M,
        key: t,
        from: f,
        to: k,
        groupId: `${M}:${t}`
      });
    }
    m = o[d] || {};
    let y = null, g, w;
    if (process.env.NODE_ENV !== "production" && Ye && (y = window.performance.now(), g = "intlify-message-resolve-start", w = "intlify-message-resolve-end", De && De(g)), (b = l(m, t)) === null && (b = m[t]), process.env.NODE_ENV !== "production" && Ye) {
      const L = window.performance.now(), _ = e.__v_emitter;
      _ && y && b && _.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: b,
        time: L - y,
        groupId: `${M}:${t}`
      }), g && w && De && St && (De(w), St("intlify message resolve", g, w));
    }
    if (U(b) || Lt(b) || Ue(b))
      break;
    if (!Dr(d, c)) {
      const L = jn(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        d,
        s,
        M
      );
      L !== t && (b = L);
    }
    f = k;
  }
  return [b, d, m];
}
function us(e, t, i, n, a, s) {
  const { messageCompiler: o, warnHtmlMessage: r } = e;
  if (Ue(n)) {
    const d = n;
    return d.locale = d.locale || i, d.key = d.key || t, d;
  }
  if (o == null) {
    const d = () => n;
    return d.locale = i, d.key = t, d;
  }
  let l = null, u, c;
  process.env.NODE_ENV !== "production" && Ye && (l = window.performance.now(), u = "intlify-message-compilation-start", c = "intlify-message-compilation-end", De && De(u));
  const m = o(n, Fr(e, i, a, n, r, s));
  if (process.env.NODE_ENV !== "production" && Ye) {
    const d = window.performance.now(), b = e.__v_emitter;
    b && l && b.emit("message-compilation", {
      type: "message-compilation",
      message: n,
      time: d - l,
      groupId: `translate:${t}`
    }), u && c && De && St && (De(c), St("intlify message compilation", u, c));
  }
  return m.locale = i, m.key = t, m.source = n, m;
}
function Rr(e, t, i) {
  let n = null, a, s;
  process.env.NODE_ENV !== "production" && Ye && (n = window.performance.now(), a = "intlify-message-evaluation-start", s = "intlify-message-evaluation-end", De && De(a));
  const o = t(i);
  if (process.env.NODE_ENV !== "production" && Ye) {
    const r = window.performance.now(), l = e.__v_emitter;
    l && n && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: o,
      time: r - n,
      groupId: `translate:${t.key}`
    }), a && s && De && St && (De(s), St("intlify message evaluation", a, s));
  }
  return o;
}
function tn(...e) {
  const [t, i, n] = e, a = {};
  if (!U(t) && !_e(t) && !Ue(t) && !Lt(t))
    throw Ge(Me.INVALID_ARGUMENT);
  const s = _e(t) ? String(t) : (Ue(t), t);
  return _e(i) ? a.plural = i : U(i) ? a.default = i : Y(i) && !Ci(i) ? a.named = i : we(i) && (a.list = i), _e(n) ? a.plural = n : U(n) ? a.default = n : Y(n) && Se(a, n), [s, a];
}
function Fr(e, t, i, n, a, s) {
  return {
    locale: t,
    key: i,
    warnHtmlMessage: a,
    onError: (o) => {
      if (s && s(o), process.env.NODE_ENV !== "production") {
        const r = Vr(n), l = `Message compilation error: ${o.message}`, u = o.location && r && yo(r, o.location.start.offset, o.location.end.offset), c = e.__v_emitter;
        c && r && c.emit("compile-error", {
          message: r,
          error: o.message,
          start: o.location && o.location.start.offset,
          end: o.location && o.location.end.offset,
          groupId: `translate:${i}`
        }), console.error(u ? `${l}
${u}` : l);
      } else
        throw o;
    },
    onCacheKey: (o) => ho(t, i, o)
  };
}
function Vr(e) {
  if (U(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function qr(e, t, i, n) {
  const { modifiers: a, pluralRules: s, messageResolver: o, fallbackLocale: r, fallbackWarn: l, missingWarn: u, fallbackContext: c } = e, d = {
    locale: t,
    modifiers: a,
    pluralRules: s,
    messages: (b) => {
      let f = o(i, b);
      if (f == null && c) {
        const [, , k] = ds(c, b, t, r, l, u);
        f = o(k, b);
      }
      if (U(f) || Lt(f)) {
        let k = !1;
        const j = us(e, b, t, f, b, () => {
          k = !0;
        });
        return k ? oa : j;
      } else
        return Ue(f) ? f : oa;
    }
  };
  return e.processor && (d.processor = e.processor), n.list && (d.list = n.list), n.named && (d.named = n.named), _e(n.plural) && (d.pluralIndex = n.plural), d;
}
const la = typeof Intl < "u", ms = {
  dateTimeFormat: la && typeof Intl.DateTimeFormat < "u",
  numberFormat: la && typeof Intl.NumberFormat < "u"
};
function ca(e, ...t) {
  const { datetimeFormats: i, unresolving: n, fallbackLocale: a, onWarn: s, localeFallbacker: o } = e, { __datetimeFormatters: r } = e;
  if (process.env.NODE_ENV !== "production" && !ms.dateTimeFormat)
    return s(Ct(Ee.CANNOT_FORMAT_DATE)), bi;
  const [l, u, c, m] = nn(...t), d = le(c.missingWarn) ? c.missingWarn : e.missingWarn, b = le(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, f = !!c.part, k = zn(e, c), M = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    a,
    k
  );
  if (!U(l) || l === "")
    return new Intl.DateTimeFormat(k, m).format(u);
  let j = {}, y, g = null, w = k, L = null;
  const _ = "datetime format";
  for (let C = 0; C < M.length; C++) {
    if (y = L = M[C], process.env.NODE_ENV !== "production" && k !== y && Ti(b, l) && s(Ct(Ee.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: y
    })), process.env.NODE_ENV !== "production" && k !== y) {
      const O = e.__v_emitter;
      O && O.emit("fallback", {
        type: _,
        key: l,
        from: w,
        to: L,
        groupId: `${_}:${l}`
      });
    }
    if (j = i[y] || {}, g = j[l], Y(g))
      break;
    jn(e, l, y, d, _), w = L;
  }
  if (!Y(g) || !U(y))
    return n ? Pi : l;
  let E = `${y}__${l}`;
  Ci(m) || (E = `${E}__${JSON.stringify(m)}`);
  let T = r.get(E);
  return T || (T = new Intl.DateTimeFormat(y, Se({}, g, m)), r.set(E, T)), f ? T.formatToParts(u) : T.format(u);
}
const ps = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function nn(...e) {
  const [t, i, n, a] = e, s = {};
  let o = {}, r;
  if (U(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw Ge(Me.INVALID_ISO_DATE_ARGUMENT);
    const u = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    r = new Date(u);
    try {
      r.toISOString();
    } catch {
      throw Ge(Me.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (vo(t)) {
    if (isNaN(t.getTime()))
      throw Ge(Me.INVALID_DATE_ARGUMENT);
    r = t;
  } else if (_e(t))
    r = t;
  else
    throw Ge(Me.INVALID_ARGUMENT);
  return U(i) ? s.key = i : Y(i) && Object.keys(i).forEach((l) => {
    ps.includes(l) ? o[l] = i[l] : s[l] = i[l];
  }), U(n) ? s.locale = n : Y(n) && (o = n), Y(a) && (o = a), [s.key || "", r, s, o];
}
function da(e, t, i) {
  const n = e;
  for (const a in i) {
    const s = `${t}__${a}`;
    n.__datetimeFormatters.has(s) && n.__datetimeFormatters.delete(s);
  }
}
function ua(e, ...t) {
  const { numberFormats: i, unresolving: n, fallbackLocale: a, onWarn: s, localeFallbacker: o } = e, { __numberFormatters: r } = e;
  if (process.env.NODE_ENV !== "production" && !ms.numberFormat)
    return s(Ct(Ee.CANNOT_FORMAT_NUMBER)), bi;
  const [l, u, c, m] = an(...t), d = le(c.missingWarn) ? c.missingWarn : e.missingWarn, b = le(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, f = !!c.part, k = zn(e, c), M = o(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    a,
    k
  );
  if (!U(l) || l === "")
    return new Intl.NumberFormat(k, m).format(u);
  let j = {}, y, g = null, w = k, L = null;
  const _ = "number format";
  for (let C = 0; C < M.length; C++) {
    if (y = L = M[C], process.env.NODE_ENV !== "production" && k !== y && Ti(b, l) && s(Ct(Ee.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: y
    })), process.env.NODE_ENV !== "production" && k !== y) {
      const O = e.__v_emitter;
      O && O.emit("fallback", {
        type: _,
        key: l,
        from: w,
        to: L,
        groupId: `${_}:${l}`
      });
    }
    if (j = i[y] || {}, g = j[l], Y(g))
      break;
    jn(e, l, y, d, _), w = L;
  }
  if (!Y(g) || !U(y))
    return n ? Pi : l;
  let E = `${y}__${l}`;
  Ci(m) || (E = `${E}__${JSON.stringify(m)}`);
  let T = r.get(E);
  return T || (T = new Intl.NumberFormat(y, Se({}, g, m)), r.set(E, T)), f ? T.formatToParts(u) : T.format(u);
}
const hs = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function an(...e) {
  const [t, i, n, a] = e, s = {};
  let o = {};
  if (!_e(t))
    throw Ge(Me.INVALID_ARGUMENT);
  const r = t;
  return U(i) ? s.key = i : Y(i) && Object.keys(i).forEach((l) => {
    hs.includes(l) ? o[l] = i[l] : s[l] = i[l];
  }), U(n) ? s.locale = n : Y(n) && (o = n), Y(a) && (o = a), [s.key || "", r, s, o];
}
function ma(e, t, i) {
  const n = e;
  for (const a in i) {
    const s = `${t}__${a}`;
    n.__numberFormatters.has(s) && n.__numberFormatters.delete(s);
  }
}
tr();
/*!
  * vue-i18n v9.13.1
  * (c) 2024 kazuya kawaguchi
  * Released under the MIT License.
  */
const Gr = "9.13.1";
function Kr() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Ze().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Ze().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_JIT_COMPILATION__ != "boolean" && (Ze().__INTLIFY_JIT_COMPILATION__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ze().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ze().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const gs = Ee.__EXTEND_POINT__, We = Li(gs), Ae = {
  FALLBACK_TO_ROOT: gs,
  // 9
  NOT_SUPPORTED_PRESERVE: We(),
  // 10
  NOT_SUPPORTED_FORMATTER: We(),
  // 11
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: We(),
  // 12
  NOT_SUPPORTED_GET_CHOICE_INDEX: We(),
  // 13
  COMPONENT_NAME_LEGACY_COMPATIBLE: We(),
  // 14
  NOT_FOUND_PARENT_SCOPE: We(),
  // 15
  IGNORE_OBJ_FLATTEN: We(),
  // 16
  NOTICE_DROP_ALLOW_COMPOSITION: We(),
  // 17
  NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: We()
  // 18
}, Hr = {
  [Ae.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Ae.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [Ae.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [Ae.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [Ae.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [Ae.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [Ae.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Ae.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [Ae.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze",
  [Ae.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: "'translateExistCompatible' option will be dropped in the next major version."
};
function wi(e, ...t) {
  return yn(Hr[e], ...t);
}
const vs = Me.__EXTEND_POINT__, Te = Li(vs), ge = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: vs,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: Te(),
  // 25
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: Te(),
  // 26
  NOT_INSTALLED: Te(),
  // 27
  NOT_AVAILABLE_IN_LEGACY_MODE: Te(),
  // 28
  // directive module errors
  REQUIRED_VALUE: Te(),
  // 29
  INVALID_VALUE: Te(),
  // 30
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: Te(),
  // 31
  NOT_INSTALLED_WITH_PROVIDE: Te(),
  // 32
  // unexpected error
  UNEXPECTED_ERROR: Te(),
  // 33
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: Te(),
  // 34
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: Te(),
  // 35
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: Te(),
  // 36
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: Te(),
  // 37
  // for enhancement
  __EXTEND_POINT__: Te()
  // 38
};
function dt(e, ...t) {
  return Vt(e, null, process.env.NODE_ENV !== "production" ? { messages: Wr, args: t } : void 0);
}
const Wr = {
  [ge.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [ge.INVALID_ARGUMENT]: "Invalid argument",
  [ge.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [ge.NOT_INSTALLED]: "Need to install with `app.use` function",
  [ge.UNEXPECTED_ERROR]: "Unexpected error",
  [ge.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [ge.REQUIRED_VALUE]: "Required in value: {0}",
  [ge.INVALID_VALUE]: "Invalid value",
  [ge.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [ge.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [ge.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [ge.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [ge.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [ge.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, sn = /* @__PURE__ */ tt("__translateVNode"), on = /* @__PURE__ */ tt("__datetimeParts"), rn = /* @__PURE__ */ tt("__numberParts"), ln = /* @__PURE__ */ tt("__enableEmitter"), cn = /* @__PURE__ */ tt("__disableEmitter"), Jr = tt("__setPluralRules"), fs = /* @__PURE__ */ tt("__injectWithOption"), dn = /* @__PURE__ */ tt("__dispose");
function ni(e) {
  if (!ie(e))
    return e;
  for (const t in e)
    if (fi(e, t))
      if (!t.includes("."))
        ie(e[t]) && ni(e[t]);
      else {
        const i = t.split("."), n = i.length - 1;
        let a = e, s = !1;
        for (let o = 0; o < n; o++) {
          if (i[o] in a || (a[i[o]] = {}), !ie(a[i[o]])) {
            process.env.NODE_ENV !== "production" && it(wi(Ae.IGNORE_OBJ_FLATTEN, {
              key: i[o]
            })), s = !0;
            break;
          }
          a = a[i[o]];
        }
        s || (a[i[n]] = e[t], delete e[t]), ie(a[i[n]]) && ni(a[i[n]]);
      }
  return e;
}
function _n(e, t) {
  const { messages: i, __i18n: n, messageResolver: a, flatJson: s } = t, o = Y(i) ? i : we(n) ? {} : { [e]: {} };
  if (we(n) && n.forEach((r) => {
    if ("locale" in r && "resource" in r) {
      const { locale: l, resource: u } = r;
      l ? (o[l] = o[l] || {}, gi(u, o[l])) : gi(u, o);
    } else
      U(r) && gi(JSON.parse(r), o);
  }), a == null && s)
    for (const r in o)
      fi(o, r) && ni(o[r]);
  return o;
}
function ks(e) {
  return e.type;
}
function Zr(e, t, i) {
  let n = ie(t.messages) ? t.messages : {};
  "__i18nGlobal" in i && (n = _n(e.locale.value, {
    messages: n,
    __i18n: i.__i18nGlobal
  }));
  const a = Object.keys(n);
  a.length && a.forEach((s) => {
    e.mergeLocaleMessage(s, n[s]);
  });
  {
    if (ie(t.datetimeFormats)) {
      const s = Object.keys(t.datetimeFormats);
      s.length && s.forEach((o) => {
        e.mergeDateTimeFormat(o, t.datetimeFormats[o]);
      });
    }
    if (ie(t.numberFormats)) {
      const s = Object.keys(t.numberFormats);
      s.length && s.forEach((o) => {
        e.mergeNumberFormat(o, t.numberFormats[o]);
      });
    }
  }
}
function pa(e) {
  return F(ao, null, e, 0);
}
const ha = "__INTLIFY_META__", ga = () => [], Yr = () => !1;
let va = 0;
function fa(e) {
  return (t, i, n, a) => e(i, n, wn() || void 0, a);
}
const Xr = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = wn();
  let t = null;
  return e && (t = ks(e)[ha]) ? { [ha]: t } : null;
};
function Qr(e = {}, t) {
  const { __root: i, __injectWithOption: n } = e, a = i === void 0, s = e.flatJson, o = Ye ? J : Fa, r = !!e.translateExistCompatible;
  process.env.NODE_ENV !== "production" && r && Ka(wi(Ae.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG));
  let l = le(e.inheritLocale) ? e.inheritLocale : !0;
  const u = o(
    // prettier-ignore
    i && l ? i.locale.value : U(e.locale) ? e.locale : ii
  ), c = o(
    // prettier-ignore
    i && l ? i.fallbackLocale.value : U(e.fallbackLocale) || we(e.fallbackLocale) || Y(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : u.value
  ), m = o(_n(u.value, e)), d = o(Y(e.datetimeFormats) ? e.datetimeFormats : { [u.value]: {} }), b = o(Y(e.numberFormats) ? e.numberFormats : { [u.value]: {} });
  let f = i ? i.missingWarn : le(e.missingWarn) || $t(e.missingWarn) ? e.missingWarn : !0, k = i ? i.fallbackWarn : le(e.fallbackWarn) || $t(e.fallbackWarn) ? e.fallbackWarn : !0, M = i ? i.fallbackRoot : le(e.fallbackRoot) ? e.fallbackRoot : !0, j = !!e.fallbackFormat, y = ce(e.missing) ? e.missing : null, g = ce(e.missing) ? fa(e.missing) : null, w = ce(e.postTranslation) ? e.postTranslation : null, L = i ? i.warnHtmlMessage : le(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, _ = !!e.escapeParameter;
  const E = i ? i.modifiers : Y(e.modifiers) ? e.modifiers : {};
  let T = e.pluralRules || i && i.pluralRules, C;
  C = (() => {
    a && na(null);
    const S = {
      version: Gr,
      locale: u.value,
      fallbackLocale: c.value,
      messages: m.value,
      modifiers: E,
      pluralRules: T,
      missing: g === null ? void 0 : g,
      missingWarn: f,
      fallbackWarn: k,
      fallbackFormat: j,
      unresolving: !0,
      postTranslation: w === null ? void 0 : w,
      warnHtmlMessage: L,
      escapeParameter: _,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    S.datetimeFormats = d.value, S.numberFormats = b.value, S.__datetimeFormatters = Y(C) ? C.__datetimeFormatters : void 0, S.__numberFormatters = Y(C) ? C.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (S.__v_emitter = Y(C) ? C.__v_emitter : void 0);
    const I = Ir(S);
    return a && na(I), I;
  })(), Yt(C, u.value, c.value);
  function B() {
    return [
      u.value,
      c.value,
      m.value,
      d.value,
      b.value
    ];
  }
  const x = H({
    get: () => u.value,
    set: (S) => {
      u.value = S, C.locale = u.value;
    }
  }), z = H({
    get: () => c.value,
    set: (S) => {
      c.value = S, C.fallbackLocale = c.value, Yt(C, u.value, S);
    }
  }), A = H(() => m.value), $ = /* @__PURE__ */ H(() => d.value), q = /* @__PURE__ */ H(() => b.value);
  function Z() {
    return ce(w) ? w : null;
  }
  function X(S) {
    w = S, C.postTranslation = S;
  }
  function W() {
    return y;
  }
  function ae(S) {
    S !== null && (g = fa(S)), y = S, C.missing = g;
  }
  function se(S, I) {
    return S !== "translate" || !I.resolvedMessage;
  }
  const he = (S, I, te, ke, st, oi) => {
    B();
    let It;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (C.fallbackContext = i ? xr() : void 0), It = S(C);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, a || (C.fallbackContext = void 0);
    }
    if (te !== "translate exists" && // for not `te` (e.g `t`)
    _e(It) && It === Pi || te === "translate exists" && !It) {
      const [yt, Qs] = I();
      if (process.env.NODE_ENV !== "production" && i && U(yt) && se(te, Qs) && (M && (Ti(k, yt) || as(f, yt)) && it(wi(Ae.FALLBACK_TO_ROOT, {
        key: yt,
        type: te
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Rn } = C;
        Rn && M && Rn.emit("fallback", {
          type: te,
          key: yt,
          to: "global",
          groupId: `${te}:${yt}`
        });
      }
      return i && M ? ke(i) : st(yt);
    } else {
      if (oi(It))
        return It;
      throw dt(ge.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Oe(...S) {
    return he((I) => Reflect.apply(ra, null, [I, ...S]), () => tn(...S), "translate", (I) => Reflect.apply(I.t, I, [...S]), (I) => I, (I) => U(I));
  }
  function Ce(...S) {
    const [I, te, ke] = S;
    if (ke && !ie(ke))
      throw dt(ge.INVALID_ARGUMENT);
    return Oe(I, te, Se({ resolvedMessage: !0 }, ke || {}));
  }
  function Ve(...S) {
    return he((I) => Reflect.apply(ca, null, [I, ...S]), () => nn(...S), "datetime format", (I) => Reflect.apply(I.d, I, [...S]), () => bi, (I) => U(I));
  }
  function nt(...S) {
    return he((I) => Reflect.apply(ua, null, [I, ...S]), () => an(...S), "number format", (I) => Reflect.apply(I.n, I, [...S]), () => bi, (I) => U(I));
  }
  function Ke(S) {
    return S.map((I) => U(I) || _e(I) || le(I) ? pa(String(I)) : I);
  }
  const Gt = {
    normalize: Ke,
    interpolate: (S) => S,
    type: "vnode"
  };
  function xt(...S) {
    return he(
      (I) => {
        let te;
        const ke = I;
        try {
          ke.processor = Gt, te = Reflect.apply(ra, null, [ke, ...S]);
        } finally {
          ke.processor = null;
        }
        return te;
      },
      () => tn(...S),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (I) => I[sn](...S),
      (I) => [pa(I)],
      (I) => we(I)
    );
  }
  function Kt(...S) {
    return he(
      (I) => Reflect.apply(ua, null, [I, ...S]),
      () => an(...S),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (I) => I[rn](...S),
      ga,
      (I) => U(I) || we(I)
    );
  }
  function Ht(...S) {
    return he(
      (I) => Reflect.apply(ca, null, [I, ...S]),
      () => nn(...S),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (I) => I[on](...S),
      ga,
      (I) => U(I) || we(I)
    );
  }
  function Wt(S) {
    T = S, C.pluralRules = T;
  }
  function D(S, I) {
    return he(() => {
      if (!S)
        return !1;
      const te = U(I) ? I : u.value, ke = wt(te), st = C.messageResolver(ke, S);
      return r ? st != null : Lt(st) || Ue(st) || U(st);
    }, () => [S], "translate exists", (te) => Reflect.apply(te.te, te, [S, I]), Yr, (te) => le(te));
  }
  function ee(S) {
    let I = null;
    const te = Xa(C, c.value, u.value);
    for (let ke = 0; ke < te.length; ke++) {
      const st = m.value[te[ke]] || {}, oi = C.messageResolver(st, S);
      if (oi != null) {
        I = oi;
        break;
      }
    }
    return I;
  }
  function Jt(S) {
    const I = ee(S);
    return I ?? (i ? i.tm(S) || {} : {});
  }
  function wt(S) {
    return m.value[S] || {};
  }
  function Zt(S, I) {
    if (s) {
      const te = { [S]: I };
      for (const ke in te)
        fi(te, ke) && ni(te[ke]);
      I = te[S];
    }
    m.value[S] = I, C.messages = m.value;
  }
  function $i(S, I) {
    m.value[S] = m.value[S] || {};
    const te = { [S]: I };
    if (s)
      for (const ke in te)
        fi(te, ke) && ni(te[ke]);
    I = te[S], gi(I, m.value[S]), C.messages = m.value;
  }
  function h(S) {
    return d.value[S] || {};
  }
  function v(S, I) {
    d.value[S] = I, C.datetimeFormats = d.value, da(C, S, I);
  }
  function P(S, I) {
    d.value[S] = Se(d.value[S] || {}, I), C.datetimeFormats = d.value, da(C, S, I);
  }
  function R(S) {
    return b.value[S] || {};
  }
  function ue(S, I) {
    b.value[S] = I, C.numberFormats = b.value, ma(C, S, I);
  }
  function oe(S, I) {
    b.value[S] = Se(b.value[S] || {}, I), C.numberFormats = b.value, ma(C, S, I);
  }
  va++, i && Ye && (vi(i.locale, (S) => {
    l && (u.value = S, C.locale = S, Yt(C, u.value, c.value));
  }), vi(i.fallbackLocale, (S) => {
    l && (c.value = S, C.fallbackLocale = S, Yt(C, u.value, c.value));
  }));
  const ne = {
    id: va,
    locale: x,
    fallbackLocale: z,
    get inheritLocale() {
      return l;
    },
    set inheritLocale(S) {
      l = S, S && i && (u.value = i.locale.value, c.value = i.fallbackLocale.value, Yt(C, u.value, c.value));
    },
    get availableLocales() {
      return Object.keys(m.value).sort();
    },
    messages: A,
    get modifiers() {
      return E;
    },
    get pluralRules() {
      return T || {};
    },
    get isGlobal() {
      return a;
    },
    get missingWarn() {
      return f;
    },
    set missingWarn(S) {
      f = S, C.missingWarn = f;
    },
    get fallbackWarn() {
      return k;
    },
    set fallbackWarn(S) {
      k = S, C.fallbackWarn = k;
    },
    get fallbackRoot() {
      return M;
    },
    set fallbackRoot(S) {
      M = S;
    },
    get fallbackFormat() {
      return j;
    },
    set fallbackFormat(S) {
      j = S, C.fallbackFormat = j;
    },
    get warnHtmlMessage() {
      return L;
    },
    set warnHtmlMessage(S) {
      L = S, C.warnHtmlMessage = S;
    },
    get escapeParameter() {
      return _;
    },
    set escapeParameter(S) {
      _ = S, C.escapeParameter = S;
    },
    t: Oe,
    getLocaleMessage: wt,
    setLocaleMessage: Zt,
    mergeLocaleMessage: $i,
    getPostTranslationHandler: Z,
    setPostTranslationHandler: X,
    getMissingHandler: W,
    setMissingHandler: ae,
    [Jr]: Wt
  };
  return ne.datetimeFormats = $, ne.numberFormats = q, ne.rt = Ce, ne.te = D, ne.tm = Jt, ne.d = Ve, ne.n = nt, ne.getDateTimeFormat = h, ne.setDateTimeFormat = v, ne.mergeDateTimeFormat = P, ne.getNumberFormat = R, ne.setNumberFormat = ue, ne.mergeNumberFormat = oe, ne[fs] = n, ne[sn] = xt, ne[on] = Ht, ne[rn] = Kt, process.env.NODE_ENV !== "production" && (ne[ln] = (S) => {
    C.__v_emitter = S;
  }, ne[cn] = () => {
    C.__v_emitter = void 0;
  }), ne;
}
const Sn = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function el({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((n, a) => [
    ...n,
    // prettier-ignore
    ...a.type === Tt ? a.children : [a]
  ], []) : t.reduce((i, n) => {
    const a = e[n];
    return a && (i[n] = a()), i;
  }, {});
}
function bs(e) {
  return Tt;
}
Se({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validator: (e) => _e(e) || !isNaN(e)
  }
}, Sn);
function tl(e) {
  return we(e) && !U(e[0]);
}
function ws(e, t, i, n) {
  const { slots: a, attrs: s } = t;
  return () => {
    const o = { part: !0 };
    let r = {};
    e.locale && (o.locale = e.locale), U(e.format) ? o.key = e.format : ie(e.format) && (U(e.format.key) && (o.key = e.format.key), r = Object.keys(e.format).reduce((d, b) => i.includes(b) ? Se({}, d, { [b]: e.format[b] }) : d, {}));
    const l = n(e.value, o, r);
    let u = [o.key];
    we(l) ? u = l.map((d, b) => {
      const f = a[d.type], k = f ? f({ [d.type]: d.value, index: b, parts: l }) : [d.value];
      return tl(k) && (k[0].key = `${d.type}-${b}`), k;
    }) : U(l) && (u = [l]);
    const c = Se({}, s), m = U(e.tag) || ie(e.tag) ? e.tag : bs();
    return bn(m, c, u);
  };
}
Se({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Sn);
Se({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, Sn);
function ka(e, t) {
}
const il = /* @__PURE__ */ tt("global-vue-i18n");
function Ai(e = {}) {
  const t = wn();
  if (t == null)
    throw dt(ge.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw dt(ge.NOT_INSTALLED);
  const i = nl(t), n = sl(i), a = ks(t), s = al(e, a);
  if (__VUE_I18N_LEGACY_API__ && i.mode === "legacy" && !e.__useComponent) {
    if (!i.allowComposition)
      throw dt(ge.NOT_AVAILABLE_IN_LEGACY_MODE);
    return cl(t, s, n, e);
  }
  if (s === "global")
    return Zr(n, e, a), n;
  if (s === "parent") {
    let l = ol(i, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && it(wi(Ae.NOT_FOUND_PARENT_SCOPE)), l = n), l;
  }
  const o = i;
  let r = o.__getInstance(t);
  if (r == null) {
    const l = Se({}, e);
    "__i18n" in a && (l.__i18n = a.__i18n), n && (l.__root = n), r = Qr(l), o.__composerExtend && (r[dn] = o.__composerExtend(r)), ll(o, t, r), o.__setInstance(t, r);
  }
  return r;
}
function nl(e) {
  {
    const t = io(e.isCE ? il : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!t)
      throw dt(e.isCE ? ge.NOT_INSTALLED_WITH_PROVIDE : ge.UNEXPECTED_ERROR);
    return t;
  }
}
function al(e, t) {
  return Ci(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function sl(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function ol(e, t, i = !1) {
  let n = null;
  const a = t.root;
  let s = rl(t, i);
  for (; s != null; ) {
    const o = e;
    if (e.mode === "composition")
      n = o.__getInstance(s);
    else if (__VUE_I18N_LEGACY_API__) {
      const r = o.__getInstance(s);
      r != null && (n = r.__composer, i && n && !n[fs] && (n = null));
    }
    if (n != null || a === s)
      break;
    s = s.parent;
  }
  return n;
}
function rl(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function ll(e, t, i) {
  let n = null;
  pt(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = i, n = Mo();
      const a = i;
      a[ln] && a[ln](n), n.on("*", ka);
    }
  }, t), Ra(() => {
    const a = i;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (n && n.off("*", ka), a[cn] && a[cn](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const s = a[dn];
    s && (s(), delete a[dn]);
  }, t);
}
function cl(e, t, i, n = {}) {
  const a = t === "local", s = Fa(null);
  if (a && e.proxy && !(e.proxy.$options.i18n || e.proxy.$options.__i18n))
    throw dt(ge.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
  const o = le(n.inheritLocale) ? n.inheritLocale : !U(n.locale), r = J(
    // prettier-ignore
    !a || o ? i.locale.value : U(n.locale) ? n.locale : ii
  ), l = J(
    // prettier-ignore
    !a || o ? i.fallbackLocale.value : U(n.fallbackLocale) || we(n.fallbackLocale) || Y(n.fallbackLocale) || n.fallbackLocale === !1 ? n.fallbackLocale : r.value
  ), u = J(_n(r.value, n)), c = J(Y(n.datetimeFormats) ? n.datetimeFormats : { [r.value]: {} }), m = J(Y(n.numberFormats) ? n.numberFormats : { [r.value]: {} }), d = a ? i.missingWarn : le(n.missingWarn) || $t(n.missingWarn) ? n.missingWarn : !0, b = a ? i.fallbackWarn : le(n.fallbackWarn) || $t(n.fallbackWarn) ? n.fallbackWarn : !0, f = a ? i.fallbackRoot : le(n.fallbackRoot) ? n.fallbackRoot : !0, k = !!n.fallbackFormat, M = ce(n.missing) ? n.missing : null, j = ce(n.postTranslation) ? n.postTranslation : null, y = a ? i.warnHtmlMessage : le(n.warnHtmlMessage) ? n.warnHtmlMessage : !0, g = !!n.escapeParameter, w = a ? i.modifiers : Y(n.modifiers) ? n.modifiers : {}, L = n.pluralRules || a && i.pluralRules;
  function _() {
    return [
      r.value,
      l.value,
      u.value,
      c.value,
      m.value
    ];
  }
  const E = H({
    get: () => s.value ? s.value.locale.value : r.value,
    set: (D) => {
      s.value && (s.value.locale.value = D), r.value = D;
    }
  }), T = H({
    get: () => s.value ? s.value.fallbackLocale.value : l.value,
    set: (D) => {
      s.value && (s.value.fallbackLocale.value = D), l.value = D;
    }
  }), C = H(() => s.value ? s.value.messages.value : u.value), O = H(() => c.value), B = H(() => m.value);
  function x() {
    return s.value ? s.value.getPostTranslationHandler() : j;
  }
  function z(D) {
    s.value && s.value.setPostTranslationHandler(D);
  }
  function A() {
    return s.value ? s.value.getMissingHandler() : M;
  }
  function $(D) {
    s.value && s.value.setMissingHandler(D);
  }
  function q(D) {
    return _(), D();
  }
  function Z(...D) {
    return s.value ? q(() => Reflect.apply(s.value.t, null, [...D])) : q(() => "");
  }
  function X(...D) {
    return s.value ? Reflect.apply(s.value.rt, null, [...D]) : "";
  }
  function W(...D) {
    return s.value ? q(() => Reflect.apply(s.value.d, null, [...D])) : q(() => "");
  }
  function ae(...D) {
    return s.value ? q(() => Reflect.apply(s.value.n, null, [...D])) : q(() => "");
  }
  function se(D) {
    return s.value ? s.value.tm(D) : {};
  }
  function he(D, ee) {
    return s.value ? s.value.te(D, ee) : !1;
  }
  function Oe(D) {
    return s.value ? s.value.getLocaleMessage(D) : {};
  }
  function Ce(D, ee) {
    s.value && (s.value.setLocaleMessage(D, ee), u.value[D] = ee);
  }
  function Ve(D, ee) {
    s.value && s.value.mergeLocaleMessage(D, ee);
  }
  function nt(D) {
    return s.value ? s.value.getDateTimeFormat(D) : {};
  }
  function Ke(D, ee) {
    s.value && (s.value.setDateTimeFormat(D, ee), c.value[D] = ee);
  }
  function at(D, ee) {
    s.value && s.value.mergeDateTimeFormat(D, ee);
  }
  function Gt(D) {
    return s.value ? s.value.getNumberFormat(D) : {};
  }
  function xt(D, ee) {
    s.value && (s.value.setNumberFormat(D, ee), m.value[D] = ee);
  }
  function Kt(D, ee) {
    s.value && s.value.mergeNumberFormat(D, ee);
  }
  const Ht = {
    get id() {
      return s.value ? s.value.id : -1;
    },
    locale: E,
    fallbackLocale: T,
    messages: C,
    datetimeFormats: O,
    numberFormats: B,
    get inheritLocale() {
      return s.value ? s.value.inheritLocale : o;
    },
    set inheritLocale(D) {
      s.value && (s.value.inheritLocale = D);
    },
    get availableLocales() {
      return s.value ? s.value.availableLocales : Object.keys(u.value);
    },
    get modifiers() {
      return s.value ? s.value.modifiers : w;
    },
    get pluralRules() {
      return s.value ? s.value.pluralRules : L;
    },
    get isGlobal() {
      return s.value ? s.value.isGlobal : !1;
    },
    get missingWarn() {
      return s.value ? s.value.missingWarn : d;
    },
    set missingWarn(D) {
      s.value && (s.value.missingWarn = D);
    },
    get fallbackWarn() {
      return s.value ? s.value.fallbackWarn : b;
    },
    set fallbackWarn(D) {
      s.value && (s.value.missingWarn = D);
    },
    get fallbackRoot() {
      return s.value ? s.value.fallbackRoot : f;
    },
    set fallbackRoot(D) {
      s.value && (s.value.fallbackRoot = D);
    },
    get fallbackFormat() {
      return s.value ? s.value.fallbackFormat : k;
    },
    set fallbackFormat(D) {
      s.value && (s.value.fallbackFormat = D);
    },
    get warnHtmlMessage() {
      return s.value ? s.value.warnHtmlMessage : y;
    },
    set warnHtmlMessage(D) {
      s.value && (s.value.warnHtmlMessage = D);
    },
    get escapeParameter() {
      return s.value ? s.value.escapeParameter : g;
    },
    set escapeParameter(D) {
      s.value && (s.value.escapeParameter = D);
    },
    t: Z,
    getPostTranslationHandler: x,
    setPostTranslationHandler: z,
    getMissingHandler: A,
    setMissingHandler: $,
    rt: X,
    d: W,
    n: ae,
    tm: se,
    te: he,
    getLocaleMessage: Oe,
    setLocaleMessage: Ce,
    mergeLocaleMessage: Ve,
    getDateTimeFormat: nt,
    setDateTimeFormat: Ke,
    mergeDateTimeFormat: at,
    getNumberFormat: Gt,
    setNumberFormat: xt,
    mergeNumberFormat: Kt
  };
  function Wt(D) {
    D.locale.value = r.value, D.fallbackLocale.value = l.value, Object.keys(u.value).forEach((ee) => {
      D.mergeLocaleMessage(ee, u.value[ee]);
    }), Object.keys(c.value).forEach((ee) => {
      D.mergeDateTimeFormat(ee, c.value[ee]);
    }), Object.keys(m.value).forEach((ee) => {
      D.mergeNumberFormat(ee, m.value[ee]);
    }), D.escapeParameter = g, D.fallbackFormat = k, D.fallbackRoot = f, D.fallbackWarn = b, D.missingWarn = d, D.warnHtmlMessage = y;
  }
  return no(() => {
    if (e.proxy == null || e.proxy.$i18n == null)
      throw dt(ge.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
    const D = s.value = e.proxy.$i18n.__composer;
    t === "global" ? (r.value = D.locale.value, l.value = D.fallbackLocale.value, u.value = D.messages.value, c.value = D.datetimeFormats.value, m.value = D.numberFormats.value) : a && Wt(D);
  }), Ht;
}
Kr();
__INTLIFY_JIT_COMPILATION__ ? ia($r) : ia(Ur);
Er(cr);
Pr(Xa);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Ze();
  e.__INTLIFY__ = !0, kr(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
const dl = {
  waitMessage: "Er der næsten. "
}, ul = {
  buttonLabel: "Gemme",
  buttonLabelClose: "Tæt",
  confirmEmailMessage: "Bekræft din e-mail-adresse",
  copy: "For at opdatere din e-mailadresse skal du tilføje den nye nedenfor:",
  errorMessageCopy: "Noget gik galt. ",
  errorMessageHeadline: "Fejl",
  headline: "Profildetaljer",
  inputEmailConfirmPlaceholder: "Bekræft din emailadresse",
  inputEmailPlaceholder: "Email adresse",
  invalidEmailMessage: "E-mail ikke gyldig!",
  rememberMeLabel: "Husk mig",
  successMessageCopy: "Din e-mailadresse er blevet opdateret.",
  successMessageHeadline: "E-mail-adresse opdateret"
}, ml = {
  closeButtonLabel: "Tæt",
  confirmPasswordLabel: "Bekræft kodeord",
  currentPasswordLabel: "Nuværende kodeord",
  newPasswordLabel: "nyt kodeord",
  passwordMismatchError: "Adgangskoden passer ikke",
  passwordUpdateErrorTitle: "Fejl",
  passwordUpdateSuccessTitle: "Adgangskode opdateret",
  samePasswordError: "Denne adgangskode blev brugt tidligere. Indsend venligst en ny adgangskode",
  subtitle: "For at ændre din adgangskode skal du udfylde felterne nedenfor:",
  submitButtonLabel: "Indsend",
  successfulChangeLabel: "Din adgangskode er blevet opdateret",
  title: "Adgangskodeændring"
}, pl = {
  invalidEmail: "Forkert e-mail",
  invalidPassword: "Forkert kodeord",
  sap_206002: "Din konto afventer bekræftelse. Jeg er bange for, at vi ikke kan lade dig fortsætte i øjeblikket. ",
  sap_206006: "Det ser ud til, at den e-mailadresse, du har indsendt, afventer bekræftelse",
  sap_400003: "Denne e-mail findes allerede, brug venligst en anden e-mailadresse!",
  sap_400028: "Den indsendte e-mailadresse afventer bekræftelse",
  sap_400050: "Beklager, vi er ikke i stand til at validere dine legitimationsoplysninger i øjeblikket.",
  sap_400097: "Det ser ud til, at du får adgang til vores tjenester fra en usikker/ikke-understøttet browser. ",
  sap_401030: "Denne adgangskode blev brugt tidligere. Indsend venligst en ny adgangskode",
  sap_403005: "Vi har ikke en konto tilknyttet denne e-mailadresse. Tjek venligst din e-mail og prøv igen",
  sap_403011: "Sessionen er udløbet. ",
  sap_403012: "Sessionen er udløbet. ",
  sap_403013: "Beklager, vi er ikke i stand til at validere dine legitimationsoplysninger i øjeblikket.",
  sap_403035: "Beklager, vi er ikke i stand til at validere dine legitimationsoplysninger i øjeblikket.",
  sap_403041: "Vi har ikke en konto tilknyttet denne e-mailadresse. Tjek venligst din e-mail og prøv igen",
  sap_403042: "E-mail",
  sap_403043: "E-mail",
  sap_403047: "E-mail",
  sap_403100: "Der er for nylig anmodet om en anmodning om opdatering af adgangskode. Fortæl os venligst, indtil anmodningen er behandlet",
  sap_403025: "Linket til nulstilling af adgangskode er ugyldigt. Send venligst anmodning om glemt adgangskode igen for at modtage et nyt nulstillingslink.",
  sapErrorTitle: "Fejl ved behandling af anmodning",
  sessionExpired: "Sessionen er udløbet",
  tooWeakPassword: "Adgangskoden skal indeholde mindst {minLength} tegn og {minCharGroups} af følgende: stort bogstav, lille bogstav, tal, specialsymbol | Adgangskoden skal indeholde mindst {minLength} tegn",
  unexpectedDescription: "Hvis problemet fortsætter, bedes du kontakte os via kontaktformularen med detaljer.",
  unexpectedTitle: "Der opstod en uventet fejl",
  unknownDescription: "Der opstod en uventet fejl. ",
  unknownTitle: "Åh åh!"
}, hl = {
  subtitle: "Indstil din nye adgangskode.",
  title: "Glemt din adgangskode?"
}, gl = {
  headMetaDescription: "Kunde login side",
  headTitle: "Log ind med din e-mail og adgangskode:",
  subtitle: "Log ind eller opret en konto for at få alle Mieles funktioner.",
  title: "Log ind på din konto",
  error: {
    invalidEmailPasswordDescription: "Kombinationen af ​​e-mailadresse og adgangskode er ikke gyldig.",
    invalidEmailPasswordTitle: "Ugyldige legitimationsoplysninger",
    missingConcentTitle: "Konto afventer registrering",
    noAccountDescription: "Der er ingen konto knyttet til denne e-mailadresse.",
    noAccountTitle: "Ingen konto registreret"
  },
  extraConsentScene: {
    continue: "Blive ved",
    privacyStatementCheckboxLabel: "Jeg har noteret mig {0}.",
    privacyStatementName: "fortrolighedserklæring",
    privacyStatementTitle: "Vores privatlivspolitik er ændret",
    termsOfUseCheckboxLabel: "Jeg accepterer {0}.",
    termsOfUseName: "vilkår for brug",
    termsOfUseTitle: "Vores vilkår for brug er ændret",
    title: "Profil færdiggørelse"
  },
  forgotPasswordScene: {
    backButtonLabel: "Tilbage til Login",
    submitButtonLabel: "Indsend",
    successDescription: "Tjek venligst din e-mail, du vil snart modtage oplysningerne på din konto for at starte med processen til nulstilling af adgangskode.",
    successTitle: "Din anmodning er modtaget.",
    title: "Indtast venligst din e-mailadresse for at nulstille din adgangskode:"
  },
  loginModalScene: {
    copy: "Log ind eller opret en konto for at få alle Mieles funktioner.",
    title: "Log ind på din konto"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Glemt min adgangskode",
    invalidEmailMessage: "E-mail ikke gyldig!",
    loginButtonLabel: "Log på",
    passwordInputLabel: "Adgangskode",
    rememberMeLabel: "Husk mig",
    title: "Log ind med din e-mail og adgangskode:"
  }
}, vl = {
  accessibility: {
    close: "Tæt"
  }
}, fl = {
  tooShort: "For kort",
  medium: "Middel",
  strong: "Stærk",
  tooWeak: "For svag",
  veryStrong: "Meget stærk",
  weak: "Svag"
}, kl = {
  showPasswordText: "Vis",
  hidePasswordText: "Skjul"
}, bl = {
  registerButtonLabel: "Tilmeld",
  registerTitle: "Har du ikke en konto?",
  whyRegister: {
    list: [
      "Adgang til eksklusive fordele fra Miele Club",
      "Registrer apparater, spor ordrer, få adgang til manualer",
      "Modtag personlige tilbud og kampagner",
      "Se alle dine ordrer, garantier, begivenheder og tjenester"
    ],
    title: "Hvorfor registrere?"
  },
  closeButtonLabel: "Tæt",
  passwordMismatchError: "Adgangskoderne stemmer ikke overens",
  passwordUpdateErrorTitle: "Fejl ved opdatering af adgangskode",
  passwordUpdateSuccessTitle: "Adgangskode opdateret",
  successfulChangeLabel: "Din adgangskode er blevet opdateret"
}, wl = {
  title: "Marketingpræferencer",
  description: "Sæt kryds nedenfor for eksklusive tilbud, nyheder, begivenheder og hvordan du får mest muligt ud af dit apparat.",
  submit: "Gemme",
  levelOne: {
    shortText: 'Ja, jeg ønsker at modtage markedsføringskommunikation fra Miele A/S og Miele & Cie. KG ("Miele"), som er tilpasset mine personlige interesser via e-mail, sms, post og via Miele-apps og hjemmeside (hvis relevant)',
    text: `Ja, jeg ønsker at modtage markedsføringskommunikation fra Miele A/S og Miele & Cie. KG ("Miele"), som er tilpasset mine personlige interesser via e-mail, sms, post og via Miele-apps og hjemmeside (hvis relevant) med oplysninger om produkter, tilbud og nyheder fra Mieles produktsortiment og om Miele-events kundeundersøgelser, produktvurderinger, anmeldelser og opskrifter. Til dette formål kan Miele bruge mine kontaktoplysninger (titel,navn, e-mailadresse, mobiltelefonnummer og postadresse) og tilpasse kommunikationen baseret på min købs-, service-, begivenhedshistorik, klik- og åbningsadfærd for nyhedsbrevet samt kundeværdi, som nærmere beskrevet i vores privatlivspolitik. Jeg kan til enhver tid tilbagekalde mit samtykke uden at angive årsager med virkning for fremtiden (f.eks. ved at sende en besked til  contact{'@'}miele-support.dk, kontaktoplysningerne i impressum eller ved at klikke på afmeldingslinket i e-mails).`,
    link: {
      title: "Privatlivspolitik",
      ref: "https://www.miele.dk/c/databeskyttelse-14.htm"
    }
  },
  levelTwo: {
    text: "Ud over mit grundlæggende samtykke giver jeg også tilladelse til, at Miele kan behandle data fra min brug af Miele-apps og mine besøg på Mieles hjemmeside (www.miele.dk), herunder brugeradfærd på Mieles websteder efter klik på det tilknyttede nyhedsbrev, for at supplere min brugerprofil til personliggjort reklamekommunikation, forudsat jeg har givet separat samtykke i appen eller på webstedet til databehandling. Jeg kan til enhver tid tilbagekalde mit samtykke uden begrundelse med virkning for fremtiden. Yderligere detaljer i Mieles databeskyttelsespolitik.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Ud over mit grundlæggende samtykke giver jeg også tilladelse til, at Miele må behandle data fra mine tilsluttede Miele-produkter (data om brug af produktet og status) for at supplere min brugerprofil med henblik på personliggjort annoncering. Jeg kan finde flere oplysninger om behandlingen af produktdata i privatlivspolitikken for Miele{'@'}Home-systemet. Jeg kan til enhver tid tilbagekalde mit samtykke uden begrundelse med virkning for fremtiden. Se Mieles databeskyttelsespolitik for yderligere informationer.",
    link: {
      title: "Miele{'@'}Home-systeem",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ja, jeg accepterer vilkårene for brug.",
    link: {
      title: "Se vilkår for brug*",
      ref: "https://www.miele.dk/c/brugsbetingelser-304.htm"
    }
  }
}, yl = {
  headline: "Miele Club",
  why: {
    title: "Gratis medlemskab - Eksklusive tilbud for medlemmer.",
    reasons: [
      "Velkomstgave 10 % rabat",
      "Fødselsdagsoverraskelse",
      "Eksklusive tilbud",
      "Invitationer til events og oplevelser"
    ]
  },
  birthDateTitle: "Må vi sende dig en fødselsdagsgave?",
  birthDateLabel: "Din fødselsdato (frivilligt)",
  birthDateValidation: {
    requirementMsg: "Indtast venligst dette datoformat: DD/MM/YYYY",
    errorMsg: "Ugyldig dato"
  },
  joinClubLabel: "Ja, jeg vil gerne blive medlem af Miele Club.",
  termsAndCondition: {
    description: "Jeg accepterer Miele Club {termsAndConditionLink} og bekræfter, at jeg har læst og forstået informationen om {privacyLink} for Miele Club.",
    termsAndConditionLink: {
      title: "Vilkår for deltagelse og brug",
      ref: "https://www.miele.dk/c/betingelser-og-vilkar-13.htm"
    },
    privacyLink: {
      title: "Databeskyttelse",
      ref: "https://www.miele.dk/c/databeskyttelse-14.htm"
    }
  },
  newsletter: {
    description: "Ja, jeg ønsker at modtage Miele Club-reklamer fra Miele A/S (“Miele”), der er skræddersyet til mine personlige interesser, via e-mail og post med specialtilbud, oplysninger, invitationer til begivenheder og kundeundersøgelser om Mieles produkter og tjenester. Til dette formål kan Miele bruge mine kontaktoplysninger (titel, navn, e-mail og postadresse) og tilpasse kommunikationen på baggrund af min købs- og nyhedsbrevsadfærd, samt min Miele Club-status, som beskrevet nærmere i {privacyLink}. Jeg kan til enhver tid tilbagekalde mit samtykke med fremtidig virkning (fx ved at sende en uformel besked til info{'@'}miele.dk, kontaktoplysningerne angivet i aftrykket eller ved at trykke på afmeldingslinket i e-mails). Den kontraktlige Miele Club {termsAndConditionLink} forbliver upåvirket af dette, indtil medlemskabet opsiges.",
    shortDescription: "Ja, jeg ønsker at modtage Miele Club-reklamer fra Miele A/S (“Miele”), der er skræddersyet til mine personlige interesser, via e-mail og post",
    privacyLink: {
      title: "Datasikkerhed",
      href: "https://www.miele.dk/c/databeskyttelse-14.htm"
    },
    termsAndConditionLink: {
      title: "kommunikation",
      href: "https://www.miele.dk/c/betingelser-og-vilkar-13.htm"
    },
    supportEmail: "info{'@'}miele.dk"
  },
  selectAllConsents: {
    description: "For at blive medlem af Miele Club skal du acceptere alle vilkår og betingelser *"
  }
}, Ml = "vis hele erklæringen", zl = "vis mindre", jl = {
  auth: dl,
  changeEmailScene: ul,
  changePasswordScene: ml,
  errors: pl,
  forgotPassword: hl,
  login: gl,
  modal: vl,
  passwordStrength: fl,
  passwordHelper: kl,
  register: bl,
  "marketing-consent": {
    title: "Marketingpræferencer",
    description: "Sæt kryds nedenfor for eksklusive tilbud, nyheder, begivenheder og hvordan du får mest muligt ud af dit apparat.",
    submit: "Gemme",
    newsletter: {
      text: "Jeg giver samtykke til, at Miele A/S (“Miele”) sender mig information om produkter og innovationer fra Mieles sortiment og om Mieles arrangementer, kundeundersøgelser, vurderinger og anmeldelser af produkter og opskrifter via e-mail, Miele-apps og SMS, og at Miele til dette formål behandler de kontaktoplysninger, jeg har oplyst (titel, navn, e-mailadresse, mobiltelefonnummer og postnummer) og om de Miele-produkter, jeg har købt og vil købe i fremtiden, så vidt det er relevant, jeg har angivet.",
      link: {
        title: "Se databeskyttelsespolitik",
        ref: ""
      }
    },
    personalisation: {
      text: "Jeg accepterer, at Miele må behandle oplysninger om de tjenester, jeg har brugt, og teknikeropgaver, jeg har udført, samt arrangementer, jeg har deltaget i, med henblik på forbedret personalisering.",
      link: {
        title: "Se databeskyttelsespolitik",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Ud over den udvidede personalisering accepterer jeg, at Miele også må behandle data fra brugen af ​​Miele-appen og mine besøg på Mieles hjemmesider (www.miele.co.uk) for at supplere min brugerprofil, forudsat at jeg har givet særskilt samtykke ",
      link: {
        title: "Se databeskyttelsespolitik",
        ref: ""
      }
    },
    highlightedText: {
      text: "Jeg kan til enhver tid tilbagekalde mit samtykke uden at angive grunde med virkning for fremtiden.  ",
      link: {
        title: "databeskyttelsespolitik.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ja, jeg accepterer vilkårene for brug.",
      link: {
        title: "Se vilkår for brug*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: wl,
  mieleClub: yl,
  readMore: Ml,
  readLess: zl
}, _l = {
  waitMessage: "Fast geschafft..."
}, Sl = {
  buttonLabel: "Speichern",
  buttonLabelClose: "Schliessen",
  confirmEmailMessage: "Bestätige deine E-Mail-Adresse",
  copy: "Ändere deine E-Mail-Adresse:",
  errorMessageCopy: "Etwas ist schief gelaufen. Versuche es erneut.",
  errorMessageHeadline: "Das hat nicht geklappt",
  headline: "Profil Details",
  inputEmailConfirmPlaceholder: "Bestätige deine E-Mail-Adresse",
  inputEmailPlaceholder: "E-Mail-Adresse",
  invalidEmailMessage: "E-Mail-Adresse ungültig!",
  rememberMeLabel: "Eingeloggt bleiben",
  successMessageCopy: "Deine E-Mail-Adresse wurde erfolgreich geändert",
  successMessageHeadline: "E-Mail-Address aktualisiert"
}, Cl = {
  closeButtonLabel: "Schliessen",
  confirmPasswordLabel: "Passwort bestätigen",
  currentPasswordLabel: "Aktuelles Passwort",
  newPasswordLabel: "Neues Passwort",
  passwordMismatchError: "Die Passwörter stimmen nicht überein",
  passwordUpdateErrorTitle: "Fehler",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  samePasswordError: "Dieses Passwort wurde zuvor verwendet. Bitte geben Sie ein neues Passwort ein.",
  subtitle: "Um ihr Passwort zu ändern, füllen Sie bitte die folgenden Felder aus:",
  submitButtonLabel: "Speichern",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert",
  title: "Passwort ändern"
}, Ll = {
  invalidEmail: "Ungültige E-Mail Adresse",
  invalidPassword: "Ungültiges Passwort",
  sap_206002: "Ihr Konto muss noch verifiziert werden. Bitte kontaktieren Sie uns für weitere Details.",
  sap_206006: "Es sieht so aus, als ob die von Ihnen angegebene E-Mail-Adresse noch überprüft werden muss.",
  sap_400003: "Diese E-Mail existiert bereits, bitte verwenden Sie eine andere E-Mail Adresse!",
  sap_400028: "Die E-Mail-Adresse steht noch aus und muss noch verifiziert werden.",
  sap_400050: "Es tut uns leid, im Moment können wir Ihre Anmeldeinformationen nicht bestätigen.",
  sap_400097: "Es scheint, dass Sie auf unsere Dienste von einem unsicheren/nicht unterstützten Browser aus zugreifen. Bitte versuchen Sie es erneut mit einem anderen Browser.",
  sap_401030: "Dieses Passwort wurde zuvor verwendet. Bitte geben Sie ein neues Passwort ein.",
  sap_403005: "Es ist kein Konto mit dieser E-Mail-Adresse verknüpft. Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
  sap_403011: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403012: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403013: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403035: "Es tut uns leid, im Moment können wir Ihre Anmeldeinformationen nicht bestätigen.",
  sap_403041: "Es ist kein Konto mit dieser E-Mail-Adresse verknüpft. Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
  sap_403042: "Die Kombination aus E-Mail und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403043: "Die Kombination aus E-Mail und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403047: "Die eingegebene E-Mail-Adresse ist nicht registriert.",
  sap_403100: "Es wurde kürzlich eine Anfrage zur Aktualisierung des Passworts gestellt. Bitte haben Sie noch etwas Geduld.",
  sap_403025: 'Der Link zum Zurücksetzen des Passworts ist ungültig. Bitte senden Sie die Anfrage "Passwort vergessen" erneut, um einen neuen Link zum Zurücksetzen zu erhalten.',
  sapErrorTitle: "Fehler bei Anfrage",
  sessionExpired: "Sitzung ist abgelaufen",
  tooWeakPassword: "Das Passwort muss mindestens {minLength} Zeichen lang sein und {minCharGroups} der folgenden Zeichen enthalten: Großbuchstabe, Kleinbuchstabe, Zahl, Sonderzeichen | Das Passwort muss mindestens {minLength} Zeichen lang sein",
  unexpectedDescription: "Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte über das Kontaktformular.",
  unexpectedTitle: "Ein unerwarteter Fehler ist aufgetreten.",
  unknownDescription: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
  unknownTitle: "Oje!"
}, El = {
  subtitle: "Neues Passwort vergeben",
  title: "Passwort vergessen?"
}, Pl = {
  headMetaDescription: "Benutzerkonto Login",
  headTitle: "Melden Sie sich mit Ihrer E-Mail Adresse und Ihrem Passwort an:",
  subtitle: "Anmelden oder Benutzerkonto erstellen, um alle Miele Vorteile zu genießen.",
  title: "Melden Sie sich mit Ihren Benutzerdaten an",
  error: {
    invalidEmailPasswordDescription: "Ungültige E-Mail Adresse oder Passwort",
    invalidEmailPasswordTitle: "Anmeldedaten nicht korrekt",
    missingConcentTitle: "Kein Benutzerkonto vorhanden",
    noAccountDescription: "Kein Benutzerkonto zu der angegebenen E-Mail Adresse gefunden.",
    noAccountTitle: "Kein Benutzerkonto vorhanden"
  },
  extraConsentScene: {
    continue: "Senden",
    privacyStatementCheckboxLabel: "Ich habe die {0} zur Kenntnis genommen.",
    privacyStatementName: "Datenschutzbestimmungen",
    privacyStatementTitle: "Unsere Datenschutzbestimmungen haben sich geändert",
    termsOfUseCheckboxLabel: "Ich stimme den {0} zu.",
    termsOfUseName: "Nutzungsbedingungen",
    termsOfUseTitle: "Unsere Nutzungsbedingungen haben sich geändert",
    title: "Profile Akualisierung"
  },
  forgotPasswordScene: {
    backButtonLabel: "Zurück zur Anmeldung",
    submitButtonLabel: "Bestätigen",
    successDescription: "Bitte überprüfen Sie Ihren Posteingang, wir haben Ihnen eine E-Mail bezüglich der Passwortänderung gesendet.",
    successTitle: "Ihre Anfrage hat uns erreicht.",
    title: "Um Ihr Passwort zurückzusetzen, geben Sie bitte Sie Ihre E-Mail Adresse ein."
  },
  loginModalScene: {
    copy: "Melden Sie sich an in Ihrem Benutzerkonto, um alle Miele Vorteile zu genießen.",
    title: "Melden Sie sich in Ihrem Benutzerkonto an"
  },
  loginScene: {
    emailInputLabel: "E-Mail",
    forgotPwdButtonLabel: "Passwort vergessen",
    invalidEmailMessage: "E-Mail-Adresse ungültig!",
    loginButtonLabel: "Anmelden",
    passwordInputLabel: "Passwort",
    rememberMeLabel: "Eingeloggt bleiben",
    title: "E-Mail Adresse und Passwort eingeben:"
  }
}, Tl = {
  accessibility: {
    close: "Schliessen"
  }
}, Al = {
  tooShort: "Zu kurz",
  medium: "Mittel",
  strong: "Stark",
  tooWeak: "Zu schwach",
  veryStrong: "Sehr stark",
  weak: "Schwach"
}, xl = {
  showPasswordText: "Anzeigen",
  hidePasswordText: "Verbergen"
}, Il = {
  registerButtonLabel: "Registrieren",
  registerTitle: "Sie haben kein Benutzerkonto?",
  whyRegister: {
    list: [
      "Exklusive Miele Club Vorteile",
      "Geräteregistrierung, Sendeverfolgung, Informationen zu Ihren Geräten, Gebrauchsanweisungen und Zubehör",
      "Individuelle Angebote und Aktionen",
      "Alle Bestellungen, Garantien, Events und Services einsehen"
    ],
    title: "Warum registrieren?"
  },
  closeButtonLabel: "Schliessen",
  passwordMismatchError: "Die Passwörter stimmen nicht überein",
  passwordUpdateErrorTitle: "Fehler bei Passwort-Aktualisierung",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert"
}, Dl = {
  title: "Marketing-Präferenzen",
  description: "Kreuzen Sie unten an, um exklusive Angebote, Neuigkeiten, Veranstaltungen und Informationen darüber zu erhalten, wie Sie das Beste aus Ihrem Gerät herausholen können.",
  submit: "Speichern",
  levelOne: {
    shortText: "Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Werbekommunikation der Miele Gesellschaft m.b.H. sowie der Miele & Cie. KG („Miele“) per E-Mail, SMS, Post und über die Miele Apps und Webseiten (soweit genutzt) erhalten",
    text: "Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Werbekommunikation der Miele Gesellschaft m.b.H. sowie der Miele & Cie. KG („Miele“) per E-Mail, SMS, Post und über die Miele Apps und Webseiten (soweit genutzt) erhalten mit Informationen zu Produkten, Angeboten und Neuerungen aus dem Miele-Sortiment und zu Miele-Events sowie Kundenbefragungen, Produktbewertungs- und Rezensionsanfragen und Rezepten. Dafür darf Miele meine Kontaktdaten (Anrede, Name, E-Mail-Adresse, Mobilfunknummer und Postadresse) nutzen und die Kommunikation auf Basis meiner Kauf-, Event- und Servicehistorie, meines Newsletterklick- und -öffnungsverhaltens und meines Kundenwerts ausgestalten, wie in unseren Datenschutzhinweisen näher beschrieben. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen (bspw. per formloser Nachricht an info{'@'}miele.at, die im Impressum angegebenen Kontaktdaten oder Klick auf den Abmeldelink in E-Mails).",
    link: {
      title: "Datenschutzhinweisen",
      ref: "https://www.miele.at/c/datenschutz-14.htm"
    }
  },
  levelTwo: {
    text: "Zusätzlich zu meiner Basiseinwilligung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meiner Besuche auf den Miele-Webseiten (www.miele.at), einschließlich an Newsletterklicks anknüpfendes Nutzerverhalten auf den dort verlinkten Miele-Webseiten, zur Ergänzung meines Nutzerprofils für personalisierte Werbekommunikation verarbeitet, soweit meine gesonderte Einwilligung in der App bzw. auf der Webseite die Datenverarbeitung freigibt. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen. Weitere Details in den Datenschutzbestimmungen.",
    link: {
      title: "Datenschutzbestimmungen",
      ref: "https://www.miele.at/c/datenschutz-14.htm"
    }
  },
  levelThree: {
    text: "Zusätzlich zu meiner Basiseinwilligung bin ich damit einverstanden, dass Miele Daten von meinen vernetzten Miele-Geräten (Daten zu Gerätenutzung und -status) zur Ergänzung meines Nutzerprofils für personalisierte Werbung verarbeitet. Weitere Informationen zur Verarbeitung von Gerätedaten finde ich in der Datenschutzerklärung über das Miele{'@'}Home-System. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen. Weitere Details in den Datenschutzbestimmungen.",
    link: {
      title: "Miele{'@'}Home-System",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ja, ich stimme den Nutzungsbedingungen zu",
    link: {
      title: "Nutzungsbedingungen ansehen*",
      ref: "https://www.miele.at/c/nutzungsbedingungen-304.htm"
    }
  }
}, Nl = {
  headline: "Miele Club",
  birthDateTitle: "Dürfen wir Ihnen ein Geburtstagsgeschenk senden?",
  birthDateLabel: "Ihr Geburtstagsdatum (freiwillig) ",
  why: {
    title: "Exklusive Vorteile für Mitglieder - Persönliche Club Kommunikation.",
    reasons: [
      "10% Willkommensrabatt auf Zubehör und Reinigungsprodukte",
      "Geburtstagsüberraschung",
      "Exklusive Angebote",
      "Tipps & Tricks zur Nutzung der Geräte"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Bitte verwenden sie das folgende Datumsformat: DD/MM/YYYY",
    errorMsg: "Inkorrektes Datum"
  },
  joinClubLabel: "Ja, ich möchte dem Miele Club beitreten.",
  termsAndCondition: {
    description: "Ich stimme den Miele Club {termsAndConditionLink} zu und bestätige, dass ich die Hinweise zum {privacyLink} für den Miele Club zur Kenntnis genommen habe.",
    termsAndConditionLink: {
      title: "Teilnahme- und Nutzungsbedingungen",
      ref: "https://www.miele.at/c/agb-13.htm"
    },
    privacyLink: {
      title: "Datenschutzbestimmungen",
      ref: "https://www.miele.at/c/datenschutz-14.htm"
    }
  },
  newsletter: {
    shortDescription: 'Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Clubwerbekommunikation der Miele Gesellschaft m.b.H. („Miele") per E-Mail und Post erhalten',
    description: `Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Clubwerbekommunikation der Miele Gesellschaft m.b.H. („Miele") per E-Mail und Post erhalten mit speziellen Angeboten, Informationen, Eventeinladungen und Kundenbefragungen zu unseren Produkten und Dienstleistungen. Dafür darf Miele meine Kontaktdaten (Anrede, Name, E-Mail und postalische Adresse) nutzen und die Kommunikation auf Basis meines Kauf- und Newsletterverhaltens sowie meines Kundenwerts ausgestalten, wie in unseren {privacyLink} näher beschrieben. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen (bspw. per formloser Nachricht an info{'@'}miele.at, die im Impressum angegebenen Kontaktdaten oder Klick auf den Abmeldelink in E-Mails). Die vertragliche {termsAndConditionLink} bleibt davon bis zur Kündigung der Mitgliedschaft unberührt.`,
    privacyLink: {
      title: "Club-Datenschutzhinweisen",
      href: "https://www.miele.at/c/datenschutz-14.htm"
    },
    termsAndConditionLink: {
      title: "Clubkommunikation",
      href: "https://www.miele.at/c/agb-13.htm#p264"
    },
    supportEmail: "info{'@'}miele.at"
  },
  selectAllConsents: {
    description: "Um dem Miele Club beizutreten, müssen Sie allen Geschäftsbedingungen zustimmen *"
  }
}, Ol = "vollständige Erklärung anzeigen", Ul = "vollständige Erklärung ausblenden", $l = {
  auth: _l,
  changeEmailScene: Sl,
  changePasswordScene: Cl,
  errors: Ll,
  forgotPassword: El,
  login: Pl,
  modal: Tl,
  passwordStrength: Al,
  passwordHelper: xl,
  register: Il,
  "marketing-consent": {
    title: "Marketing-Präferenzen",
    description: "Kreuzen Sie unten an, um exklusive Angebote, Neuigkeiten, Veranstaltungen und Informationen darüber zu erhalten, wie Sie das Beste aus Ihrem Gerät herausholen können.",
    submit: "Speichern",
    newsletter: {
      text: 'Ich bin damit einverstanden, dass die Miele Gesellschaft m.b.H. ("Miele") mir Informationen zu Produkten und Neuerungen aus dem Miele-Sortiment und zu Miele-Events sowie Kundenbefragungen, Produktbewertungen und Rezensionen und Rezepte per E-Mail, die Miele Apps und SMS sendet und Miele zu diesem Zweck die von mir angegebenen Kontaktdaten (Anrede, Name, E-Mail-Adresse, Mobilfunknummer und Postleitzahl) und die von mir bislang und zukünftig erworbenen Miele-Produkte sowie die von mir angegebenen Interessen verarbeitet. Ich bin ferner damit einverstanden, dass Miele auch über den Newsletter erhaltene Empfangs- und Lesebestätigungen und Informationen über die Links, die ich geklickt habe, sowie mein daran anknüpfendes Nutzerverhalten auf der verlinkten Website, zum Zweck der Personalisierung verarbeitet. Das Gleiche gilt für die In-App-Push-Nachrichten, soweit die Miele Apps genutzt werden.',
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen",
        ref: "https://www.miele.at/c/datenschutz-14.htm"
      }
    },
    personalisation: {
      text: "Ich bin damit einverstanden, dass Miele zur Personalisierung Informationen über die von mir in Anspruch genommenen Dienstleistungen und durchgeführte Technikereinsätze sowie über Events, an denen ich teilgenommen habe, verarbeitet.",
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen",
        ref: "https://www.miele.at/c/datenschutz-14.htm"
      }
    },
    extendedPersonalisation: {
      text: "Zusätzlich zur weiteren Personalisierung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meiner Besuche auf den Miele-Webseiten (www.miele.at) zur Ergänzung meines Nutzerprofils verarbeitet, sofern ich in die Verarbeitung dieser Daten gesondert eingewilligt habe.",
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen",
        ref: "https://www.miele.at/c/datenschutz-14.htm"
      }
    },
    highlightedText: {
      text: "Meine Einwilligung kann ich jederzeit mit Wirkung für die Zukunft widerrufen. Meinen Widerruf kann ich zu jedem späteren Zeitpunkt ohne Angaben von Gründen schriftlich (Miele Gesellschaft m.b.H., Mielestraße 1, A-5071 Wals) oder per E-Mail (info{'@'}miele.at) erklären. Zudem befindet sich in jeder E-Mail an mich ein Abmeldelink, mit dem ich meinen Widerruf ebenfalls erklären kann. Weitere Informationen, wie Miele mit Ihren Daten umgeht finden Sie in den Datenschutzbestimmungen.",
      link: {
        title: "Datenschutzbestimmungen.",
        ref: "https://www.miele.at/c/datenschutz-14.htm"
      }
    },
    termsOfUse: {
      text: "Ja, ich stimme den Nutzungsbedingungen zu",
      link: {
        title: "Nutzungsbedingungen ansehen*",
        ref: "https://www.miele.at/c/nutzungsbedingungen-304.htm"
      }
    }
  },
  multiLevelMarketingConsent: Dl,
  mieleClub: Nl,
  readMore: Ol,
  readLess: Ul
}, Bl = {
  waitMessage: "Fast geschafft. Bitte warten…"
}, Rl = {
  buttonLabel: "Speichern",
  buttonLabelClose: "Schliessen",
  confirmEmailMessage: "Bestätigen Sie Ihre E-Mail-Adresse",
  copy: "Um Ihre E-Mail-Adresse zu aktualisieren, fügen Sie bitte die neue unten ein:",
  errorMessageCopy: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
  errorMessageHeadline: "Fehlersadlinen",
  headline: "Profilangaben",
  inputEmailConfirmPlaceholder: "Bestätigen Sie Ihre E-Mail-Adresse",
  inputEmailPlaceholder: "E-Mail-Adresse",
  invalidEmailMessage: "E-Mail nicht gültig!",
  rememberMeLabel: "Angemeldet bleiben",
  successMessageCopy: "Ihre E-Mail-Adresse wurde erfolgreich aktualisiert.",
  successMessageHeadline: "E-Mail-Adresse aktualisiert"
}, Fl = {
  closeButtonLabel: "Schliessen",
  confirmPasswordLabel: "Passwort bestätigen ",
  currentPasswordLabel: "Aktuelles Passwort",
  newPasswordLabel: "Neues Passwort",
  passwordMismatchError: "Passwort stimmt nicht überein",
  passwordUpdateErrorTitle: "Fehler",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  samePasswordError: "Dieses Passwort wurde bereits verwendet. Bitte geben Sie ein neues Passwort ein.",
  subtitle: "Um Ihr Passwort zu ändern, füllen Sie bitte die folgenden Felder aus:",
  submitButtonLabel: "Absenden",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert",
  title: "Passwort ändern"
}, Vl = {
  invalidEmail: "Falsche E-Mail-Adresse",
  invalidPassword: "Falsches Passwort",
  sap_206002: "Ihr Konto wartet noch auf Bestätigung. Leider können wir Sie momentan nicht weiterleiten. Bitte kontaktieren Sie uns für weitere Informationen.",
  sap_206006: "Die angegebene E-Mail-Adresse wartet noch auf Bestätigung.",
  sap_400003: "Diese E-Mail-Adresse existiert bereits. Bitte verwenden Sie eine andere E-Mail-Adresse.",
  sap_400028: "Die angegebene E-Mail-Adresse wartet noch auf Bestätigung.",
  sap_400050: "Bitte entschuldigen Sie, wir können Ihre Anmeldeinformationen momentan nicht validieren.",
  sap_400097: "Es scheint, als ob Sie unsere Dienste von einem unsicheren/nicht unterstützten Browser aus aufrufen. Bitte versuchen Sie es erneut mit einem anderen Browser.",
  sap_401030: "Dieses Passwort wurde bereits verwendet. Bitte geben Sie ein neues Passwort ein.",
  sap_403005: "Wir haben kein Konto mit dieser E-Mail-Adresse gefunden. Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
  sap_403011: "Sitzung abgelaufen. Bitte aktualisieren Sie den Browser und melden Sie sich erneut an.",
  sap_403012: "Sitzung abgelaufen. Bitte aktualisieren Sie den Browser und melden Sie sich erneut an.",
  sap_403013: "Bitte entschuldigen Sie, wir können Ihre Anmeldeinformationen momentan nicht validieren.",
  sap_403035: "Bitte entschuldigen Sie, wir können Ihre Anmeldeinformationen momentan nicht validieren.",
  sap_403041: "Wir haben kein Konto mit dieser E-Mail-Adresse gefunden. Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
  sap_403042: 'Die Kombination aus E-Mail und Passwort ist nicht gültig. Bitte überprüfen Sie die mit dem Konto verbundene E-Mail oder wählen Sie "Passwort vergessen", wenn Sie es zurücksetzen möchten.',
  sap_403043: 'Die Kombination aus E-Mail und Passwort ist nicht gültig. Bitte überprüfen Sie die mit dem Konto verbundene E-Mail oder wählen Sie "Passwort vergessen", wenn Sie es zurücksetzen möchten.',
  sap_403047: 'Die Kombination aus E-Mail und Passwort ist nicht gültig. Bitte überprüfen Sie die mit dem Konto verbundene E-Mail oder wählen Sie "Passwort vergessen", wenn Sie es zurücksetzen möchten.',
  sap_403100: "Eine Änderung des Passworts wurde kürzlich angefordert. Bitte haben Sie Geduld, bis die Anfrage bearbeitet wurde.",
  sap_403025: "Der Link zum Zurücksetzen des Passworts ist ungültig. Bitte setzen Sie Ihr Passwort erneut zurück, um einen neuen Link zu erhalten.",
  sapErrorTitle: "Fehler bei der Verarbeitung der Anfrage",
  sessionExpired: "Sitzung abgelaufen",
  tooWeakPassword: "Das Passwort muss mindestens {minLength} Zeichen lang sein und mindestens {minCharGroups} der folgenden Zeichen enthalten: Grossbuchstabe, Kleinbuchstabe, Zahl, Sonderzeichen | Das Passwort muss mindestens {minLength} Zeichen lang sein",
  unexpectedDescription: "Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte über das Kontaktformular mit Details.",
  unexpectedTitle: "Ein unerwarteter Fehler ist aufgetreten",
  unknownDescription: "Unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut.",
  unknownTitle: "Oh Oh!"
}, ql = {
  subtitle: "Legen Sie Ihr neues Passwort fest.",
  title: "Passwort vergessen?"
}, Gl = {
  headMetaDescription: "Kunden-Anmeldeseite",
  headTitle: "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an:",
  subtitle: "Melden Sie sich an oder erstellen Sie ein Konto, um alle Funktionen von Miele nutzen zu können.",
  title: "Melden Sie sich bei Ihrem Konto an",
  error: {
    invalidEmailPasswordDescription: "Die Kombination aus E-Mail-Adresse und Passwort ist nicht gültig.",
    invalidEmailPasswordTitle: "Ungültige Anmeldedaten",
    missingConcentTitle: "Konto wartet auf Registrierung",
    noAccountDescription: "Es gibt kein Konto, das mit dieser E-Mail-Adresse verknüpft ist.",
    noAccountTitle: "Kein Konto registriert"
  },
  extraConsentScene: {
    continue: "Weiter",
    privacyStatementCheckboxLabel: "Ich habe die {0} zur Kenntnis genommen.",
    privacyStatementName: "Datenschutzerklärung",
    privacyStatementTitle: "Unsere Datenschutzerklärung wurde aktualisiert",
    termsOfUseCheckboxLabel: "Ich stimme den {0} zu.",
    termsOfUseName: "Nutzungsbedingungen",
    termsOfUseTitle: "Unsere Nutzungsbedingungen wurden aktualisiert",
    title: "Profil vervollständigen"
  },
  forgotPasswordScene: {
    backButtonLabel: "Zurück zur Anmeldung",
    submitButtonLabel: "Absenden",
    successDescription: "Bitte überprüfen Sie Ihre E-Mail. Sie erhalten in Kürze Informationen zu Ihrem Konto, um den Prozess zur Zurücksetzung des Passworts zu starten.",
    successTitle: "Wir haben Ihre Anfrage erhalten.",
    title: "Bitte geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen:"
  },
  loginModalScene: {
    copy: "Melden Sie sich an oder erstellen Sie ein Konto, um alle Funktionen von Miele nutzen zu können.",
    title: "Melden Sie sich bei Ihrem Konto an"
  },
  loginScene: {
    emailInputLabel: "E-Mail",
    forgotPwdButtonLabel: "Passwort vergessen",
    invalidEmailMessage: "E-Mail nicht gültig!",
    loginButtonLabel: "Anmelden",
    passwordInputLabel: "Passwort",
    rememberMeLabel: "Angemeldet bleiben",
    title: "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an:"
  }
}, Kl = {
  accessibility: {
    close: "Schliessen"
  }
}, Hl = {
  tooShort: "Zu kurz",
  medium: "Mittel",
  strong: "Stark",
  tooWeak: "Zu schwach",
  veryStrong: "Sehr stark",
  weak: "Schwach"
}, Wl = {
  showPasswordText: "Anzeigen",
  hidePasswordText: "Ausblenden"
}, Jl = {
  registerButtonLabel: "Registrieren",
  registerTitle: "Sie haben noch kein Konto?",
  whyRegister: {
    list: [
      "Zugang zu exklusiven Vorteilen des Miele Clubs",
      "Registrierung von Geräten, Auftragsverfolgung, Zugriff auf Gebrauchsanweisungen",
      "Personalisierte Angebote und Promotionen",
      "Alle Ihre Bestellungen, Garantien, Events und Dienstleistungen einsehen"
    ],
    title: "Warum registrieren?"
  },
  closeButtonLabel: "Schliessen",
  passwordMismatchError: "Die Passwörter stimmen nicht überein",
  passwordUpdateErrorTitle: "Fehler beim Aktualisieren des Passworts",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert"
}, Zl = {
  title: "Marketingpräferenzen",
  description: "Interessieren Sie sich für exklusive Angebote, Produktneuheiten, Events, Kundenbefragungen und weiteren nützlichen Informationen aus der Miele-Welt?",
  submit: "Speichern",
  levelOne: {
    text: "Ich bin damit einverstanden, dass die Miele AG («Miele») mir Informationen und Angebote zu Produkten und Dienstleistungen sowie Einladungen zu Events und Kundenbefragungen per E-Mail (Newsletter), Miele Apps, Post und SMS sendet. Um die kommerzielle Kommunikation bestmöglich auf Ihre Bedürfnisse abzustimmen, verarbeitet Miele die folgende Personendaten und führen dabei ein sogenanntes Profiling durch (d.h. eine automatisierte Bearbeitung von Personendaten, um persönliche Aspekte zu analysieren oder Prognosen zu treffen): Kontaktdaten, Gerätedaten, Daten aus Kundenbefragungen/Surveys, Kaufhistorie und Newsletter-Klicks, beanspruchte Dienstleistungen, Technikereinsätze und Event-Teilnahmen, Nutzungsverhalten Miele App und Webseiten. Weitere Details finden Sie in den ",
    link: {
      title: "Datenschutzhinweisen.",
      ref: "https://www.miele.ch/de/c/datenschutz-14.htm"
    }
  },
  levelTwo: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  highlightedText: {
    text: "Ich kann meine Einwilligung jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen. Weitere Informationen darüber, wie Miele mit Ihren Daten umgeht, finden Sie in der ",
    link: {
      title: "Miele Datenschutzerklärung.",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ja, ich stimme den Nutzungsbedingungen zu.",
    link: {
      title: "Nutzungsbedingungen anzeigen.",
      ref: "https://www.miele.ch/de/c/nutzungsbedingungen-304.htm"
    }
  }
}, Yl = {
  headline: "Miele Club",
  why: {
    title: "Exklusive Vorteile für Mitglieder - Persönliche Club Kommunikation.",
    reasons: [
      "10% Willkommensrabatt",
      "Geburtstagsüberraschung",
      "Exklusive Angebote und Events",
      "Tipps & Tricks zur Nutzung der Geräte"
    ]
  },
  birthDateTitle: "Möchten Sie eine Geburtstagsüberraschung erhalten?",
  birthDateLabel: "Ihr Geburtstagsdatum (freiwillig) ",
  birthDateValidation: {
    requirementMsg: "Bitte verwenden sie das folgende Datumsformat: DD/MM/YYYY",
    errorMsg: "Inkorrektes Datum"
  },
  joinClubLabel: "Ja, ich möchte dem Miele Club beitreten.",
  termsAndCondition: {
    description: "Ja, ich habe die Miele Club {termsAndConditionLink} gelesen und akzeptiere sie.",
    termsAndConditionLink: {
      title: "Teilnahme- und Nutzungsbedingungen",
      ref: "https://www.miele.ch/de/c/agb-13.htm#p7364"
    },
    privacyLink: {
      title: "",
      ref: ""
    }
  },
  newsletter: {
    description: "Ja, ich habe die Miele Club {privacyLink} gelesen und akzeptiere sie. Die Bearbeitung gemäss Datenschutzbestimmungen umfasst insbesondere das Profiling gestützt auf das Kundenverhalten und die Nutzung der Kundenprofile für Marketing und weitere Zwecke.",
    privacyLink: {
      title: "Datenschutzbestimmungen",
      href: "https://www.miele.ch/de/c/datenschutz-14.htm"
    },
    termsAndConditionLink: {
      title: "",
      href: ""
    },
    supportEmail: "info{'@'}miele.ch"
  },
  selectAllConsents: {
    description: "Um dem Miele Club beizutreten, müssen Sie allen Geschäftsbedingungen zustimmen"
  }
}, Xl = "vollständige Erklärung anzeigen", Ql = "vollständige Erklärung ausblenden", ec = {
  auth: Bl,
  changeEmailScene: Rl,
  changePasswordScene: Fl,
  errors: Vl,
  forgotPassword: ql,
  login: Gl,
  modal: Kl,
  passwordStrength: Hl,
  passwordHelper: Wl,
  register: Jl,
  "marketing-consent": {
    title: "Marketingpräferenzen",
    description: "Interessieren Sie sich für exklusive Angebote, Produktneuheiten, Events, Kundenbefragungen und weiteren nützlichen Informationen aus der Miele-Welt?",
    submit: "Speichern",
    newsletter: {
      text: "Ich bin damit einverstanden, dass die Miele AG («Miele») mir Informationen und Angebote zu Produkten und Dienstleistungen sowie Einladungen zu Events und Kundenbefragungen per E-Mail (Newsletter), Miele Apps, Post und SMS sendet. Um die kommerzielle Kommunikation bestmöglich auf Ihre Bedürfnisse abzustimmen, verarbeitet Miele die folgende Personendaten und führen dabei ein sogenanntes Profiling durch (d.h. eine automatisierte Bearbeitung von Personendaten, um persönliche Aspekte zu analysieren oder Prognosen zu treffen): Kontaktdaten, Gerätedaten, Daten aus Kundenbefragungen/Surveys, Kaufhistorie und Newsletter-Klicks, beanspruchte Dienstleistungen, Technikereinsätze und Event-Teilnahmen, Nutzungsverhalten Miele App und Webseiten. ",
      link: {
        title: "Siehe Datenschutzerklärung",
        ref: ""
      }
    },
    personalisation: {
      text: "Ich bin damit einverstanden, dass Miele Informationen über die von mir in Anspruch genommenen Dienstleistungen und durchgeführten Technikereinsätze sowie über von mir besuchte Events zum Zweck der erweiterten Personalisierung verarbeitet.",
      link: {
        title: "Siehe Datenschutzerklärung",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Zusätzlich zur erweiterten Personalisierung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meinen Besuchen der Miele Webseiten (www.miele.ch)  verarbeitet, um mein Benutzerprofil zu ergänzen, sofern ich der Verarbeitung dieser Daten separat zugestimmt habe. Weitere Einzelheiten finden Sie in der Miele Datenschutzerklärung.",
      link: {
        title: "Siehe Datenschutzerklärung",
        ref: ""
      }
    },
    highlightedText: {
      text: "Ich kann meine Einwilligung jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen. Weitere Informationen darüber, wie Miele mit Ihren Daten umgeht, finden Sie in der ",
      link: {
        title: "Miele Datenschutzerklärung.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ja, ich stimme den Nutzungsbedingungen zu.",
      link: {
        title: "Nutzungsbedingungen anzeigen*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: Zl,
  mieleClub: Yl,
  readMore: Xl,
  readLess: Ql
}, tc = {
  waitMessage: "Fast geschafft..."
}, ic = {
  buttonLabel: "Speichern",
  buttonLabelClose: "Schließen",
  confirmEmailMessage: "E-Mail-Adresse bestätigen",
  copy: "Ändern Sie Ihre E-Mail-Adresse:",
  errorMessageCopy: "Etwas ist schief gelaufen. Versuchen Sie es erneut.",
  errorMessageHeadline: "Das hat nicht geklappt.",
  headline: "Profil Details",
  inputEmailConfirmPlaceholder: "E-Mail-Adresse bestätigen",
  inputEmailPlaceholder: "E-Mail-Adresse",
  invalidEmailMessage: "E-Mail-Adresse ungültig!",
  rememberMeLabel: "Eingeloggt bleiben",
  successMessageCopy: "Ihre E-Mail-Adresse wurde erfolgreich geändert.",
  successMessageHeadline: "E-Mail-Adresse aktualisiert"
}, nc = {
  closeButtonLabel: "Schließen",
  confirmPasswordLabel: "Passwort bestätigen",
  currentPasswordLabel: "Aktuelles Passwort",
  newPasswordLabel: "Neues Passwort",
  passwordMismatchError: "Die Passwörter stimmen nicht überein.",
  passwordUpdateErrorTitle: "Fehler",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  samePasswordError: "Dieses Passwort wurde zuvor verwendet. Bitte geben Sie ein neues Passwort ein.",
  subtitle: "Um Ihr Passwort zu ändern, füllen Sie bitte die folgenden Felder aus:",
  submitButtonLabel: "Speichern",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert.",
  title: "Passwort ändern"
}, ac = {
  invalidEmail: "Ungültige E-Mail-Adresse",
  invalidPassword: "Ungültiges Passwort",
  sap_206002: "Ihr Konto muss noch verifiziert werden. Bitte kontaktieren Sie uns für weitere Details.",
  sap_206006: "Es sieht so aus, als ob die von Ihnen angegebene E-Mail-Adresse noch überprüft werden muss.",
  sap_400003: "Diese E-Mail-Adresse existiert bereits. Bitte verwenden Sie eine andere E-Mail-Adresse!",
  sap_400028: "Die E-Mail-Adresse muss noch verifiziert werden.",
  sap_400050: "Es tut uns leid, im Moment können wir Ihre Anmeldeinformationen nicht bestätigen.",
  sap_400097: "Es scheint, dass Sie auf unsere Dienste von einem unsicheren/nicht unterstützten Browser aus zugreifen. Bitte versuchen Sie es erneut mit einem anderen Browser.",
  sap_401030: "Dieses Passwort wurde zuvor verwendet. Bitte geben Sie ein neues Passwort ein.",
  sap_403005: "Es ist kein Konto mit dieser E-Mail-Adresse verknüpft. Bitte überprüfen Sie Ihre E-Mail-Adresse und versuchen Sie es erneut.",
  sap_403011: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403012: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403013: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403035: "Es tut uns leid, im Moment können wir Ihre Anmeldeinformationen nicht bestätigen.",
  sap_403041: "Es ist kein Konto mit dieser E-Mail-Adresse verknüpft. Bitte überprüfen Sie Ihre E-Mail-Adresse und versuchen Sie es erneut.",
  sap_403042: "Die Kombination aus E-Mail-Adresse und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403043: "Die Kombination aus E-Mail-Adresse und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403047: "Die Kombination aus E-Mail-Adresse und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403100: "Es wurde kürzlich eine Anfrage zur Aktualisierung des Passworts gestellt. Bitte haben Sie noch etwas Geduld.",
  sap_403025: "Der Link zum Zurücksetzen des Passworts ist ungültig. Bitte setzen Sie Ihr Passwort erneut zurück, um einen neuen Link zu erhalten.",
  sapErrorTitle: "Fehler bei Anfrage",
  sessionExpired: "Sitzung ist abgelaufen",
  tooWeakPassword: "Das Passwort muss mindestens {minLength} Zeichen lang sein und {minCharGroups} der folgenden Zeichen enthalten: Großbuchstabe, Kleinbuchstabe, Zahl, Sonderzeichen | Das Passwort muss mindestens {minLength} Zeichen lang sein",
  unexpectedDescription: "Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte über das Kontaktformular.",
  unexpectedTitle: "Ein unerwarteter Fehler ist aufgetreten.",
  unknownDescription: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
  unknownTitle: "Oje!"
}, sc = {
  subtitle: "Neues Passwort vergeben",
  title: "Passwort vergessen?"
}, oc = {
  headMetaDescription: "Benutzerkonto Login",
  headTitle: "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an:",
  subtitle: "Anmelden oder Benutzerkonto erstellen, um alle Miele Vorteile zu genießen.",
  title: "Melden Sie sich mit Ihren Benutzerdaten an",
  error: {
    invalidEmailPasswordDescription: "Ungültige E-Mail-Adresse oder Passwort",
    invalidEmailPasswordTitle: "Anmeldedaten nicht korrekt",
    missingConcentTitle: "Kein Benutzerkonto vorhanden",
    noAccountDescription: "Kein Benutzerkonto zu der angegebenen E-Mail-Adresse gefunden.",
    noAccountTitle: "Kein Benutzerkonto vorhanden"
  },
  extraConsentScene: {
    continue: "Senden",
    privacyStatementCheckboxLabel: "Ich habe die {0} zur Kenntnis genommen.",
    privacyStatementName: "Datenschutzbestimmungen",
    privacyStatementTitle: "Unsere Datenschutzbestimmungen haben sich geändert.",
    termsOfUseCheckboxLabel: "Ich stimme den {0} zu.",
    termsOfUseName: "Nutzungsbedingungen",
    termsOfUseTitle: "Unsere Nutzungsbedingungen haben sich geändert",
    title: "Profile Akualisierung"
  },
  forgotPasswordScene: {
    backButtonLabel: "Zurück zur Anmeldung",
    submitButtonLabel: "Bestätigen",
    successDescription: "Bitte überprüfen Sie Ihren Posteingang, wir haben Ihnen eine E-Mail bezüglich der Passwortänderung gesendet.",
    successTitle: "Ihre Anfrage hat uns erreicht.",
    title: "Um Ihr Passwort zurückzusetzen, geben Sie bitte Sie Ihre E-Mail Adresse ein."
  },
  loginModalScene: {
    copy: "Melden Sie sich in Ihrem Benutzerkonto an, um alle Miele Vorteile zu genießen.",
    title: "Melden Sie sich in Ihrem Benutzerkonto an"
  },
  loginScene: {
    emailInputLabel: "E-Mail-Adresse",
    forgotPwdButtonLabel: "Passwort vergessen",
    invalidEmailMessage: "E-Mail-Adresse ungültig!",
    loginButtonLabel: "Anmelden",
    passwordInputLabel: "Passwort",
    rememberMeLabel: "Eingeloggt bleiben",
    title: "E-Mail-Adresse und Passwort eingeben:"
  }
}, rc = {
  accessibility: {
    close: "Schließen"
  }
}, lc = {
  tooShort: "Zu kurz",
  medium: "Mittel",
  strong: "Stark",
  tooWeak: "Zu schwach",
  veryStrong: "Sehr stark",
  weak: "Schwach"
}, cc = {
  showPasswordText: "Anzeigen",
  hidePasswordText: "Verbergen"
}, dc = {
  registerButtonLabel: "Registrieren",
  registerTitle: "Sie haben kein Benutzerkonto?",
  whyRegister: {
    list: [
      "Exklusive myMiele Club Vorteile",
      "Geräteregistrierung, Sendungsverfolgung, Informationen zu Ihren Geräten, Gebrauchsanweisungen und Zubehör",
      "Individuelle Angebote und Aktionen",
      "Alle Bestellungen, Garantien, Events und Services einsehen"
    ],
    title: "Warum registrieren?"
  },
  closeButtonLabel: "Schließen",
  passwordMismatchError: "Die Passwörter stimmen nicht überein.",
  passwordUpdateErrorTitle: "Fehler bei Passwort-Aktualisierung",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert."
}, uc = {
  title: "Marketing-Präferenzen",
  description: "Kreuzen Sie unten an, um exklusive Angebote, Neuigkeiten, Veranstaltungen und Informationen darüber zu erhalten, wie Sie das Beste aus Ihrem Gerät herausholen können.",
  submit: "Speichern",
  levelOne: {
    shortText: "Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Werbekommunikation der Miele Vertriebsgesellschaft Deutschland KG sowie der Miele & Cie. KG („Miele“) per E-Mail, SMS, Post sowie über die Miele Apps und Webseiten (soweit genutzt) erhalten",
    text: "Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Werbekommunikation der Miele Vertriebsgesellschaft Deutschland KG sowie der Miele & Cie. KG („Miele“) per E-Mail, SMS, Post sowie über die Miele Apps und Webseiten (soweit genutzt) erhalten mit Informationen zu Produkten, Angeboten und Neuerungen aus dem Miele Sortiment und zu Miele Events sowie Kundenbefragungen, Produktbewertungs- und Rezensionsanfragen und Rezepten. Dafür darf Miele meine Kontaktdaten (Anrede, Name, E-Mail-Adresse, Mobilfunknummer und Postadresse) nutzen und die Kommunikation auf Basis meiner Kauf-, Event- und Servicehistorie, meines Newsletter-Klick- und -Öffnungsverhaltens und meines Kundenwerts ausgestalten, wie in unseren Datenschutzhinweisen näher beschrieben. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen (bspw. per formloser Nachricht an info{'@'}miele.de, die im Impressum angegebenen Kontaktdaten oder Klick auf den Abmeldelink in E-Mails).",
    link: {
      title: "Datenschutzhinweisen",
      ref: "https://www.miele.de/c/datenschutz-14.htm"
    }
  },
  levelTwo: {
    text: "Zusätzlich zu meiner Basiseinwilligung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meiner Besuche auf den Miele Webseiten (www.miele.de), einschließlich an Newsletter-Klicks anknüpfendes Nutzerverhalten auf den dort verlinkten Miele Webseiten, zur Ergänzung meines Nutzerprofils für personalisierte Werbekommunikation verarbeitet, soweit meine gesonderte Einwilligung in der App bzw. auf der Webseite die Datenverarbeitung freigibt. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen. Weitere Details in den Datenschutzbestimmungen.",
    link: {
      title: "Datenschutzbestimmungen",
      ref: "https://www.miele.de/c/datenschutz-14.htm"
    }
  },
  levelThree: {
    text: "Zusätzlich zu meiner Basiseinwilligung bin ich damit einverstanden, dass Miele Daten von meinen vernetzten Miele Geräten (Daten zu Gerätenutzung und -status) zur Ergänzung meines Nutzerprofils für personalisierte Werbung verarbeitet. Weitere Informationen zur Verarbeitung von Gerätedaten finde ich in der Datenschutzerklärung über das Miele{'@'}Home-System. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen. Weitere Details in den Datenschutzbestimmungen.",
    link: {
      title: "Miele{'@'}Home-System",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ja, ich stimme den Nutzungsbedingungen zu.",
    link: {
      title: "Nutzungsbedingungen ansehen*",
      ref: "https://www.miele.de/c/nutzungsbedingungen-304.htm"
    }
  }
}, mc = {
  headline: "Miele Club",
  birthDateTitle: "Können wir Ihnen ein Geburtstagsgeschenk schicken?",
  birthDateLabel: "Geburtstag (optional)",
  why: {
    title: "Mitgliedschaft",
    reasons: [
      "Mitgliedskonto mit Informationen zu Ihren Geräten",
      "Transaktionen und persönlichen Daten"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Geben Sie dieses Datumsformat ein: MM/DD/YYYY",
    errorMsg: "Ungültiges Datum"
  },
  joinClubLabel: "Ja, ich möchte dem Miele Club beitreten.",
  termsAndCondition: {
    description: "Ich stimme den Miele Club {termsAndConditionLink} zu und bestätige, dass ich die Hinweise zum {privacyLink} für den Miele Club zur Kenntnis genommen habe.",
    termsAndConditionLink: {
      title: "Teilnahme- und Nutzungsbedingungen",
      ref: "https://www.miele.de/c/agb-13.htm"
    },
    privacyLink: {
      title: "Datenschutz",
      ref: "https://www.miele.de/c/agb-13.htm"
    }
  },
  newsletter: {
    shortDescription: 'Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Clubwerbekommunikation der Miele Gesellschaft m.b.H. („Miele") per E-Mail und Post erhalten',
    description: `Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Clubwerbekommunikation der Miele Gesellschaft m.b.H. („Miele") per E-Mail und Post erhalten mit speziellen Angeboten, Informationen, Eventeinladungen und Kundenbefragungen zu unseren Produkten und Dienstleistungen. Dafür darf Miele meine Kontaktdaten (Anrede, Name, E-Mail und postalische Adresse) nutzen und die Kommunikation auf Basis meines Kauf- und Newsletterverhaltens sowie meines Kundenwerts ausgestalten, wie in unseren {privacyLink} näher beschrieben. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen (bspw. per formloser Nachricht an info{'@'}miele.de, die im Impressum angegebenen Kontaktdaten oder Klick auf den Abmeldelink in E-Mails). Die vertragliche {termsAndConditionLink} bleibt davon bis zur Kündigung der Mitgliedschaft unberührt.`,
    privacyLink: {
      title: "Club-Datenschutzhinweisen",
      href: "https://www.miele.de/c/datenschutz-14.htm"
    },
    termsAndConditionLink: {
      title: "Clubkommunikation",
      href: "https://www.miele.de/c/agb-13.htm#p264"
    },
    supportEmail: "info{'@'}miele.de"
  },
  selectAllConsents: {
    description: "Um dem Miele Club beizutreten, müssen Sie allen Geschäftsbedingungen zustimmen *"
  }
}, pc = "vollständige Erklärung anzeigen", hc = "vollständige Erklärung ausblenden", gc = {
  auth: tc,
  changeEmailScene: ic,
  changePasswordScene: nc,
  errors: ac,
  forgotPassword: sc,
  login: oc,
  modal: rc,
  passwordStrength: lc,
  passwordHelper: cc,
  register: dc,
  "marketing-consent": {
    title: "Marketingeinwilligung",
    description: "",
    submit: "Speichern",
    newsletter: {
      text: 'Ich bin damit einverstanden, dass die Miele Vertriebsgesellschaft Deutschland KG ("Miele") mir Informationen zu Produkten und Neuerungen aus dem Miele-Sortiment und zu Miele-Events sowie Kundenbefragungen, Produktbewertungen, -rezensionen und Rezepte per E-Mail, die Miele Apps und SMS sendet und Miele zu diesem Zweck die von mir angegebenen Kontaktdaten (Anrede, Name, E-Mail-Adresse, Mobilfunknummer und Postleitzahl) und die von mir bislang und zukünftig erworbenen Miele-Produkte sowie die von mir angegebenen Interessen verarbeitet. Ich bin ferner damit einverstanden, dass Miele auch über den Newsletter erhaltene Empfangs- und Lesebestätigungen und Informationen über die Links, die ich geklickt habe, sowie mein daran anknüpfendes Nutzerverhalten auf der verlinkten Website, zum Zweck der Personalisierung verarbeitet. Das Gleiche gilt für die In-App-Push-Nachrichten, soweit die Miele Apps genutzt werden.',
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen.",
        ref: "https://www.miele.de/c/datenschutz-14.htm"
      }
    },
    personalisation: {
      text: "Ich bin damit einverstanden, dass Miele zur Personalisierung Informationen über die von mir in Anspruch genommenen Dienstleistungen und durchgeführte Technikereinsätze sowie über Events, an denen ich teilgenommen habe, verarbeitet.",
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen.",
        ref: "https://www.miele.de/c/datenschutz-14.htm"
      }
    },
    extendedPersonalisation: {
      text: "Zusätzlich zur weiteren Personalisierung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meiner Besuche auf den Miele Webseiten (www.miele.de) zur Ergänzung meines Nutzerprofils verarbeitet, sofern ich in die Verarbeitung dieser Daten gesondert eingewilligt habe.",
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen.",
        ref: "https://www.miele.de/c/datenschutz-14.htm"
      }
    },
    highlightedText: {
      text: "Meine Einwilligung kann ich jederzeit mit Wirkung für die Zukunft widerrufen. Meinen Widerruf kann ich zu jedem späteren Zeitpunkt ohne Angaben von Gründen schriftlich (Miele Vertriebsgesellschaft Deutschland KG, Carl-Miele-Straße 29, 33332 Gütersloh ) oder per E-Mail (info{'@'}miele.de) erklären. Zudem befindet sich in jeder E-Mail an mich ein Abmeldelink, mit dem ich meinen Widerruf ebenfalls erklären kann. Weitere Informationen, wie Miele mit Ihren Daten umgeht finden Sie in den Datenschutzbestimmungen.",
      link: {
        title: "Datenschutzbestimmungen.",
        ref: "https://www.miele.de/c/datenschutz-14.htm"
      }
    },
    termsOfUse: {
      text: "Ja, ich stimme den Nutzungsbedingungen zu.",
      link: {
        title: "Nutzungsbedingungen ansehen*",
        ref: "https://www.miele.de/c/nutzungsbedingungen-304.htm"
      }
    }
  },
  multiLevelMarketingConsent: uc,
  mieleClub: mc,
  readMore: pc,
  readLess: hc
}, vc = {
  waitMessage: "Fast geschafft..."
}, fc = {
  buttonLabel: "Speichern",
  buttonLabelClose: "Schliessen",
  confirmEmailMessage: "Bestätige deine E-Mail-Adresse",
  copy: "Ändere deine E-Mail-Adresse:",
  errorMessageCopy: "Etwas ist schief gelaufen. Versuche es erneut.",
  errorMessageHeadline: "Das hat nicht geklappt",
  headline: "Profil Details",
  inputEmailConfirmPlaceholder: "Bestätige deine E-Mail-Adresse",
  inputEmailPlaceholder: "E-Mail-Adresse",
  invalidEmailMessage: "E-Mail-Adresse ungültig!",
  rememberMeLabel: "Eingeloggt bleiben",
  successMessageCopy: "Deine E-Mail-Adresse wurde erfolgreich geändert",
  successMessageHeadline: "E-Mail-Address aktualisiert"
}, kc = {
  closeButtonLabel: "Schliessen",
  confirmPasswordLabel: "Passwort bestätigen",
  currentPasswordLabel: "Aktuelles Passwort",
  newPasswordLabel: "Neues Passwort",
  passwordMismatchError: "Die Passwörter stimmen nicht überein",
  passwordUpdateErrorTitle: "Fehler",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  samePasswordError: "Dieses Passwort wurde zuvor verwendet. Bitte geben Sie ein neues Passwort ein.",
  subtitle: "Um ihr Passwort zu ändern, füllen Sie bitte die folgenden Felder aus:",
  submitButtonLabel: "Speichern",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert",
  title: "Passwort ändern"
}, bc = {
  invalidEmail: "Ungültige E-Mail Adresse",
  invalidPassword: "Ungültiges Passwort",
  sap_206002: "Ihr Konto muss noch verifiziert werden. Bitte kontaktieren Sie uns für weitere Details.",
  sap_206006: "Es sieht so aus, als ob die von Ihnen angegebene E-Mail-Adresse noch überprüft werden muss.",
  sap_400003: "Diese E-Mail existiert bereits, bitte verwenden Sie eine andere E-Mail Adresse!",
  sap_400028: "Die E-Mail-Adresse steht noch aus und muss noch verifiziert werden.",
  sap_400050: "Es tut uns leid, im Moment können wir Ihre Anmeldeinformationen nicht bestätigen.",
  sap_400097: "Es scheint, dass Sie auf unsere Dienste von einem unsicheren/nicht unterstützten Browser aus zugreifen. Bitte versuchen Sie es erneut mit einem anderen Browser.",
  sap_401030: "Dieses Passwort wurde zuvor verwendet. Bitte geben Sie ein neues Passwort ein.",
  sap_403005: "Es ist kein Konto mit dieser E-Mail-Adresse verknüpft. Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
  sap_403011: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403012: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403013: "Die Sitzung ist abgelaufen. Bitte laden Sie den Browser neu und melden Sie sich erneut an.",
  sap_403035: "Es tut uns leid, im Moment können wir Ihre Anmeldeinformationen nicht bestätigen.",
  sap_403041: "Es ist kein Konto mit dieser E-Mail-Adresse verknüpft. Bitte überprüfen Sie Ihre E-Mail und versuchen Sie es erneut.",
  sap_403042: "Die Kombination aus E-Mail und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403043: "Die Kombination aus E-Mail und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403047: "Die Kombination aus E-Mail und Passwort ist ungültig. Bitte überprüfen Sie die E-Mail-Adresse oder wählen Sie 'Passwort vergessen', wenn Sie es zurücksetzen möchten.",
  sap_403100: "Es wurde kürzlich eine Anfrage zur Aktualisierung des Passworts gestellt. Bitte haben Sie noch etwas Geduld.",
  sap_403025: "Paroles atiestatīšanas saite nav derīga. Lūdzu, vēlreiz nosūtiet aizmirstās paroles pieprasījumu, lai saņemtu jaunu atiestatīšanas saiti.",
  sapErrorTitle: "Fehler bei Anfrage",
  sessionExpired: "Sitzung ist abgelaufen",
  tooWeakPassword: "Das Passwort muss mindestens {minLength} Zeichen lang sein und {minCharGroups} der folgenden Zeichen enthalten: Großbuchstabe, Kleinbuchstabe, Zahl, Sonderzeichen | Das Passwort muss mindestens {minLength} Zeichen lang sein",
  unexpectedDescription: "Wenn das Problem weiterhin besteht, kontaktieren Sie uns bitte über das Kontaktformular.",
  unexpectedTitle: "Ein unerwarteter Fehler ist aufgetreten.",
  unknownDescription: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
  unknownTitle: "Oje!"
}, wc = {
  subtitle: "Neues Passwort vergeben",
  title: "Passwort vergessen?"
}, yc = {
  headMetaDescription: "Benutzerkonto Login",
  headTitle: "Melden Sie sich mit Ihrer E-Mail Adresse und Ihrem Passwort an:",
  subtitle: "Anmelden oder Benutzerkonto erstellen, um alle Miele Vorteile zu genießen.",
  title: "Melden Sie sich mit Ihren Benutzerdaten an",
  error: {
    invalidEmailPasswordDescription: "Ungültige E-Mail Adresse oder Passwort",
    invalidEmailPasswordTitle: "Anmeldedaten nicht korrekt",
    missingConcentTitle: "Kein Benutzerkonto vorhanden",
    noAccountDescription: "Kein Benutzerkonto zu der angegebenen E-Mail Adresse gefunden.",
    noAccountTitle: "Kein Benutzerkonto vorhanden"
  },
  extraConsentScene: {
    continue: "Senden",
    privacyStatementCheckboxLabel: "Ich habe die {0} zur Kenntnis genommen.",
    privacyStatementName: "Datenschutzbestimmungen",
    privacyStatementTitle: "Unsere Datenschutzbestimmungen haben sich geändert",
    termsOfUseCheckboxLabel: "Ich stimme den {0} zu.",
    termsOfUseName: "Nutzungsbedingungen",
    termsOfUseTitle: "Unsere Nutzungsbedingungen haben sich geändert",
    title: "Profile Akualisierung"
  },
  forgotPasswordScene: {
    backButtonLabel: "Zurück zur Anmeldung",
    submitButtonLabel: "Bestätigen",
    successDescription: "Bitte überprüfen Sie Ihren Posteingang, wir haben Ihnen eine E-Mail bezüglich der Passwortänderung gesendet.",
    successTitle: "Ihre Anfrage hat uns erreicht.",
    title: "Um Ihr Passwort zurückzusetzen, geben Sie bitte Sie Ihre E-Mail Adresse ein."
  },
  loginModalScene: {
    copy: "Melden Sie sich an in Ihrem Benutzerkonto, um alle Miele Vorteile zu genießen.",
    title: "Melden Sie sich in Ihrem Benutzerkonto an"
  },
  loginScene: {
    emailInputLabel: "E-Mail",
    forgotPwdButtonLabel: "Passwort vergessen",
    invalidEmailMessage: "E-Mail-Adresse ungültig!",
    loginButtonLabel: "Anmelden",
    passwordInputLabel: "Passwort",
    rememberMeLabel: "Eingeloggt bleiben",
    title: "E-Mail Adresse und Passwort eingeben:"
  }
}, Mc = {
  accessibility: {
    close: "Schliessen"
  }
}, zc = {
  tooShort: "Zu kurz",
  medium: "Mittel",
  strong: "Stark",
  tooWeak: "Zu schwach",
  veryStrong: "Sehr stark",
  weak: "Schwach"
}, jc = {
  showPasswordText: "Anzeigen",
  hidePasswordText: "Verbergen"
}, _c = {
  registerButtonLabel: "Registrieren",
  registerTitle: "Sie haben kein Benutzerkonto?",
  whyRegister: {
    list: [
      "Geräteregistrierung, Sendeverfolgung, Informationen zu Ihren Geräten, Gebrauchsanweisungen und Zubehör",
      "Individuelle Angebote und Aktionen",
      "Alle Bestellungen, Garantien, Events und Services einsehen"
    ],
    title: "Warum registrieren?"
  },
  closeButtonLabel: "Schliessen",
  passwordMismatchError: "Die Passwörter stimmen nicht überein",
  passwordUpdateErrorTitle: "Fehler bei Passwort-Aktualisierung",
  passwordUpdateSuccessTitle: "Passwort aktualisiert",
  successfulChangeLabel: "Ihr Passwort wurde erfolgreich aktualisiert"
}, Sc = {
  title: "Marketing-Präferenzen",
  description: "Kreuzen Sie unten an, um exklusive Angebote, Neuigkeiten, Veranstaltungen und Informationen darüber zu erhalten, wie Sie das Beste aus Ihrem Gerät herausholen können",
  submit: "Speichern",
  levelOne: {
    shortText: "Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Werbekommunikation der Miele s.à r.l. sowie der Miele & Cie. KG („Miele“) per E-Mail, SMS, Post und über die Miele Apps und Websites (soweit genutzt) erhalten",
    text: "Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Werbekommunikation der Miele s.à r.l. sowie der Miele & Cie. KG („Miele“) per E-Mail, SMS, Post und über die Miele Apps und Websites (soweit genutzt) erhalten mit Informationen zu Produkten, Angeboten und Neuerungen aus dem Miele-Sortiment und zu Miele-Events sowie Kundenbefragungen, Produktbewertungs- und Rezensionsanfragen und Rezepten. Dafür darf Miele meine Kontaktdaten (Anrede, Name, E-Mail-Adresse, Mobilfunknummer und Postadresse) nutzen und die Kommunikation auf Basis meiner Kauf-, Event- und Servicehistorie, meines Newsletterklick- und -öffnungsverhaltens und meines Kundenwerts ausgestalten, wie in unseren Datenschutzhinweisen näher beschrieben. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen (bspw. per formloser Nachricht an privacy{'@'}miele.lu, die im Impressum angegebenen Kontaktdaten oder Klick auf den Abmeldelink in E-Mails).",
    link: {
      title: "Datenschutz",
      ref: "https://www.miele.lu/de/c/datenschutz-14.htm"
    }
  },
  levelTwo: {
    text: "Zusätzlich zu meiner Basiseinwilligung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meiner Besuche auf den Miele-Webseiten (www.miele.lu), einschließlich an Newsletterklicks anknüpfendes Nutzerverhalten auf den dort verlinkten Miele-Webseiten, zur Ergänzung meines Nutzerprofils für personalisierte Werbekommunikation verarbeitet, soweit meine gesonderte Einwilligung in der App bzw. auf der Webseite die Datenverarbeitung freigibt. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen. Weitere Details in den Datenschutzbestimmungen.",
    link: {
      title: "Datenschutzbestimmungen",
      ref: "https://www.miele.lu/de/c/datenschutz-14.htm"
    }
  },
  levelThree: {
    text: "Zusätzlich zu meiner Basiseinwilligung bin ich damit einverstanden, dass Miele Daten von meinen vernetzten Miele-Geräten (Daten zu Gerätenutzung und -status) zur Ergänzung meines Nutzerprofils für personalisierte Werbung verarbeitet. Weitere Informationen zur Verarbeitung von Gerätedaten finde ich in der Datenschutzerklärung über das Miele{'@'}Home-System. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen. Weitere Details in den Datenschutzbestimmungen.",
    link: {
      title: "Miele{'@'}Home-System",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ich stimme den",
    link: {
      title: "Nutzungsbestimmungen  zu.",
      ref: "https://www.miele.lu/de/c/agb-13.htm"
    }
  }
}, Cc = {
  headline: "Miele Club",
  birthDateTitle: "Dürfen wir Ihnen ein Geburtstagsgeschenk senden?",
  birthDateLabel: "Ihr Geburtstagsdatum (freiwillig) ",
  why: {
    title: "Exklusive Vorteile für Mitglieder - Persönliche Club Kommunikation.",
    reasons: [
      "10% Willkommensrabatt auf Zubehör und Reinigungsprodukte",
      "Geburtstagsüberraschung",
      "Exklusive Angebote",
      "Tipps & Tricks zur Nutzung der Geräte"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Bitte verwenden sie das folgende Datumsformat : DD/MM/YYYY",
    errorMsg: "Inkorrektes Datum"
  },
  joinClubLabel: "Ja, ich möchte dem Miele Club beitreten.",
  termsAndCondition: {
    description: "Ich stimme den Miele Club {termsAndConditionLink} zu und bestätige, dass ich die Hinweise zum {privacyLink} für den Miele Club zur Kenntnis genommen habe.",
    termsAndConditionLink: {
      title: "Teilnahme- und Nutzungsbedingungen",
      ref: "https://www.miele.lu/c/agb-13.htm"
    },
    privacyLink: {
      title: "Datenschutz",
      ref: "https://www.miele.lu/c/agb-13.htm"
    }
  },
  newsletter: {
    shortDescription: 'Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Clubwerbekommunikation der Miele Gesellschaft m.b.H. („Miele") per E-Mail und Post erhalten',
    description: `Ja, ich möchte auf meine persönlichen Interessen zugeschnittene Clubwerbekommunikation der Miele Gesellschaft m.b.H. („Miele") per E-Mail und Post erhalten mit speziellen Angeboten, Informationen, Eventeinladungen und Kundenbefragungen zu unseren Produkten und Dienstleistungen. Dafür darf Miele meine Kontaktdaten (Anrede, Name, E-Mail und postalische Adresse) nutzen und die Kommunikation auf Basis meines Kauf- und Newsletterverhaltens sowie meines Kundenwerts ausgestalten, wie in unseren {privacyLink} näher beschrieben. Meine Einwilligung kann ich jederzeit für die Zukunft widerrufen (bspw. per formloser Nachricht an info{'@'}miele.lu, die im Impressum angegebenen Kontaktdaten oder Klick auf den Abmeldelink in E-Mails). Die vertragliche {termsAndConditionLink} bleibt davon bis zur Kündigung der Mitgliedschaft unberührt.`,
    privacyLink: {
      title: "Club-Datenschutzhinweisen",
      href: "https://www.miele.lu/c/datenschutz-14.htm"
    },
    termsAndConditionLink: {
      title: "Clubkommunikation",
      href: "https://www.miele.lu/c/agb-13.htm#p264"
    },
    supportEmail: "info{'@'}miele.lu"
  },
  selectAllConsents: {
    description: "Um dem Miele Club beizutreten, müssen Sie allen Geschäftsbedingungen zustimmen *"
  }
}, Lc = "vollständige Erklärung anzeigen", Ec = "vollständige Erklärung ausblenden", Pc = {
  auth: vc,
  changeEmailScene: fc,
  changePasswordScene: kc,
  errors: bc,
  forgotPassword: wc,
  login: yc,
  modal: Mc,
  passwordStrength: zc,
  passwordHelper: jc,
  register: _c,
  "marketing-consent": {
    title: "Marketing-Präferenzen",
    submit: "Kreuzen Sie unten an, um exklusive Angebote, Neuigkeiten, Veranstaltungen und Informationen darüber zu erhalten, wie Sie das Beste aus Ihrem Gerät herausholen können",
    description: "Speichern",
    newsletter: {
      text: 'Ich bin damit einverstanden, dass die Miele Gesellschaft m.b.H. ("Miele") mir Informationen zu Produkten und Neuerungen aus dem Miele-Sortiment und zu Miele-Events sowie Kundenbefragungen und Rezepte per E-Mail, die Miele Apps und SMS sendet und Miele zu diesem Zweck die von mir angegebenen Kontaktdaten (Anrede, Name, E-Mail-Adresse, Mobilfunknummer und Postleitzahl) und die von mir bislang und zukünftig erworbenen Miele-Produkte sowie die von mir angegebenen Interessen verarbeitet. Ich bin ferner damit einverstanden, dass Miele auch über den Newsletter erhaltene Empfangs- und Lesebestätigungen und Informationen über die Links, die ich geklickt habe, sowie mein daran anknüpfendes Nutzerverhalten auf der verlinkten Website, zum Zweck der Personalisierung verarbeitet. Das Gleiche gilt für die In-App-Push-Nachrichten, soweit die Miele Apps genutzt werden.',
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen",
        ref: "#"
      }
    },
    personalisation: {
      text: "Ich bin damit einverstanden, dass Miele zur Personalisierung Informationen über die von mir in Anspruch genommenen Dienstleistungen und durchgeführte Technikereinsätze sowie über Events, an denen ich teilgenommen habe, verarbeitet.",
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "Zusätzlich zur weiteren Personalisierung bin ich damit einverstanden, dass Miele auch Daten aus der Nutzung der Miele App und meiner Besuche auf den Miele-Webseiten (www.miele.lu) zur Ergänzung meines Nutzerprofils verarbeitet, sofern ich in die Verarbeitung dieser Daten gesondert eingewilligt habe.",
      link: {
        title: "Weitere Details in den Datenschutzbestimmungen",
        ref: "#"
      }
    },
    highlightedText: {
      text: "Ich kann meine Einwilligung jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen. Weitere Informationen zum Umgang mit Ihren Daten bei Miele finden Sie in der Miele ",
      link: {
        title: "Datenschutzbestimmungen.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Ja, ich stimme den Nutzungsbedingungen zu",
      link: {
        title: "Nutzungsbedingungen ansehen*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: Sc,
  mieleClub: Cc,
  readMore: Lc,
  readLess: Ec
}, Tc = {
  waitMessage: "Nearly there. Hang tight ..."
}, Ac = {
  buttonLabel: "Save",
  buttonLabelClose: "Close",
  confirmEmailMessage: "Confirm your e-mail adress",
  copy: "To update your email address, please add the new one below:",
  errorMessageCopy: "Something went wrong. Try again.",
  errorMessageHeadline: "Error",
  headline: "Profile Details",
  inputEmailConfirmPlaceholder: "Confirm your e-mail address",
  inputEmailPlaceholder: "E-mail address",
  invalidEmailMessage: "E-Mail not valid!",
  rememberMeLabel: "Remember me",
  successMessageCopy: "Your email address was successfully updated.",
  successMessageHeadline: "E-mail address updated"
}, xc = {
  closeButtonLabel: "Close",
  confirmPasswordLabel: "Confirm Password",
  currentPasswordLabel: "Current Password",
  newPasswordLabel: "New Password",
  passwordMismatchError: "Password does not match",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Password updated",
  samePasswordError: "This password was used previously, please submit a new password",
  subtitle: "To change your password, please fill in the fields below:",
  submitButtonLabel: "Submit",
  successfulChangeLabel: "Your password has been successfully updated",
  title: "Password Change"
}, Ic = {
  invalidEmail: "Incorrect Email",
  invalidPassword: "Wrong password",
  sap_206002: "Your account is pending verification, I'm afraid we can't let you proceed at the moment. Please contact us for more details.",
  sap_206006: "Looks like the email address you submitted is pending verification",
  sap_400003: "This email already exists, please use a different email address.",
  sap_400028: "The email address submitted  is pending verification",
  sap_400050: "Sorry, we're unable to validate your credentials at this moment.",
  sap_400097: "Looks like you are accessing our services fom an insecure/unsupported browser. Please try again with another browswer",
  sap_401030: "This password was used previously, please submit a new password",
  sap_403005: "We do not have an account associated with this email address, please check your email and try again",
  sap_403011: "Session expired. Please reload the browser and sign-in again.",
  sap_403012: "Session expired. Please reload the browser and sign-in again.",
  sap_403013: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403035: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403041: "We do not have an account associated with this email address, please check your email and try again",
  sap_403042: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403043: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403047: "The email address you entered is not registered.",
  sap_403100: "A request for password update is recently requested, please bare with us until the request is processed",
  sap_403025: "Reset password link invalid, please send forgot password request again to receive new reset link.",
  sapErrorTitle: "Error Processing Request",
  sessionExpired: "Session expired",
  tooWeakPassword: "Password must contain at least {minLength} characters and {minCharGroups} of the following: uppercase letter, lowercase letter, number, special symbol | Password must contain at least {minLength} characters",
  unexpectedDescription: "If the issue persists please get in touch with us via the contact form with details.",
  unexpectedTitle: "An unexpected error occurred",
  unknownDescription: "Unexpected error occurred. Please try again.",
  unknownTitle: "Uh Oh!"
}, Dc = {
  subtitle: "Set your new password.",
  title: "Forgot your password?"
}, Nc = {
  headMetaDescription: "Customer login page",
  headTitle: "Log in with your email and password:",
  subtitle: "Login or create an account to get all the Miele features.",
  title: "Login to your account",
  error: {
    invalidEmailPasswordDescription: "The combination of email address and password is not valid.",
    invalidEmailPasswordTitle: "Invalid credentials",
    missingConcentTitle: "Account Pending Registration",
    noAccountDescription: "There is no account associated to this email address.",
    noAccountTitle: "No account registered"
  },
  extraConsentScene: {
    continue: "Continue",
    privacyStatementCheckboxLabel: "I have taken note of the {0}.",
    privacyStatementName: "privacy statement",
    privacyStatementTitle: "Our Privacy Policy has changed",
    termsOfUseCheckboxLabel: "I agree to the {0}.",
    termsOfUseName: "terms of use",
    termsOfUseTitle: "Our Terms of Use have changed",
    title: "Profile completion"
  },
  forgotPasswordScene: {
    backButtonLabel: "Back to Login",
    submitButtonLabel: "Submit",
    successDescription: "Please check your e-mail, you will receive soon the information on your account to start with the password reset process.",
    successTitle: "Your request has been received.",
    title: "Please enter your email address to reset your password:"
  },
  loginModalScene: {
    copy: "Login or create an account to get all the Miele features.",
    title: "Login to your account"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Forgot my password",
    invalidEmailMessage: "E-Mail not valid!",
    loginButtonLabel: "Login",
    passwordInputLabel: "Password",
    rememberMeLabel: "Remember me",
    title: "Log in with your email and password:"
  }
}, Oc = {
  accessibility: {
    close: "Close"
  }
}, Uc = {
  tooShort: "Too Short",
  medium: "Medium",
  strong: "Strong",
  tooWeak: "Too Weak",
  veryStrong: "Very Strong",
  weak: "Weak"
}, $c = {
  showPasswordText: "Show",
  hidePasswordText: "Hide"
}, Bc = {
  registerButtonLabel: "register",
  registerTitle: "Don't have an account?",
  whyRegister: {
    list: [
      "Access to exclusive benefits from Miele Club",
      "Register appliances, track orders, access manuals",
      "Receive personalized offers and promotions",
      "See all your orders, warranties, events and services"
    ],
    title: "Why register?"
  },
  closeButtonLabel: "Close",
  passwordMismatchError: "The passwords do not match",
  passwordUpdateErrorTitle: "Password update error",
  passwordUpdateSuccessTitle: "Password updated",
  successfulChangeLabel: "Your password has been successfully updated"
}, Rc = {
  title: "Marketing Preferences",
  description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
  submit: "Save",
  levelOne: {
    shortText: 'Yes, I would like to receive promotional communications from Miele Co Ltd. and Miele & Cie. KG ("Miele") tailored to my personal interests by email, text message, post or via the Miele apps and websites (if used)',
    text: `Yes, I would like to receive promotional communications from Miele Co Ltd. and Miele & Cie. KG ("Miele") tailored to my personal interests by email, text message, post or via the Miele apps and websites (if used) with information on products, offers and innovations from the Miele product range and on Miele events as well as customer surveys, product rating and review requests and recipes. For this purpose, Miele may use my contact information (title, name, email address, mobile phone number and postal address) and design the communication based on my purchase, service, event history, newsletter click and open behavior as well as customer value, as described in detail in our privacy policy. I can revoke my consent at any time without giving reasons with effect for the future (e.g. by sending an informal message to info{'@'}miele.co.uk, the contact details given in the imprint or by clicking on the unsubscribe link in emails).`,
    link: {
      title: "Privacy policy",
      ref: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    }
  },
  levelTwo: {
    text: "In addition to my basic consent, I agree that Miele may also process data from the use of the Miele app and my visits to Miele websites (www.miele.co.uk), including user behavior on the Miele websites after linked newsletter clicks, to supplement my user profile for personalized advertising communications, provided that my separate consent in the app or on the website releases the data processing. I can revoke my consent at any time without giving reasons with effect for the future. Further details in Miele's data protection policy.",
    link: {
      title: "See data protection policy",
      ref: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    }
  },
  levelThree: {
    text: "In addition to my basic consent, I agree that Miele may also process data from my connected Miele appliances (data on appliance usage and status) to supplement my user profile for personalized advertising. I can find more information about the processing of device data in the privacy policy about the Miele{'@'}Home system. I can revoke my consent at any time without giving reasons with effect for the future. Further details in Miele's data protection policy.",
    link: {
      title: "Privacy Policy Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Yes, I agree to the terms of use.",
    link: {
      title: "See Terms of Use*",
      ref: "#"
    }
  }
}, Fc = {
  headline: "Miele Club",
  birthDateTitle: "Would you like to receive a birthday surprise?",
  birthDateLabel: "Your date of birth (optional)",
  why: {
    title: "Free membership - Exclusive offers for members.",
    reasons: [
      "£ 10 Welcome voucher",
      "Birthday surprise",
      "Special sale offers",
      "Invites to exclusive events & experiences"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Please enter this date format: DD/MM/YYYY",
    errorMsg: "Incorrect date"
  },
  joinClubLabel: "Yes, I would like to join the Miele Club.",
  termsAndCondition: {
    description: "I consent to the Miele Club {termsAndConditionLink} and acknowledge the {privacyLink} information regarding the Miele Club.",
    termsAndConditionLink: {
      title: "Terms and Conditions",
      ref: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Data privacy",
      ref: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Yes, I would like to receive Club marketing communications that are tailored to my personal interests from the Miele Co Ltd. (“Miele”) via e-mail and in the post",
    description: "Yes, I would like to receive Club marketing communications that are tailored to my personal interests from the Miele Co Ltd. (“Miele”) via e-mail and in the post including special offers, information, event invitations and customer surveys on our products and services. To do this, Miele may use my contact details (title, name, e-mail and postal address) and personalise the communications based on my purchasing behaviour, how I interact with the newsletter and my status as a customer, as described in more detail in our {privacyLink}. I may withdraw my consent with effect for the future at any time (for example, by sending an e-mail to info{'@'}miele.co.uk, getting in touch via the contact details provided in the legal notice or clicking the unsubscribe link in e-mails). Contractual Club {termsAndConditionLink} are not affected by this unless I terminate my membership.",
    privacyLink: {
      title: "Club privacy notice",
      href: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "communications",
      href: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.co.uk"
  },
  selectAllConsents: {
    description: "To join the Miele Club, you must agree to all the terms and conditions *"
  }
}, Vc = "show full statement", qc = "hide full statement", Gc = {
  auth: Tc,
  changeEmailScene: Ac,
  changePasswordScene: xc,
  errors: Ic,
  forgotPassword: Dc,
  login: Nc,
  modal: Oc,
  passwordStrength: Uc,
  passwordHelper: $c,
  register: Bc,
  "marketing-consent": {
    title: "Marketing Preferences",
    description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
    submit: "Save",
    newsletter: {
      text: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps and SMS and that Miele may process the contact details I have provided (title, name, email address, mobile phone number and postcode) and the Miele products I have purchased to date and will purchase in the future as well as the interests I have indicated for this purpose. I further agree that Miele may also process receipt and read confirmations received via the newsletter and information about the links I have clicked on as well as my related user behaviour on the linked website for the purpose of personalisation. The same applies to in-app push messages, insofar as the Miele apps are used.',
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    personalisation: {
      text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "In addition to the extended personalisation, I agree that Miele may also process data from the use of the Miele app and my visits to the Miele websites (www.miele.co.uk) to supplement my user profile, provided that I have separately consented to the processing of this data.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    highlightedText: {
      text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
      link: {
        title: "data protection policy.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Yes, I agree to the terms of use.",
      link: {
        title: "See Terms of Use*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: Rc,
  mieleClub: Fc,
  readMore: Vc,
  readLess: qc
}, Kc = {
  waitMessage: "Nearly there. Hang tight ..."
}, Hc = {
  buttonLabel: "Save",
  buttonLabelClose: "Close",
  confirmEmailMessage: "Confirm your e-mail adress",
  copy: "To update your email address, please add the new one below:",
  errorMessageCopy: "Something went wrong. Try again.",
  errorMessageHeadline: "Error",
  headline: "Profile Details",
  inputEmailConfirmPlaceholder: "Confirm your e-mail address",
  inputEmailPlaceholder: "E-mail address",
  invalidEmailMessage: "E-Mail not valid!",
  rememberMeLabel: "Remember me",
  successMessageCopy: "Your email address was successfully updated.",
  successMessageHeadline: "E-mail address updated"
}, Wc = {
  closeButtonLabel: "Close",
  confirmPasswordLabel: "Confirm Password",
  currentPasswordLabel: "Current Password",
  newPasswordLabel: "New Password",
  passwordMismatchError: "Password does not match",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Password updated",
  samePasswordError: "This password was used previously, please submit a new password",
  subtitle: "To change your password, please fill in the fields below:",
  submitButtonLabel: "Submit",
  successfulChangeLabel: "Your password has been successfully updated",
  title: "Password Change"
}, Jc = {
  invalidEmail: "Incorrect Email",
  invalidPassword: "Wrong password",
  sap_206002: "Your account is pending verification, I'm afraid we can't let you proceed at the moment. Please contact us for more details.",
  sap_206006: "Looks like the email address you submitted is pending verification",
  sap_400003: "This email already exists, please use a different email address.",
  sap_400028: "The email address submitted  is pending verification",
  sap_400050: "Sorry, we're unable to validate your credentials at this moment.",
  sap_400097: "Looks like you are accessing our services fom an insecure/unsupported browser. Please try again with another browswer",
  sap_401030: "This password was used previously, please submit a new password",
  sap_403005: "We do not have an account associated with this email address, please check your email and try again",
  sap_403011: "Session expired. Please reload the browser and sign-in again.",
  sap_403012: "Session expired. Please reload the browser and sign-in again.",
  sap_403013: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403035: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403041: "We do not have an account associated with this email address, please check your email and try again",
  sap_403042: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403043: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403047: "The email address you entered is not registered.",
  sap_403100: "A request for password update is recently requested, please bare with us until the request is processed",
  sap_403025: "Reset password link invalid, please send forgot password request again to receive new reset link.",
  sapErrorTitle: "Error Processing Request",
  sessionExpired: "Session expired",
  tooWeakPassword: "Password must contain at least {minLength} characters and {minCharGroups} of the following: uppercase letter, lowercase letter, number, special symbol | Password must contain at least {minLength} characters",
  unexpectedDescription: "If the issue persists please get in touch with us via the contact form with details.",
  unexpectedTitle: "An unexpected error occurred",
  unknownDescription: "Unexpected error occurred. Please try again.",
  unknownTitle: "Uh Oh!"
}, Zc = {
  subtitle: "Set your new password.",
  title: "Forgot your password?"
}, Yc = {
  headMetaDescription: "Customer login page",
  headTitle: "Log in with your email and password:",
  subtitle: "Login or create an account to get all the Miele features.",
  title: "Login to your account",
  error: {
    invalidEmailPasswordDescription: "The combination of email address and password is not valid.",
    invalidEmailPasswordTitle: "Invalid credentials",
    missingConcentTitle: "Account Pending Registration",
    noAccountDescription: "There is no account associated to this email address.",
    noAccountTitle: "No account registered"
  },
  extraConsentScene: {
    continue: "Continue",
    privacyStatementCheckboxLabel: "I have taken note of the {0}.",
    privacyStatementName: "privacy statement",
    privacyStatementTitle: "Our Privacy Policy has changed",
    termsOfUseCheckboxLabel: "I agree to the {0}.",
    termsOfUseName: "terms of use",
    termsOfUseTitle: "Our Terms of Use have changed",
    title: "Profile completion"
  },
  forgotPasswordScene: {
    backButtonLabel: "Back to Login",
    submitButtonLabel: "Submit",
    successDescription: "Please check your e-mail, you will receive soon the information on your account to start with the password reset process.",
    successTitle: "Your request has been received.",
    title: "Please enter your email address to reset your password:"
  },
  loginModalScene: {
    copy: "Login or create an account to get all the Miele features.",
    title: "Login to your account"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Forgot my password",
    invalidEmailMessage: "E-Mail not valid!",
    loginButtonLabel: "Login",
    passwordInputLabel: "Password",
    rememberMeLabel: "Remember me",
    title: "Log in with your email and password:"
  }
}, Xc = {
  accessibility: {
    close: "Close"
  }
}, Qc = {
  tooShort: "Too Short",
  medium: "Medium",
  strong: "Strong",
  tooWeak: "Too Weak",
  veryStrong: "Very Strong",
  weak: "Weak"
}, ed = {
  showPasswordText: "Show",
  hidePasswordText: "Hide"
}, td = {
  registerButtonLabel: "register",
  registerTitle: "Don't have an account?",
  whyRegister: {
    list: [
      "Access to exclusive benefits from Miele Club",
      "Register appliances, track orders, access manuals",
      "Receive personalized offers and promotions",
      "See all your orders, warranties, events and services"
    ],
    title: "Why register?"
  },
  closeButtonLabel: "Close",
  passwordMismatchError: "The passwords do not match",
  passwordUpdateErrorTitle: "Password update error",
  passwordUpdateSuccessTitle: "Password updated",
  successfulChangeLabel: "Your password has been successfully updated"
}, id = {
  title: "Marketing Preferences",
  description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
  submit: "Save",
  levelOne: {
    text: `Yes, I would like to receive promotional communications from Miele Pte Ltd. and Miele & Cie. KG ("Miele") tailored to my personal interests by email, text message, post and via the Miele apps (if used) with information on products, offers and innovations from the Miele product range and on Miele events as well as customer surveys, product rating and review requests and recipes. For this purpose, Miele may use my contact information (title, name, email address, mobile phone number and postal address) and design the communication based on my purchase, service, event history, newsletter click and open behavior as well as customer value, as described in detail in our privacy policy. I can revoke my consent at any time without giving reasons with effect for the future (e.g. by sending an informal message to info{'@'}miele.sg, the contact details given in the imprint or by clicking on the unsubscribe link in emails).`,
    link: {
      title: "Privacy Policy",
      ref: "https://www.miele.sg/domestic/privacy-notice-46.htm"
    }
  },
  levelTwo: {
    text: "In addition to my basic consent, I agree that Miele may also process data from the use of the Miele app and my visits to Miele websites (www.miele.sg), including user behavior on the Miele websites after linked newsletter clicks, to supplement my user profile for personalized advertising communications, provided that my separate consent in the app or on the website releases the data processing. I can revoke my consent at any time without giving reasons with effect for the future. Further details in Miele's data protection policy.",
    link: {
      title: "See data protection policy",
      ref: "https://www.miele.sg/domestic/privacy-notice-46.htm"
    }
  },
  levelThree: {
    text: "In addition to my basic consent, I agree that Miele may also process data from my connected Miele appliances (data on appliance usage and status) to supplement my user profile for personalized advertising. I can find more information about the processing of device data in the privacy policy about the Miele{'@'}Home system. I can revoke my consent at any time without giving reasons with effect for the future. Further details in Miele's data protection policy.",
    link: {
      title: "Privacy Policy Miele{'@'}home",
      ref: "https://www.miele.sg/domestic/privacy-notice-46.htm"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Yes, I agree to the terms of use.",
    link: {
      title: "See Terms of Use*",
      ref: "https://www.miele.sg/domestic/terms-and-conditions-48.htm"
    }
  }
}, nd = {
  headline: "Miele Club",
  birthDateTitle: "Would you like to receive a birthday surprise?",
  birthDateLabel: "Your date of birth (optional)",
  why: {
    title: "Free membership - Exclusive offers for members.",
    reasons: [
      "£ 10 Welcome voucher",
      "Birthday surprise",
      "Special sale offers",
      "Invites to exclusive events & experiences"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Please enter this date format: DD/MM/YYYY",
    errorMsg: "Incorrect date"
  },
  joinClubLabel: "Yes, I would like to join the Miele Club.",
  termsAndCondition: {
    description: "I consent to the Miele Club {termsAndConditionLink} and acknowledge the {privacyLink} information regarding the Miele Club.",
    termsAndConditionLink: {
      title: "Terms and Conditions",
      ref: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Data privacy",
      ref: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Yes, I would like to receive Club marketing communications that are tailored to my personal interests from the Miele Co Ltd. (“Miele”) via e-mail and in the post",
    description: "Yes, I would like to receive Club marketing communications that are tailored to my personal interests from the Miele Co Ltd. (“Miele”) via e-mail and in the post including special offers, information, event invitations and customer surveys on our products and services. To do this, Miele may use my contact details (title, name, e-mail and postal address) and personalise the communications based on my purchasing behaviour, how I interact with the newsletter and my status as a customer, as described in more detail in our {privacyLink}. I may withdraw my consent with effect for the future at any time (for example, by sending an e-mail to info{'@'}miele.co.uk, getting in touch via the contact details provided in the legal notice or clicking the unsubscribe link in e-mails). Contractual Club {termsAndConditionLink} are not affected by this unless I terminate my membership.",
    privacyLink: {
      title: "Club privacy notice",
      href: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "communications",
      href: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.co.uk"
  },
  selectAllConsents: {
    description: "To join the Miele Club, you must agree to all the terms and conditions *"
  }
}, ad = "show full statement", sd = "hide full statement", od = {
  auth: Kc,
  changeEmailScene: Hc,
  changePasswordScene: Wc,
  errors: Jc,
  forgotPassword: Zc,
  login: Yc,
  modal: Xc,
  passwordStrength: Qc,
  passwordHelper: ed,
  register: td,
  "marketing-consent": {
    title: "Marketing Preferences",
    description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
    submit: "Save",
    newsletter: {
      text: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps and SMS and that Miele may process the contact details I have provided (title, name, email address, mobile phone number and postcode) and the Miele products I have purchased to date and will purchase in the future as well as the interests I have indicated for this purpose. I further agree that Miele may also process receipt and read confirmations received via the newsletter and information about the links I have clicked on as well as my related user behaviour on the linked website for the purpose of personalisation. The same applies to in-app push messages, insofar as the Miele apps are used.',
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    personalisation: {
      text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "In addition to the extended personalisation, I agree that Miele may also process data from the use of the Miele app and my visits to the Miele websites (www.miele.co.uk) to supplement my user profile, provided that I have separately consented to the processing of this data.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    highlightedText: {
      text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
      link: {
        title: "data protection policy.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Yes, I agree to the terms of use.",
      link: {
        title: "See Terms of Use*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: id,
  mieleClub: nd,
  readMore: ad,
  readLess: sd
}, rd = {
  waitMessage: "Nearly there. Hang tight ..."
}, ld = {
  buttonLabel: "Save",
  buttonLabelClose: "Close",
  confirmEmailMessage: "Confirm your e-mail adress",
  copy: "To update your email address, please add the new one below:",
  errorMessageCopy: "Something went wrong. Try again.",
  errorMessageHeadline: "Error",
  headline: "Profile Details",
  inputEmailConfirmPlaceholder: "Confirm your e-mail address",
  inputEmailPlaceholder: "E-mail address",
  invalidEmailMessage: "E-Mail not valid!",
  rememberMeLabel: "Remember me",
  successMessageCopy: "Your email address was successfully updated.",
  successMessageHeadline: "E-mail address updated"
}, cd = {
  closeButtonLabel: "Close",
  confirmPasswordLabel: "Confirm Password",
  currentPasswordLabel: "Current Password",
  newPasswordLabel: "New Password",
  passwordMismatchError: "Password does not match",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Password updated",
  samePasswordError: "This password was used previously, please submit a new password",
  subtitle: "To change your password, please fill in the fields below:",
  submitButtonLabel: "Submit",
  successfulChangeLabel: "Your password has been successfully updated",
  title: "Password Change"
}, dd = {
  invalidEmail: "Incorrect Email",
  invalidPassword: "Wrong password",
  sap_206002: "Your account is pending verification, I'm afraid we can't let you proceed at the moment. Please contact us for more details.",
  sap_206006: "Looks like the email address you submitted is pending verification",
  sap_400003: "This email already exists, please use a different email address.",
  sap_400028: "The email address submitted  is pending verification",
  sap_400050: "Sorry, we're unable to validate your credentials at this moment.",
  sap_400097: "Looks like you are accessing our services fom an insecure/unsupported browser. Please try again with another browswer",
  sap_401030: "This password was used previously, please submit a new password",
  sap_403005: "We do not have an account associated with this email address, please check your email and try again",
  sap_403011: "Session expired. Please reload the browser and sign-in again.",
  sap_403012: "Session expired. Please reload the browser and sign-in again.",
  sap_403013: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403035: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403041: "We do not have an account associated with this email address, please check your email and try again",
  sap_403042: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403043: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403047: "No account found with this email address. Please check the email address or create a new account.",
  sap_403100: "A request for password update is recently requested, please bare with us until the request is processed",
  sap_403025: "Reset password link invalid, please send forgot password request again to receive new reset link.",
  sapErrorTitle: "Error Processing Request",
  sessionExpired: "Session expired",
  tooWeakPassword: "Password must contain at least {minLength} characters and {minCharGroups} of the following: uppercase letter, lowercase letter, number, special symbol | Password must contain at least {minLength} characters",
  unexpectedDescription: "If the issue persists please get in touch with us via the contact form with details.",
  unexpectedTitle: "An unexpected error occured",
  unknownDescription: "Unexpected error ocurred. Please try again.",
  unknownTitle: "Uh Oh!"
}, ud = {
  subtitle: "Set your new password.",
  title: "Forgot your password?"
}, md = {
  headMetaDescription: "Customer login page",
  headTitle: "Log in with your email and password:",
  subtitle: "Login or create an account to get all the Miele features.",
  title: "Login to your account",
  error: {
    invalidEmailPasswordDescription: "The combination of email address and password is not valid.",
    invalidEmailPasswordTitle: "Invalid credentials",
    missingConcentTitle: "Account Pending Registration",
    noAccountDescription: "There is no account associated to this email address.",
    noAccountTitle: "No account registered"
  },
  extraConsentScene: {
    continue: "Continue",
    privacyStatementCheckboxLabel: "I have taken note of the {0}.",
    privacyStatementName: "privacy statement",
    privacyStatementTitle: "Our Privacy Policy has changed",
    termsOfUseCheckboxLabel: "I agree to the {0}.",
    termsOfUseName: "terms of use",
    termsOfUseTitle: "Our Terms of Use have changed",
    title: "Profile completion"
  },
  forgotPasswordScene: {
    backButtonLabel: "Back to Login",
    submitButtonLabel: "Submit",
    successDescription: "Please check your e-mail, you will receive soon the information on your account to start with the password reset process.",
    successTitle: "Your request has been received.",
    title: "Please enter your email address to reset your password:"
  },
  loginModalScene: {
    copy: "Login or create an account to get all the Miele features.",
    title: "Login to your account"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Forgot my password",
    invalidEmailMessage: "E-Mail not valid!",
    loginButtonLabel: "Login",
    passwordInputLabel: "Password",
    rememberMeLabel: "Remember me",
    title: "Log in with your email and password:"
  }
}, pd = {
  accessibility: {
    close: "Close"
  }
}, hd = {
  tooShort: "Too Short",
  medium: "Medium",
  strong: "Strong",
  tooWeak: "Too Weak",
  veryStrong: "Very Strong",
  weak: "Weak"
}, gd = {
  showPasswordText: "Show",
  hidePasswordText: "Hide"
}, vd = {
  registerButtonLabel: "register",
  registerTitle: "Don't have an account?",
  whyRegister: {
    list: [
      "Register appliances, track orders, access manuals",
      "Receive personalized offers and promotions",
      "See all your orders, warranties, events and services"
    ],
    title: "Why register?"
  },
  closeButtonLabel: "Close",
  passwordMismatchError: "The passwords do not match",
  passwordUpdateErrorTitle: "Password update error",
  passwordUpdateSuccessTitle: "Password updated",
  successfulChangeLabel: "Your password has been successfully updated"
}, fd = {
  title: "Marketing Preferences",
  description: "Check below for the ultimate personalized Miele experience with offers, events and product content even more tailored for you.",
  submit: "Save",
  levelOne: {
    text: 'By checking this box, I acknowledge and agree that (i) I am a U.S. resident, (ii) at least 18 years of age and that (iii) Miele, Incorporated or any of its affiliates ("Miele") may collect and process personal information about and from me (e.g. name, email address, phone number, postal code, purchase history, receipt and read confirmations via Miele newsletters) and track my use of the Miele apps and Miele websites for the purposes listed in the Miele privacy policy, which includes a notice at collection (together, the ”Privacy Policy”), and I have read and understand the terms of the Privacy Policy. I further acknowledge and agree that among other purposes listed in the privacy policy, Miele may send me information about the Miele product assortment and events as well as customer surveys, product ratings and reviews, and recipes as newsletters or otherwise via email. Further details in Miele’s data protection policy. I understand that I may revoke my consent at any time with or without reason through the methods mentioned in the privacy policy.',
    link: {
      title: "See data protection policy",
      ref: "https://www.mieleusa.com/c/privacy-policy-14.htm"
    }
  },
  levelTwo: {
    text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
    link: {
      title: "See data protection policy",
      ref: "https://www.mieleusa.com/c/privacy-policy-14.htm"
    }
  },
  levelThree: {
    text: "I agree that Miele may also process data from my connected Miele appliances (data on appliance usage and status) to supplement my user profile for personalized advertising. I can find more information about the processing of device data in the privacy policy about the Miele{'@'}Home system. I can revoke my consent at any time without giving reasons with effect for the future.",
    link: {
      title: "Privacy Policy Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
    link: {
      title: "data protection policy.",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Yes, I agree to the terms of use.",
    link: {
      title: "See Terms of Use*",
      ref: "https://www.mieleusa.com/c/terms-of-use-304.htm"
    }
  }
}, kd = {
  headline: "Miele Club",
  birthDateTitle: "Can we send you a birthday gift?",
  birthDateLabel: "Birthday (optional)",
  why: {
    title: "Membership",
    reasons: [
      "Birthday surprise",
      "Exclusive offers and campaigns",
      "Welcome gift",
      "VIP offers and experiences",
      "Attractive savings",
      "Club news"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Use format like MM/DD/YYYY",
    errorMsg: "Invalid date"
  },
  joinClubLabel: "Yes, I want to join the Miele club.",
  termsAndCondition: {
    description: "I consent to the Miele Club {termsAndConditionLink} and acknowledge the {privacyLink} information regarding the Miele Club.",
    termsAndConditionLink: {
      title: "Terms and Conditions",
      ref: "https://www.mieleusa.com/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Data privacy",
      ref: "https://www.mieleusa.com/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Yes, I would like to receive Miele Club promotional communication, tailored to my personal interests, via email and in the post",
    description: "Yes, I would like to receive Miele Club promotional communication, tailored to my personal interests, via email and in the post including special offers, information, invitations to events and customer surveys about Miele products and services. For this purpose, Miele can use my contact information (title, name, e-mail and postal address) and adapt the communication on the basis of my purchase and newsletter behavior, as well as my customer value, as described in more detail in our {privacyLink}. I may revoke my consent with effect for the future at any time (for example, by sending an email to info{'@'}mieleusa.com, getting in touch via the contact details provided in the legal notice or clicking the unsubscribe link in e-mails). The contractual Miele Club communications {termsAndConditionLink} are not affected by this unless I terminate my membership.",
    privacyLink: {
      title: "Miele Club data privacy",
      href: "https://www.mieleusa.com/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Club communication",
      href: "https://www.mieleusa.com/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}mieleusa.com"
  },
  selectAllConsents: {
    description: "To join the Miele Club, you must agree to all the terms and conditions *"
  }
}, bd = "show full statement", wd = "hide full statement", yd = {
  auth: rd,
  changeEmailScene: ld,
  changePasswordScene: cd,
  errors: dd,
  forgotPassword: ud,
  login: md,
  modal: pd,
  passwordStrength: hd,
  passwordHelper: gd,
  register: vd,
  "marketing-consent": {
    title: "Marketing Preferences",
    description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
    submit: "Save",
    newsletter: {
      text: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps and SMS and that Miele may process the contact details I have provided (title, name, email address, mobile phone number and postcode) and the Miele products I have purchased to date and will purchase in the future as well as the interests I have indicated for this purpose. I further agree that Miele may also process receipt and read confirmations received via the newsletter and information about the links I have clicked on as well as my related user behaviour on the linked website for the purpose of personalisation. The same applies to in-app push messages, insofar as the Miele apps are used.',
      link: {
        title: "See data protection policy",
        ref: "https://www.mieleusa.com/c/privacy-policy-14.htm"
      }
    },
    personalisation: {
      text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "In addition to the extended personalisation, I agree that Miele may also process data from the use of the Miele app and my visits to the Miele websites (www.miele.co.uk) to supplement my user profile, provided that I have separately consented to the processing of this data.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    highlightedText: {
      text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
      link: {
        title: "data protection policy.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Yes, I agree to the terms of use.",
      link: {
        title: "See Terms of Use*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: fd,
  mieleClub: kd,
  readMore: bd,
  readLess: wd
}, Md = {
  waitMessage: "Casi listo. Espere un momento..."
}, zd = {
  buttonLabel: "Guardar",
  buttonLabelClose: "Cerrar",
  confirmEmailMessage: "Confirme su dirección de correo electrónico",
  copy: "Para actualizar su dirección de correo electrónico, por favor agregue la nueva dirección debajo:",
  errorMessageCopy: "Algo salió mal. Inténtelo de nuevo.",
  errorMessageHeadline: "Error",
  headline: "Detalles del perfil",
  inputEmailConfirmPlaceholder: "Confirme su dirección de correo electrónico",
  inputEmailPlaceholder: "Dirección de correo electrónico",
  invalidEmailMessage: "¡El correo electrónico no es válido!",
  rememberMeLabel: "Recuérdame",
  successMessageCopy: "Su dirección de correo electrónico se ha actualizado correctamente.",
  successMessageHeadline: "Dirección de correo electrónico actualizada"
}, jd = {
  closeButtonLabel: "Cerrar",
  confirmPasswordLabel: "Confirmar contraseña",
  currentPasswordLabel: "Contraseña actual",
  newPasswordLabel: "Nueva contraseña",
  passwordMismatchError: "La contraseña no coincide",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Contraseña actualizada",
  samePasswordError: "Esta contraseña fue utilizada anteriormente, por favor envíe una nueva contraseña",
  subtitle: "Para cambiar su contraseña, por favor complete los campos a continuación:",
  submitButtonLabel: "Enviar",
  successfulChangeLabel: "Su contraseña se ha actualizado correctamente",
  title: "Cambio de contraseña"
}, _d = {
  invalidEmail: "Correo electrónico incorrecto",
  invalidPassword: "Contraseña incorrecta",
  sap_206002: "Su cuenta está pendiente de verificación, lamentablemente no podemos permitir que proceda en este momento. Por favor contáctenos para más detalles.",
  sap_206006: "Parece que la dirección de correo electrónico que proporcionó está pendiente de verificación",
  sap_400003: "¡Esta dirección de correo electrónico ya existe, por favor use una dirección de correo electrónico diferente!",
  sap_400028: "La dirección de correo electrónico enviada está pendiente de verificación",
  sap_400050: "Lo siento, no podemos validar sus credenciales en este momento.",
  sap_400097: "Parece que está accediendo a nuestros servicios desde un navegador inseguro/no compatible. Por favor, intente de nuevo con otro navegador.",
  sap_401030: "Esta contraseña fue utilizada previamente, por favor envíe una nueva contraseña",
  sap_403005: "No tenemos una cuenta asociada a esta dirección de correo electrónico, por favor revise su correo electrónico e intente de nuevo",
  sap_403011: "La sesión ha expirado. Por favor, recargue el navegador e inicie sesión de nuevo.",
  sap_403012: "La sesión ha expirado. Por favor, recargue el navegador e inicie sesión de nuevo.",
  sap_403013: "Lo siento, no podemos validar sus credenciales en este momento",
  sap_403035: "Lo siento, no podemos validar sus credenciales en este momento",
  sap_403041: "No tenemos una cuenta asociada con esta dirección de correo electrónico, por favor revise su correo electrónico e intente de nuevo",
  sap_403042: "La combinación de correo electrónico y contraseña no es válida. Por favor, compruebe el correo electrónico asociado a la cuenta o elija 'olvidé mi contraseña' si desea restablecerla.",
  sap_403043: "La combinación de correo electrónico y contraseña no es válida. Por favor, compruebe el correo electrónico asociado a la cuenta o elija 'olvidé mi contraseña' si desea restablecerla.",
  sap_403047: "La combinación de correo electrónico y contraseña no es válida. Por favor, compruebe el correo electrónico asociado a la cuenta o elija 'olvidé mi contraseña' si desea restablecerla.",
  sap_403100: "Recientemente se solicitó una actualización de la contraseña, por favor espere a que la solicitud sea procesada",
  sap_403025: "El enlace de restablecimiento de contraseña no es válido, envíe nuevamente la solicitud de contraseña olvidada para recibir un nuevo enlace de restablecimiento.",
  sapErrorTitle: "Error procesando la solicitud",
  sessionExpired: "La sesión ha expirado",
  tooWeakPassword: "La contraseña debe contener al menos {minLength} caracteres y {minCharGroups} de los siguientes: letra mayúscula, letra minúscula, número, símbolo especial | La contraseña debe contener al menos {minLength} caracteres",
  unexpectedDescription: "Si el problema persiste, comuníquese con nosotros a través del formulario de contacto con los detalles.",
  unexpectedTitle: "Ha ocurrido un error inesperado",
  unknownDescription: "Error inesperado. Por favor, inténtelo de nuevo.",
  unknownTitle: "¡Uh Oh!"
}, Sd = {
  subtitle: "Establecer su nueva contraseña.",
  title: "¿Olvidó su contraseña?"
}, Cd = {
  headMetaDescription: "Página de inicio de sesión del cliente",
  headTitle: "Inicie sesión con su correo electrónico y contraseña:",
  subtitle: "Inicie sesión o cree una cuenta para obtener todas las características de Miele.",
  title: "Inicie sesión en su cuenta",
  error: {
    invalidEmailPasswordDescription: "La combinación de dirección de correo electrónico y contraseña no es válida.",
    invalidEmailPasswordTitle: "Credenciales inválidas",
    missingConcentTitle: "Cuenta pendiente de registro",
    noAccountDescription: "No hay ninguna cuenta asociada a esta dirección de correo electrónico.",
    noAccountTitle: "Ninguna cuenta registrada"
  },
  extraConsentScene: {
    continue: "Continuar",
    privacyStatementCheckboxLabel: "He tomado nota de la {0}.",
    privacyStatementName: "declaración de privacidad",
    privacyStatementTitle: "Nuestra política de privacidad ha cambiado",
    termsOfUseCheckboxLabel: "Acepto los {0}.",
    termsOfUseName: "términos de uso",
    termsOfUseTitle: "Nuestros Términos de Uso han cambiado",
    title: "Completar perfil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Volver al inicio de sesión",
    submitButtonLabel: "Enviar",
    successDescription: "Por favor, revise su correo electrónico, pronto recibirá la información de su cuenta para comenzar con el proceso de restablecimiento de contraseña.",
    successTitle: "Hemos recibido su solicitud.",
    title: "Por favor ingrese su dirección de correo electrónico para restablecer su contraseña:"
  },
  loginModalScene: {
    copy: "Inicie sesión o cree una cuenta para obtener todas las funciones de Miele.",
    title: "Iniciar sesión en su cuenta"
  },
  loginScene: {
    emailInputLabel: "Correo electrónico",
    forgotPwdButtonLabel: "Olvidé mi contraseña",
    invalidEmailMessage: "¡El correo electrónico no es válido!",
    loginButtonLabel: "Ingresar",
    passwordInputLabel: "Contraseña",
    rememberMeLabel: "Recordarme",
    title: "Inicie sesión con su correo electrónico y contraseña:"
  }
}, Ld = {
  accessibility: {
    close: "Cerrar"
  }
}, Ed = {
  tooShort: "Demasiado corta",
  medium: "Media",
  strong: "Fuerte",
  tooWeak: "Muy débil",
  veryStrong: "Muy fuerte",
  weak: "Débil"
}, Pd = {
  showPasswordText: "Mostrar",
  hidePasswordText: "Ocultar"
}, Td = {
  registerButtonLabel: "Registrar",
  registerTitle: "¿No tiene una cuenta?",
  whyRegister: {
    list: {
      0: "Acceso a beneficios exclusivos del Club Miele",
      1: "Registrar electrodomésticos, hacer seguimiento de pedidos, acceder a manuales",
      2: "Recibir ofertas y promociones personalizadas",
      3: "Ver todos sus pedidos, garantías, eventos y servicios"
    },
    title: "¿Por qué registrarse?"
  },
  closeButtonLabel: "Cerrar",
  passwordMismatchError: "Las contraseñas no coinciden",
  passwordUpdateErrorTitle: "Error al actualizar la contraseña",
  passwordUpdateSuccessTitle: "Contraseña actualizada",
  successfulChangeLabel: "Su contraseña se ha actualizado correctamente"
}, Ad = {
  title: "Preferencias de marketing",
  description: "Marque a continuación para recibir ofertas exclusivas, noticias, eventos y cómo sacar el máximo provecho de su electrodoméstico.",
  submit: "Guardar",
  levelOne: {
    shortText: 'Sí, me gustaría recibir comunicaciones promocionales de MIELE S.A.U y Miele & Cie. KG ("Miele") adaptadas a mis intereses personales por correo electrónico, mensaje de texto, correo postal y a través de las aplicaciones y sitios web de Miele (si los utilizo)',
    text: `Sí, me gustaría recibir comunicaciones promocionales de MIELE S.A.U y Miele & Cie. KG ("Miele") adaptadas a mis intereses personales por correo electrónico, mensaje de texto, correo postal y a través de las aplicaciones y sitios web de Miele (si los utilizo) con información sobre productos, ofertas e innovaciones de la gama de productos de Miele y sobre eventos de Miele, así como encuestas de clientes, solicitudes de valoración y reseñas de productos y recetas. Para este fin, Miele puede utilizar mi información de contacto (título, nombre, dirección de correo electrónico, número de teléfono móvil y dirección postal) y diseñar la comunicación basándose en mi compra, servicio, historial de eventos, comportamiento de clics y apertura de boletines, así como en el valor del cliente, tal y como se describe detalladamente en nuestra política de privacidad. Puedo revocar mi consentimiento en cualquier momento sin indicar los motivos con efecto para el futuro (por ejemplo, enviando un mensaje informal a info{'@'}miele.es, a los datos de contacto que figuran en el pie de página o haciendo clic en el enlace para darse de baja en los correos electrónicos).`,
    link: {
      title: "Privacidad",
      ref: "https://www.miele.es/c/proteccion-de-datos-14.htm"
    }
  },
  levelTwo: {
    text: "Además de mi consentimiento básico, acepto que Miele también pueda procesar datos procedentes del uso de la app de Miele y de mis visitas a los sitios web de Miele (www.miele.es), incluido el comportamiento del usuario en los sitios web de Miele después de hacer clic en el boletín vinculado, para complementar mi perfil de usuario para comunicaciones publicitarias personalizadas, siempre que mi consentimiento por separado en la app o en el sitio web libere el procesamiento de datos. Puedo revocar mi consentimiento en cualquier momento sin indicar los motivos con efecto para el futuro. Más detalles en la política de protección de datos de Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Además de mi consentimiento básico, acepto que Miele también procese datos de mis aparatos Miele conectados (datos sobre el uso y el estado de los aparatos) para complementar mi perfil de usuario para publicidad personalizada. Puedo encontrar más información sobre el tratamiento de los datos de los aparatos en la política de privacidad sobre el sistema Miele{'@'}Home. Puedo revocar mi consentimiento en cualquier momento sin indicar los motivos con efecto para el futuro. Más detalles en la política de protección de datos de Miele.",
    link: {
      title: "Privacy Policy Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Sí, estoy de acuerdo con los términos de uso.",
    link: {
      title: "Ver términos de uso",
      ref: "https://www.miele.es/c/condiciones-de-uso-304.htm"
    }
  }
}, xd = {
  headline: "Miele Club",
  why: {
    title: "Formar parte del Miele Club es gratuito - Ventajas exclusivas para socios.",
    reasons: [
      "Regalo de bienvenida: 10% de descuento en Accesorios y Consumibles para tu próxima compra con el cupón de Bienvenida. Consulta las condiciones en www.miele.es/e/miele-club",
      "Regalo de cumpleaños",
      "Promociones especiales",
      "Invitaciones a eventos y experiencias exclusivas"
    ]
  },
  birthDateTitle: "¿Te gustaría recibir una sorpresa de cumpleaños?",
  birthDateLabel: "Fecha de nacimiento (opcional)",
  birthDateValidation: {
    requirementMsg: "Introduce la fecha con este formato: DD/MM/AAAA",
    errorMsg: "Fecha incorrecta"
  },
  joinClubLabel: "Sí, me gustaría unirme al Club Miele",
  termsAndCondition: {
    description: "Acepto las {termsAndConditionLink} y confirmo que he leído y comprendido la {privacyLink}",
    termsAndConditionLink: {
      title: "Condiciones de participación y uso del Club Miele",
      ref: "https://www.miele.es/c/terminos-y-condiciones-generales-13.htm#p7846"
    },
    privacyLink: {
      title: "Privacidad del Miele Club",
      ref: "https://www.miele.es/c/proteccion-de-datos-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Sí, me gustaría recibir comunicaciones del Club adaptadas a mis intereses personales por parte de MIELE S.A.U («Miele») por e-mail y por correo postal",
    description: "Sí, me gustaría recibir comunicaciones del Club adaptadas a mis intereses personales por parte de MIELE S.A.U («Miele») por e-mail y por correo postal con promociones especiales, información de producto, invitaciones a eventos y encuestas sobre los productos y servicios de Miele. Con este fin, Miele puede usar mis datos de contacto (tratamiento, nombre, correo electrónico y dirección postal) y diseñar comunicaciones basadas en mi comportamiento de compra y en mis pedidos, tal y como se describe con más detalle en nuestro Aviso {privacyLink}. Puedo revocar mi consentimiento en cualquier momento con efecto futuro (p. ej. con un mensaje a info{'@'}miele.es , a los datos postales incluidos en el Aviso legal o haciendo clic en el enlace de darse de baja de los correos electrónicos). La comunicación contractual del Miele Club {termsAndConditionLink} no se verá afectada por ello hasta que se cancele la membresía.",
    privacyLink: {
      title: "Privacidad del Miele Club",
      href: "https://www.miele.es/c/proteccion-de-datos-14.htm"
    },
    termsAndConditionLink: {
      title: "Comunicación contractual del Miele Club ",
      href: "https://www.miele.es/c/terminos-y-condiciones-generales-13.htm#p7846"
    },
    supportEmail: "info{'@'}miele.es"
  },
  selectAllConsents: {
    description: "Para unirse al Miele Club, debe aceptar todos los términos y condiciones *"
  }
}, Id = "mostrar declaración completa", Dd = "ocultar declaración completa", Nd = {
  auth: Md,
  changeEmailScene: zd,
  changePasswordScene: jd,
  errors: _d,
  forgotPassword: Sd,
  login: Cd,
  modal: Ld,
  passwordStrength: Ed,
  passwordHelper: Pd,
  register: Td,
  "marketing-consent": {
    title: "Preferencias de marketing",
    description: "Marque a continuación para recibir ofertas exclusivas, noticias, eventos y cómo sacar el máximo provecho de su electrodoméstico.",
    submit: "Guardar",
    newsletter: {
      text: 'Acepto que MIELE S.A.U ("Miele") me envíe información sobre productos e innovaciones de la gama de productos de Miele y sobre eventos de Miele, así como encuestas de clientes, reseñas de productos y recetas por correo electrónico, las aplicaciones de Miele y SMS, y que Miele procese los datos de contacto que he proporcionado (título, nombre, dirección de correo electrónico, número de teléfono móvil y código postal) y los productos de Miele que he comprado hasta la fecha y que compraré en el futuro , así como los intereses que he indicado para este fin. Asimismo, acepto que Miele procese las confirmaciones de recepción y lectura recibidas a través del boletín informativo y la información sobre los enlaces en los que he hecho clic, así como mi comportamiento de usuario relacionado en el sitio web vinculado con fines de personalización. Lo mismo se aplica a los mensajes push in-app, en la medida en que se utilicen las aplicaciones de Miele. ',
      link: {
        title: "Puede encontrar más información de la Política de Privacidad de Miele",
        ref: "https://www.miele.es/c/proteccion-de-datos-14.htm"
      }
    },
    personalisation: {
      text: "Estoy de acuerdo en que Miele pueda procesar información sobre los servicios que he utilizado y las asignaciones de técnicos que he llevado a cabo, así como los eventos a los que he asistido, con el fin de mejorar la personalización. ",
      link: {
        title: "Puede encontrar más información de la Política de Privacidad de Miele",
        ref: "https://www.miele.es/c/proteccion-de-datos-14.htm"
      }
    },
    extendedPersonalisation: {
      text: "Además de la personalización extendida, estoy de acuerdo en que Miele también pueda procesar los datos del uso de la aplicación de Miele y mis visitas a los sitios web de Miele (www.miele.co.uk) para completar mi perfil de usuario, siempre y cuando haya dado mi consentimiento por separado para el procesamiento de estos datos. ",
      link: {
        title: "Puede encontrar más información de la Política de Privacidad de Miele",
        ref: "https://www.miele.es/c/proteccion-de-datos-14.htm"
      }
    },
    highlightedText: {
      text: "Puedo revocar mi consentimiento en cualquier momento sin dar razones con efectos para el futuro. Para obtener más información sobre cómo Miele maneja sus datos, consulte la ",
      link: {
        title: "política de protección de datos de Miele.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Sí, estoy de acuerdo con los términos de uso.",
      link: {
        title: "Ver términos de uso",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: Ad,
  mieleClub: xd,
  readMore: Id,
  readLess: Dd
}, Od = {
  waitMessage: "Casi listo. Espere un momento..."
}, Ud = {
  buttonLabel: "Guardar",
  buttonLabelClose: "Cerrar",
  confirmEmailMessage: "Confirme su dirección de correo electrónico",
  copy: "Para actualizar su dirección de correo electrónico, por favor agregue la nueva dirección debajo:",
  errorMessageCopy: "Algo salió mal. Inténtelo de nuevo.",
  errorMessageHeadline: "Error",
  headline: "Detalles del perfil",
  inputEmailConfirmPlaceholder: "Confirme su dirección de correo electrónico",
  inputEmailPlaceholder: "Dirección de correo electrónico",
  invalidEmailMessage: "¡El correo electrónico no es válido!",
  rememberMeLabel: "Recuérdame",
  successMessageCopy: "Su dirección de correo electrónico se ha actualizado correctamente.",
  successMessageHeadline: "Dirección de correo electrónico actualizada"
}, $d = {
  closeButtonLabel: "Cerrar",
  confirmPasswordLabel: "Confirmar contraseña",
  currentPasswordLabel: "Contraseña actual",
  newPasswordLabel: "Nueva contraseña",
  passwordMismatchError: "La contraseña no coincide",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Contraseña actualizada",
  samePasswordError: "Esta contraseña fue utilizada anteriormente, por favor envíe una nueva contraseña",
  subtitle: "Para cambiar su contraseña, por favor complete los campos a continuación:",
  submitButtonLabel: "Enviar",
  successfulChangeLabel: "Su contraseña se ha actualizado correctamente",
  title: "Cambio de contraseña"
}, Bd = {
  invalidEmail: "Correo electrónico incorrecto",
  invalidPassword: "Contraseña incorrecta",
  sap_206002: "Su cuenta está pendiente de verificación, lamentablemente no podemos permitir que proceda en este momento. Por favor contáctenos para más detalles.",
  sap_206006: "Parece que la dirección de correo electrónico que proporcionó está pendiente de verificación",
  sap_400003: "¡Esta dirección de correo electrónico ya existe, por favor use una dirección de correo electrónico diferente!",
  sap_400028: "La dirección de correo electrónico enviada está pendiente de verificación",
  sap_400050: "Lo siento, no podemos validar sus credenciales en este momento.",
  sap_400097: "Parece que está accediendo a nuestros servicios desde un navegador inseguro/no compatible. Por favor, intente de nuevo con otro navegador.",
  sap_401030: "Esta contraseña fue utilizada previamente, por favor envíe una nueva contraseña",
  sap_403005: "No tenemos una cuenta asociada a esta dirección de correo electrónico, por favor revise su correo electrónico e intente de nuevo",
  sap_403011: "La sesión ha expirado. Por favor, recargue el navegador e inicie sesión de nuevo.",
  sap_403012: "La sesión ha expirado. Por favor, recargue el navegador e inicie sesión de nuevo.",
  sap_403013: "Lo siento, no podemos validar sus credenciales en este momento",
  sap_403035: "Lo siento, no podemos validar sus credenciales en este momento",
  sap_403041: "No tenemos una cuenta asociada con esta dirección de correo electrónico, por favor revise su correo electrónico e intente de nuevo",
  sap_403042: "La combinación de correo electrónico y contraseña no es válida. Por favor, compruebe el correo electrónico asociado a la cuenta o elija 'olvidé mi contraseña' si desea restablecerla.",
  sap_403043: "La combinación de correo electrónico y contraseña no es válida. Por favor, compruebe el correo electrónico asociado a la cuenta o elija 'olvidé mi contraseña' si desea restablecerla.",
  sap_403047: "La combinación de correo electrónico y contraseña no es válida. Por favor, compruebe el correo electrónico asociado a la cuenta o elija 'olvidé mi contraseña' si desea restablecerla.",
  sap_403100: "Recientemente se solicitó una actualización de la contraseña, por favor espere a que la solicitud sea procesada",
  sap_403025: "El enlace de restablecimiento de contraseña no es válido, envíe nuevamente la solicitud de contraseña olvidada para recibir un nuevo enlace de restablecimiento.",
  sapErrorTitle: "Error procesando la solicitud",
  sessionExpired: "La sesión ha expirado",
  tooWeakPassword: "La contraseña debe contener al menos {minLength} caracteres y {minCharGroups} de los siguientes: letra mayúscula, letra minúscula, número, símbolo especial | La contraseña debe contener al menos {minLength} caracteres",
  unexpectedDescription: "Si el problema persiste, comuníquese con nosotros a través del formulario de contacto con los detalles.",
  unexpectedTitle: "Ha ocurrido un error inesperado",
  unknownDescription: "Error inesperado. Por favor, inténtelo de nuevo.",
  unknownTitle: "¡Uh Oh!"
}, Rd = {
  subtitle: "Establecer su nueva contraseña.",
  title: "¿Olvidó su contraseña?"
}, Fd = {
  headMetaDescription: "Página de inicio de sesión del cliente",
  headTitle: "Inicie sesión con su correo electrónico y contraseña:",
  subtitle: "Inicie sesión o cree una cuenta para obtener todas las características de Miele.",
  title: "Inicie sesión en su cuenta",
  error: {
    invalidEmailPasswordDescription: "La combinación de dirección de correo electrónico y contraseña no es válida.",
    invalidEmailPasswordTitle: "Credenciales inválidas",
    missingConcentTitle: "Cuenta pendiente de registro",
    noAccountDescription: "No hay ninguna cuenta asociada a esta dirección de correo electrónico.",
    noAccountTitle: "Ninguna cuenta registrada"
  },
  extraConsentScene: {
    continue: "Continuar",
    privacyStatementCheckboxLabel: "He tomado nota de la {0}.",
    privacyStatementName: "declaración de privacidad",
    privacyStatementTitle: "Nuestra política de privacidad ha cambiado",
    termsOfUseCheckboxLabel: "Acepto los {0}.",
    termsOfUseName: "términos de uso",
    termsOfUseTitle: "Nuestros Términos de Uso han cambiado",
    title: "Completar perfil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Volver al inicio de sesión",
    submitButtonLabel: "Enviar",
    successDescription: "Por favor, revise su correo electrónico, pronto recibirá la información de su cuenta para comenzar con el proceso de restablecimiento de contraseña.",
    successTitle: "Hemos recibido su solicitud.",
    title: "Por favor ingrese su dirección de correo electrónico para restablecer su contraseña:"
  },
  loginModalScene: {
    copy: "Inicie sesión o cree una cuenta para obtener todas las funciones de Miele.",
    title: "Iniciar sesión en su cuenta"
  },
  loginScene: {
    emailInputLabel: "Correo electrónico",
    forgotPwdButtonLabel: "Olvidé mi contraseña",
    invalidEmailMessage: "¡El correo electrónico no es válido!",
    loginButtonLabel: "Ingresar",
    passwordInputLabel: "Contraseña",
    rememberMeLabel: "Recordarme",
    title: "Inicie sesión con su correo electrónico y contraseña:"
  }
}, Vd = {
  accessibility: {
    close: "Cerrar"
  }
}, qd = {
  tooShort: "Demasiado corta",
  medium: "Media",
  strong: "Fuerte",
  tooWeak: "Muy débil",
  veryStrong: "Muy fuerte",
  weak: "Débil"
}, Gd = {
  showPasswordText: "Mostrar",
  hidePasswordText: "Ocultar"
}, Kd = {
  registerButtonLabel: "Registrar",
  registerTitle: "¿No tiene una cuenta?",
  whyRegister: {
    list: {
      0: "Acceso a beneficios exclusivos del Club Miele",
      1: "Registrar electrodomésticos, hacer seguimiento de pedidos, acceder a manuales",
      2: "Recibir ofertas y promociones personalizadas",
      3: "Ver todos sus pedidos, garantías, eventos y servicios"
    },
    title: "¿Por qué registrarse?"
  },
  closeButtonLabel: "Cerrar",
  passwordMismatchError: "Las contraseñas no coinciden",
  passwordUpdateErrorTitle: "Error al actualizar la contraseña",
  passwordUpdateSuccessTitle: "Contraseña actualizada",
  successfulChangeLabel: "Su contraseña se ha actualizado correctamente"
}, Hd = {
  title: "Preferencias de marketing",
  description: "Marque a continuación para recibir ofertas exclusivas, noticias, eventos y cómo sacar el máximo provecho de su electrodoméstico.",
  submit: "Guardar",
  levelOne: {
    shortText: 'Sí, me gustaría recibir comunicaciones promocionales de MIELE S.A.U y Miele & Cie. KG ("Miele") adaptadas a mis intereses personales por correo electrónico, mensaje de texto, correo postal y a través de las aplicaciones de Miele (si las utilizo)',
    text: `Sí, me gustaría recibir comunicaciones promocionales de MIELE S.A.U y Miele & Cie. KG ("Miele") adaptadas a mis intereses personales por correo electrónico, mensaje de texto, correo postal y a través de las aplicaciones de Miele (si las utilizo) con información sobre productos, ofertas e innovaciones de la gama de productos de Miele y sobre eventos de Miele, así como encuestas de clientes, solicitudes de valoración y reseñas de productos y recetas. Para este fin, Miele puede utilizar mi información de contacto (título, nombre, dirección de correo electrónico, número de teléfono móvil y dirección postal) y diseñar la comunicación basándose en mi compra, servicio, historial de eventos, comportamiento de clics y apertura de boletines, así como en el valor del cliente, tal y como se describe detalladamente en nuestra política de privacidad. Puedo revocar mi consentimiento en cualquier momento sin indicar los motivos con efecto para el futuro (por ejemplo, enviando un mensaje informal a info{'@'}miele.com.mx, a los datos de contacto que figuran en el pie de página o haciendo clic en el enlace para darse de baja en los correos electrónicos).`,
    link: {
      title: "Protección de datos",
      ref: "https://www.miele.com.mx/c/proteccion-de-datos-14.htm"
    }
  },
  levelTwo: {
    text: "Además de mi consentimiento básico, acepto que Miele también pueda procesar datos procedentes del uso de la app de Miele y de mis visitas a los sitios web de Miele (www.miele.com.mx), incluido el comportamiento del usuario en los sitios web de Miele después de hacer clic en el boletín vinculado, para complementar mi perfil de usuario para comunicaciones publicitarias personalizadas, siempre que mi consentimiento por separado en la app o en el sitio web libere el procesamiento de datos. Puedo revocar mi consentimiento en cualquier momento sin indicar los motivos con efecto para el futuro. Más detalles en la política de protección de datos de Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Además de mi consentimiento básico, acepto que Miele también procese datos de mis aparatos Miele conectados (datos sobre el uso y el estado de los aparatos) para complementar mi perfil de usuario para publicidad personalizada. Puedo encontrar más información sobre el tratamiento de los datos de los aparatos en la política de privacidad sobre el sistema Miele{'@'}Home. Puedo revocar mi consentimiento en cualquier momento sin indicar los motivos con efecto para el futuro. Más detalles en la política de protección de datos de Miele.",
    link: {
      title: "Privacy Policy Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Sí, estoy de acuerdo con los términos de uso.",
    link: {
      title: "Ver términos de uso",
      ref: "https://www.miele.com.mx/c/condiciones-de-uso-304.htm"
    }
  }
}, Wd = {
  headline: "Miele Club",
  why: {
    title: "Formar parte del Miele Club es gratuito - Ventajas exclusivas para socios.",
    reasons: [
      "Regalo de bienvenida: 10% de descuento en Accesorios y Consumibles para tu próxima compra con el cupón de Bienvenida. Consulta las condiciones en www.miele.com.mx/e/miele-club",
      "Regalo de cumpleaños",
      "Promociones especiales",
      "Invitaciones a eventos y experiencias exclusivas"
    ]
  },
  birthDateTitle: "¿Te gustaría recibir una sorpresa de cumpleaños?",
  birthDateLabel: "Fecha de nacimiento (opcional)",
  birthDateValidation: {
    requirementMsg: "Introduce la fecha con este formato: DD/MM/AAAA",
    errorMsg: "Fecha incorrecta"
  },
  joinClubLabel: "Sí, me gustaría unirme al Club Miele",
  termsAndCondition: {
    description: "Acepto las {termsAndConditionLink} y confirmo que he leído y comprendido la {privacyLink}",
    termsAndConditionLink: {
      title: "Condiciones de participación y uso del Club Miele",
      ref: "https://www.miele.com.mx/c/terminos-y-condiciones-generales-13.htm#p7846"
    },
    privacyLink: {
      title: "Privacidad del Miele Club",
      ref: "https://www.miele.com.mx/c/proteccion-de-datos-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Sí, me gustaría recibir comunicaciones del Club adaptadas a mis intereses personales por parte de MIELE S.A.U («Miele») por e-mail y por correo postal",
    description: "Sí, me gustaría recibir comunicaciones del Club adaptadas a mis intereses personales por parte de MIELE S.A.U («Miele») por e-mail y por correo postal con promociones especiales, información de producto, invitaciones a eventos y encuestas sobre los productos y servicios de Miele. Con este fin, Miele puede usar mis datos de contacto (tratamiento, nombre, correo electrónico y dirección postal) y diseñar comunicaciones basadas en mi comportamiento de compra y en mis pedidos, tal y como se describe con más detalle en nuestro Aviso {privacyLink}. Puedo revocar mi consentimiento en cualquier momento con efecto futuro (p. ej. con un mensaje a info{'@'}miele.com.mx , a los datos postales incluidos en el Aviso legal o haciendo clic en el enlace de darse de baja de los correos electrónicos). La comunicación contractual del Miele Club {termsAndConditionLink} no se verá afectada por ello hasta que se cancele la membresía.",
    privacyLink: {
      title: "Privacidad del Miele Club",
      href: "https://www.miele.com.mx/c/proteccion-de-datos-14.htm"
    },
    termsAndConditionLink: {
      title: "Comunicación contractual del Miele Club ",
      href: "https://www.miele.com.mx/c/terminos-y-condiciones-generales-13.htm#p7846"
    },
    supportEmail: "info{'@'}miele.com.mx"
  },
  selectAllConsents: {
    description: "Para unirse al Miele Club, debe aceptar todos los términos y condiciones *"
  }
}, Jd = "mostrar declaración completa", Zd = "ocultar declaración completa", Yd = {
  auth: Od,
  changeEmailScene: Ud,
  changePasswordScene: $d,
  errors: Bd,
  forgotPassword: Rd,
  login: Fd,
  modal: Vd,
  passwordStrength: qd,
  passwordHelper: Gd,
  register: Kd,
  "marketing-consent": {
    title: "Preferencias de marketing",
    description: "Marque a continuación para recibir ofertas exclusivas, noticias, eventos y cómo sacar el máximo provecho de su electrodoméstico.",
    submit: "Guardar",
    newsletter: {
      text: 'Acepto que MIELE S.A.U ("Miele") me envíe información sobre productos e innovaciones de la gama de productos de Miele y sobre eventos de Miele, así como encuestas de clientes, reseñas de productos y recetas por correo electrónico, las aplicaciones de Miele y SMS, y que Miele procese los datos de contacto que he proporcionado (título, nombre, dirección de correo electrónico, número de teléfono móvil y código postal) y los productos de Miele que he comprado hasta la fecha y que compraré en el futuro , así como los intereses que he indicado para este fin. Asimismo, acepto que Miele procese las confirmaciones de recepción y lectura recibidas a través del boletín informativo y la información sobre los enlaces en los que he hecho clic, así como mi comportamiento de usuario relacionado en el sitio web vinculado con fines de personalización. Lo mismo se aplica a los mensajes push in-app, en la medida en que se utilicen las aplicaciones de Miele. ',
      link: {
        title: "Puede encontrar más información de la Política de Privacidad de Miele",
        ref: "https://www.miele.com.mx/c/proteccion-de-datos-14.htm"
      }
    },
    personalisation: {
      text: "Estoy de acuerdo en que Miele pueda procesar información sobre los servicios que he utilizado y las asignaciones de técnicos que he llevado a cabo, así como los eventos a los que he asistido, con el fin de mejorar la personalización. ",
      link: {
        title: "Puede encontrar más información de la Política de Privacidad de Miele",
        ref: "https://www.miele.com.mx/c/proteccion-de-datos-14.htm"
      }
    },
    extendedPersonalisation: {
      text: "Además de la personalización extendida, estoy de acuerdo en que Miele también pueda procesar los datos del uso de la aplicación de Miele y mis visitas a los sitios web de Miele (www.miele.co.uk) para completar mi perfil de usuario, siempre y cuando haya dado mi consentimiento por separado para el procesamiento de estos datos. ",
      link: {
        title: "Puede encontrar más información de la Política de Privacidad de Miele",
        ref: "https://www.miele.com.mx/c/proteccion-de-datos-14.htm"
      }
    },
    highlightedText: {
      text: "Puedo revocar mi consentimiento en cualquier momento sin dar razones con efectos para el futuro. Para obtener más información sobre cómo Miele maneja sus datos, consulte la ",
      link: {
        title: "política de protección de datos de Miele.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Sí, estoy de acuerdo con los términos de uso.",
      link: {
        title: "Ver términos de uso",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: Hd,
  mieleClub: Wd,
  readMore: Jd,
  readLess: Zd
}, Xd = {
  waitMessage: "Lähes siellä. "
}, Qd = {
  buttonLabel: "Tallentaa",
  buttonLabelClose: "kiinni",
  confirmEmailMessage: "Vahvista sähköpostiosoitteesi",
  copy: "Päivitä sähköpostiosoitteesi lisäämällä uusi alle:",
  errorMessageCopy: "Jotain meni pieleen. ",
  errorMessageHeadline: "Virhe",
  headline: "Profiilin tiedot",
  inputEmailConfirmPlaceholder: "Vahvista sähköpostiosoitteesi",
  inputEmailPlaceholder: "Sähköpostiosoite",
  invalidEmailMessage: "Sähköposti ei kelpaa!",
  rememberMeLabel: "Muista minut",
  successMessageCopy: "Sähköpostiosoitteesi päivitys onnistui.",
  successMessageHeadline: "Sähköpostiosoite päivitetty"
}, eu = {
  closeButtonLabel: "kiinni",
  confirmPasswordLabel: "Vahvista salasana",
  currentPasswordLabel: "Nykyinen salasana",
  newPasswordLabel: "uusi salasana",
  passwordMismatchError: "Salasana ei täsmää",
  passwordUpdateErrorTitle: "Virhe",
  passwordUpdateSuccessTitle: "Salasana päivitetty",
  samePasswordError: "Tätä salasanaa käytettiin aiemmin, lähetä uusi salasana",
  subtitle: "Jos haluat vaihtaa salasanasi, täytä alla olevat kentät:",
  submitButtonLabel: "Lähetä",
  successfulChangeLabel: "Salasanasi on päivitetty onnistuneesti",
  title: "Salasanan vaihto"
}, tu = {
  invalidEmail: "väärä sähköposti",
  invalidPassword: "Väärä salasana",
  sap_206002: "Tilisi odottaa vahvistusta. Emme valitettavasti voi antaa sinun jatkaa tällä hetkellä. ",
  sap_206006: "Näyttää siltä, ​​että lähettämäsi sähköpostiosoite odottaa vahvistusta",
  sap_400003: "Tämä sähköpostiosoite on jo olemassa, käytä toista sähköpostiosoitetta!",
  sap_400028: "Lähetetty sähköpostiosoite odottaa vahvistusta",
  sap_400050: "Valitettavasti emme voi vahvistaa kirjautumistietojasi tällä hetkellä.",
  sap_400097: "Näyttää siltä, ​​että käytät palveluitamme suojaamattomasta/tukemattomasta selaimesta. ",
  sap_401030: "Tätä salasanaa käytettiin aiemmin, lähetä uusi salasana",
  sap_403005: "Meillä ei ole tähän sähköpostiosoitteeseen liittyvää tiliä. Tarkista sähköpostisi ja yritä uudelleen",
  sap_403011: "Istunto päättyi. ",
  sap_403012: "Istunto päättyi. ",
  sap_403013: "Valitettavasti emme voi vahvistaa kirjautumistietojasi tällä hetkellä.",
  sap_403035: "Valitettavasti emme voi vahvistaa kirjautumistietojasi tällä hetkellä.",
  sap_403041: "Meillä ei ole tähän sähköpostiosoitteeseen liittyvää tiliä. Tarkista sähköpostisi ja yritä uudelleen",
  sap_403042: "Sähköposti",
  sap_403043: "Sähköposti",
  sap_403047: "Sähköposti",
  sap_403100: "Salasanan päivityspyyntöä on pyydetty äskettäin, ole hyvä ja kerro meille, kunnes pyyntö on käsitelty",
  sap_403025: "Salasanan palautuslinkki on virheellinen, lähetä unohtunut salasana -pyyntö uudelleen saadaksesi uuden palautuslinkin.",
  sapErrorTitle: "Virhe pyynnön käsittelyssä",
  sessionExpired: "Istunto päättyi",
  tooWeakPassword: "Salasanan tulee sisältää vähintään {minLength} merkkiä ja {minCharGroups} seuraavista: iso kirjain, pieni kirjain, numero, erikoissymboli | Salasanan tulee sisältää vähintään {minLength} merkkiä",
  unexpectedDescription: "Jos ongelma jatkuu, ota meihin yhteyttä yhteydenottolomakkeella ja kerro tarkemmat tiedot.",
  unexpectedTitle: "Tapahtui odottamaton virhe",
  unknownDescription: "Tapahtui odottamaton virhe. ",
  unknownTitle: "Voi ei!"
}, iu = {
  subtitle: "Aseta uusi salasanasi.",
  title: "Unohditko salasanasi?"
}, nu = {
  headMetaDescription: "Asiakkaan kirjautumissivu",
  headTitle: "Kirjaudu sisään sähköpostiosoitteellasi ja salasanallasi:",
  subtitle: "Kirjaudu sisään tai luo tili saadaksesi kaikki Mielen ominaisuudet.",
  title: "Kirjaudu tilillesi",
  error: {
    invalidEmailPasswordDescription: "Sähköpostiosoitteen ja salasanan yhdistelmä ei kelpaa.",
    invalidEmailPasswordTitle: "Virheelliset kirjautumistiedot",
    missingConcentTitle: "Tili odottaa rekisteröintiä",
    noAccountDescription: "Tähän sähköpostiosoitteeseen ei ole liitetty tiliä.",
    noAccountTitle: "Tiliä ei ole rekisteröity"
  },
  extraConsentScene: {
    continue: "Jatkaa",
    privacyStatementCheckboxLabel: "Olen pannut merkille {0}.",
    privacyStatementName: "Tietosuojalausunto",
    privacyStatementTitle: "Tietosuojakäytäntömme on muuttunut",
    termsOfUseCheckboxLabel: "Hyväksyn {0}.",
    termsOfUseName: "käyttöehdot",
    termsOfUseTitle: "Käyttöehtomme ovat muuttuneet",
    title: "Profiilin viimeistely"
  },
  forgotPasswordScene: {
    backButtonLabel: "Takaisin sisäänkirjautumiseen",
    submitButtonLabel: "Lähetä",
    successDescription: "Tarkista sähköpostisi, saat pian tilillesi tiedot, jotta voit aloittaa salasanan vaihtoprosessin.",
    successTitle: "Pyyntösi on vastaanotettu.",
    title: "Anna sähköpostiosoitteesi vaihtaaksesi salasanasi:"
  },
  loginModalScene: {
    copy: "Kirjaudu sisään tai luo tili saadaksesi kaikki Mielen ominaisuudet.",
    title: "Kirjaudu tilillesi"
  },
  loginScene: {
    emailInputLabel: "Sähköposti",
    forgotPwdButtonLabel: "Unohdin salasanani",
    invalidEmailMessage: "Sähköposti ei kelpaa!",
    loginButtonLabel: "Kirjaudu sisään",
    passwordInputLabel: "Salasana",
    rememberMeLabel: "Muista minut",
    title: "Kirjaudu sisään sähköpostiosoitteellasi ja salasanallasi:"
  }
}, au = {
  accessibility: {
    close: "kiinni"
  }
}, su = {
  tooShort: "Liian lyhyt",
  medium: "Keskivahva",
  strong: "Vahva",
  tooWeak: "Liian heikko",
  veryStrong: "Erittäin vahva",
  weak: "Heikko"
}, ou = {
  showPasswordText: "Näytä",
  hidePasswordText: "Piilota"
}, ru = {
  registerButtonLabel: "rekisteröidy",
  registerTitle: "Eikö sinulla ole tiliä?",
  whyRegister: {
    list: [
      "Pääsy Miele Clubin eksklusiivisiin etuihin",
      "Rekisteröi laitteita, seuraa tilauksia, käytä käsikirjoja",
      "Vastaanota henkilökohtaisia ​​tarjouksia ja kampanjoita",
      "Katso kaikki tilauksesi, takuusi, tapahtumasi ja palvelusi"
    ],
    title: "Miksi rekisteröityä?"
  },
  closeButtonLabel: "kiinni",
  passwordMismatchError: "salasanat eivät täsmää",
  passwordUpdateErrorTitle: "Salasanan päivitysvirhe",
  passwordUpdateSuccessTitle: "Salasana päivitetty",
  successfulChangeLabel: "Salasanasi on päivitetty onnistuneesti"
}, lu = {
  title: "Markkinointiasetukset",
  description: "Rasti alla nähdäksesi eksklusiiviset tarjoukset, uutiset, tapahtumat ja miten saat kaiken irti laitteestasi.",
  submit: "Tallentaa",
  levelOne: {
    shortText: 'Kyllä, haluan vastaanottaa Miele Oy:ltä ja Miele & Cie. KG:ltä ("Miele") sähköpostitse, tekstiviestein, postitse ja Miele-sovelluksen ja verkkosivun kautta (jos käytössä) henkilökohtaisten kiinnostusteni mukaan räätälöityä mainosviestintää',
    text: `Kyllä, haluan vastaanottaa Miele Oy:ltä ja Miele & Cie. KG:ltä ("Miele") sähköpostitse, tekstiviestein, postitse ja Miele-sovelluksen ja verkkosivun kautta (jos käytössä) henkilökohtaisten kiinnostusteni mukaan räätälöityä mainosviestintää, jossa on tietoa Miele-tuotevalikoiman tuotteista, tarjouksista ja innovaatioista, Miele-tapahtumista sekä asiakaskyselyistä, tuotearvioinneista ja -arvosteluista sekä resepteistä. Tätä tarkoitusta varten Miele voi käyttää yhteystietojani (titteli, nimi, sähköpostiosoite, matkapuhelinnumero ja postiosoite) ja suunnitella viestintää osto-, palvelu- ja tapahtumahistoriani, uutiskirjeen klikkaus- ja avauskäyttäytymiseni sekä asiakasarvoni perusteella, kuten Mielen tietosuojaselosteessa  on yksityiskohtaisesti kuvattu. Voin milloin vain perustelematta peruuttaa suostumukseni tulevaisuutta koskevin vaikutuksin (esim. lähettämällä epävirallisen viestin osoitteeseen contact{'@'}miele-support.fi, klikkauksella annettuihin yhteystietoihin tai klikkaamalla sähköpostiviestien peruutuslinkkiä). `,
    link: {
      title: "Tietosuojaselosteessa",
      ref: "https://www.miele.fi/c/tietosuoja-14.htm"
    }
  },
  levelTwo: {
    text: "Antamani perussuostumuksen lisäksi hyväksyn, että Miele voi myös käsitellä Miele-sovelluksen käytöstäni ja Miele-sivustoilla (www.miele.fi) tekemistäni käynneistä saatuja tietoja, mukaan lukien käyttäjän käyttäytyminen Miele-sivustoilla linkitetyn uutiskirjeen napsautuksen jälkeen, täydentääkseen käyttäjäprofiiliani yksilöllistä mainosviestintää varten edellyttäen, että sovelluksessa tai verkkosivustolla antamani erillinen suostumus antaa suostumuksen tietojen käsittelyn. Voin milloin vain syytä ilmoittamatta peruuttaa suostumukseni tulevaisuutta koskevin vaikutuksin. Lisätietoja Mielen tietosuojaselosteessa.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Perussuostumukseni lisäksi suostun siihen, että Miele voi myös käsitellä yhdistetyistä Miele-laitteistani saatuja tietoja (tietoja laitteen käytöstä ja sen tilasta) käyttäjäprofiilini täydentämiseksi henkilökohtaista mainontaa varten. Voin saada lisätietoja laitetietojen käsittelystä Miele{'@'}Home-järjestelmän tietosuojaselosteesta. Voin milloin vain syytä ilmoittamatta peruuttaa suostumuksenitulevaisuutta koskevin vaikutuksin.",
    link: {
      title: "Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Kyllä, hyväksyn käyttöehdot.",
    link: {
      title: "Katso käyttöehdot*",
      ref: "https://www.miele.fi/c/mieleshopin-kaeyttoeehdot-13.htm"
    }
  }
}, cu = {
  headline: "Miele Club",
  birthDateTitle: "Voimmeko lähettää sinulle syntymäpäivälahjan?",
  birthDateLabel: "Syntymäaika (vapaaehtoinen)",
  why: {
    title: "Maksuton jäsenyys - Eksklusiivisia tarjouksia jäsenille.",
    reasons: [
      "Saat tervetuliaislahjana 10 % alennuksen",
      "Syntymäpäiväyllätys",
      "Eksklusiiviset tarjoukset",
      "Kutsut tapahtumiin ja elämyksiin "
    ]
  },
  birthDateValidation: {
    requirementMsg: "Anna päivämäärä tässä muodossa: PP/KK/VVVV",
    errorMsg: "Virheellinen päivämäärä"
  },
  joinClubLabel: "Kyllä, haluaisin liittyä Miele Clubiin.",
  termsAndCondition: {
    description: "Hyväksyn Miele Clubin {termsAndConditionLink} ja vahvistan, että olen lukenut ja ymmärtänyt Miele Clubin {privacyLink} koskevat tiedot.",
    termsAndConditionLink: {
      title: "osallistumis- ja käyttöehdot",
      ref: "https://www.miele.fi/c/mieleshopin-kaeyttoeehdot-13.htm"
    },
    privacyLink: {
      title: "tietosuojaa",
      ref: "https://www.miele.fi/c/tietosuoja-14.htm"
    }
  },
  newsletter: {
    description: "Kyllä, haluan saada Miele Oy:ltä (“Miele”) henkilökohtaisten kiinnostuksen kohteideni mukaisesti räätälöityä klubimainosviestintää sähköpostitse ja postitse, kuten erikoistarjouksia, tiedotteita, kutsuja tapahtumiin sekä asiakaskyselyjä Mielen tarjoamista tuotteista ja palveluista. Miele saa käyttää tähän tarkoitukseen yhteystietojani (titteli , nimi, sähköposti- ja postiosoite) ja muokata viestejä osto- ja uutiskirjekäyttäytymiseni ja jäsenluokkani perusteella Miele Clubin {privacyLink} kuvatulla tavalla. Voin milloin vain syytä ilmoittamatta perua suostumukseni tulevaisuutta koskevin vaikutuksin (esim. epämuodollisella sähköpostiviestillä osoitteeseen asiakaspalvelu{'@'}miele.fi, ottamalla yhteyttä verkkosivuiltamme löytyvien yhteystitetojen kautta tai napsauttamalla sähköpostiviestin Peru tilaus -linkkiä. Muu Miele Clubin jäsen- ja {termsAndConditionLink} perustuva klubiviestintä jatkuu tästä huolimatta Miele Clubista eroamiseen asti.",
    shortDescription: "Kyllä, haluan saada Miele Oy:ltä (“Miele”) henkilökohtaisten kiinnostuksen kohteideni mukaisesti räätälöityä klubimainosviestintää sähköpostitse ja postitse",
    privacyLink: {
      title: "tietosuojakäytännössä",
      href: "https://www.miele.fi/c/tietosuoja-14.htm"
    },
    termsAndConditionLink: {
      title: "käyttöehtoihin",
      href: "https://www.miele.fi/c/mieleshopin-kaeyttoeehdot-13.htm"
    },
    supportEmail: "info{'@'}miele.fi"
  },
  selectAllConsents: {
    description: "Liittyäksesi Miele Clubiin sinun täytyy hyväksyä kaikki ehdot *"
  }
}, du = "näytä koko lausunto", uu = "piilota koko lausunto", mu = {
  auth: Xd,
  changeEmailScene: Qd,
  changePasswordScene: eu,
  errors: tu,
  forgotPassword: iu,
  login: nu,
  modal: au,
  passwordStrength: su,
  passwordHelper: ou,
  register: ru,
  "marketing-consent": {
    title: "Markkinointiasetukset",
    description: "Rasti alla nähdäksesi eksklusiiviset tarjoukset, uutiset, tapahtumat ja miten saat kaiken irti laitteestasi.",
    submit: "Tallentaa",
    newsletter: {
      text: "Hyväksyn, että Miele Oy (“Miele”) lähettää minulle sähköpostitse, Miele-sovellusten ja tekstiviestien välityksellä tietoa Miele-valikoiman tuotteista ja uutuuksista, Miele-tapahtumista, asiakaskyselyistä, tuotearvioinnit ja arvostelut sekä ruokaresepteistä. Tätä tarkoitusta varten Miele käyttää antamiani yhteystietoja (nimi, sähköpostiosoite, puhelinnumero ja osoite). Tähän sisältyvät myös Miele-tuotteet, joita olen ostanut aiemmin tai aion ostaa tulevaisuudessa, sekä ilmoittamani erilaiset kiinnostuksen kohteet.",
      link: {
        title: "Katso tietosuojakäytäntö",
        ref: ""
      }
    },
    personalisation: {
      text: "Hyväksyn, että Miele voi käsitellä tietoja käyttämistäni palveluista ja suorittamistani teknikkotehtävistä sekä tapahtumista, joihin olen osallistunut henkilökohtaistamisen tehostamiseksi.",
      link: {
        title: "Katso tietosuojakäytäntö",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Laajennetun personoinnin lisäksi hyväksyn, että Miele voi käsitellä myös Miele-sovelluksen käytöstä ja Mielen verkkosivuilla (www.miele.co.uk) käynneistäni saatuja tietoja käyttäjäprofiilini täydentämiseksi edellyttäen, että olen siihen erikseen suostunut. ",
      link: {
        title: "Katso tietosuojakäytäntö",
        ref: ""
      }
    },
    highlightedText: {
      text: "Voin peruuttaa suostumukseni milloin tahansa ilmoittamatta tulevaisuutta koskevia syitä.  ",
      link: {
        title: "tietosuojakäytäntö.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Kyllä, hyväksyn käyttöehdot.",
      link: {
        title: "Katso käyttöehdot.",
        ref: "https://www.miele.fi/c/mieleshopin-kaeyttoeehdot-13.htm"
      }
    }
  },
  multiLevelMarketingConsent: lu,
  mieleClub: cu,
  readMore: du,
  readLess: uu
}, pu = {
  waitMessage: "Presque là. Tenez bon ..."
}, hu = {
  buttonLabel: "Enregistrer",
  buttonLabelClose: "Fermer",
  confirmEmailMessage: "Confirmer votre adresse e-mail",
  copy: "Pour mettre à jour votre adresse e-mail, veuillez saisir la nouvelle ci-dessous:",
  errorMessageCopy: "Quelque chose s'est mal passé. Réessayez.",
  errorMessageHeadline: "Erreur",
  headline: "Détails du profil",
  inputEmailConfirmPlaceholder: "Confirmez votre adresse e-mail",
  inputEmailPlaceholder: "Adresse e-mail",
  invalidEmailMessage: "Adresse e-mail non valide !",
  rememberMeLabel: "Se souvenir de moi",
  successMessageCopy: "Votre adresse e-mail a été mise à jour avec succès.",
  successMessageHeadline: "Adresse e-mail mise à jour"
}, gu = {
  closeButtonLabel: "Fermer",
  confirmPasswordLabel: "Confirmer le mot de passe",
  currentPasswordLabel: "Mot de passe actuel",
  newPasswordLabel: "Nouveau mot de passe",
  passwordMismatchError: "Le mot de passe ne correspond pas",
  passwordUpdateErrorTitle: "Erreur",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  samePasswordError: "Ce mot de passe a déjà été utilisé auparavant. Veuillez saisir un nouveau mot de passe.",
  subtitle: "Pour changer votre mot de passe, veuillez remplir les champs ci-dessous : ",
  submitButtonLabel: "Soumettre",
  successfulChangeLabel: "Votre mot de passe a été mis à jour avec succès",
  title: "Changement de mot de passe"
}, vu = {
  invalidEmail: "Adresse e-mail incorrecte",
  invalidPassword: "Mot de passe incorrect",
  sap_206002: "Votre compte est en attente de vérification. Malheureusement, nous ne pouvons pas vous autoriser à continuer pour le moment. Veuillez nous contacter pour plus de détails.",
  sap_206006: "Il semblerait que l'adresse e-mail que vous avez soumise soit en attente de vérification.",
  sap_400003: "Cet e-mail existe déjà, veuillez utiliser une adresse e-mail différente !",
  sap_400028: "L'adresse e-mail soumise est en attente de vérification",
  sap_400050: "Désolé, nous ne pouvons pas valider vos informations d'identification pour le moment.",
  sap_400097: "Il semblerait que vous accédiez à nos services à partir d'un navigateur non sécurisé/ non-supporté. Veuillez réessayer avec un autre navigateur.",
  sap_401030: "Ce mot de passe a déjà été utilisé précédemment, veuillez saisir un nouveau mot de passe",
  sap_403005: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer",
  sap_403011: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403012: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403013: "Désolé, nous ne sommes pas en mesure de valider vos identifiants pour le moment.",
  sap_403035: "Désolé, nous ne sommes pas en mesure de valider vos identifiants pour le moment.",
  sap_403041: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer",
  sap_403042: "La combinaison E-mail et Mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisir Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403043: "La combinaison E-mail et Mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisir Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403047: "La combinaison E-mail et Mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisir Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403100: "Une demande de mise à jour de mot de passe a été récemment effectuée, veuillez patienter jusqu'à ce que la demande soit traitée.",
  sap_403025: "Le lien de réinitialisation du mot de passe n'est pas valide, veuillez envoyer à nouveau une demande de mot de passe oublié pour recevoir un nouveau lien de réinitialisation.",
  sapErrorTitle: "Erreur de traitement de la demande",
  sessionExpired: "Session expirée",
  tooWeakPassword: "Le mot de passe doit contenir au moins {minLength} caractères et {minCharGroups} des éléments suivants : une lettre majuscule, une lettre minuscule, un chiffre, un symbole spécial | Le mot de passe doit contenir au moins {minLength} caractères",
  unexpectedDescription: "Si le problème persiste, veuillez nous contacter via le formulaire de contact en nous fournissant les détails.",
  unexpectedTitle: "Une erreur imprévue est survenue",
  unknownDescription: "Erreur imprévue. Veuillez réessayer.",
  unknownTitle: "Oups !"
}, fu = {
  subtitle: "Définissez votre nouveau mot de passe.",
  title: "Vous avez oublié votre mot de passe ?"
}, ku = {
  headMetaDescription: "Page de connexion du client",
  headTitle: "Connectez-vous avec votre email et votre mot de passe :",
  subtitle: "Connectez-vous ou créez un compte pour bénéficier de toutes les fonctionnalités Miele.",
  title: "Connectez-vous à votre compte",
  error: {
    invalidEmailPasswordDescription: "La combinaison de l'adresse e-mail et du mot de passe n'est pas valide.",
    invalidEmailPasswordTitle: "Informations d'identification invalides",
    missingConcentTitle: "En attente d'enregistrement du compte",
    noAccountDescription: "Il n'y a aucun compte associé à cette adresse e-mail.",
    noAccountTitle: "Aucun compte enregistré"
  },
  extraConsentScene: {
    continue: "Continuer",
    privacyStatementCheckboxLabel: "J'ai pris connaissance de la {0}.",
    privacyStatementName: "politique de confidentialité",
    privacyStatementTitle: "Notre politique de confidentialité a été modifiée",
    termsOfUseCheckboxLabel: "J'accepte les {0}.",
    termsOfUseName: "conditions d'utilisation",
    termsOfUseTitle: "Nos conditions d'utilisation ont été modifiées",
    title: "Compléter le profil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Retour à la page de connexion",
    submitButtonLabel: "Envoyer",
    successDescription: "Veuillez consulter votre messagerie, vous recevrez bientôt les informations concernant votre compte pour commencer le processus de réinitialisation du mot de passe.",
    successTitle: "Votre demande a été reçue.",
    title: "Veuillez saisir votre adresse e-mail pour réinitialiser votre mot de passe :"
  },
  loginModalScene: {
    copy: "Connectez-vous ou créez un compte pour profiter de toutes les fonctionnalités de Miele.",
    title: "Connectez-vous à votre compte"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "J'ai oublié mon mot de passe",
    invalidEmailMessage: "L'e-mail n'est pas valide !",
    loginButtonLabel: "Connexion",
    passwordInputLabel: "Mot de passe",
    rememberMeLabel: "Se souvenir de moi",
    title: "Connectez-vous avec votre e-mail et votre mot de passe :"
  }
}, bu = {
  accessibility: {
    close: "Fermer"
  }
}, wu = {
  tooShort: "Trop court",
  medium: "Moyen",
  strong: "Fort",
  tooWeak: "Trop faible",
  veryStrong: "Très fort",
  weak: "Faible"
}, yu = {
  showPasswordText: "Afficher",
  hidePasswordText: "Masquer"
}, Mu = {
  registerButtonLabel: "S'enregistrer",
  registerTitle: "Vous n'avez pas de compte ?",
  whyRegister: {
    list: {
      0: "Accès aux avantages exclusifs du Club Miele",
      1: "Enregistrer les appareils, suivre les commandes, accéder aux manuels",
      2: "Recevoir des offres et promotions personnalisées",
      3: "Voir toutes vos commandes, garanties, événements et services"
    },
    title: "Pourquoi s'inscrire ?"
  },
  closeButtonLabel: "Fermer",
  passwordMismatchError: "Les mots de passe ne correspondent pas",
  passwordUpdateErrorTitle: "Erreur de mise à jour de mot de passe",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  successfulChangeLabel: "Préférences de marketing"
}, zu = {
  title: "Sélectionnez ci-dessous pour des offres exclusives, des actualités, des événements et des astuces pour votre appareil.",
  submit: "Enregistrer",
  description: "Cochez la case ci-dessous pour recevoir des offres exclusives, des invitations à des évenements, des conseils pour profiter pleinement de vos appareils.",
  levelOne: {
    shortText: 'Oui, je souhaite recevoir des communications promotionnelles de Miele SAS. et Miele & Cie. KG ("Miele") adaptées à mes intérêts personnels par e-mail, SMS, courrier et via les applications et les sites internet Miele (si utilisées)',
    text: `Oui, je souhaite recevoir des communications promotionnelles de Miele SAS. et Miele & Cie. KG ("Miele") adaptées à mes intérêts personnels par e-mail, SMS, courrier et via les applications et les sites internet Miele (si utilisées) avec des informations sur les produits, les offres et les innovations de la gamme de produits Miele et sur les événements Miele, ainsi qu'avec des enquêtes auprès des clients, des demandes d'évaluation et d'appréciation des produits et des recettes. À cette fin, Miele peut utiliser mes coordonnées (titre, nom, adresse électronique, numéro de téléphone portable et adresse postale) et concevoir la communication sur la base de mes achats, de mes services, de l'historique des événements, du comportement de clic et d'ouverture des newsletters ainsi que de la valeur client, comme décrit en détail dans notre politique de confidentialité. Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet immédiat (par exemple, en envoyant un message informel à rgpd{'@'}miele.fr, aux coordonnées indiquées dans les mentions légales ou en cliquant sur le lien de désinscription dans les newsletter).`,
    link: {
      title: "Politique de confidentialité",
      ref: "https://www.miele.fr/c/protection-des-donnees-14.htm"
    }
  },
  levelTwo: {
    text: "En plus de mon consentement de base, j'accepte que Miele traite également les données issues de l'utilisation de l'appli Miele et de mes visites sur les sites Internet de Miele (www.miele.fr), y compris le comportement de l'utilisateur sur les sites Internet de Miele après les clics de newsletter liés, afin de compléter mon profil d'utilisateur pour des communications publicitaires personnalisées, à condition que mon consentement séparé dans l'appli ou sur le site Internet libère le traitement des données. Je peux révoquer mon consentement à tout moment sans donner de raisons avec effet immédiat.",
    link: {
      title: "Pour plus de détails, voir la politique de protection des données de Miele.",
      ref: "https://www.miele.fr/c/protection-des-donnees-14.htm"
    }
  },
  levelThree: {
    text: "En plus de mon consentement de base, j'accepte que Miele traite également les données de mes appareils Miele connectés (données sur l'utilisation et l'état des appareils) pour compléter mon profil d'utilisateur en vue d'une publicité personnalisée. Je peux trouver plus d'informations sur le traitement des données des appareils dans la politique de confidentialité du système Miele{'@'}Home. Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir.",
    link: {
      title: "Pour plus de détails, voir la politique de protection des données de Miele.",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Je peux révoquer mon consentement pour le traitement de mes données personnelles à tout moment. Pour plus d'informations sur la gestion de vos données personnelles par Miele, veuillez consulter la politique de confidentialité de Miele",
    link: {
      title: "politique de confidentialité",
      ref: "https://www.miele.fr/c/politique-de-confidentialite-14.htm"
    }
  },
  termsOfUse: {
    text: "Oui, j'accepte les conditions d'utilisation.",
    link: {
      title: "Voir les conditions d'utilisation*",
      ref: "https://www.miele.fr/c/agb-13.htm"
    }
  }
}, ju = {
  headline: "Miele Club",
  why: {
    title: "Adhésion gratuite - Offres exclusives pour les membres.",
    reasons: [
      "Offre de bienvenue de -15%",
      "Surprise pour votre anniversaire",
      "Offres spéciales membres",
      "Invitations à nos evenements exclusifs"
    ]
  },
  birthDateTitle: "Souhaitez-vous recevoir une offre pour votre anniversaire?",
  birthDateValidation: {
    requirementMsg: "Entrez la date dans le format suivant: JJ/MM/AAAA",
    errorMsg: "Date incorrecte"
  },
  joinClubLabel: "Oui, je souhaite adhérer au Miele Club.",
  termsAndCondition: {
    description: "J'accepte les {termsAndConditionLink} du Miele Club et confirme avoir pris connaissance des informations sur la {privacyLink} pour le Miele Club.",
    termsAndConditionLink: {
      title: "Conditions de participation et d’utilisation",
      ref: "https://www.miele.fr/c/cgv-13.htm"
    },
    privacyLink: {
      title: " Protection des données",
      ref: "https://www.miele.fr/c/protection-des-donnees-14.htm"
    }
  },
  newsletter: {
    description: "Oui, je souhaite recevoir des communications publicitaires du Club de la société Miele SAS (« Miele ») personnalisées en fonction de mes intérêts personnels par e-mail et par courrier pour des offres spéciales, des informations, des invitations à des événements et des sondages clients sur nos produits et nos services. J’autorise pour cela Miele à utiliser mes coordonnées (civilité, nom, e-mail, téléphone et adresse postale) et à adapter la communication sur la base de mes habitudes d’achat et de mon comportement vis-à-vis des newsletters, comme décrit plus en détail dans la {privacyLink}. Je peux révoquer mon consentement à tout moment à l’avenir (par exemple par simple email à info{'@'}miele.fr, aux coordonnées indiquées dans les mentions légales ou en cliquant sur le lien de désinscription figurant dans les e-mails). La communication contractuelle du Club {termsAndConditionLink} n’en est pas affectée jusqu’à la résiliation de l’adhésion.",
    shortDescription: "Oui, je souhaite recevoir des communications publicitaires du Club de la société Miele SAS (« Miele ») personnalisées en fonction de mes intérêts personnels par e-mail et par courrier",
    privacyLink: {
      title: "Miele Club proteciton des données",
      href: "https://www.miele.fr/c/protection-des-donnees-14.htm"
    },
    termsAndConditionLink: {
      title: "Communications du Club",
      href: "https://www.miele.fr/c/cgv-13.htm"
    },
    supportEmail: "info{'@'}miele.fr"
  },
  selectAllConsents: {
    description: "Pour rejoindre le Miele Club, vous devez accepter tous les termes et conditions *"
  },
  birthDateLabel: "Votre date de naissance (facultatif)"
}, _u = "afficher la déclaration complète", Su = "masquer la déclaration complète", Cu = {
  auth: pu,
  changeEmailScene: hu,
  changePasswordScene: gu,
  errors: vu,
  forgotPassword: fu,
  login: ku,
  modal: bu,
  passwordStrength: wu,
  passwordHelper: yu,
  register: Mu,
  "marketing-consent": {
    title: "Sélectionnez ci-dessous pour des offres exclusives, des actualités, des événements et des astuces pour votre appareil.",
    description: "Enregistrer",
    submit: `Je suis d'accord que Miele Co Ltd. ("Miele") peut m'envoyer des informations sur les produits et les innovations de la gamme de produits Miele, ainsi que des sondages auprès des clients, et des recettes par courrier électronique, les applications Miele et SMS et que Miele peut traiter les coordonnées que j'ai fournies (titre, nom, adresse e-mail, numéro de téléphone portable et code postal) et les produits Miele que j'ai achetés jusqu'à présent et que j'achèterai à l'avenir ainsi que les intérêts que j'ai indiqués à cette fin. Je suis également d'accord que Miele peut également traiter les confirmations de réception et de lecture reçues par le biais de la newsletter et des informations sur les liens sur lesquels j'ai cliqué, ainsi que sur mon comportement d'utilisateur associé sur le site web lié à des fins de personnalisation. Il en va de même pour les messages push in-app, dans la mesure où les applications Miele sont utilisées.`,
    newsletter: {
      text: "Voir la politique de protection des données",
      link: {
        title: "#",
        ref: "Je suis d'accord que Miele puisse traiter des informations sur les services que j'ai utilisés, les affectations de techniciens que j'ai effectuées, ainsi que des événements auxquels j'ai participé, afin d'améliorer la personnalisation."
      }
    },
    personalisation: {
      text: "Voir la politique de protection des données",
      link: {
        title: "#",
        ref: "En plus de la personnalisation étendue, je suis d'accord que Miele puisse également traiter les données d'utilisation de l'application Miele et de mes visites sur les sites web de Miele (www.miele.co.uk) pour compléter mon profil utilisateur, à condition que j'ai donné mon consentement séparément pour le traitement de ces données."
      }
    },
    extendedPersonalisation: {
      text: "Voir la politique de protection des données",
      link: {
        title: "#",
        ref: "Je peux révoquer mon consentement à tout moment sans donner de raisons pour l'avenir. Pour plus d'informations sur la manière dont Miele traite vos données, veuillez vous référer à la "
      }
    },
    highlightedText: {
      text: "politique de protection des données de Miele.",
      link: {
        title: "#",
        ref: "Oui, j'accepte les conditions d'utilisation."
      }
    },
    termsOfUse: {
      text: "Oui, j'accepte les conditions d'utilisation.",
      link: {
        title: "Voir les conditions d'utilisation*",
        ref: "https://www.miele.fr/c/agb-13.htm"
      }
    }
  },
  multiLevelMarketingConsent: zu,
  mieleClub: ju,
  readMore: _u,
  readLess: Su
}, Lu = {
  waitMessage: "Nous y sommes presque. Veuillez attendre encore un peu..."
}, Eu = {
  buttonLabel: "Sauvegarder",
  buttonLabelClose: "Fermer",
  confirmEmailMessage: "Confirmez votre adresse e-mail",
  copy: "Pour mettre à jour votre adresse e-mail, veuillez ajouter la nouvelle adresse ci-dessous :",
  errorMessageCopy: "Un problème s'est produit. Réessayez.",
  errorMessageHeadline: "Erreur",
  headline: "Détails du compte",
  inputEmailConfirmPlaceholder: "Confirmez votre adresse e-mail",
  inputEmailPlaceholder: "Adresse e-mail",
  invalidEmailMessage: "L'adresse e-mail n'est pas valide !",
  rememberMeLabel: "Se souvenir de moi",
  successMessageCopy: "Votre adresse e-mail a été mise à jour avec succès.",
  successMessageHeadline: "Mise à jour de l'adresse e-mail"
}, Pu = {
  closeButtonLabel: "Fermer",
  confirmPasswordLabel: "Confirmer le mot de passe",
  currentPasswordLabel: "Mot de passe actuel",
  newPasswordLabel: "Nouveau mot de passe",
  passwordMismatchError: "Le mot de passe ne correspond pas",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  samePasswordError: "Ce mot de passe a été utilisé précédemment, veuillez soumettre un nouveau mot de passe",
  subtitle: "Pour modifier votre mot de passe, veuillez remplir les champs ci-dessous :",
  submitButtonLabel: "Soumettre",
  successfulChangeLabel: "Votre mot de passe a été mis à jour avec succès",
  title: "Changement de mot de passe"
}, Tu = {
  invalidEmail: "Email incorrect",
  invalidPassword: "Mot de passe incorrect",
  sap_206002: "Votre compte est en attente de vérification, je crains que nous ne puissions pas vous permettre de continuer pour le moment. Veuillez nous contacter pour plus de détails.",
  sap_206006: "Il semble que l'adresse électronique que vous avez fournie soit en attente de vérification.",
  sap_400003: "Cet email existe déjà, veuillez utiliser une autre adresse email.",
  sap_400028: "L'adresse électronique soumise est en attente de vérification",
  sap_400050: "Désolé, nous ne sommes pas en mesure de valider vos informations d'identification pour le moment.",
  sap_400097: "Il semble que vous accédiez à nos services à partir d'un navigateur non sécurisé/non pris en charge. Veuillez réessayer avec un autre navigateur. ",
  sap_401030: "Ce mot de passe a été utilisé précédemment, veuillez soumettre un nouveau mot de passe.",
  sap_403005: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer.",
  sap_403011: "La session a expiré. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403012: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403013: "Désolé, nous ne sommes pas en mesure de valider vos informations d'identification pour le moment.",
  sap_403035: "Désolé, nous ne sommes pas en mesure de valider vos informations d'identification pour le moment.",
  sap_403041: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre adresse e-mail et réessayer.",
  sap_403042: "La combinaison de l'adresse électronique et du mot de passe n'est pas valide. Veuillez vérifier l'adresse électronique associée au compte ou choisissez « Mot de passe oublié » si vous souhaitez le réinitialiser.",
  sap_403043: "La combinaison email et mot de passe n'est pas valide. Veuillez vérifier l'adresse électronique associée au compte ou choisissez Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403047: "La combinaison email et mot de passe n'est pas valide. Veuillez vérifier l'adresse électronique associée au compte ou choisissez Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403100: "Une demande de mise à jour du mot de passe a été récemment introduite. Veuillez patienter jusqu'à ce que la demande soit traitée.",
  sap_403025: "Le lien de réinitialisation du mot de passe n'est pas valide, veuillez envoyer à nouveau une demande de mot de passe oublié pour recevoir un nouveau lien de réinitialisation.",
  sapErrorTitle: "Erreur dans le traitement de la demande",
  sessionExpired: "Session expirée",
  tooWeakPassword: "Le mot de passe doit contenir au moins {minLength} caractères et {minCharGroups} des éléments suivants : lettre majuscule, lettre minuscule, chiffre, symbole spécial. | Le mot de passe doit contenir au moins {minLength} caractères",
  unexpectedDescription: "Si le problème persiste, veuillez nous contacter via le formulaire de contact.",
  unexpectedTitle: "Une erreur inattendue s'est produite",
  unknownDescription: "Une erreur inattendue s'est produite. Veuillez réessayer.",
  unknownTitle: "Oh là là !"
}, Au = {
  subtitle: "Définissez votre nouveau mot de passe.",
  title: "Vous avez oublié votre mot de passe ?"
}, xu = {
  headMetaDescription: "Page de connexion du client",
  headTitle: "Connectez-vous avec votre email et votre mot de passe :",
  subtitle: "Connectez-vous ou créez un compte pour bénéficier de toutes les fonctionnalités Miele.",
  title: "Connexion à votre compte",
  error: {
    invalidEmailPasswordDescription: "La combinaison de l'adresse e-mail et du mot de passe n'est pas valide.",
    invalidEmailPasswordTitle: "Informations d'identification invalides",
    missingConcentTitle: "Compte en attente d'enregistrement",
    noAccountDescription: "Aucun compte n'est associé à cette adresse e-mail.",
    noAccountTitle: "Aucun compte enregistré"
  },
  extraConsentScene: {
    continue: "Continuer",
    privacyStatementCheckboxLabel: "J'ai pris connaissance des {0}.",
    privacyStatementName: "Protection des données",
    privacyStatementTitle: "Notre politique de protection des données a changé",
    termsOfUseCheckboxLabel: "J'accepte les {0}.",
    termsOfUseName: "Conditions d'utilisation",
    termsOfUseTitle: "Nos conditions d'utilisation ont été modifiées",
    title: "Compléter le compte"
  },
  forgotPasswordScene: {
    backButtonLabel: "Retour à la connexion",
    submitButtonLabel: "Soumettre",
    successDescription: "Veuillez vérifier votre e-mail, vous recevrez bientôt les informations sur votre compte pour commencer le processus de réinitialisation du mot de passe.",
    successTitle: "Votre demande a été reçue.",
    title: "Veuillez saisir votre adresse e-mail pour réinitialiser votre mot de passe :"
  },
  loginModalScene: {
    copy: "Connectez-vous ou créez un compte pour bénéficier de toutes les fonctionnalités Miele.",
    title: "Connexion à votre compte"
  },
  loginScene: {
    emailInputLabel: "Adresse e-mail",
    forgotPwdButtonLabel: "J'ai oublié mon mot de passe",
    invalidEmailMessage: "L'e-mail n'est pas valide !",
    loginButtonLabel: "Se connecter",
    passwordInputLabel: "Mot de passe",
    rememberMeLabel: "Se souvenir de moi",
    title: "Connectez-vous avec votre e-mail et votre mot de passe :"
  }
}, Iu = {
  accessibility: {
    close: "Fermer"
  }
}, Du = {
  tooShort: "Trop court",
  medium: "Moyen",
  strong: "Forte",
  tooWeak: "Trop faible",
  veryStrong: "Très forte",
  weak: "Faible"
}, Nu = {
  showPasswordText: "Montrer",
  hidePasswordText: "Cacher"
}, Ou = {
  registerButtonLabel: "S'inscrire",
  registerTitle: "Vous n'avez pas de compte ?",
  whyRegister: {
    list: [
      "Vue d'ensemble pratique de toutes vos commandes et réservations d'événements",
      "Vue d'ensemble de tous vos appareils avec accessoires et modes d’emploi",
      "Un aperçu de toutes vos réparations et garanties"
    ],
    title: "Pourquoi s'inscrire ?"
  },
  closeButtonLabel: "Fermer",
  passwordMismatchError: "Les mots de passe ne correspondent pas",
  passwordUpdateErrorTitle: "Erreur de mise à jour du mot de passe",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  successfulChangeLabel: "Votre mot de passe a été mis à jour avec succès"
}, Uu = {
  title: "Préférences marketing",
  description: "Cochez la case ci-dessous pour recevoir des offres exclusives, des informations, des conseils sur les produits et bien plus encore.",
  submit: "Sauvegarder",
  levelOne: {
    shortText: 'Oui, je souhaite recevoir des communications promotionnelles de Miele Belgique S.A. et Miele & Cie. KG ("Miele) adaptées à mes intérêts personnels par e-mail, SMS, courrier et via les applications et les sites  internet Miele (si utilisées)',
    text: `Oui, je souhaite recevoir des communications promotionnelles de Miele Belgique S.A. et Miele & Cie. KG ("Miele) adaptées à mes intérêts personnels par e-mail, SMS, courrier et via les applications et les sites  internet Miele (si utilisées) avec des informations sur les produits, les offres et les innovations de la gamme de produits Miele et sur les événements Miele, ainsi que des enquêtes clients, des demandes d'évaluation et d'appréciation des produits et des recettes. À cette fin, Miele peut utiliser mes coordonnées (titre, nom, adresse électronique, numéro de téléphone portable et adresse postale) et élaborer la communication sur la base de mes achats, de mes services, de l'historique des événements, du comportement de clic et d'ouverture des newsletters ainsi que de la valeur client, comme décrit en détail dans notre politique de confidentialité. Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir (par exemple, en envoyant un email à privacy{'@'}miele.be , aux coordonnées indiquées dans les mentions légales ou en cliquant sur le lien de désinscription dans les emails).`,
    link: {
      title: "Politique de confidentialité",
      ref: "https://www.miele.be/fr/c/protection-des-donnees-14.htm"
    }
  },
  levelTwo: {
    text: "En plus de mon consentement de base, j'accepte que Miele traite également les données issues de l'utilisation de l'application Miele et de mes visites sur les sites Internet de Miele (www.miele.be), y compris le comportement de l'utilisateur sur les sites Internet de Miele après les clics de newsletter liés, afin de compléter mon profil d'utilisateur pour des communications publicitaires personnalisées, à condition que mon consentement distinct dans l'application ou sur le site Internet autorise le traitement des données. Je peux révoquer mon consentement à tout moment sans donner de raisons avec effet pour l'avenir. Pour plus de détails, voir la politique de protection des données de Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "En plus de mon consentement de base, j'accepte que Miele traite également les données de mes appareils Miele connectés (données sur l'utilisation et l'état des appareils) pour compléter mon profil d'utilisateur en vue d'une publicité personnalisée. Je peux trouver plus d'informations sur le traitement des données des appareils dans la politique de confidentialité du système Miele{'@'}Home. Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir. Pour plus de détails, voir la politique de protection des données de Miele.",
    link: {
      title: "Privacy Policy Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir. Pour plus d'informations sur la manière dont Miele traite vos données, veuillez consulter la politique de protection des données de Miele. ",
    link: {
      title: "politique de protection des données de Miele.",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Oui, j'accepte les conditions d'utilisation.",
    link: {
      title: "Voir les conditions d'utilisation*",
      ref: "#"
    }
  }
}, $u = {
  headline: "Miele Club",
  why: {
    title: "Adhésion",
    reasons: [
      "Surprise d'anniversaire",
      "Offres et campagnes exclusives",
      "Cadeau de bienvenue",
      "Offres et expériences VIP",
      "Des économies attractives",
      "Actualités du club"
    ]
  },
  birthDateTitle: "Souhaitez-vous recevoir une offre pour votre anniversaire?",
  birthDateValidation: {
    requirementMsg: "Entrez la date dans le format suivant: JJ/MM/AAAA",
    errorMsg: "Date incorrecte"
  },
  joinClubLabel: "Oui, je souhaite adhérer au Miele Club.",
  termsAndCondition: {
    description: "J'accepte les {termsAndConditionLink} du Miele Club et confirme avoir pris connaissance des informations sur la {privacyLink} pour le Miele Club.",
    termsAndConditionLink: {
      title: "Conditions de participation et d’utilisation",
      ref: "https://www.miele.be/fr/c/cgv-13.htm"
    },
    privacyLink: {
      title: "Protection des données",
      ref: "https://www.miele.be/fr/c/protection-des-donnees-14.htm"
    }
  },
  newsletter: {
    description: "Oui, je souhaite recevoir des communications publicitaires du Club de la société Miele SAS (« Miele ») personnalisées en fonction de mes intérêts personnels par e-mail et par courrier pour des offres spéciales, des informations, des invitations à des événements et des sondages clients sur nos produits et nos services. J’autorise pour cela Miele à utiliser mes coordonnées (civilité, nom, e-mail, téléphone et adresse postale) et à adapter la communication sur la base de mes habitudes d’achat et de mon comportement vis-à-vis des newsletters, comme décrit plus en détail dans la {privacyLink}. Je peux révoquer mon consentement à tout moment à l’avenir (par exemple par simple email à info{'@'}miele.be, aux coordonnées indiquées dans les mentions légales ou en cliquant sur le lien de désinscription figurant dans les e-mails). La communication contractuelle du Club {termsAndConditionLink} n’en est pas affectée jusqu’à la résiliation de l’adhésion.",
    shortDescription: "Oui, je souhaite recevoir des communications publicitaires du Club de la société Miele SAS (« Miele ») personnalisées en fonction de mes intérêts personnels par e-mail et par courrier",
    privacyLink: {
      title: "Miele Club proteciton des données",
      href: "https://www.miele.be/fr/c/protection-des-donnees-14.htm"
    },
    termsAndConditionLink: {
      title: "Communications du Club",
      href: "https://www.miele.be/fr/c/cgv-13.htm"
    },
    supportEmail: "info{'@'}miele.be"
  },
  selectAllConsents: {
    description: "Pour rejoindre le Miele Club, vous devez accepter tous les termes et conditions *"
  },
  birthDateLabel: "Votre date de naissance (facultatif)"
}, Bu = "afficher la déclaration complète", Ru = "masquer la déclaration complète", Fu = {
  auth: Lu,
  changeEmailScene: Eu,
  changePasswordScene: Pu,
  errors: Tu,
  forgotPassword: Au,
  login: xu,
  modal: Iu,
  passwordStrength: Du,
  passwordHelper: Nu,
  register: Ou,
  "marketing-consent": {
    title: "Préférences marketing",
    description: "Cochez la case ci-dessous pour recevoir des offres exclusives, des informations, des événements et des conseils pour tirer le meilleur parti de votre appareil.",
    submit: "Sauvegarder",
    newsletter: {
      text: "J'accepte que Miele Belgique S.A. (Miele) m'envoie des informations sur les produits et les nouveautés de l'assortiment Miele, les événements, les enquêtes clients et des recettes par e-mail, via l'application Miele et par SMS. J'accepte également que Miele traite à cette fin les coordonnées que j'ai fournies (civilité, nom, adresse e-mail, numéro de téléphone et code postal), les produits Miele que j'ai achetés jusqu'à présent et que j'achèterai à l'avenir, ainsi que les centres d'intérêts que j'ai spécifiés. De plus, j'accepte que Miele traite, à des fins de personnalisation, les accusés de réception et de lecture reçus via la newsletter, ainsi que les informations concernant les liens sur lesquels j'ai cliqué et mon comportement d'utilisateur connexe sur le site web. Il en va de même pour les notifications push in-app, dans la mesure où les applications Miele sont utilisées.",
      link: {
        title: "Voir la politique de protection des données",
        ref: "#"
      }
    },
    personalisation: {
      text: "J’accepte que Miele traite, à des fins de personnalisation avancée, des informations sur les services que j’ai utilisés et les interventions de techniciens effectuées, ainsi que sur les événements auxquels j’ai participé. ",
      link: {
        title: "Voir la politique de protection des données",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "En plus de la personnalisation avancée, j’accepte que Miele traite également les données issues de l’utilisation de l’App Miele et de mes visites sur le sites Internet de Miele (www.miele.be) afin de compléter mon profil d’utilisateur, dans la mesure où j’ai donné mon consentement spécifique au traitement de ces données.",
      link: {
        title: "Voir la politique de protection des données",
        ref: "#"
      }
    },
    highlightedText: {
      text: "Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir. Pour plus d'informations sur la manière dont Miele traite vos données, veuillez consulter la politique de protection des données de Miele. ",
      link: {
        title: "politique de protection des données de Miele.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Oui, j'accepte les conditions d'utilisation.",
      link: {
        title: "Voir les conditions d'utilisation.",
        ref: "https://www.miele.be/fr/c/cgv-13.htm"
      }
    }
  },
  multiLevelMarketingConsent: Uu,
  mieleClub: $u,
  readMore: Bu,
  readLess: Ru
}, Vu = {
  waitMessage: "Presque là. Patientez…"
}, qu = {
  buttonLabel: "Enregistrer",
  buttonLabelClose: "Fermer",
  confirmEmailMessage: "Confirmez votre adresse e-mail",
  copy: "Pour mettre à jour votre adresse e-mail, veuillez ajouter la nouvelle ci-dessous:",
  errorMessageCopy: "Quelque chose s'est mal passé. Réessayez.",
  errorMessageHeadline: "Erreur",
  headline: "Détails du profil",
  inputEmailConfirmPlaceholder: "Confirmez votre adresse e-mail",
  inputEmailPlaceholder: "Adresse e-mail",
  invalidEmailMessage: "E-mail non valide !",
  rememberMeLabel: "Rester connecté",
  successMessageCopy: "Votre adresse e-mail a été mise à jour avec succès.",
  successMessageHeadline: "Adresse e-mail mise à jour"
}, Gu = {
  closeButtonLabel: "Fermer",
  confirmPasswordLabel: "Confirmer le mot de passe",
  currentPasswordLabel: "Mot de passe actuel",
  newPasswordLabel: "Nouveau mot de passe",
  passwordMismatchError: "Le mot de passe ne correspond pas",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  samePasswordError: "Ce mot de passe a déjà été utilisé auparavant. Veuillez saisir un nouveau mot de passe.",
  subtitle: "Pour changer votre mot de passe, veuillez remplir les champs ci-dessous :",
  submitButtonLabel: "Soumettre",
  successfulChangeLabel: "Votre mot de passe a été mis à jour avec succès",
  title: "Changement de mot de passe"
}, Ku = {
  invalidEmail: "E-mail incorrect",
  invalidPassword: "Mot de passe incorrect",
  sap_206002: "Votre compte est en attente de vérification, nous ne pouvons malheureusement pas vous laisser continuer pour le moment. Veuillez nous contacter pour plus de détails.",
  sap_206006: "Il semble que l'adresse e-mail que vous avez soumise soit en attente de vérification.",
  sap_400003: "Cette adresse e-mail existe déjà, veuillez utiliser une adresse e-mail différente.",
  sap_400028: "L'adresse e-mail soumise est en attente de vérification.",
  sap_400050: "Désolé, nous ne pouvons pas valider vos informations d'identification pour le moment.",
  sap_400097: "Il semble que vous accédiez à nos services à partir d'un navigateur non sécurisé/non pris en charge. Veuillez réessayer avec un autre navigateur.",
  sap_401030: "Ce mot de passe a déjà été utilisé, veuillez soumettre un nouveau mot de passe",
  sap_403005: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer.",
  sap_403011: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403012: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403013: "Désolé, nous ne pouvons pas valider vos informations d'identification pour le moment.",
  sap_403035: "Désolé, nous ne pouvons pas valider vos informations d'identification pour le moment.",
  sap_403041: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer.",
  sap_403042: `La combinaison e-mail & mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisissez "mot de passe oublié" si vous souhaitez le réinitialiser.`,
  sap_403043: `La combinaison e-mail & mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisissez "mot de passe oublié" si vous souhaitez le réinitialiser.`,
  sap_403047: `La combinaison e-mail & mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisissez "mot de passe oublié" si vous souhaitez le réinitialiser.`,
  sap_403100: "Une demande de mise à jour de mot de passe a été récemment demandée, veuillez patienter jusqu'à ce que la demande soit traitée",
  sap_403025: "Le lien de réinitialisation du mot de passe n'est pas valide, veuillez envoyer à nouveau une demande de mot de passe oublié pour recevoir un nouveau lien de réinitialisation.",
  sapErrorTitle: "Erreur de traitement de la demande",
  sessionExpired: "Session expirée",
  tooWeakPassword: "Le mot de passe doit contenir au moins {minLength} caractères et {minCharGroups} des éléments suivants : lettre majuscule, lettre minuscule, chiffre, symbole spécial | Le mot de passe doit contenir au moins {minLength} caractères",
  unexpectedDescription: "Si le problème persiste, veuillez nous contacter via le formulaire de contact avec les détails.",
  unexpectedTitle: "Une erreur inattendue s'est produite",
  unknownDescription: "Erreur inattendue. Veuillez réessayer.",
  unknownTitle: "Oups !"
}, Hu = {
  subtitle: "Définissez votre nouveau mot de passe.",
  title: "Mot de passe oublié ?"
}, Wu = {
  headMetaDescription: "Page de connexion client",
  headTitle: "Connectez-vous avec votre e-mail et votre mot de passe :",
  subtitle: "Connectez-vous ou créez un compte pour bénéficier de toutes les fonctionnalités de Miele.",
  title: "Connectez-vous à votre compte",
  error: {
    invalidEmailPasswordDescription: "La combinaison de l'adresse e-mail et du mot de passe n'est pas valide.",
    invalidEmailPasswordTitle: "Identifiants invalides",
    missingConcentTitle: "Compte en attente d'inscription",
    noAccountDescription: "Aucun compte associé à cette adresse e-mail.",
    noAccountTitle: "Aucun compte enregistré"
  },
  extraConsentScene: {
    continue: "Continuer",
    privacyStatementCheckboxLabel: "J'ai pris connaissance de la {0}.",
    privacyStatementName: "déclaration de confidentialité",
    privacyStatementTitle: "Notre déclaration de confidentialité a été mise à jour",
    termsOfUseCheckboxLabel: "J'accepte les {0}.",
    termsOfUseName: "conditions d'utilisation",
    termsOfUseTitle: "Nos conditions d'utilisation ont été mises à jour",
    title: "Compléter le profil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Retour à la connexion",
    submitButtonLabel: "Soumettre",
    successDescription: "Veuillez vérifier votre e-mail, vous recevrez bientôt les informations sur votre compte pour commencer le processus de réinitialisation du mot de passe.",
    successTitle: "Votre demande a été reçue.",
    title: "Veuillez saisir votre adresse e-mail pour réinitialiser votre mot de passe :"
  },
  loginModalScene: {
    copy: "Connectez-vous ou créez un compte pour bénéficier de toutes les fonctionnalités de Miele.",
    title: "Connectez-vous à votre compte"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Mot de passe oublié",
    invalidEmailMessage: "E-mail non valide !",
    loginButtonLabel: "Se connecter",
    passwordInputLabel: "Mot de passe",
    rememberMeLabel: "Rester connecté",
    title: "Connectez-vous avec votre e-mail et votre mot de passe :"
  }
}, Ju = {
  accessibility: {
    close: "Fermer"
  }
}, Zu = {
  tooShort: "Trop court",
  medium: "Moyen",
  strong: "Fort",
  tooWeak: "Trop faible",
  veryStrong: "Très fort",
  weak: "Faible"
}, Yu = {
  showPasswordText: "Afficher",
  hidePasswordText: "Masquer"
}, Xu = {
  registerButtonLabel: "S'inscrire",
  registerTitle: "Vous n'avez pas de compte ?",
  whyRegister: {
    list: [
      "Accès à des avantages exclusifs du Club Mieleb",
      "Enregistrement des appareils, suivi des commandes, accès aux manuels",
      "Recevoir des offres et des promotions personnalisées",
      "Voir toutes vos commandes, garanties, événements et services"
    ],
    title: "Pourquoi s'inscrire ?"
  },
  closeButtonLabel: "Fermer",
  passwordMismatchError: "Les mots de passe ne correspondent pas",
  passwordUpdateErrorTitle: "Erreur de mise à jour du mot de passe",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  successfulChangeLabel: "Votre mot de passe a été mis à jour avec succès"
}, Qu = {
  title: "Préférences marketing",
  description: "Vous êtes intéressé(e) par des offres exclusives, des nouveautés produits, des événements, des enquêtes clients et d’autres informations utiles sur l’univers Miele ?",
  submit: "Enregistrer",
  levelOne: {
    text: "J’accepte que Miele AG (“Miele”) m’envoie des informations et des offres sur ses produits et services ainsi que des invitations pour participer à des événements et à des enquêtes clients par e-mail (newsletter), courrier, SMS ou via les applications Miele. Afin d’adapter au mieux la communication commerciale à vos besoins, Miele traite les données personnelles suivantes et procède à un profilage (c’est-à-dire un traitement automatisé des données personnelles afin d’analyser des aspects personnels ou de faire des prévisions) : données de contact, données des appareils, données issues de sondages ou d’enquêtes clients, historique des achats et clics sur la newsletter, prestations de service demandées, interventions de techniciens et participations à des événements, comportement d’utilisation de l’application Miele et des pages Internet. Vous trouverez plus de détails dans la ",
    link: {
      title: "Déclaration de confidentialité.",
      ref: "https://www.miele.ch/fr/c/protection-des-donnees-14.htm"
    }
  },
  levelTwo: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  highlightedText: {
    text: "Je peux révoquer mon consentement à tout moment et sans donner de raisons, avec effet pour l’avenir. Pour plus d’informations sur la manière dont Miele traite vos données, veuillez consulter ",
    link: {
      title: "la politique de protection des données de Miele.",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Oui, j'accepte les conditions d'utilisation.",
    link: {
      title: "Voir les conditions d'utilisation.",
      ref: "https://www.miele.ch/fr/c/conditions-d-utilisation-304.htm"
    }
  }
}, em = {
  headline: "Club Miele",
  why: {
    title: "Avantages exclusifs pour les membres - Communication personnelle du club.",
    reasons: [
      "Cadeau de bienvenue -10%",
      "Surprise d'anniversaire",
      "Offres et événements exclusives",
      "Conseils sur l'utilisation des appareils"
    ]
  },
  birthDateTitle: "Souhaitez-vous recevoir une offre pour votre anniversaire?",
  birthDateValidation: {
    requirementMsg: "Entrez la date dans le format suivant: JJ/MM/AAAA",
    errorMsg: "Date incorrecte"
  },
  joinClubLabel: "Oui, je souhaite adhérer au Miele Club.",
  termsAndCondition: {
    description: "Oui, j’ai lu et j’accepte les {termsAndConditionLink} au Club Miele.",
    termsAndConditionLink: {
      title: "conditions de participation",
      ref: "https://www.miele.ch/fr/c/agb-13.htm#p7364"
    },
    privacyLink: {
      title: "",
      ref: ""
    }
  },
  newsletter: {
    description: "Oui, j’ai lu et j’accepte la {privacyLink} du Club Miele. Conformément à la Déclaration de confidentialité, le traitement comprend notamment le profilage basé sur le comportement des clients et l’utilisation des profils clients à des fins de marketing et à d'autres fins.",
    privacyLink: {
      title: "Déclaration de confidentialité",
      href: "https://www.miele.ch/fr/c/datenschutz-14.htm"
    },
    termsAndConditionLink: {
      title: "",
      href: ""
    },
    supportEmail: "info{'@'}miele.ch"
  },
  selectAllConsents: {
    description: "Pour adhérer au Miele Club, vous devez accepter l'ensemble des conditions générales."
  },
  birthDateLabel: "Votre date de naissance (facultatif)"
}, tm = "afficher la déclaration complète", im = "masquer la déclaration complète", nm = {
  auth: Vu,
  changeEmailScene: qu,
  changePasswordScene: Gu,
  errors: Ku,
  forgotPassword: Hu,
  login: Wu,
  modal: Ju,
  passwordStrength: Zu,
  passwordHelper: Yu,
  register: Xu,
  "marketing-consent": {
    title: "Préférences marketing",
    description: "Vous êtes intéressé(e) par des offres exclusives, des nouveautés produits, des événements, des enquêtes clients et d’autres informations utiles sur l’univers Miele ?",
    submit: "Enregistrer",
    newsletter: {
      text: "J’accepte que Miele AG (“Miele”) m’envoie des informations et des offres sur ses produits et services ainsi que des invitations pour participer à des événements et à des enquêtes clients par e-mail (newsletter), courrier, SMS ou via les applications Miele. Afin d’adapter au mieux la communication commerciale à vos besoins, Miele traite les données personnelles suivantes et procède à un profilage (c’est-à-dire un traitement automatisé des données personnelles afin d’analyser des aspects personnels ou de faire des prévisions) : données de contact, données des appareils, données issues de sondages ou d’enquêtes clients, historique des achats et clics sur la newsletter, prestations de service demandées, interventions de techniciens et participations à des événements, comportement d’utilisation de l’application Miele et des pages Internet.",
      link: {
        title: "Voir la déclaration de confidentialité",
        ref: "#"
      }
    },
    personalisation: {
      text: "Je consens à ce que Miele traite les informations relatives aux services que j’ai utilisés, aux interventions de technicien auxquelles j’ai eu recours ainsi qu’aux événements auxquels j’ai participé, dans le but d’améliorer la personnalisation.",
      link: {
        title: "Voir la déclaration de confidentialité",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "En plus de la personnalisation étendue, je consens également à ce que Miele traite les données issues de l’utilisation de l’app Miele et de mes consultations des sites Internet de Miele (www.miele.ch) pour compléter mon profil d’utilisateur, dans la mesure où j’ai consenti séparément au traitement de ces données. Pour plus de détails, voir la politique de protection des données de Miele.",
      link: {
        title: "Voir la déclaration de confidentialité",
        ref: ""
      }
    },
    highlightedText: {
      text: "Je peux révoquer mon consentement à tout moment et sans donner de raisons, avec effet pour l’avenir. Pour plus d’informations sur la manière dont Miele traite vos données, veuillez consulter ",
      link: {
        title: "la politique de protection des données de Miele.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Oui, j'accepte les conditions d'utilisation.",
      link: {
        title: "Voir les conditions d'utilisation*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: Qu,
  mieleClub: em,
  readMore: tm,
  readLess: im
}, am = {
  waitMessage: "Presque là. Tenez bon ..."
}, sm = {
  buttonLabel: "Enregistrer",
  buttonLabelClose: "Fermer",
  confirmEmailMessage: "Confirmer votre adresse e-mail",
  copy: "Pour mettre à jour votre adresse e-mail, veuillez saisir la nouvelle ci-dessous:",
  errorMessageCopy: "Quelque chose s'est mal passé. Réessayez.",
  errorMessageHeadline: "Erreur",
  headline: "Détails du profil",
  inputEmailConfirmPlaceholder: "Confirmez votre adresse e-mail",
  inputEmailPlaceholder: "Adresse e-mail",
  invalidEmailMessage: "Adresse e-mail non valide !",
  rememberMeLabel: "Se souvenir de moi",
  successMessageCopy: "Votre adresse e-mail a été mise à jour avec succès.",
  successMessageHeadline: "Adresse e-mail mise à jour"
}, om = {
  closeButtonLabel: "Fermer",
  confirmPasswordLabel: "Confirmer le mot de passe",
  currentPasswordLabel: "Mot de passe actuel",
  newPasswordLabel: "Nouveau mot de passe",
  passwordMismatchError: "Le mot de passe ne correspond pas",
  passwordUpdateErrorTitle: "Erreur",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  samePasswordError: "Ce mot de passe a été utilisé précédemment. Veuillez saisir un nouveau mot de passe.",
  subtitle: "Pour changer votre mot de passe, veuillez remplir les champs ci-dessous : ",
  submitButtonLabel: "Soumettre",
  successfulChangeLabel: "Votre mot de passe a été mis à jour avec succès",
  title: "Changement de mot de passe"
}, rm = {
  invalidEmail: "Adresse e-mail incorrecte",
  invalidPassword: "Mot de passe incorrect",
  sap_206002: "Votre compte est en attente de vérification. Malheureusement, nous ne pouvons pas vous autoriser à continuer pour le moment. Veuillez nous contacter pour plus de détails.",
  sap_206006: "Il semblerait que l'adresse e-mail que vous avez soumise soit en attente de vérification.",
  sap_400003: "Cet e-mail existe déjà, veuillez utiliser une adresse e-mail différente !",
  sap_400028: "L'adresse e-mail soumise est en attente de vérification",
  sap_400050: "Désolé, nous ne pouvons pas valider vos informations d'identification pour le moment.",
  sap_400097: "Il semblerait que vous accédiez à nos services à partir d'un navigateur non sécurisé/ non-supporté. Veuillez réessayer avec un autre navigateur.",
  sap_401030: "Ce mot de passe a déjà été utilisé précédemment, veuillez saisir un nouveau mot de passe",
  sap_403005: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer",
  sap_403011: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403012: "Session expirée. Veuillez recharger le navigateur et vous connecter à nouveau.",
  sap_403013: "Désolé, nous ne sommes pas en mesure de valider vos identifiants pour le moment.",
  sap_403035: "Désolé, nous ne sommes pas en mesure de valider vos identifiants pour le moment.",
  sap_403041: "Nous n'avons pas de compte associé à cette adresse e-mail, veuillez vérifier votre e-mail et réessayer",
  sap_403042: "La combinaison E-mail et Mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisir Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403043: "La combinaison E-mail et Mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisir Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403047: "La combinaison E-mail et Mot de passe n'est pas valide. Veuillez vérifier l'e-mail associé au compte ou choisir Mot de passe oublié si vous souhaitez le réinitialiser.",
  sap_403100: "Une demande de mise à jour de mot de passe a été récemment effectuée, veuillez patienter jusqu'à ce que la demande soit traitée.",
  sap_403025: "Le lien de réinitialisation du mot de passe n'est pas valide, veuillez envoyer à nouveau une demande de mot de passe oublié pour recevoir un nouveau lien de réinitialisation.",
  sapErrorTitle: "Erreur de traitement de la demande",
  sessionExpired: "Session expirée",
  tooWeakPassword: "Le mot de passe doit contenir au moins {minLength} caractères et {minCharGroups} des éléments suivants : une lettre majuscule, une lettre minuscule, un chiffre, un symbole spécial | Le mot de passe doit contenir au moins {minLength} caractères",
  unexpectedDescription: "Si le problème persiste, veuillez nous contacter via le formulaire de contact en nous fournissant les détails.",
  unexpectedTitle: "Une erreur imprévue est survenue",
  unknownDescription: "Erreur imprévue. Veuillez réessayer.",
  unknownTitle: "Oups !"
}, lm = {
  subtitle: "Définissez votre nouveau mot de passe.",
  title: "Vous avez oublié votre mot de passe ?"
}, cm = {
  headMetaDescription: "Page de connexion du client",
  headTitle: "Connectez-vous avec votre email et votre mot de passe :",
  subtitle: "Connectez-vous ou créez un compte pour bénéficier de toutes les fonctionnalités Miele.",
  title: "Connectez-vous à votre compte",
  error: {
    invalidEmailPasswordDescription: "La combinaison de l'adresse e-mail et du mot de passe n'est pas valide.",
    invalidEmailPasswordTitle: "Informations d'identification invalides",
    missingConcentTitle: "En attente d'enregistrement du compte",
    noAccountDescription: "Il n'y a aucun compte associé à cette adresse e-mail.",
    noAccountTitle: "Aucun compte enregistré"
  },
  extraConsentScene: {
    continue: "Continuer",
    privacyStatementCheckboxLabel: "J'ai pris connaissance de la {0}.",
    privacyStatementName: "politique de confidentialité",
    privacyStatementTitle: "Notre politique de confidentialité a été modifiée",
    termsOfUseCheckboxLabel: "J'accepte les {0}.",
    termsOfUseName: "conditions d'utilisation",
    termsOfUseTitle: "Nos conditions d'utilisation ont été modifiées",
    title: "Compléter le profil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Retour à la page de connexion",
    submitButtonLabel: "Envoyer",
    successDescription: "Veuillez consulter votre messagerie, vous recevrez bientôt les informations concernant votre compte pour commencer le processus de réinitialisation du mot de passe.",
    successTitle: "Votre demande a été reçue.",
    title: "Veuillez saisir votre adresse e-mail pour réinitialiser votre mot de passe :"
  },
  loginModalScene: {
    copy: "Connectez-vous ou créez un compte pour profiter de toutes les fonctionnalités de Miele.",
    title: "Connectez-vous à votre compte"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "J'ai oublié mon mot de passe",
    invalidEmailMessage: "L'e-mail n'est pas valide !",
    loginButtonLabel: "Connexion",
    passwordInputLabel: "Mot de passe",
    rememberMeLabel: "Se souvenir de moi",
    title: "Connectez-vous avec votre e-mail et votre mot de passe :"
  }
}, dm = {
  accessibility: {
    close: "Fermer"
  }
}, um = {
  tooShort: "Trop court",
  medium: "Moyen",
  strong: "Fort",
  tooWeak: "Trop faible",
  veryStrong: "Très fort",
  weak: "Faible"
}, mm = {
  showPasswordText: "Afficher",
  hidePasswordText: "Masquer"
}, pm = {
  registerButtonLabel: "S'enregistrer",
  registerTitle: "Vous n'avez pas de compte ?",
  whyRegister: {
    list: {
      1: "Enregistrer les appareils, suivre les commandes, accéder aux manuels",
      2: "Recevoir des offres et promotions personnalisées",
      3: "Voir toutes vos commandes, garanties, événements et services"
    },
    title: "Pourquoi s'inscrire ?"
  },
  closeButtonLabel: "Fermer",
  passwordMismatchError: "Les mots de passe ne correspondent pas",
  passwordUpdateErrorTitle: "Erreur de mise à jour de mot de passe",
  passwordUpdateSuccessTitle: "Mot de passe mis à jour",
  successfulChangeLabel: "Votre mot de passe a été mis à jour."
}, hm = {
  title: "Préférences de marketing",
  description: "Sélectionnez ci-dessous pour des offres exclusives, des actualités, des événements et des astuces pour votre appareil.",
  submit: "Enregistrer",
  levelOne: {
    shortText: "Oui, je souhaite recevoir des communications promotionnelles de Miele s.à r.l. et Miele & Cie. KG («Miele») adaptées à mes intérêts personnels par e-mail, SMS, courrier et via les applications et les sites internet Miele (si utilisées)",
    text: "Oui, je souhaite recevoir des communications promotionnelles de Miele s.à r.l. et Miele & Cie. KG («Miele») adaptées à mes intérêts personnels par e-mail, SMS, courrier et via les applications et les sites internet Miele (si utilisées) avec des informations sur les produits, les offres et les innovations de la gamme de produits Miele et sur les événements Miele, ainsi que des enquêtes clients, des demandes d'évaluation et d'appréciation des produits et des recettes. À cette fin, Miele peut utiliser mes coordonnées (titre, nom, adresse électronique, numéro de téléphone portable et adresse postale) et élaborer la communication sur la base de mes achats, de mes services, de l'historique des événements, du comportement de clic et d'ouverture des newsletters ainsi que de la valeur client, comme décrit en détail dans notre politique de confidentialité. Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir (par exemple, en envoyant un e-mail à privacy{'@'}miele.lu, aux coordonnées indiquées dans les mentions légales ou en cliquant sur le lien de désinscription dans les e-mails).",
    link: {
      title: "Protection des données",
      ref: "https://www.miele.lu/fr/c/protection-des-donnees-14.htm"
    }
  },
  levelTwo: {
    text: "En plus de mon consentement de base, j'accepte que Miele traite également les données issues de l'utilisation de l'application Miele et de mes visites sur les sites Internet de Miele (www.miele.lu), y compris le comportement de l'utilisateur sur les sites Internet de Miele après les clics de newsletter liés, afin de compléter mon profil d'utilisateur pour des communications publicitaires personnalisées, à condition que mon consentement distinct dans l'application ou sur le site Internet autorise le traitement des données. Je peux révoquer mon consentement à tout moment sans donner de raisons avec effet pour l'avenir. Pour plus de détails, voir la politique de protection des données de Miele.",
    link: {
      title: "Protection des données",
      ref: "https://www.miele.lu/fr/c/protection-des-donnees-14.htm"
    }
  },
  levelThree: {
    text: "En plus de mon consentement de base, j'accepte que Miele traite également les données de mes appareils Miele connectés (données sur l'utilisation et l'état des appareils) pour compléter mon profil d'utilisateur en vue d'une publicité personnalisée. Je peux trouver plus d'informations sur le traitement des données des appareils dans la politique de confidentialité du système Miele{'@'}Home. Je peux révoquer mon consentement à tout moment, sans donner de raisons, avec effet pour l'avenir. Pour plus de détails, voir la politique de Protection des données de Miele.",
    link: {
      title: "Système Miele{'@'}Home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "J'ai lu et j'accepte les",
    link: {
      title: "Conditions d'utilisation",
      ref: "https://www.miele.lu/fr/c/cgv-13.htm"
    }
  }
}, gm = {
  headline: "Miele Club",
  why: {
    title: "Adhésion gratuite - Offres exclusives pour les membres.",
    reasons: [
      "Offre de bienvenue de -15%",
      "Surprise pour votre anniversaire",
      "Offres spéciales membres",
      "Invitations à nos evenements exclusifs"
    ]
  },
  birthDateTitle: "Souhaitez-vous recevoir une offre pour votre anniversaire?",
  birthDateValidation: {
    requirementMsg: "Entrez la date dans le format suivant: JJ/MM/AAAA",
    errorMsg: "Date incorrecte"
  },
  joinClubLabel: "Oui, je souhaite adhérer au Miele Club.",
  termsAndCondition: {
    description: "J'accepte les {termsAndConditionLink} du Miele Club et confirme avoir pris connaissance des informations sur la {privacyLink} pour le Miele Club.",
    termsAndConditionLink: {
      title: "Conditions de participation et d’utilisation",
      ref: "https://www.miele.lu/fr/c/cgv-13.htm"
    },
    privacyLink: {
      title: " Protection des données",
      ref: "https://www.miele.lu/fr/c/protection-des-donnees-14.htm"
    }
  },
  newsletter: {
    description: "Oui, je souhaite recevoir des communications publicitaires du Club de la société Miele SAS (« Miele ») personnalisées en fonction de mes intérêts personnels par e-mail et par courrier pour des offres spéciales, des informations, des invitations à des événements et des sondages clients sur nos produits et nos services. J’autorise pour cela Miele à utiliser mes coordonnées (civilité, nom, e-mail, téléphone et adresse postale) et à adapter la communication sur la base de mes habitudes d’achat et de mon comportement vis-à-vis des newsletters, comme décrit plus en détail dans la {privacyLink}. Je peux révoquer mon consentement à tout moment à l’avenir (par exemple par simple email à info{'@'}miele.lu, aux coordonnées indiquées dans les mentions légales ou en cliquant sur le lien de désinscription figurant dans les e-mails). La communication contractuelle du Club {termsAndConditionLink} n’en est pas affectée jusqu’à la résiliation de l’adhésion.",
    shortDescription: "Oui, je souhaite recevoir des communications publicitaires du Club de la société Miele SAS (« Miele ») personnalisées en fonction de mes intérêts personnels par e-mail et par courrier",
    privacyLink: {
      title: "Miele Club proteciton des données",
      href: "https://www.miele.lu/fr/c/protection-des-donnees-14.htm"
    },
    termsAndConditionLink: {
      title: "Communications du Club",
      href: "https://www.miele.lu/fr/c/cgv-13.htm"
    },
    supportEmail: "info{'@'}miele.lu"
  },
  selectAllConsents: {
    description: "Pour rejoindre le Miele Club, vous devez accepter tous les termes et conditions *"
  },
  birthDateLabel: "Votre date de naissance (facultatif)"
}, vm = "afficher la déclaration complète", fm = "masquer la déclaration complète", km = {
  auth: am,
  changeEmailScene: sm,
  changePasswordScene: om,
  errors: rm,
  forgotPassword: lm,
  login: cm,
  modal: dm,
  passwordStrength: um,
  passwordHelper: mm,
  register: pm,
  "marketing-consent": {
    title: "Préférences de marketing",
    submit: "Sélectionnez ci-dessous pour des offres exclusives, des actualités, des événements et des astuces pour votre appareil.",
    description: "Enregistrer",
    newsletter: {
      text: `Je suis d'accord que Miele Co Ltd. ("Miele") peut m'envoyer des informations sur les produits et les innovations de la gamme de produits Miele, ainsi que des sondages auprès des clients, et des recettes par courrier électronique, les applications Miele et SMS et que Miele peut traiter les coordonnées que j'ai fournies (titre, nom, adresse e-mail, numéro de téléphone portable et code postal) et les produits Miele que j'ai achetés jusqu'à présent et que j'achèterai à l'avenir ainsi que les intérêts que j'ai indiqués à cette fin. Je suis également d'accord que Miele peut également traiter les confirmations de réception et de lecture reçues par le biais de la newsletter et des informations sur les liens sur lesquels j'ai cliqué, ainsi que sur mon comportement d'utilisateur associé sur le site web lié à des fins de personnalisation. Il en va de même pour les messages push in-app, dans la mesure où les applications Miele sont utilisées.`,
      link: {
        title: "Voir la politique de protection des données",
        ref: "#"
      }
    },
    personalisation: {
      text: "Je suis d'accord que Miele puisse traiter des informations sur les services que j'ai utilisés, les affectations de techniciens que j'ai effectuées, ainsi que des événements auxquels j'ai participé, afin d'améliorer la personnalisation.",
      link: {
        title: "Voir la politique de protection des données",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "En plus de la personnalisation étendue, je suis d'accord que Miele puisse également traiter les données d'utilisation de l'application Miele et de mes visites sur les sites web de Miele (www.miele.lu) pour compléter mon profil utilisateur, à condition que j'ai donné mon consentement séparément pour le traitement de ces données.",
      link: {
        title: "Voir la politique de protection des données",
        ref: "#"
      }
    },
    highlightedText: {
      text: " Je peux révoquer mon consentement à tout moment sans donner de raisons avec effet pour l'avenir. Pour plus d'informations sur la manière dont Miele traite vos données, veuillez consulter la page ",
      link: {
        title: "Politique de protection des données",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Oui, j'accepte les conditions d'utilisation.",
      link: {
        title: "Voir les conditions d'utilisation*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: hm,
  mieleClub: gm,
  readMore: vm,
  readLess: fm
}, bm = {
  waitMessage: "Quasi arrivati. Resistete..."
}, wm = {
  buttonLabel: "Salva",
  buttonLabelClose: "Chiudi",
  confirmEmailMessage: "Conferma il tuo indirizzo email",
  copy: "Per aggiornare il tuo indirizzo email, inserisci quello nuovo qui sotto:",
  errorMessageCopy: "Qualcosa è andato storto. Riprova.",
  errorMessageHeadline: "Errore",
  headline: "Dettagli profilo",
  inputEmailConfirmPlaceholder: "Conferma il tuo indirizzo email",
  inputEmailPlaceholder: "Indirizzo email",
  invalidEmailMessage: "Indirizzo email non valido!",
  rememberMeLabel: "Ricordami",
  successMessageCopy: "Il tuo indirizzo email è stato aggiornato con successo.",
  successMessageHeadline: "Indirizzo email aggiornato"
}, ym = {
  closeButtonLabel: "Chiudi",
  confirmPasswordLabel: "Conferma Password",
  currentPasswordLabel: "Password attuale",
  newPasswordLabel: "Nuova Password",
  passwordMismatchError: "La password non corrisponde",
  passwordUpdateErrorTitle: "Errore",
  passwordUpdateSuccessTitle: "Password aggiornata",
  samePasswordError: "Questa password è stata utilizzata in precedenza, invia una nuova password",
  subtitle: "Per cambiare la password, compila i campi qui sotto:",
  submitButtonLabel: "Invia",
  successfulChangeLabel: "La tua password è stata aggiornata con successo",
  title: "Cambio password"
}, Mm = {
  invalidEmail: "Email non corretta",
  invalidPassword: "Password errata",
  sap_206002: "Il tuo account è in attesa di verifica, mi dispiace ma al momento non possiamo permetterti di procedere. Contattaci per maggiori dettagli.",
  sap_206006: "Sembra che l'indirizzo email che hai inviato sia in attesa di verifica",
  sap_400003: "Questo indirizzo email esiste già, per favore utilizza un altro indirizzo email!",
  sap_400028: "L'indirizzo email inviato è in attesa di verifica",
  sap_400050: "Mi dispiace, al momento non siamo in grado di convalidare le tue credenziali.",
  sap_400097: "Sembra che tu stia accedendo ai nostri servizi da un browser non protetto/non supportato. Riprova con un altro browser.",
  sap_401030: "Questa password è stata utilizzata in precedenza, per favore inserisci una nuova password",
  sap_403005: "Non abbiamo un account associato a questo indirizzo email, per favore controlla la tua email e riprova.",
  sap_403011: "Sessione scaduta. Si prega di ricaricare il browser e accedere nuovamente.",
  sap_403012: "Sessione scaduta. Si prega di ricaricare il browser e accedere nuovamente.",
  sap_403013: "Spiacenti, al momento non siamo in grado di convalidare le tue credenziali.",
  sap_403035: "Spiacenti, al momento non siamo in grado di convalidare le tue credenziali.",
  sap_403041: "Non abbiamo un account associato a questo indirizzo email, per favore controlla la tua email e riprova.",
  sap_403042: "La combinazione Email & Password non è valida. Si prega di controllare l'email associata all'account o scegliere l'opzione di recupero password se si desidera reimpostarla.",
  sap_403043: "La combinazione Email & Password non è valida. Si prega di controllare l'email associata all'account o scegliere l'opzione di recupero password se si desidera reimpostarla.",
  sap_403047: "La combinazione Email & Password non è valida. Si prega di controllare l'email associata all'account o scegliere l'opzione di recupero password se si desidera reimpostarla.",
  sap_403100: "È stata richiesta di recente una modifica della password, per favore attendi finché la richiesta viene elaborata.",
  sap_403025: "Il link per la reimpostazione della password non è valido. Invia nuovamente la richiesta di password dimenticata per ricevere un nuovo link per la reimpostazione.",
  sapErrorTitle: "Errore elaborazione richiesta",
  sessionExpired: "Sessione scaduta",
  tooWeakPassword: "La password deve contenere almeno {minLength} caratteri e {minCharGroups} dei seguenti elementi: lettera maiuscola, lettera minuscola, numero, simbolo speciale | La password deve contenere almeno {minLength} caratteri",
  unexpectedDescription: "Se il problema persiste, contattaci attraverso il modulo di contatto fornendoci i dettagli necessari.",
  unexpectedTitle: "Si è verificato un errore imprevisto",
  unknownDescription: "Errore imprevisto. Riprova per favore.",
  unknownTitle: "Oops!"
}, zm = {
  subtitle: "Imposta la tua nuova password.",
  title: "Hai dimenticato la password?"
}, jm = {
  headMetaDescription: "Pagina di login del cliente",
  headTitle: "Accedi con la tua e-mail e password:",
  subtitle: "Accedi o crea un account per accedere a tutte le funzioni Miele.",
  title: "Accedi al tuo account",
  error: {
    invalidEmailPasswordDescription: "La combinazione di indirizzo e-mail e password non è valida.",
    invalidEmailPasswordTitle: "Credenziali non valide",
    missingConcentTitle: "Account in attesa di registrazione",
    noAccountDescription: "Non esiste alcun account associato a questo indirizzo e-mail.",
    noAccountTitle: "Nessun account registrato"
  },
  extraConsentScene: {
    continue: "Continua",
    privacyStatementCheckboxLabel: "Ho preso visione dell'{0}.",
    privacyStatementName: "informativa sulla privacy",
    privacyStatementTitle: "La nostra politica sulla privacy è cambiata",
    termsOfUseCheckboxLabel: "Accetto i {0}.",
    termsOfUseName: "termini di utilizzo",
    termsOfUseTitle: "I nostri termini di utilizzo sono cambiati",
    title: "Completamento profilo"
  },
  forgotPasswordScene: {
    backButtonLabel: "Torna al Login",
    submitButtonLabel: "Invia",
    successDescription: "Controlla la tua e-mail, riceverai presto le istruzioni sul tuo account per iniziare il processo di reset della password.",
    successTitle: "Abbiamo ricevuto la tua richiesta.",
    title: "Inserisci il tuo indirizzo email per reimpostare la password:"
  },
  loginModalScene: {
    copy: "Accedi o crea un account per usufruire di tutte le funzionalità Miele.",
    title: "Accedi al tuo account"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Ho dimenticato la password",
    invalidEmailMessage: "E-mail non valida!",
    loginButtonLabel: "Accedi",
    passwordInputLabel: "Password",
    rememberMeLabel: "Ricordami",
    title: "Accedi con il tuo indirizzo email e la password:"
  }
}, _m = {
  accessibility: {
    close: "Chiudi"
  }
}, Sm = {
  tooShort: "Troppo corta",
  medium: "Media",
  strong: "Forte",
  tooWeak: "Troppo debole",
  veryStrong: "Molto forte",
  weak: "Debole"
}, Cm = {
  showPasswordText: "Mostra",
  hidePasswordText: "Nascondi"
}, Lm = {
  registerButtonLabel: "registrati",
  registerTitle: "Non hai ancora un account?",
  whyRegister: {
    list: {
      0: "Accesso a vantaggi esclusivi del Miele Club",
      1: "Registra i tuoi elettrodomestici, traccia gli ordini, accedi ai manuali",
      2: "Ricevi offerte e promozioni personalizzate",
      3: "Visualizza tutti i tuoi ordini, garanzie, eventi e servizi"
    },
    title: "Perché registrarsi?"
  },
  closeButtonLabel: "Chiudi",
  passwordMismatchError: "Le password non corrispondono",
  passwordUpdateErrorTitle: "Errore durante l'aggiornamento della password",
  passwordUpdateSuccessTitle: "Password aggiornata",
  successfulChangeLabel: "La tua password è stata aggiornata con successo"
}, Em = {
  title: "Preferenze di marketing",
  description: "Spunta la casella qui sotto per ricevere offerte esclusive, notizie, consigli sui prodotti e altro ancora",
  submit: "Salva",
  levelOne: {
    shortText: 'Sì, desidero ricevere comunicazioni promozionali da Miele Italia S.r.l. e Miele & Cie. KG ("Miele"), personalizzate in base ai miei interessi personali, via e-mail, SMS, posta e tramite le app Miele e il sito web (se utilizzati)',
    text: `Sì, desidero ricevere comunicazioni promozionali da Miele Italia S.r.l. e Miele & Cie. KG ("Miele"), personalizzate in base ai miei interessi personali, via e-mail, SMS, posta e tramite le app Miele e il sito web (se utilizzati) con informazioni su prodotti, offerte e innovazioni della gamma di prodotti Miele e su eventi Miele, nonché sondaggi tra i clienti, richieste di valutazione e recensione dei prodotti e ricette. A tal fine, Miele può utilizzare i miei dati di contatto (titolo, nome, indirizzo e-mail, numero di cellulare e indirizzo postale) e progettare la comunicazione in base ai miei acquisti, ai servizi, alla cronologia degli eventi, al comportamento di clic e apertura della newsletter e al valore del cliente, come descritto in dettaglio nella nostra informativa sulla privacy. Posso revocare il mio consenso in qualsiasi momento, senza fornire motivazioni, con effetto per il futuro (ad esempio, inviando un messaggio informale a contact{'@'}miele-support.it, ai dettagli di contatto indicati nell'imprinting o facendo clic sul link di annullamento dell'iscrizione nelle e-mail).`,
    link: {
      title: "Privacy",
      ref: "https://www.miele.it/c/privacy-14.htm"
    }
  },
  levelTwo: {
    text: "Oltre al mio consenso di base, accetto che Miele possa trattare anche i dati derivanti dall'utilizzo dell'app Miele e dalle mie visite ai siti web Miele (www.miele.it), compreso il comportamento dell'utente sui siti web Miele dopo i clic sulla newsletter collegata, per integrare il mio profilo utente per comunicazioni pubblicitarie personalizzate, a condizione che il mio consenso separato nell'app o sul sito web autorizzi il trattamento dei dati. Posso revocare il mio consenso in qualsiasi momento, senza fornire motivazioni, con effetto per il futuro. Ulteriori dettagli nella politica di protezione dei dati di Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Oltre al mio consenso di base, accetto che Miele possa elaborare anche i dati dei miei elettrodomestici Miele collegati (dati sull'utilizzo e sullo stato degli elettrodomestici) per integrare il mio profilo utente per la pubblicità personalizzata. Posso trovare ulteriori informazioni sul trattamento dei dati degli elettrodomestici nell'informativa sulla privacy del sistema Miele{'@'}Home. Posso revocare il mio consenso in qualsiasi momento, senza fornire motivazioni, con effetto per il futuro. Ulteriori dettagli nella politica di protezione dei dati di Miele.",
    link: {
      title: "Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Possono revocare il mio consenso in qualsiasi momento senza dover fornire delle motivazioni e con effetto futuro. Per maggiori informazioni su come Miele gestisce i tuoi dati, si prega di consultare la ",
    link: {
      title: "politica di protezione dei dati di Miele.",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Sì, acconsento ai termini d'uso.",
    link: {
      title: "Vedi i termini d'uso.",
      ref: "https://www.miele.it/c/condizioni-di-utilizzo-304.htm"
    }
  }
}, Pm = {
  headline: "Miele Club",
  why: {
    title: "Vantaggi esclusivi e comunicazioni personalizzate per i membri.",
    reasons: [
      "Regalo di benvenuto",
      "Sorpresa di compleanno",
      "Offerte ed eventi esclusivi",
      "Consiglio sull'utilizzo di elettrodomestici, detersivi e accessori"
    ]
  },
  birthDateTitle: "Vuoi ricevere una sorpresa di compleanno?",
  birthDateValidation: {
    requirementMsg: "Si prega di inserire il seguente formato per la data: GG/MM/AAAA",
    errorMsg: "Data incorretta"
  },
  joinClubLabel: "Si, voglio iscrivermi al Miele Club.",
  termsAndCondition: {
    description: "Accetto le {termsAndConditionLink} del Miele Club e prendo atto dei {privacyLink} relativi al Miele Club.",
    termsAndConditionLink: {
      title: "Condizioni di partecipazione",
      ref: "https://www.miele.it/c/condizioni-generali-di-vendita-13.htm#p7207"
    },
    privacyLink: {
      title: "Regolamenti sulla protezione dei dati",
      ref: "https://www.miele.it/c/privacy-14.htm"
    }
  },
  newsletter: {
    description: `Sì, desidero ricevere comunicazioni promozionali personalizzate in base ai miei interessi personali da parte di Miele Italia S.r.l. ("Miele") via email e per posta con offerte speciali, informazioni, inviti a eventi e sondaggi sui nostri prodotti e servizi. A tal fine, Miele puó utilizzare i miei dati di contatto (titolo, nome, e-mail e indirizzo postale) e strutturare la comunicazione in base al mio comportamento di acquisto e in materia di newsletter, nonché al mio valore di cliente, come descritto piú dettagliatamente nella nostra informativa sui  {privacyLink}. Posso revocare il mio consenso per il futuro in qualsiasi momento, inviando un messaggio a contact{'@'}miele-support.it, ai recapiti indicati nell´impressum o cliccando sul link di annullamento dell´iscrizione nelle email. Le condizioni generali di {termsAndConditionLink} rimangono inalterate fino alla cancellazione dell´iscrizione.`,
    shortDescription: 'Sì, desidero ricevere comunicazioni promozionali personalizzate in base ai miei interessi personali da parte di Miele Italia S.r.l. ("Miele") via email e per posta',
    privacyLink: {
      title: "Regolamenti sulla protezione dei dati",
      href: "https://www.miele.it/c/privacy-14.htm"
    },
    termsAndConditionLink: {
      title: "Comunicazione di Miele Club",
      href: "https://www.miele.it/c/condizioni-generali-di-vendita-13.htm#p7207"
    },
    supportEmail: "contact{'@'}miele-support.it"
  },
  selectAllConsents: {
    description: "Per unirti al Miele Club, devi accettare tutti i termini e condizioni *"
  },
  birthDateLabel: "Inserisci la tua data di nascita (facoltativo)"
}, Tm = "mostra la dichiarazione completa", Am = "nascondi l'intera dichiarazione", xm = {
  auth: bm,
  changeEmailScene: wm,
  changePasswordScene: ym,
  errors: Mm,
  forgotPassword: zm,
  login: jm,
  modal: _m,
  passwordStrength: Sm,
  passwordHelper: Cm,
  register: Lm,
  "marketing-consent": {
    title: "Preferenze di marketing",
    description: "Seleziona le caselle qui sotto per ricevere offerte esclusive, novità, eventi e informazioni su come ottenere il massimo dal tuo elettrodomestico.",
    submit: "Salva",
    newsletter: {
      text: 'Accetto che Miele Co Ltd. ("Miele") possa inviarmi informazioni sui prodotti e le innovazioni dalla gamma di prodotti Miele e su eventi Miele, nonché sondaggi sui clienti e ricette tramite e-mail, le app Miele e SMS e che Miele possa trattare i dettagli di contatto che ho fornito (titolo, nome, indirizzo email, numero di telefono mobile e codice postale) e i prodotti Miele che ho acquistato fino ad oggi e acquisterò in futuro, nonché gli interessi che ho indicato a tale scopo. Inoltre, acconsento a che Miele possa trattare i comprovanti di ricezione e lettura ricevuti tramite il newsletter e le informazioni sui link su cui ho cliccato nonché il mio comportamento utente correlato al sito Web collegato ai fini della personalizzazione. Lo stesso si applica alle notifiche push in-app, nella misura in cui vengono utilizzate le app Miele.',
      link: {
        title: "Vedi la politica di protezione dei dati",
        ref: "#"
      }
    },
    personalisation: {
      text: "Acconsento che Miele possa elaborare le informazioni sui servizi utilizzati, le assegnazioni tecniche effettuate e gli eventi a cui ho partecipato, al fine di migliorare la personalizzazione.",
      link: {
        title: "Vedi la politica di protezione dei dati",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "Inoltre alla personalizzazione estesa, acconsento che Miele possa elaborare anche i dati relativi all'uso dell'app Miele e le visite ai siti web Miele (www.miele.co.uk) per integrare il mio profilo utente, a condizione che abbia precedentemente acconsentito al trattamento di questi dati.",
      link: {
        title: "Vedi la politica di protezione dei dati",
        ref: "#"
      }
    },
    highlightedText: {
      text: "Possono revocare il mio consenso in qualsiasi momento senza dover fornire delle motivazioni e con effetto futuro. Per maggiori informazioni su come Miele gestisce i tuoi dati, si prega di consultare la ",
      link: {
        title: "politica di protezione dei dati di Miele.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Sì, acconsento ai termini d'uso.",
      link: {
        title: "Vedi i termini d'uso*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: Em,
  mieleClub: Pm,
  readMore: Tm,
  readLess: Am
}, Im = {
  waitMessage: "Quasi pronto. Attendere…"
}, Dm = {
  buttonLabel: "Salva",
  buttonLabelClose: "Chiudere",
  confirmEmailMessage: "Confermate il vostro indirizzo e-mail",
  copy: "Per aggiornare il vostro indirizzo e-mail, inserite il nuovo qui sotto:",
  errorMessageCopy: "Qualcosa è andato storto. Riprovate.",
  errorMessageHeadline: "Errore",
  headline: "Dettagli del profilo",
  inputEmailConfirmPlaceholder: "Conferma il vostro indirizzo e-mail",
  inputEmailPlaceholder: "Indirizzo e-mail",
  invalidEmailMessage: "E-mail non valida!",
  rememberMeLabel: "Resta connesso",
  successMessageCopy: "Il vostro indirizzo e-mail è stato aggiornato con successo.",
  successMessageHeadline: "Indirizzo e-mail aggiornato"
}, Nm = {
  closeButtonLabel: "Chiudere",
  confirmPasswordLabel: "Conferma password",
  currentPasswordLabel: "Password attuale",
  newPasswordLabel: "Nuova password",
  passwordMismatchError: "La password non corrisponde",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Password aggiornata",
  samePasswordError: "Questa password è stata utilizzata in precedenza, si prega di inserirne una nuova",
  subtitle: "Per cambiare la password, compila i campi qui sotto:",
  submitButtonLabel: "Invia",
  successfulChangeLabel: "La password è stata aggiornata con successo",
  title: "Cambia password"
}, Om = {
  invalidEmail: "E-mail non corretta",
  invalidPassword: "Password errata",
  sap_206002: "Il account è in attesa di verifica, non possiamo lasciarti procedere al momento. Contattaci per maggiori dettagli.",
  sap_206006: "L'indirizzo e-mail inviato è in attesa di verifica",
  sap_400003: "Questo indirizzo e-mail esiste già, si prega di utilizzare un indirizzo e-mail diverso.",
  sap_400028: "L'indirizzo e-mail inviato è in attesa di verifica",
  sap_400050: "Non siamo in grado di convalidare le credenziali in questo momento.",
  sap_400097: "Sembra che si stia accedendo ai nostri servizi da un browser non sicuro/non supportato. Si prega di riprovare con un altro browser.",
  sap_401030: "Questa password è stata utilizzata in precedenza, si prega di inviare una nuova password",
  sap_403005: "Non abbiamo un account associato a questo indirizzo e-mail, si prega di controllare la e-mail e riprovare.",
  sap_403011: "Sessione scaduta. Si prega di ricaricare il browser e accedere di nuovo.",
  sap_403012: "Sessione scaduta. Si prega di ricaricare il browser e accedere di nuovo.",
  sap_403013: "Non siamo in grado di convalidare le credenziali in questo momento.",
  sap_403035: "Non siamo in grado di convalidare le credenziali in questo momento.",
  sap_403041: "Non abbiamo un account associato a questo indirizzo e-mail, si prega di controllare la e-mail e riprovare.",
  sap_403042: `La combinazione e-mail e password non è valida. Si prega di controllare l'e-mail associata all'account o scegliere "password dimenticata" se si desidera reimpostarla.`,
  sap_403043: `La combinazione e-mail e password non è valida. Si prega di controllare l'e-mail associata all'account o scegliere "password dimenticata" se si desidera reimpostarla.`,
  sap_403047: `La combinazione e-mail e password non è valida. Si prega di controllare l'e-mail associata all'account o scegliere "password dimenticata" se si desidera reimpostarla.`,
  sap_403100: "È stata richiesta di recente un'aggiornamento della password, si prega di attendere fino a quando la richiesta viene elaborata",
  sap_403025: "Il link per la reimpostazione della password non è valido. Invia nuovamente la richiesta di password dimenticata per ricevere un nuovo link per la reimpostazione.",
  sapErrorTitle: "Errore durante l'elaborazione della richiesta",
  sessionExpired: "Sessione scaduta",
  tooWeakPassword: "La password deve contenere almeno {minLength} caratteri e {minCharGroups} dei seguenti: lettera maiuscola, lettera minuscola, numero, simbolo speciale | La password deve contenere almeno {minLength} caratteri",
  unexpectedDescription: "Se il problema persiste, contattaci tramite il modulo di contatto fornendo i dettagli.",
  unexpectedTitle: "Si è verificato un errore imprevisto",
  unknownDescription: "Si è verificato un errore imprevisto. Si prega di riprovare.",
  unknownTitle: "Ops!"
}, Um = {
  subtitle: "Imposta la nuova password.",
  title: "Hai dimenticato la password?"
}, $m = {
  headMetaDescription: "Pagina di accesso cliente",
  headTitle: "Accedi con il e-mail e la password:",
  subtitle: "Accedi o crea un account per usufruire di tutte le funzionalità di Miele.",
  title: "Accedi",
  error: {
    invalidEmailPasswordDescription: "La combinazione di indirizzo e-mail e password non è valida.",
    invalidEmailPasswordTitle: "Credenziali non valide",
    missingConcentTitle: "Account in attesa di registrazione",
    noAccountDescription: "Non è presente alcun account associato a questo indirizzo e-mail.",
    noAccountTitle: "Nessun account registrato"
  },
  extraConsentScene: {
    continue: "Continua",
    privacyStatementCheckboxLabel: "Ho preso visione della {0}.",
    privacyStatementName: "informativa sulla privacy",
    privacyStatementTitle: "La nostra informativa sulla privacy è stata aggiornata",
    termsOfUseCheckboxLabel: "Accetto i {0}.",
    termsOfUseName: "condizioni di utilizzo",
    termsOfUseTitle: "I nostri condizioni di utilizzo sono stati aggiornati",
    title: "Completamento del profilo"
  },
  forgotPasswordScene: {
    backButtonLabel: "Torna al login",
    submitButtonLabel: "Invia",
    successDescription: "Controlla la e-mail, riceverai presto le informazioni su account per iniziare il processo di reimpostazione della password.",
    successTitle: "La richiesta è stata ricevuta.",
    title: "Inserisci il indirizzo e-mail per reimpostare la password:"
  },
  loginModalScene: {
    copy: "Accedi o crea un account per usufruire di tutte le funzionalità di Miele.",
    title: "Accedi "
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Password dimenticata",
    invalidEmailMessage: "E-mail non valida!",
    loginButtonLabel: "Accedi",
    passwordInputLabel: "Password",
    rememberMeLabel: "Resta connesso",
    title: "Accedi con il e-mail e la password:"
  }
}, Bm = {
  accessibility: {
    close: "Chiudere"
  }
}, Rm = {
  tooShort: "Troppo corta",
  medium: "Media",
  strong: "Forte",
  tooWeak: "Troppo debole",
  veryStrong: "Molto forte",
  weak: "Debole"
}, Fm = {
  showPasswordText: "Mostra",
  hidePasswordText: "Nascondi"
}, Vm = {
  registerButtonLabel: "registrati",
  registerTitle: "Non hai un account?",
  whyRegister: {
    list: [
      "Accesso a vantaggi esclusivi del Club Miele",
      "Registra elettrodomestici, traccia ordini, accedi ai manuali ",
      "Ricevi offerte e promozioni personalizzate",
      "Visualizza tutti i tuoi ordini, garanzie, eventi e servizi  "
    ],
    title: "Perché registrarsi?"
  },
  closeButtonLabel: "Chiudere",
  passwordMismatchError: "Le password non corrispondono",
  passwordUpdateErrorTitle: "Errore di aggiornamento della password",
  passwordUpdateSuccessTitle: "Password aggiornata",
  successfulChangeLabel: "La password è stata aggiornata con successo"
}, qm = {
  title: "Preferenze di marketing",
  description: "Le interessano offerte esclusive, nuovi prodotti, eventi, sondaggi tra i clienti e altre informazioni utili dal mondo Miele?",
  submit: "Salva",
  levelOne: {
    text: "Acconsento all’invio da parte di Miele AG («Miele») di informazioni e offerte su prodotti e servizi, nonché di inviti a eventi e sondaggi tra i clienti tramite e-mail (newsletter), app Miele, posta e SMS. Al fine di adattare al meglio le comunicazioni commerciali alle sue esigenze, Miele tratta i seguenti dati personali ed effettua la cosiddetta profilazione (ossia il trattamento automatizzato di dati personali al fine di analizzare aspetti personali o fare previsioni): dati di contatto, dati relativi agli apparecchi, dati provenienti da sondaggi dei clienti, cronologia degli acquisti e clic sulla newsletter, servizi utilizzati, interventi di tecnici e partecipazione a eventi, comportamento di utilizzo dell’app Miele e del sito web. Ulteriori dettagli sono disponibili nell’ ",
    link: {
      title: "Informativa sulla privacy.",
      ref: "https://www.miele.ch/it/c/tutela-della-privacy-14.htm"
    }
  },
  levelTwo: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  highlightedText: {
    text: "Posso revocare il mio consenso in qualsiasi momento, senza indicarne i motivi, con effetto nel futuro. Per ulteriori informazioni sul trattamento dei dati da parte di Miele, si prega di consultare ",
    link: {
      title: "l’informativa sulla privacy di Miele.",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Sì, accetto i condizioni di utilizzo.",
    link: {
      title: "Vedi i condizioni di Utilizzo.",
      ref: "https://www.miele.ch/it/c/condizioni-di-utilizzo-304.htm"
    }
  }
}, Gm = {
  headline: "Miele Club",
  why: {
    title: "Vantaggi esclusivi per i soci - Comunicazione personale del club.",
    reasons: [
      "10% Regalo di benvenuto",
      "Sorpresa di compleanno",
      "Offerte e eventi esclusive",
      "Consigli sull'uso dei apparecchi"
    ]
  },
  birthDateTitle: "Volete ricevere una sorpresa di compleanno?",
  birthDateValidation: {
    requirementMsg: "Si prega di inserire il seguente formato per la data: GG/MM/AAAA",
    errorMsg: "Data incorretta"
  },
  joinClubLabel: "Si, voglio iscrivermi al Miele Club.",
  termsAndCondition: {
    description: "Sì, ho letto e accetto le {termsAndConditionLink} al Miele Club.",
    termsAndConditionLink: {
      title: "Condizioni di partecipazione",
      ref: "https://www.miele.ch/it/c/agb-13.htm#p7364"
    },
    privacyLink: {
      title: "",
      ref: ""
    }
  },
  newsletter: {
    description: "Sì, ho letto e accetto l’ {privacyLink} del Miele Club. Il trattamento in conformità alle disposizioni sulla protezione dei dati comprende, in particolare, la profilazione basata sul comportamento dei clienti e l’utilizzo dei profili dei clienti per scopi di marketing e di altro tipo.",
    privacyLink: {
      title: "Informativa sulla privacy",
      href: "https://www.miele.ch/it/c/datenschutz-14.htm"
    },
    termsAndConditionLink: {
      title: "",
      href: ""
    },
    supportEmail: "info{'@'}miele.ch"
  },
  selectAllConsents: {
    description: "Per aderire al Miele Club, é necessario accettare le condizioni di utilizzo e partecipazione al Miele Club"
  },
  birthDateLabel: "Data di nascita (facoltativo)"
}, Km = "mostra l'intera dichiarazione", Hm = "nascondi l'intera dichiarazione", Wm = {
  auth: Im,
  changeEmailScene: Dm,
  changePasswordScene: Nm,
  errors: Om,
  forgotPassword: Um,
  login: $m,
  modal: Bm,
  passwordStrength: Rm,
  passwordHelper: Fm,
  register: Vm,
  "marketing-consent": {
    title: "Preferenze di marketing",
    description: "Le interessano offerte esclusive, nuovi prodotti, eventi, sondaggi tra i clienti e altre informazioni utili dal mondo Miele?",
    submit: "Salva",
    newsletter: {
      text: "Acconsento all’invio da parte di Miele AG («Miele») di informazioni e offerte su prodotti e servizi, nonché di inviti a eventi e sondaggi tra i clienti tramite e-mail (newsletter), app Miele, posta e SMS. Al fine di adattare al meglio le comunicazioni commerciali alle sue esigenze, Miele tratta i seguenti dati personali ed effettua la cosiddetta profilazione (ossia il trattamento automatizzato di dati personali al fine di analizzare aspetti personali o fare previsioni): dati di contatto, dati relativi agli apparecchi, dati provenienti da sondaggi dei clienti, cronologia degli acquisti e clic sulla newsletter, servizi utilizzati, interventi di tecnici e partecipazione a eventi, comportamento di utilizzo dell’app Miele e del sito web. ",
      link: {
        title: "Vedi l'informativa sulla privacy",
        ref: ""
      }
    },
    personalisation: {
      text: "Acconsento al trattamento da parte di Miele delle informazioni relative ai servizi da me utilizzati, agli incarichi tecnici da me svolti e agli eventi a cui ho partecipato ai fini di una maggiore personalizzazione.",
      link: {
        title: "Vedi l'informativa sulla privacy",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Oltre che ai fini di personalizzazione, accetto che Miele possa trattare anche i dati derivanti dall’uso dell’app Miele e dalle mie visite ai siti web Miele (www.miele.ch) per integrare il mio profilo utente, a condizione che io abbia acconsentito separatamente al trattamento di questi dati. Ulteriori dettagli nell’informativa sulla privacy di Miele.",
      link: {
        title: "Vedi l'informativa sulla privacy",
        ref: ""
      }
    },
    highlightedText: {
      text: "Posso revocare il mio consenso in qualsiasi momento, senza indicarne i motivi, con effetto nel futuro. Per ulteriori informazioni sul trattamento dei dati da parte di Miele, si prega di consultare ",
      link: {
        title: "l’informativa sulla privacy di Miele.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Sì, accetto i condizioni di utilizzo.",
      link: {
        title: "Vedi i condizioni di Utilizzo*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: qm,
  mieleClub: Gm,
  readMore: Km,
  readLess: Hm
}, Jm = {
  waitMessage: "Bijna daar. "
}, Zm = {
  buttonLabel: "Opslaan",
  buttonLabelClose: "Sluit",
  confirmEmailMessage: "Bevestig uw e-mailadres",
  copy: "Voeg je nieuwe e-mailadres hieronder toe om het te wijzigen.",
  errorMessageCopy: "Er is iets fout gegaan. ",
  errorMessageHeadline: "Fout",
  headline: "profiel details",
  inputEmailConfirmPlaceholder: "Bevestig je e-mailadres",
  inputEmailPlaceholder: "E-mailadres",
  invalidEmailMessage: "E-mail niet geldig!",
  rememberMeLabel: "Onthoud me",
  successMessageCopy: "Uw e-mailadres is succesvol bijgewerkt.",
  successMessageHeadline: "E-mailadres bijgewerkt"
}, Ym = {
  closeButtonLabel: "Sluit",
  confirmPasswordLabel: "bevestig wachtwoord",
  currentPasswordLabel: "huidig ​​wachtwoord",
  newPasswordLabel: "nieuw paswoord",
  passwordMismatchError: "Wachtwoord komt niet overeen",
  passwordUpdateErrorTitle: "Fout",
  passwordUpdateSuccessTitle: "wachtwoord bijgewerkt",
  samePasswordError: "Dit wachtwoord werd eerder gebruikt, geef een nieuw wachtwoord op",
  subtitle: "Vul onderstaande velden in om uw wachtwoord te wijzigen:",
  submitButtonLabel: "Indienen",
  successfulChangeLabel: "je wachtwoord is succesvol geupdate",
  title: "Wachtwoord verandering"
}, Xm = {
  invalidEmail: "incorrecte Email",
  invalidPassword: "Verkeerd wachtwoord",
  sap_206002: "Uw account is in afwachting van verificatie. Ik ben bang dat we u op dit moment niet verder kunnen laten gaan. ",
  sap_206006: "Het lijkt erop dat het e-mailadres dat je hebt opgegeven in afwachting is van verificatie",
  sap_400003: "Dit e-mailadres bestaat al, gebruik een ander e-mailadres!",
  sap_400028: "Het ingediende e-mailadres is in afwachting van verificatie",
  sap_400050: "Sorry, we kunnen uw inloggegevens op dit moment niet valideren.",
  sap_400097: "Het lijkt erop dat u onze services opent vanuit een onveilige/niet-ondersteunde browser. ",
  sap_401030: "Dit wachtwoord is eerder gebruikt, gelieve een nieuw wachtwoord in te dienen",
  sap_403005: "We hebben geen account gekoppeld aan dit e-mailadres, controleer uw e-mail en probeer het opnieuw",
  sap_403011: "Sessie verlopen. ",
  sap_403012: "Sessie verlopen. ",
  sap_403013: "Sorry, we kunnen uw inloggegevens op dit moment niet valideren.",
  sap_403035: "Sorry, we kunnen uw inloggegevens op dit moment niet valideren.",
  sap_403041: "We hebben geen account gekoppeld aan dit e-mailadres, controleer uw e-mail en probeer het opnieuw",
  sap_403042: "De combinatie van e-mailadres en wachtwoord is ongeldig. Controleer het e-mailadres of selecteer 'Wachtwoord vergeten' als u het opnieuw wilt instellen.",
  sap_403043: "De combinatie van e-mailadres en wachtwoord is ongeldig. Controleer het e-mailadres of selecteer 'Wachtwoord vergeten' als u het opnieuw wilt instellen.",
  sap_403047: "Het ingevulde email adres is niet geregistreerd",
  sap_403100: "Er is onlangs een verzoek om wachtwoordupdate aangevraagd, neem contact met ons op totdat het verzoek is verwerkt",
  sap_403025: "De link om het wachtwoord opnieuw in te stellen is ongeldig. Stuur het verzoek om een nieuw wachtwoord te ontvangen opnieuw, om een nieuwe link te ontvangen.",
  sapErrorTitle: "Fout bij verwerken van verzoek",
  sessionExpired: "Sessie verlopen",
  tooWeakPassword: "Het wachtwoord moet minimaal {minLength} tekens bevatten en {minCharGroups} van de volgende tekens: hoofdletter, kleine letter, cijfer of speciaal symbool. | Het wachtwoord moet minimaal {minLength} tekens bevatten.",
  unexpectedDescription: "Als het probleem aanhoudt, neem dan contact met ons op via het contactformulier met details.",
  unexpectedTitle: "Er is een onverwachte fout opgetreden",
  unknownDescription: "Er is een onverwachte fout opgetreden. ",
  unknownTitle: "Oh Oh!"
}, Qm = {
  subtitle: "Stel jouw nieuwe wachtwoord in.",
  title: "Je wachtwoord vergeten?"
}, ep = {
  headMetaDescription: "Inlogpagina van de klant",
  headTitle: "Log in met jouw e-mailadres en wachtwoord:",
  subtitle: "Log in of maak een account aan om alle functies van Miele te gebruiken.",
  title: "Log in op jouw account",
  error: {
    invalidEmailPasswordDescription: "De combinatie van e-mailadres en wachtwoord is niet geldig.",
    invalidEmailPasswordTitle: "Ongeldige inloggegevens",
    missingConcentTitle: "Account in afwachting van registratie",
    noAccountDescription: "Er is geen account gekoppeld aan dit e-mailadres.",
    noAccountTitle: "Geen account geregistreerd"
  },
  extraConsentScene: {
    continue: "Doorgaan",
    privacyStatementCheckboxLabel: "Ik heb kennis genomen van de {0}.",
    privacyStatementName: "privacy verklaring",
    privacyStatementTitle: "Ons privacybeleid is gewijzigd",
    termsOfUseCheckboxLabel: "Ik ga akkoord met de {0}.",
    termsOfUseName: "gebruiksvoorwaarden",
    termsOfUseTitle: "Onze Gebruiksvoorwaarden zijn gewijzigd",
    title: "Profiel voltooiing"
  },
  forgotPasswordScene: {
    backButtonLabel: "Terug naar Inloggen",
    submitButtonLabel: "Indienen",
    successDescription: "Controleer jouw e-mail, je ontvangt binnenkort de informatie over jouw account om te beginnen met het wachtwoordherstelproces.",
    successTitle: "Je verzoek is ontvangen.",
    title: "Voer jouw e-mailadres in om jouw wachtwoord opnieuw in te stellen:"
  },
  loginModalScene: {
    copy: "Log in of maak een account aan om alle functies van Miele te gebruiken.",
    title: "Log in op jouw account"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Ik ben mijn wachtwoord vergeten",
    invalidEmailMessage: "E-mail niet geldig!",
    loginButtonLabel: "Log in",
    passwordInputLabel: "Wachtwoord",
    rememberMeLabel: "Onthoud me",
    title: "Log in met jouw e-mailadres en wachtwoord:"
  }
}, tp = {
  accessibility: {
    close: "Sluit"
  }
}, ip = {
  tooShort: "Te kort",
  medium: "Gemiddeld",
  strong: "Sterk",
  tooWeak: "Te zwak",
  veryStrong: "Heel sterk",
  weak: "Zwak"
}, np = {
  showPasswordText: "Weergeven",
  hidePasswordText: "Verbergen"
}, ap = {
  registerButtonLabel: "registreren",
  registerTitle: "Heb je geen account?",
  whyRegister: {
    list: [
      "Altijd op de hoogte van leuke evenementen",
      "Maak bestellen nog eenvoudiger",
      "Ontvang relevante informatie over jouw apparaten",
      "Alle bestellingen, garantiebewijzen en services bij elkaar"
    ],
    title: "Waarom registreren?"
  },
  closeButtonLabel: "Sluit",
  passwordMismatchError: "de wachtwoorden komen niet overeen",
  passwordUpdateErrorTitle: "Fout bij bijwerken van wachtwoord",
  passwordUpdateSuccessTitle: "wachtwoord bijgewerkt",
  successfulChangeLabel: "je wachtwoord is succesvol geupdate"
}, sp = {
  title: "Marketingvoorkeuren",
  description: "Heb je interesse in de nieuwste Miele producten, wil je deelnemen aan exclusieve Miele evenementen of kook je graag? Schrijf je dan in voor de Miele nieuwsbrief. Om de inhoud beter op je behoeften af te stemmen, maken wij gebruik van personalisering.",
  submit: "Opslaan",
  levelOne: {
    shortText: "Ja, ik wil graag marketingcommunicatie van Miele Nederland B.V. en Miele & Cie. KG (“Miele”), afgestemd op mijn persoonlijke interesses per e-mail, sms, post en via de Miele apps en websites (indien gebruikt) ontvangen",
    text: "Ja, ik wil graag marketingcommunicatie van Miele Nederland B.V. en Miele & Cie. KG (“Miele”), afgestemd op mijn persoonlijke interesses per e-mail, sms, post en via de Miele apps en websites (indien gebruikt) ontvangen met informatie over producten, aanbiedingen en innovaties uit het Miele productassortiment, evenementen, klantenenquêtes, aanvragen voor productbeoordelingen en -recensies en recepten. Hiervoor kan Miele mijn contactgegevens (titel, naam, e-mailadres, mobiele telefoonnummer en adresgegevens) gebruiken en de communicatie vormgeven op basis van mijn aankoop-, service-, evenementgeschiedenis, klik- en opengedrag van de nieuwsbrief en klantwaarde, zoals in detail beschreven in ons privacybeleid. Ik kan mijn toestemming te allen tijde zonder opgaaf van redenen intrekken met werking voor de toekomst (bijv. door te klikken op de afmeldlink in e-mails of een informeel bericht te sturen naar nieuwsbrief{'@'}miele.nl).",
    link: {
      title: "Privacybeleid",
      ref: "https://www.miele.nl/c/privacybeleid-14.htm"
    }
  },
  levelTwo: {
    text: "Ik ga ermee akkoord dat Miele ook gegevens uit het gebruik van de Miele app en mijn bezoeken aan Miele website (www.miele.nl), inclusief gebruikersgedrag op de Miele websites na gekoppelde nieuwsbriefklikken, mag verwerken om mijn gebruikersprofiel voor gepersonaliseerde reclamecommunicatie aan te vullen, mits mijn afzonderlijke toestemming in de app of op de website de gegevensverwerking vrijgeeft.  Ik kan mijn toestemming te allen tijde zonder opgaaf van redenen met werking voor de toekomst intrekken. Meer informatie vindt u in het privacybeleid van Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Ik ga ermee akkoord dat Miele ook gegevens van mijn aangesloten Miele apparaten mag verwerken (gegevens over het gebruik en de status van apparaten) om mijn gebruikersprofiel aan te vullen voor gepersonaliseerde reclame. Meer informatie over de verwerking van apparaatgegevens vind je in het privacybeleid over het Miele{'@'}Home-systeem. Ik kan mijn toestemming te allen tijde zonder opgaaf van redenen intrekken met werking voor de toekomst. Meer informatie vindt u in het privacybeleid van Miele.",
    link: {
      title: "Miele{'@'}Home-systeem",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Ik kan mijn toestemming voor de verwerking van mijn persoonsgegevens op ieder moment intrekken. Meer informatie over hoe Miele met je persoonsgegevens omgaat, kun je vinden in het Miele",
    link: {
      title: "privacybeleid",
      ref: "https://www.miele.nl/c/privacybeleid-14.htm"
    }
  },
  termsOfUse: {
    text: "Ja, ik ga akkoord met de gebruiksvoorwaarden.",
    link: {
      title: "Zie gebruiksvoorwaarden*",
      ref: "https://www.miele.nl/c/agb-13.htm"
    }
  }
}, op = {
  headline: "Miele Club",
  birthDateTitle: "Mogen wij u een verjaardagscadeau sturen?",
  birthDateLabel: "Verjaardag (optioneel)",
  why: {
    title: "Lidmaatschap",
    reasons: [
      "Verjaardag verrassing",
      "Exclusieve aanbiedingen en campagnes",
      "Welkomstgeschenk",
      "VIP-aanbiedingen en ervaringen",
      "Aantrekkelijke besparingen",
      "Clubnieuws"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Gebruik een formaat zoals DD/MM/JJJJ",
    errorMsg: "Ongeldige datum"
  },
  joinClubLabel: "Ja, ik wil lid worden van de Miele-club.",
  termsAndCondition: {
    description: "Door Miele Club-lid te worden, gaat u akkoord met de {termsAndConditionLink} van Miele Club.",
    termsAndConditionLink: {
      title: "voorwaarden",
      ref: "https://www.miele.nl/c/agb-13.htm"
    },
    privacyLink: {
      title: "",
      ref: ""
    }
  },
  newsletter: {
    description: "Ja, ik wil Miele Club-lid worden en Miele Club-communicatie (welkomstgeschenk, verjaardagsverrassing, statusupgrade, Miele Club-nieuws) via e-mail ontvangen.",
    termsAndConditionLink: {
      title: "",
      href: ""
    },
    privacyLink: {
      title: "",
      href: ""
    },
    supportEmail: "info{'@'}miele.nl"
  },
  selectAllConsents: {
    description: "Om lid te worden van de Miele Club, moet je akkoord gaan met alle voorwaarden *"
  }
}, rp = "volledige verklaring tonen", lp = "verklaring minder tonen", cp = {
  auth: Jm,
  changeEmailScene: Zm,
  changePasswordScene: Ym,
  errors: Xm,
  forgotPassword: Qm,
  login: ep,
  modal: tp,
  passwordStrength: ip,
  passwordHelper: np,
  register: ap,
  "marketing-consent": {
    title: "Marketingvoorkeuren",
    description: "Vink hieronder aan voor exclusieve aanbiedingen, nieuws, evenementen en hoe u het meeste uit uw apparaat kunt halen.",
    submit: "Opslaan",
    newsletter: {
      text: 'Ik ga ermee akkoord dat Miele Nederland B.V. ("Miele") mij informatie over producten en nieuwe ontwikkelingen uit het Miele assortiment, evenementen, klantenquêtes, productbeoordelingen, reviews en recepten via e-mail, de Miele apps en sms toestuurt.',
      link: {
        title: "Zie gegevensbeschermingsbeleid",
        ref: ""
      }
    },
    personalisation: {
      text: "Ik ga ermee akkoord dat Miele informatie over de diensten die ik heb gebruikt en de opdrachten van technici die ik heb uitgevoerd, evenals evenementen die ik heb bijgewoond, mag verwerken met het oog op een betere personalisatie.",
      link: {
        title: "Zie gegevensbeschermingsbeleid",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Naast de uitgebreide personalisatie ga ik ermee akkoord dat Miele ook gegevens uit het gebruik van de Miele-app en mijn bezoeken aan de Miele-websites (www.miele.co.uk) mag verwerken om mijn gebruikersprofiel aan te vullen, op voorwaarde dat ik afzonderlijk toestemming heb gegeven ",
      link: {
        title: "Zie gegevensbeschermingsbeleid",
        ref: ""
      }
    },
    highlightedText: {
      text: "Ik kan mijn toestemming te allen tijde intrekken zonder opgaaf van redenen voor de toekomst.  ",
      link: {
        title: "gegevensbeschermingsbeleid.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ja, ik ga akkoord met de gebruiksvoorwaarden.",
      link: {
        title: "Zie gebruiksvoorwaarden*",
        ref: "https://www.miele.nl/c/agb-13.htm"
      }
    }
  },
  multiLevelMarketingConsent: sp,
  mieleClub: op,
  readMore: rp,
  readLess: lp
}, dp = {
  waitMessage: "We zijn er bijna. Nog even geduld..."
}, up = {
  buttonLabel: "Opslaan",
  buttonLabelClose: "Sluiten",
  confirmEmailMessage: "Bevestig uw e-mailadres",
  copy: "Als u uw e-mailadres wil aanpassen, voeg dan hieronder het nieuwe toe:",
  errorMessageCopy: "Er is iets misgegaan. Probeer het later opnieuw.",
  errorMessageHeadline: "Fout",
  headline: "Accountgegevens",
  inputEmailConfirmPlaceholder: "Bevestig uw e-mailadres",
  inputEmailPlaceholder: "E-mailadres",
  invalidEmailMessage: "E-mail niet geldig!",
  rememberMeLabel: "Onthoud mij",
  successMessageCopy: "Uw e-mailadres is succesvol bijgewerkt.",
  successMessageHeadline: "E-mailadres bijgewerkt"
}, mp = {
  closeButtonLabel: "Sluiten",
  confirmPasswordLabel: "Bevestig wachtwoord",
  currentPasswordLabel: "Huidig wachtwoord",
  newPasswordLabel: "Nieuw wachtwoord",
  passwordMismatchError: "Wachtwoord komt niet overeen",
  passwordUpdateErrorTitle: "Fout",
  passwordUpdateSuccessTitle: "Wachtwoord bijgewerkt",
  samePasswordError: "Dit wachtwoord werd eerder gebruikt, geef een nieuw wachtwoord op",
  subtitle: "Vul de onderstaande velden in om uw wachtwoord te wijzigen:",
  submitButtonLabel: "Verzenden",
  successfulChangeLabel: "Uw wachtwoord is succesvol bijgewerkt",
  title: "Wachtwoord wijzigen"
}, pp = {
  invalidEmail: "Onjuiste e-mail",
  invalidPassword: "Verkeerd wachtwoord",
  sap_206002: "Uw account moet nog geverifieerd worden, we kunnen u op dit moment niet verder laten gaan. Neem contact met ons op voor meer informatie.",
  sap_206006: "Het lijkt erop dat het e-mailadres dat u hebt opgegeven nog moet worden geverifieerd.",
  sap_400003: "Dit e-mailadres bestaat al, gebruik een ander e-mailadres.",
  sap_400028: "Het opgegeven e-mailadres moet nog worden geverifieerd.",
  sap_400050: "Sorry, we kunnen uw gegevens op dit moment niet valideren.",
  sap_400097: "Het lijkt erop dat u onze services benadert via een onveilige/onondersteunde browser. Probeer het opnieuw met een andere browser. ",
  sap_401030: "Dit wachtwoord werd al eerder gebruikt. Geef een nieuw wachtwoord op.",
  sap_403005: "Er is geen account gekoppeld aan dit e-mailadres. Controleer uw e-mailadres en probeer het opnieuw.",
  sap_403011: "Sessie verlopen. Laad de browser opnieuw en meld u opnieuw aan.",
  sap_403012: "Sessie verlopen. Laad de browser opnieuw en meld u opnieuw aan.",
  sap_403013: "Sorry, we kunnen uw gegevens op dit moment niet valideren.",
  sap_403035: "Sorry, we kunnen uw gegevens op dit moment niet valideren.",
  sap_403041: "Er is geen account gekoppeld aan dit e-mailadres. Controleer uw e-mailadres en probeer het opnieuw.",
  sap_403042: "De combinatie van e-mailadres en wachtwoord is ongeldig. Controleer het e-mailadres dat aan het account is gekoppeld of kies wachtwoord vergeten als u het opnieuw wilt instellen.",
  sap_403043: "De combinatie van e-mailadres en wachtwoord is ongeldig. Controleer het e-mailadres van het account of kies wachtwoord vergeten als u het opnieuw wilt instellen.",
  sap_403047: "De combinatie van e-mailadres en wachtwoord is ongeldig. Controleer het e-mailadres van het account of kies wachtwoord vergeten als u het opnieuw wilt instellen.",
  sap_403100: "Er werd onlangs een verzoek ingediend om het wachtwoord bij te werken. Blijf bij ons totdat het verzoek is verwerkt.",
  sap_403025: "De link om het wachtwoord opnieuw in te stellen is ongeldig. Stuur het verzoek om een nieuw wachtwoord te ontvangen opnieuw, om een nieuwe link te ontvangen.",
  sapErrorTitle: "Fout bij het verwerken van het verzoek",
  sessionExpired: "Sessie verlopen",
  tooWeakPassword: "Wachtwoord moet ten minste {minLength} tekens en {minCharGroups} van het volgende bevatten: hoofdletter, kleine letter, cijfer of speciaal symbool.. | Wachtwoord moet ten minste {minLength} tekens",
  unexpectedDescription: "Als het probleem zich blijft voordoen, neem dan contact met ons op via het contactformulier.",
  unexpectedTitle: "Er is een onverwachte fout opgetreden",
  unknownDescription: "Er is een onverwachte fout opgetreden. Probeer het opnieuw.",
  unknownTitle: "Uh Oh!"
}, hp = {
  subtitle: "Stel uw nieuw wachtwoord in.",
  title: "Wachtwoord vergeten?"
}, gp = {
  headMetaDescription: "Inlogpagina voor klanten",
  headTitle: "Meld u aan met uw e-mailadres en wachtwoord:",
  subtitle: "Meld u aan of maak een account aan om alle functies van Miele te gebruiken.",
  title: "Inloggen op uw account",
  error: {
    invalidEmailPasswordDescription: "De combinatie van e-mailadres en wachtwoord is ongeldig.",
    invalidEmailPasswordTitle: "Ongeldige gegevens",
    missingConcentTitle: "Account in afwachting van registratie",
    noAccountDescription: "Er is geen account gekoppeld aan dit e-mailadres.",
    noAccountTitle: "Geen account geregistreerd"
  },
  extraConsentScene: {
    continue: "Doorgaan",
    privacyStatementCheckboxLabel: "Ik heb kennis genomen van de {0}.",
    privacyStatementName: "Privacyverklaring",
    privacyStatementTitle: "Ons privacybeleid is gewijzigd",
    termsOfUseCheckboxLabel: "Ik ga akkoord met de {0}.",
    termsOfUseName: "Gebruiksvoorwaarden",
    termsOfUseTitle: "Onze gebruiksvoorwaarden zijn gewijzigd",
    title: "Account voltooien"
  },
  forgotPasswordScene: {
    backButtonLabel: "Terug naar aanmelden",
    submitButtonLabel: "Verzenden",
    successDescription: "Controleer uw e-mail, u ontvangt binnenkort de informatie over uw account om te beginnen met het resetten van uw wachtwoord.",
    successTitle: "Uw verzoek is ontvangen.",
    title: "Voer uw e-mailadres in om uw wachtwoord opnieuw in te stellen:"
  },
  loginModalScene: {
    copy: "Meld u aan of maak een account aan om alle Miele-functies te gebruiken.",
    title: "Aanmelden op uw account"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Mijn wachtwoord vergeten",
    invalidEmailMessage: "E-mail niet geldig!",
    loginButtonLabel: "Aanmelden  ",
    passwordInputLabel: "Wachtwoord",
    rememberMeLabel: "Onthoud mij",
    title: "Meld u aan met uw e-mailadres en wachtwoord:"
  }
}, vp = {
  accessibility: {
    close: "Sluiten"
  }
}, fp = {
  tooShort: "Te kort",
  medium: "Gemiddeld",
  strong: "Sterk",
  tooWeak: "Te Zwak",
  veryStrong: "Zeer sterk",
  weak: "Zwak"
}, kp = {
  showPasswordText: "Tonen",
  hidePasswordText: "Verbergen"
}, bp = {
  registerButtonLabel: "Registreren",
  registerTitle: "Hebt u nog geen account?",
  whyRegister: {
    list: [
      "Handig overzicht van al uw bestellingen en eventboekingen",
      "Overzicht van al uw toestellen met accessoires en gebruiksaanwijzingen",
      "Zicht op al uw herstellingen en garanties"
    ],
    title: "Waarom registreren?"
  },
  closeButtonLabel: "Sluiten",
  passwordMismatchError: "De wachtwoorden komen niet overeen",
  passwordUpdateErrorTitle: "Fout bij het bijwerken van het wachtwoord",
  passwordUpdateSuccessTitle: "Wachtwoord bijgewerkt",
  successfulChangeLabel: "Uw wachtwoord werd succesvol bijgewerkt"
}, wp = {
  title: "Marketingvoorkeuren",
  description: "Vink hieronder aan voor exclusieve aanbiedingen, nieuws, productadvies en meer",
  submit: "Opslaan",
  levelOne: {
    shortText: 'Ja, ik wil graag promotionele informatie van Miele België NV en Miele & Cie. KG ("Miele") afgestemd op mijn persoonlijke interesses per e-mail, sms, post en via de Miele-apps en websites (indien gebruikt) ontvangen',
    text: `Ja, ik wil graag promotionele informatie van Miele België NV en Miele & Cie. KG ("Miele") afgestemd op mijn persoonlijke interesses per e-mail, sms, post en via de Miele-apps en websites (indien gebruikt) ontvangen met informatie over producten, aanbiedingen en innovaties uit het Miele-productassortiment en over Miele-evenementen, evenals klantenenquêtes, aanvragen voor productbeoordelingen en recensies en recepten. Hiervoor kan Miele mijn contactgegevens (titel, naam, e-mailadres, mobiel telefoonnummer en postadres) gebruiken en de communicatie vormgeven op basis van mijn aankoop-, service-, evenementgeschiedenis, klik- en opengedrag van de nieuwsbrief en klantwaarde, zoals in detail beschreven in ons privacybeleid. Ik kan mijn toestemming ten allen tijde zonder vermelding van redenen intrekken met werking voor de toekomst (bijv. door een informeel bericht te sturen naar privacy{'@'}miele.be, de contactgegevens in het impressum of door te klikken op de afmeldlink in e-mails).`,
    link: {
      title: "Privacybeleid",
      ref: "https://www.miele.be/nl/c/privacybeleid-14.htm"
    }
  },
  levelTwo: {
    text: "Naast mijn basistoestemming ga ik ermee akkoord dat Miele ook gegevens uit het gebruik van de Miele-app en mijn bezoeken aan Miele-websites (www.miele.be), inclusief gebruikersgedrag op de Miele-websites na gekoppelde nieuwsbriefklikken, mag verwerken om mijn gebruikersprofiel voor gepersonaliseerde promotionele communicatie aan te vullen, mits mijn afzonderlijke toestemming in de app of op de website de gegevensverwerking vrijgeeft. Ik kan mijn toestemming ten allen tijde zonder vermelding van redenen met werking voor de toekomst intrekken. Meer informatie vindt u in het privacybeleid van Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Naast mijn basistoestemming ga ik ermee akkoord dat Miele ook gegevens van mijn aangesloten Miele-toestellen mag verwerken (gegevens over het gebruik en de status van toestellen) om mijn gebruikersprofiel aan te vullen voor gepersonaliseerde reclame. Meer informatie over de verwerking van toestelgegevens vind ik in het privacybeleid over het Miele{'@'}Home-systeem. Ik kan mijn toestemming ten allen tijde zonder vermelding van redenen intrekken met werking voor de toekomst. Meer informatie vindt u in het privacybeleid van Miele.",
    link: {
      title: "Miele{'@'}Home-systeem",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "U kunt op ieder moment de toestemming voor de verwerking van uw persoonsgegevens intrekken. Meer informatie over hoe Miele met uw persoonsgegevens omgaat, kunt u vinden in het Miele",
    link: {
      title: "privacybeleid.",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Ja, ik ga akkoord met de gebruiksvoorwaarden.",
    link: {
      title: "Bekijk de gebruiksvoorwaarden.",
      ref: "https://www.miele.be/nl/c/algemene-voorwaarden-13.htm"
    }
  }
}, yp = {
  headline: "Miele Club",
  birthDateTitle: "Mogen wij u een verjaardagscadeau sturen?",
  birthDateLabel: "Verjaardag (optioneel)",
  why: {
    title: "Lidmaatschap",
    reasons: [
      "Verjaardag verrassing",
      "Exclusieve aanbiedingen en campagnes",
      "Welkomstgeschenk",
      "VIP-aanbiedingen en ervaringen",
      "Aantrekkelijke besparingen",
      "Clubnieuws"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Gebruik een formaat zoals DD/MM/JJJJ",
    errorMsg: "Ongeldige datum"
  },
  joinClubLabel: "Ja, ik wil lid worden van de Miele-club.",
  termsAndCondition: {
    description: "Ik accepteer de Miele Club {termsAndConditionLink} en bevestig dat ik de {privacyLink}-informatie voor de Miele Club heb gelezen.",
    termsAndConditionLink: {
      title: "Voorwaarden voor deelname en gebruik",
      ref: "https://www.miele.be/nl/c/cgv-13.htm"
    },
    privacyLink: {
      title: "Gegevensbescherming",
      ref: "https://www.miele.be/nl/c/protection-des-donnees-14.htm"
    }
  },
  newsletter: {
    description: "Ja, ik wil graag Club-advertentiecommunicatie ontvangen van Miele SAS (« Miele »), afgestemd op mijn persoonlijke interesses, per e-mail en post voor speciale aanbiedingen, informatie, uitnodigingen voor evenementen en klantenenquêtes over onze producten en diensten. Om dit te doen, geef ik Miele toestemming om mijn contactgegevens (titel, naam, e-mail, telefoon en postadres) te gebruiken en de communicatie aan te passen op basis van mijn koopgedrag en mijn gedrag met betrekking tot nieuwsbrieven, zoals gedetailleerder beschreven in {privacyLink} . Ik kan mijn toestemming op elk moment in de toekomst intrekken (bijvoorbeeld door een eenvoudige e-mail te sturen naar info{'@'}miele.fr, naar de contactgegevens vermeld in de wettelijke kennisgevingen of door op de afmeldlink in de e-mails te klikken). De contractuele communicatie van de Club {termsAndConditionLink} blijft onaangetast totdat het lidmaatschap wordt beëindigd.",
    shortDescription: "Ja, ik wil graag per e-mail en per post Club-advertentiecommunicatie ontvangen van Miele SAS (« Miele »), afgestemd op mijn persoonlijke interesses",
    privacyLink: {
      title: "Gegevensbescherming van Miele Club",
      href: "https://www.miele.be/nl/c/protection-des-donnees-14.htm"
    },
    termsAndConditionLink: {
      title: "Clubcommunicatie",
      href: "https://www.miele.be/nl/c/cgv-13.htm"
    },
    supportEmail: "info{'@'}miele.be"
  },
  selectAllConsents: {
    description: "Om lid te worden van de Miele Club, moet je akkoord gaan met alle voorwaarden *"
  }
}, Mp = "volledige verklaring tonen", zp = "verklaring minder tonen", jp = {
  auth: dp,
  changeEmailScene: up,
  changePasswordScene: mp,
  errors: pp,
  forgotPassword: hp,
  login: gp,
  modal: vp,
  passwordStrength: fp,
  passwordHelper: kp,
  register: bp,
  "marketing-consent": {
    title: "Marketingvoorkeuren",
    description: "Vink hieronder aan voor exclusieve aanbiedingen, nieuws, evenementen en hoe u het meeste uit uw toestel kunt halen.",
    submit: "Opslaan",
    newsletter: {
      text: "Ik ga ermee akkoord dat Miele België NV (‘Miele’) mij informatie over producten en nieuwe ontwikkelingen uit het Miele assortiment, evenementen, klantenenquêtes en recepten via e-mail, de Miele apps en sms toestuurt. Ook ga ik ermee akkoord dat Miele voor dit doeleinde de door mij verstrekte contactgegevens (aanspreking, naam, e-mailadres, telefoonnummer en postcode), de tot nu toe en in de toekomst door mij aangeschafte Miele producten en de door mij aangegeven interesses verwerkt. Daarnaast ga ik ermee akkoord dat Miele via de nieuwsbrief ontvangen ontvangst- en leesbevestigingen, informatie over de links waarop ik heb geklikt en mijn daaraan verbonden gebruikersgedrag op de website verwerkt met als doel betere personalisering. Hetzelfde geldt voor de in-app-pushberichten, voor zover de Miele apps worden gebruikt.",
      link: {
        title: "Bekijk privacybeleid",
        ref: "#"
      }
    },
    personalisation: {
      text: "Ik ga ermee akkoord dat Miele voor de uitgebreide personalisering informatie verwerkt over de door mij aangekochte diensten en herstellingsaanvragen en over evenementen waaraan ik heb deelgenomen. ",
      link: {
        title: "Bekijk privacybeleid",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "Naast de uitgebreide personalisering ga ik ermee akkoord dat Miele gegevens uit het gebruik van de Miele app en uit mijn bezoeken aan de Miele website (www.miele.be) verwerkt om mijn profiel aan te vullen, voor zover ik heb toegestemd met de verwerking van deze gegevens.",
      link: {
        title: "Bekijk privacybeleid",
        ref: "#"
      }
    },
    highlightedText: {
      text: "U kunt op ieder moment de toestemming voor de verwerking van uw persoonsgegevens intrekken. Meer informatie over hoe Miele met uw persoonsgegevens omgaat, kunt u vinden in het Miele",
      link: {
        title: "privacybeleid.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Ja, ik ga akkoord met de gebruiksvoorwaarden.",
      link: {
        title: "Bekijk de gebruiksvoorwaarden*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: wp,
  mieleClub: yp,
  readMore: Mp,
  readLess: zp
}, _p = {
  waitMessage: "Nesten der. "
}, Sp = {
  buttonLabel: "Lagre",
  buttonLabelClose: "Lukk",
  confirmEmailMessage: "Bekreft e-postadressen din",
  copy: "For å oppdatere e-postadressen din, vennligst legg til den nye nedenfor:",
  errorMessageCopy: "Noe gikk galt. ",
  errorMessageHeadline: "Feil",
  headline: "Profildetaljer",
  inputEmailConfirmPlaceholder: "Bekreft din e-postadresse",
  inputEmailPlaceholder: "Epostadresse",
  invalidEmailMessage: "E-post ikke gyldig!",
  rememberMeLabel: "Husk meg",
  successMessageCopy: "E-postadressen din ble oppdatert.",
  successMessageHeadline: "E-postadresse oppdatert"
}, Cp = {
  closeButtonLabel: "Lukk",
  confirmPasswordLabel: "bekreft passord",
  currentPasswordLabel: "Nåværende passord",
  newPasswordLabel: "Nytt passord",
  passwordMismatchError: "Passordet stemmer ikke",
  passwordUpdateErrorTitle: "Feil",
  passwordUpdateSuccessTitle: "Passord oppdatert",
  samePasswordError: "Dette passordet ble brukt tidligere, vennligst send inn et nytt passord",
  subtitle: "For å endre passordet ditt, fyll ut feltene nedenfor:",
  submitButtonLabel: "Sende inn",
  successfulChangeLabel: "Passordet ditt har blitt oppdatert",
  title: "Endring av passord"
}, Lp = {
  invalidEmail: "ukorrekt email",
  invalidPassword: "Feil passord",
  sap_206002: "Kontoen din venter på bekreftelse. Jeg er redd vi ikke kan la deg fortsette for øyeblikket. ",
  sap_206006: "Det ser ut til at e-postadressen du sendte inn venter på bekreftelse",
  sap_400003: "Denne e-postadressen finnes allerede, vennligst bruk en annen e-postadresse!",
  sap_400028: "E-postadressen som er sendt inn venter på bekreftelse",
  sap_400050: "Beklager, vi kan ikke validere legitimasjonen din for øyeblikket.",
  sap_400097: "Det ser ut til at du får tilgang til tjenestene våre fra en usikker/ustøttet nettleser. ",
  sap_401030: "Dette passordet ble brukt tidligere, vennligst send inn et nytt passord",
  sap_403005: "Vi har ikke en konto knyttet til denne e-postadressen, vennligst sjekk e-posten din og prøv igjen",
  sap_403011: "Sesjon utløpt. ",
  sap_403012: "Sesjon utløpt. ",
  sap_403013: "Beklager, vi kan ikke validere legitimasjonen din for øyeblikket.",
  sap_403035: "Beklager, vi kan ikke validere legitimasjonen din for øyeblikket.",
  sap_403041: "Vi har ikke en konto knyttet til denne e-postadressen, vennligst sjekk e-posten din og prøv igjen",
  sap_403042: "E-post",
  sap_403043: "E-post",
  sap_403047: "E-post",
  sap_403100: "En forespørsel om passordoppdatering er nylig forespurt, vennligst informer med oss ​​til forespørselen er behandlet",
  sap_403025: "Link for tilbakestilling av passord er ugyldig. Send forespørsel om glemt passord igjen for å motta en ny tilbakestillingslenke.",
  sapErrorTitle: "Feil under behandling av forespørsel",
  sessionExpired: "Sesjon utløpt",
  tooWeakPassword: "Passord må inneholde minst {minLength} tegn og {minCharGroups} av følgende: stor bokstav, liten bokstav, tall, spesialsymbol | Passord må inneholde minst {minLength} tegn",
  unexpectedDescription: "Hvis problemet vedvarer, ta kontakt med oss ​​via kontaktskjemaet med detaljer.",
  unexpectedTitle: "Det oppstod en uventet feil",
  unknownDescription: "Det oppstod en uventet feil. ",
  unknownTitle: "UH oh!"
}, Ep = {
  subtitle: "Angi ditt nye passord.",
  title: "Glemt passordet?"
}, Pp = {
  headMetaDescription: "Kundepåloggingsside",
  headTitle: "Logg inn med e-post og passord:",
  subtitle: "Logg på eller opprett en konto for å få alle Miele-funksjonene.",
  title: "Logg inn på kontoen din",
  error: {
    invalidEmailPasswordDescription: "Kombinasjonen av e-postadresse og passord er ikke gyldig.",
    invalidEmailPasswordTitle: "Ugyldige legitimasjon",
    missingConcentTitle: "Konto venter på registrering",
    noAccountDescription: "Det er ingen konto knyttet til denne e-postadressen.",
    noAccountTitle: "Ingen konto registrert"
  },
  extraConsentScene: {
    continue: "Fortsette",
    privacyStatementCheckboxLabel: "Jeg har lagt merke til {0}.",
    privacyStatementName: "Personvernerklæring",
    privacyStatementTitle: "Våre retningslinjer for personvern er endret",
    termsOfUseCheckboxLabel: "Jeg godtar {0}.",
    termsOfUseName: "vilkår for bruk",
    termsOfUseTitle: "Våre vilkår for bruk er endret",
    title: "Fullføring av profil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Tilbake til innlogging",
    submitButtonLabel: "Sende inn",
    successDescription: "Vennligst sjekk e-posten din, du vil snart motta informasjonen på kontoen din for å starte med prosessen for tilbakestilling av passord.",
    successTitle: "Din forespørsel er mottatt.",
    title: "Vennligst skriv inn e-postadressen din for å tilbakestille passordet ditt:"
  },
  loginModalScene: {
    copy: "Logg på eller opprett en konto for å få alle Miele-funksjonene.",
    title: "Logg inn på kontoen din"
  },
  loginScene: {
    emailInputLabel: "E-post",
    forgotPwdButtonLabel: "Glemte passordet mitt",
    invalidEmailMessage: "E-post ikke gyldig!",
    loginButtonLabel: "Logg Inn",
    passwordInputLabel: "Passord",
    rememberMeLabel: "Husk meg",
    title: "Logg inn med e-post og passord:"
  }
}, Tp = {
  accessibility: {
    close: "Lukk"
  }
}, Ap = {
  tooShort: "For kort",
  medium: "Middels",
  strong: "Sterk",
  tooWeak: "For svak",
  veryStrong: "Veldig sterk",
  weak: "Svak"
}, xp = {
  showPasswordText: "Vis",
  hidePasswordText: "Skjul"
}, Ip = {
  registerButtonLabel: "registrere",
  registerTitle: "Har du ikke en konto?",
  whyRegister: {
    list: [
      "Tilgang til eksklusive fordeler fra Miele Club",
      "Registrere apparater, spore bestillinger, få tilgang til manualer",
      "Motta personlige tilbud og kampanjer",
      "Se alle dine bestillinger, garantier, arrangementer og tjenester"
    ],
    title: "Hvorfor registrere seg?"
  },
  closeButtonLabel: "Lukk",
  passwordMismatchError: "Passordene stemmer ikke",
  passwordUpdateErrorTitle: "Feil ved oppdatering av passord",
  passwordUpdateSuccessTitle: "Passord oppdatert",
  successfulChangeLabel: "Passordet ditt har blitt oppdatert"
}, Dp = {
  title: "Markedsføringspreferanser",
  description: "Klikk nedenfor for å få eksklusive tilbud, nyheter, produktrådgivning m.m.",
  submit: "Lagre",
  levelOne: {
    shortText: "Ja, jeg ønsker å motta markedsføringskommunikasjon fra Miele A/S og Miele & Cie. KG («Miele») tilpasset mine personlige interesser via e-post, SMS, post og via Miele Apper og nettsidene (om de benyttes)",
    text: "Ja, jeg ønsker å motta markedsføringskommunikasjon fra Miele A/S og Miele & Cie. KG («Miele») tilpasset mine personlige interesser via e-post, SMS, post og via Miele Apper og nettsidene (om de benyttes) med informasjon om produkter, tilbud og nyheter fra Mieles produktsortiment og om Miele-arrangementer/eventer, samt kundeundersøkelser, forespørsler om produktvurderinger og -anmeldelser og oppskrifter. Til dette formålet kan Miele bruke min kontaktinformasjon (navn, e-postadresse, mobiltelefonnummer og postadresse) og utforme kommunikasjonen basert på mine kjøp, tjenester, arrangementshistorikk, klikk- og åpningsatferd for nyhetsbrev samt kundeverdi, som beskrevet i detalj i vår personvernerklæring. Jeg kan når som helst trekke tilbake samtykket mitt uten å oppgi noen grunn med virkning for fremtiden (f.eks. ved å sende en uformell melding til contact{'@'}miele-support.no, kontaktopplysningene som er oppgitt i imprintet eller ved å klikke på avmeldingslenken i e-postmeldinger).",
    link: {
      title: "Personvernerklæring",
      ref: "https://www.miele.no/c/personvern-14.htm"
    }
  },
  levelTwo: {
    text: "I tillegg til mitt grunnleggende samtykke aksepterer jeg at Miele også kan behandle data fra bruken av Miele Appen og mine besøk på Mieles nettsider (www.miele.no), inkludert brukeratferd på Mieles nettsider etter klikk på lenkede nyhetsbrev, for å supplere min brukerprofil for personlig tilpasset reklamekommunikasjon, forutsatt at jeg har gitt et eget samtykke til databehandlingen i appen eller på nettsiden. Jeg kan når som helst trekke tilbake mitt samtykke uten å oppgi noen grunn med virkning for fremtiden. Mer informasjon finnes i Mieles personvernerklæring.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "I tillegg til mitt grunnleggende samtykke tillater jeg også at Miele kan behandle data fra mine tilkoblede Miele-produkter (data om bruk av produktet og -status) for å supplere min brukerprofil for personlig tilpasset reklame. Jeg finner mer informasjon om behandling av produktdata i personvernerklæringen til Miele{'@'}home-systemet. Jeg kan når som helst trekke tilbake mitt samtykke uten å oppgi noen grunn med virkning for fremtiden. Mer informasjon finnes i Mieles personvernerklæring.",
    link: {
      title: "Miele{'@'}home-systemet",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ja, jeg godtar vilkårene for bruk.",
    link: {
      title: "Se vilkårene for bruk*",
      ref: "https://www.miele.no/c/vilkar-for-bruk-304.htm"
    }
  }
}, Np = {
  headline: "Miele Club",
  birthDateTitle: "Kan vi sende deg en bursdagsgave?",
  birthDateLabel: "Fødselsdato (frivillig)",
  why: {
    title: "Medlemskap uten kostnad - Eksklusive medlemstilbud.",
    reasons: [
      "Velkomstgave 10 % rabatt",
      "Bursdagsoverraskelse",
      "Eksklusive tilbud ",
      "Invitasjoner til eventer og opplevelser"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Skriv datoen i dette formatet: DD/MM/ÅÅÅÅ",
    errorMsg: "Ugyldig dato"
  },
  joinClubLabel: "Ja, jeg vil gjerne bli medlem av Miele Club.",
  termsAndCondition: {
    description: "Jeg samtykker til {termsAndConditionLink} til Miele Club, og bekrefter at jeg har lest og forstått Miele Clubs {privacyLink}.",
    termsAndConditionLink: {
      title: "medlems- og bruksvilkårene",
      ref: "https://www.miele.no/c/vilkar-og-betingelser-13.htm"
    },
    privacyLink: {
      title: "personvernerklæring",
      ref: "https://www.miele.no/c/personvern-14.htm"
    }
  },
  newsletter: {
    description: "Ja, jeg ønsker å motta Miele Club reklamekommunikasjon som er tilpasset mine personlige interesser fra selskapet Miele A/S («Miele») per e-post og post. Den omfatter spesialtilbud, informasjon, invitasjoner til eventer og kundeundersøkelser om våre produkter og tjenesteytelser. Miele kan i den forbindelse benytte mine kontaktopplysninger (navn, e-postadresse og postadresse) og tilpasse kommunikasjonen basert på min kjøps- og nyhetsbrevatferd, samt min kundeverdi, slik det er beskrevet mer i detalj i Miele Clubs {privacyLink}. Jeg kan til enhver tid trekke tilbake mitt samtykke med fremtidig virkning (for eksempel i en uformell melding til info{'@'}miele.no, kontaktopplysningene som er angitt i vårt impressum eller ved å klikke på avmeldingslenken i e-poster). Den avtalefestede {termsAndConditionLink} forblir upåvirket av dette frem til medlemskapet sies opp.",
    shortDescription: "Ja, jeg ønsker å motta Miele Club reklamekommunikasjon som er tilpasset mine personlige interesser fra selskapet Miele A/S («Miele») per e-post og post",
    privacyLink: {
      title: "personvernerklæring",
      href: "https://www.miele.no/c/personvern-14.htm"
    },
    termsAndConditionLink: {
      title: "klubbkommunikasjonen",
      href: "https://www.miele.no/c/vilkar-og-betingelser-13.htm"
    },
    supportEmail: "info{'@'}miele.no"
  },
  selectAllConsents: {
    description: "For å bli medlem av Miele Klubben, må du godta alle vilkår og betingelser *"
  }
}, Op = "vis mer", Up = "vis mindre", $p = {
  auth: _p,
  changeEmailScene: Sp,
  changePasswordScene: Cp,
  errors: Lp,
  forgotPassword: Ep,
  login: Pp,
  modal: Tp,
  passwordStrength: Ap,
  passwordHelper: xp,
  register: Ip,
  "marketing-consent": {
    title: "Markedsføringspreferanser",
    description: "Kryss av nedenfor for eksklusive tilbud, nyheter, arrangementer og hvordan du får mest mulig ut av apparatet ditt.",
    submit: "Lagre",
    newsletter: {
      text: "Jeg samtykker i at Miele AS («Miele») kan sende meg informasjon om produkter og nyheter fra Mieles sortiment og om Mieles arrangementer, kundeundersøkelser, produktvurderinger and anmeldelser og oppskrifter via e-post, Miele-apper og SMS. Til dette formålet vil Miele benytte kontaktinformasjonen (navn, e-postadresse, mobilnummer og adresse) jeg har oppgitt.",
      link: {
        title: "Se retningslinjer for databeskyttelse",
        ref: ""
      }
    },
    personalisation: {
      text: "Jeg godtar at Miele kan behandle informasjon om tjenestene jeg har brukt og teknikeroppdrag jeg har utført, samt arrangementer jeg har deltatt på, med det formål å forbedre personlig tilpasning.",
      link: {
        title: "Se retningslinjer for databeskyttelse",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "I tillegg til den utvidede personaliseringen godtar jeg at Miele også kan behandle data fra bruken av Miele-appen og mine besøk på Mieles nettsteder (www.miele.co.uk) for å supplere brukerprofilen min, forutsatt at jeg har samtykket separat. ",
      link: {
        title: "Se retningslinjer for databeskyttelse",
        ref: ""
      }
    },
    highlightedText: {
      text: "Jeg kan tilbakekalle mitt samtykke når som helst uten å oppgi grunner med virkning for fremtiden.  ",
      link: {
        title: "retningslinjer for databeskyttelse.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ja, jeg godtar vilkårene for bruk.",
      link: {
        title: "Se vilkårene for bruk*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: Dp,
  mieleClub: Np,
  readMore: Op,
  readLess: Up
}, Bp = {
  waitMessage: "Quase lá. "
}, Rp = {
  buttonLabel: "Guardar",
  buttonLabelClose: "Fechar",
  confirmEmailMessage: "Confirme seu endereço de e-mail",
  copy: "Para atualizar seu endereço de e-mail, adicione o novo abaixo:",
  errorMessageCopy: "Ocorreu um erro.",
  errorMessageHeadline: "Erro",
  headline: "Detalhes de perfil",
  inputEmailConfirmPlaceholder: "Confirme seu endereço de e-mail",
  inputEmailPlaceholder: "Endereço de email",
  invalidEmailMessage: "Email inválido!",
  rememberMeLabel: "Lembre de mim",
  successMessageCopy: "O seu endereço de e-mail foi atualizado com sucesso.",
  successMessageHeadline: "Endereço de email atualizado"
}, Fp = {
  closeButtonLabel: "Fechar",
  confirmPasswordLabel: "Confirme a sua palavra-passe",
  currentPasswordLabel: "Senha atual",
  newPasswordLabel: "Nova Senha",
  passwordMismatchError: "Senha não corresponde",
  passwordUpdateErrorTitle: "Erro",
  passwordUpdateSuccessTitle: "palavra-passe atualizada",
  samePasswordError: "Esta palavra-passe foi utilizada anteriormente, envie uma nova palavra-passe",
  subtitle: "Para alterar a sua palavra-passe, por favor preencha os campos abaixo:",
  submitButtonLabel: "Enviar",
  successfulChangeLabel: "A sua palavra-passe foi atualizada com sucesso",
  title: "Mudança de palavra-passe"
}, Vp = {
  invalidEmail: "e-mail incorreto",
  invalidPassword: "Senha incorreta",
  sap_206002: "A sua conta está com verificação pendente. Infelizmente, não podemos permitir que você continue no momento.",
  sap_206006: "Parece que o endereço de e-mail que você enviou está com verificação pendente",
  sap_400003: "Este e-mail já existe, por favor, use um endereço de e-mail diferente!",
  sap_400028: "O endereço de e-mail enviado está com verificação pendente",
  sap_400050: "Desculpe, não podemos validar as suas credenciais neste momento.",
  sap_400097: "Parece que você está acedendo aos nossos serviços através de um navegador inseguro/sem suporte.",
  sap_401030: "Esta palavra-passe foi usada anteriormente, por favor, envie uma nova palavra-passe",
  sap_403005: "Não temos uma conta associada a este endereço de e-mail, verifique o seu e-mail e tente novamente",
  sap_403011: "Sessão expirada.",
  sap_403012: "Sessão expirada.",
  sap_403013: "Desculpe, não podemos validar as suas credenciais neste momento.",
  sap_403035: "Desculpe, não podemos validar as suas credenciais neste momento.",
  sap_403041: "Não temos uma conta associada a este endereço de e-mail, verifique o seu e-mail e tente novamente",
  sap_403042: "E-mail",
  sap_403043: "E-mail",
  sap_403047: "E-mail",
  sap_403100: "Uma solicitação de atualização de palavra-passe foi solicitada recentemente, por favor, fique connosco até que a solicitação seja processada",
  sap_403025: "Link de redefinição de palavra-passe inválido.",
  sapErrorTitle: "Solicitação de processamento de erro",
  sessionExpired: "Sessão expirada",
  tooWeakPassword: "A palavra-passe deve conter pelo menos {minLength} caracteres e {minCharGroups} dos seguintes: letra maiúscula, letra minúscula, número, símbolo especial | A palavra-passe deve conter pelo menos {minLength} caracteres",
  unexpectedDescription: "Se o problema persistir, entre em contacto connosco através do formulário de contacto com detalhes.",
  unexpectedTitle: "Ocorreu um erro inesperado",
  unknownDescription: "Ocorreu um erro inesperado.",
  unknownTitle: "Oh não!"
}, qp = {
  subtitle: "Defina a sua nova palavra-passe.",
  title: "Esqueceu a sua palavra-passe?"
}, Gp = {
  headMetaDescription: "página de login do cliente",
  headTitle: "Faça login com o seu e-mail e palavra-passe:",
  subtitle: "Inicie sessão ou crie uma conta para obter todas as funcionalidades Miele.",
  title: "Faça login na sua conta",
  error: {
    invalidEmailPasswordDescription: "A combinação de endereço de e-mail e palavra-passe não é válida.",
    invalidEmailPasswordTitle: "Credenciais inválidas",
    missingConcentTitle: "Registro pendente de conta",
    noAccountDescription: "Não há nenhuma conta associada a este endereço de e-mail.",
    noAccountTitle: "Nenhuma conta cadastrada"
  },
  extraConsentScene: {
    continue: "Continuar",
    privacyStatementCheckboxLabel: "Tomei nota do {0}.",
    privacyStatementName: "declaração de privacidade",
    privacyStatementTitle: "Nossa Política de Privacidade mudou",
    termsOfUseCheckboxLabel: "Eu concordo com os {0}.",
    termsOfUseName: "termos de uso",
    termsOfUseTitle: "Os nossos Termos de Uso mudaram",
    title: "Conclusão do perfil"
  },
  forgotPasswordScene: {
    backButtonLabel: "Volte ao login",
    submitButtonLabel: "Enviar",
    successDescription: "Por favor, verifique o seu e-mail, você receberá em breve as informações da sua conta para iniciar o processo de redefinição de palavra-passe.",
    successTitle: "O seu pedido foi recebido.",
    title: "Digite o seu endereço de e-mail para redefinir a sua palavra-passe:"
  },
  loginModalScene: {
    copy: "Inicie sessão ou crie uma conta para obter todas as funcionalidades Miele.",
    title: "Faça login na sua conta"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Esqueci-me da palavra-passe",
    invalidEmailMessage: "Email inválido!",
    loginButtonLabel: "Iniciar sessão",
    passwordInputLabel: "Palavra-passe",
    rememberMeLabel: "Lembre-se de mim",
    title: "Faça login com o seu e-mail e palavra-passe:"
  }
}, Kp = {
  accessibility: {
    close: "Fechar"
  }
}, Hp = {
  tooShort: "Muito curta",
  medium: "Média",
  strong: "Forte",
  tooWeak: "Muito fraco",
  veryStrong: "Muito forte",
  weak: "Fraco"
}, Wp = {
  showPasswordText: "Mostrar",
  hidePasswordText: "Esconder"
}, Jp = {
  registerButtonLabel: "registo",
  registerTitle: "Não tem uma conta?",
  whyRegister: {
    list: [
      "Acesso a vantagens exclusivas do Miele Club",
      "Registe eletrodomésticos, rastreie pedidos, aceda a manuais",
      "Receba ofertas e promoções personalizadas",
      "Veja todos os seus pedidos, garantias, eventos e serviços"
    ],
    title: "Vantagens do registo"
  },
  closeButtonLabel: "Fechar",
  passwordMismatchError: "As palavras-passe não combinam",
  passwordUpdateErrorTitle: "Erro de atualização de palavra-passe",
  passwordUpdateSuccessTitle: "palavra-passe atualizada",
  successfulChangeLabel: "A sua palavra-passe foi atualizada com sucesso"
}, Zp = {
  title: "Preferências de marketing",
  description: "Assinale abaixo para obter promoções exclusivas, notícias, conselhos sobre produtos e muito mais.",
  submit: "Salvar",
  levelOne: {
    shortText: 'Sim, gostaria de receber comunicações promocionais da Miele Portuguesa, Lda e da Miele & Cie. KG ("Miele") adaptadas aos meus interesses pessoais por e-mail, SMS, correio e através das aplicações e websites da Miele (se utilizados)',
    text: `Sim, gostaria de receber comunicações promocionais da Miele Portuguesa, Lda e da Miele & Cie. KG ("Miele") adaptadas aos meus interesses pessoais por e-mail, SMS, correio e através das aplicações e websites da Miele (se utilizados) com informações sobre produtos, ofertas e inovações dos produtos Miele e sobre eventos Miele, bem como inquéritos a clientes, pedidos de classificação e avaliação de produtos e receitas. Para tal, a Miele pode utilizar os meus dados de contacto (forma de tratamento, nome, endereço de correio eletrónico, número de telemóvel e morada) e conceber a comunicação com base na minha compra, serviço, histórico de eventos, comportamento de clique e abertura da newsletters, bem como no valor do cliente, conforme descrito em detalhe na nossa política de privacidade. Posso revogar o meu consentimento a qualquer momento, sem necessidade de indicar os motivos, com efeito futuro (por exemplo, ao enviar uma mensagem informal para info{'@'}miele.pt, para os dados de contacto indicados na ficha técnica ou ao clicar na ligação de cancelamento da subscrição nos e-mails).`,
    link: {
      title: "Politica de privacidade",
      ref: "https://www.miele.pt/c/protecao-de-dados-14.htm"
    }
  },
  levelTwo: {
    text: "Para além do meu consentimento básico, concordo que a Miele também pode processar dados da utilização da aplicação Miele e das minhas visitas aos sites da Miele (www.miele.pt), incluindo o comportamento do utilizador nos sites da Miele após cliques na newsletter, para complementar o meu perfil de utilizador para comunicações publicitárias personalizadas, desde que o meu consentimento separado na aplicação ou no site autorize o processamento de dados. Posso revogar o meu consentimento a qualquer momento, sem indicação dos motivos, com efeito futuro. Para obter mais informações, consulte a política de proteção de dados da Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Para além do meu consentimento básico, concordo que a Miele também pode processar dados dos meus aparelhos Miele ligados em rede (dados sobre a utilização e estado dos aparelhos) para complementar o meu perfil de utilizador para publicidade personalizada. Para obter mais informações sobre o processamento de dados a partir de aparelhos, consulte a política de privacidade do sistema Miele{'@'}home. Posso revogar o meu consentimento em qualquer momento, sem necessidade de justificação, com efeito futuro. Para obter mais informações, consulte a política de proteção de dados da Miele.",
    link: {
      title: "Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Posso revogar o meu consentimento a qualquer momento sem apresentar motivos com efeitos para o futuro.",
    link: {
      title: "política de proteção de dados.",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Sim, eu concordo com os termos de uso.",
    link: {
      title: "Consulte os Termos de Uso*",
      ref: ""
    }
  }
}, Yp = {
  headline: "Miele Club",
  why: {
    title: "Adesão gratuit - Vantagens e ofertas exclusivas para membros.",
    reasons: [
      "Voucher de boas-vindas com 10 % de desconto em acessórios e consumíveis na sua próxima compra. Consulte as condições em www.miele.pt/e/miele-club",
      "Surpresa de aniversário",
      "Ofertas e promoções exclusivas",
      "Convites para eventos e experiências exclusivas"
    ]
  },
  birthDateTitle: "Gostaria de receber uma surpresa de aniversário?",
  birthDateLabel: "Data de nascimento (opcional)",
  birthDateValidation: {
    requirementMsg: "Introduza a data no seguinte formato: DD/MM/AAAA",
    errorMsg: "Data incorrecta"
  },
  joinClubLabel: "Sim, gostaria de aderir ao Miele Club",
  termsAndCondition: {
    description: "Concordo com os {termsAndConditionLink} e confirmo que li a informação sobre a {privacyLink} do Clube Miele.",
    termsAndConditionLink: {
      title: "Termos e Condições de Participação e Utilização",
      ref: "https://www.miele.pt/c/condicoes-gerais-13.htm#p7613"
    },
    privacyLink: {
      title: "Regulamentos de proteção de dados",
      ref: "https://www.miele.pt/c/protecao-de-dados-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Sim, gostaria de receber comunicações sobre o Miele Club adaptadas aos meus interesses pessoais pela Miele Portuguesa («Miele») por e-mail e correio",
    description: "Sim, gostaria de receber comunicações sobre o Miele Club adaptadas aos meus interesses pessoais pela Miele Portuguesa («Miele») por e-mail e correio com promoções especiais, informações de produto, convites para eventos e inquéritos sobre os produtos e serviços da Miele. Para tal, a Miele pode utilizar os meus dados de contacto (forma de tratamento, nome, e-mail e endereço postal) e criar comunicações com base no meu comportamento de compra e de abertura de newsletters e encomendas, tal como descrito com mais detalhe na nossa {privacyLink}. Posso revogar em qualquer altura o meu consentimento com efeito futuro (por ex., com uma mensagem para info{'@'}miele.pt, para os dados de contacto indicados na ficha técnica, ou ao clicar na ligação de cancelamento da subscrição nos e-mails). A comunicação contratual do {termsAndConditionLink} mantém-se inalterada até ao cancelamento da adesão.",
    privacyLink: {
      title: "Política de privacidade",
      href: "https://www.miele.pt/c/protecao-de-dados-14.htm"
    },
    termsAndConditionLink: {
      title: "Miele Club",
      href: "https://www.miele.pt/c/condicoes-gerais-13.htm#p7613"
    },
    supportEmail: "info{'@'}miele.pt"
  },
  selectAllConsents: {
    description: "Para aderir ao Clube Miele, deve aceitar todos os termos e condições *"
  }
}, Xp = "mostrar declaração completa", Qp = "ocultar declaração completa", eh = {
  auth: Bp,
  changeEmailScene: Rp,
  changePasswordScene: Fp,
  errors: Vp,
  forgotPassword: qp,
  login: Gp,
  modal: Kp,
  passwordStrength: Hp,
  passwordHelper: Wp,
  register: Jp,
  "marketing-consent": {
    title: "Preferências de marketing",
    description: "Marque abaixo para ofertas exclusivas, notícias, eventos e como obter o máximo do seu eletrodoméstico.",
    submit: "Salvar",
    newsletter: {
      text: 'Concordo que a Miele Portuguesa ("Miele") me envie informações sobre produtos e inovações da gama de produtos Miele e sobre eventos Miele, bem como inquéritos a clientes, avaliações e críticas a produtos e receitas por e-mail, aplicações Miele e SMS e que a Miele possa processar os dados de contacto que indiquei (título, nome, endereço de e-mail, número de telemóvel e código postal) e os produtos Miele que comprei até à data e que irei comprar no futuro bem como os interesses que indiquei para este fim. Concordo ainda que a Miele possa também processar as confirmações de receção e leitura recebidas através da newsletter e informações sobre os links em que cliquei, bem como o meu comportamento de utilizador no site ligado para fins de personalização. O mesmo se aplica às mensagens push in-app, desde que sejam utilizadas as aplicações Miele. ',
      link: {
        title: "Mais informações na Política de Privacidade da Miele",
        ref: "https://www.miele.pt/c/protecao-de-dados-14.htm"
      }
    },
    personalisation: {
      text: "Concordo que a Miele processe informações sobre os serviços que utilizei e as tarefas técnicas que realizei, bem como eventos em que participei, para fins de personalização aprimorada.",
      link: {
        title: "Mais informações na Política de Privacidade da Miele",
        ref: "https://www.miele.pt/c/protecao-de-dados-14.htm"
      }
    },
    extendedPersonalisation: {
      text: "Além da personalização alargada, concordo que a Miele também possa processar dados da utilização da aplicação Miele e das minhas visitas aos sites da Miele (www.miele.co.uk) para complementar o meu perfil de utilizador, desde que eu tenha consentido separadamente ",
      link: {
        title: "Mais informações na Política de Privacidade da Miele",
        ref: "https://www.miele.pt/c/protecao-de-dados-14.htm"
      }
    },
    highlightedText: {
      text: "Posso revogar o meu consentimento a qualquer momento sem apresentar motivos com efeitos para o futuro.  ",
      link: {
        title: "Mais informações na Política de Privacidade da Miele",
        ref: "https://www.miele.pt/c/protecao-de-dados-14.htm"
      }
    },
    termsOfUse: {
      text: "Sim, eu concordo com os termos de uso.",
      link: {
        title: "Consulte os Termos de Uso*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: Zp,
  mieleClub: Yp,
  readMore: Xp,
  readLess: Qp
}, th = {
  waitMessage: "Nästan där. "
}, ih = {
  buttonLabel: "Spara",
  buttonLabelClose: "Stänga",
  confirmEmailMessage: "Bekräfta din e-postadress",
  copy: "För att uppdatera din e-postadress, lägg till den nya nedan:",
  errorMessageCopy: "Något gick fel. ",
  errorMessageHeadline: "Fel",
  headline: "Profildetaljer",
  inputEmailConfirmPlaceholder: "Bekräfta Din E-postadress",
  inputEmailPlaceholder: "E-postadress",
  invalidEmailMessage: "E-post inte giltig!",
  rememberMeLabel: "Kom ihåg mig",
  successMessageCopy: "Din e-postadress har uppdaterats.",
  successMessageHeadline: "E-postadress uppdaterad"
}, nh = {
  closeButtonLabel: "Stänga",
  confirmPasswordLabel: "Bekräfta lösenord",
  currentPasswordLabel: "Nuvarande lösenord",
  newPasswordLabel: "nytt lösenord",
  passwordMismatchError: "Lösenordet matchar inte",
  passwordUpdateErrorTitle: "Fel",
  passwordUpdateSuccessTitle: "lösenord uppdaterat",
  samePasswordError: "Detta lösenord användes tidigare, vänligen skicka in ett nytt lösenord",
  subtitle: "För att ändra ditt lösenord, fyll i fälten nedan:",
  submitButtonLabel: "Skicka in",
  successfulChangeLabel: "Ditt lösenord har uppdaterats",
  title: "Lösenordsändring"
}, ah = {
  invalidEmail: "Felaktig e-post",
  invalidPassword: "Fel lösenord",
  sap_206002: "Ditt konto väntar på verifiering, jag är rädd att vi inte kan låta dig fortsätta just nu. ",
  sap_206006: "Det verkar som att e-postadressen du skickade in väntar på verifiering",
  sap_400003: "Denna e-postadress finns redan, använd en annan e-postadress!",
  sap_400028: "Den skickade e-postadressen väntar på verifiering",
  sap_400050: "Tyvärr, vi kan inte validera dina uppgifter för närvarande.",
  sap_400097: "Det verkar som att du använder våra tjänster från en osäker/inte stödd webbläsare. ",
  sap_401030: "Detta lösenord användes tidigare, vänligen skicka in ett nytt lösenord",
  sap_403005: "Vi har inget konto kopplat till den här e-postadressen, kontrollera din e-post och försök igen",
  sap_403011: "Sessionen löpte. ",
  sap_403012: "Sessionen löpte. ",
  sap_403013: "Tyvärr, vi kan inte validera dina uppgifter för närvarande.",
  sap_403035: "Tyvärr, vi kan inte validera dina uppgifter för närvarande.",
  sap_403041: "Vi har inget konto kopplat till den här e-postadressen, kontrollera din e-post och försök igen",
  sap_403042: "E-post",
  sap_403043: "E-post",
  sap_403047: "E-post",
  sap_403100: "En begäran om lösenordsuppdatering har nyligen begärts, vänligen kontakta oss tills begäran har behandlats",
  sap_403025: "Återställ lösenordslänken är ogiltig, skicka förfrågan om glömt lösenord igen för att få en ny återställningslänk.",
  sapErrorTitle: "Fel vid behandling av begäran",
  sessionExpired: "Sessionen löpte",
  tooWeakPassword: "Lösenordet måste innehålla minst {minLength} tecken och {minCharGroups} av följande tecken: stor bokstav, liten bokstav, siffra, specialsymbol | Lösenordet måste innehålla minst {minLength} tecken",
  unexpectedDescription: "Om problemet kvarstår vänligen kontakta oss via kontaktformuläret med information.",
  unexpectedTitle: "Ett oväntat fel inträffade",
  unknownDescription: "Oväntat fel uppstod. ",
  unknownTitle: "Hoppsan!"
}, sh = {
  subtitle: "Ställ in ditt nya lösenord.",
  title: "Glömt ditt lösenord?"
}, oh = {
  headMetaDescription: "Kundinloggningssida",
  headTitle: "Logga in med din e-postadress och ditt lösenord:",
  subtitle: "Logga in eller skapa ett konto för att få alla Mieles funktioner.",
  title: "Logga in på ditt konto",
  error: {
    invalidEmailPasswordDescription: "Kombinationen av e-postadress och lösenord är inte giltig.",
    invalidEmailPasswordTitle: "Ogiltiga uppgifter",
    missingConcentTitle: "Konto väntar på registrering",
    noAccountDescription: "Det finns inget konto kopplat till den här e-postadressen.",
    noAccountTitle: "Inget konto registrerat"
  },
  extraConsentScene: {
    continue: "Fortsätta",
    privacyStatementCheckboxLabel: "Jag har noterat {0}.",
    privacyStatementName: "sekretesspolicy",
    privacyStatementTitle: "Vår integritetspolicy har ändrats",
    termsOfUseCheckboxLabel: "Jag godkänner {0}.",
    termsOfUseName: "villkor",
    termsOfUseTitle: "Våra användarvillkor har ändrats",
    title: "Profilkomplettering"
  },
  forgotPasswordScene: {
    backButtonLabel: "Tillbaka till login",
    submitButtonLabel: "Skicka in",
    successDescription: "Vänligen kontrollera din e-post, du kommer snart att få information om ditt konto för att börja med processen för återställning av lösenord.",
    successTitle: "Din förfrågan har mottagits.",
    title: "Ange din e-postadress för att återställa ditt lösenord:"
  },
  loginModalScene: {
    copy: "Logga in eller skapa ett konto för att få alla Mieles funktioner.",
    title: "Logga in på ditt konto"
  },
  loginScene: {
    emailInputLabel: "E-post",
    forgotPwdButtonLabel: "Glömde mitt lösenord",
    invalidEmailMessage: "E-post inte giltig!",
    loginButtonLabel: "Logga in",
    passwordInputLabel: "Lösenord",
    rememberMeLabel: "Kom ihåg mig",
    title: "Logga in med din e-postadress och ditt lösenord:"
  }
}, rh = {
  accessibility: {
    close: "Stänga"
  }
}, lh = {
  tooShort: "För kort",
  medium: "Medel",
  strong: "Stark",
  tooWeak: "För svag",
  veryStrong: "Väldigt stark",
  weak: "Svag"
}, ch = {
  showPasswordText: "Visa",
  hidePasswordText: "Dölj"
}, dh = {
  registerButtonLabel: "Registrera",
  registerTitle: "Har du inget konto?",
  whyRegister: {
    list: [
      "Tillgång till exklusiva förmåner från Miele Club",
      "Registrera apparater, spåra beställningar, få tillgång till manualer",
      "Få personliga erbjudanden och kampanjer",
      "Se alla dina beställningar, garantier, evenemang och tjänster"
    ],
    title: "Varför registrera sig?"
  },
  closeButtonLabel: "Stänga",
  passwordMismatchError: "Lösenorden stämmer inte överens",
  passwordUpdateErrorTitle: "Lösenordsuppdateringsfel",
  passwordUpdateSuccessTitle: "lösenord uppdaterat",
  successfulChangeLabel: "Ditt lösenord har uppdaterats"
}, uh = {
  title: "Marknadsföringspreferenser",
  description: "Markera nedan för exklusiva erbjudanden, nyheter, evenemang och hur du får ut det mesta av din apparat.",
  submit: "Spara",
  levelOne: {
    shortText: 'Ja, jag vill gärna få reklammeddelanden från Miele AB och Miele & Cie. KG ("Miele") som är anpassade till mina personliga intressen via e-post, SMS, post och via Miele-appar och webbsidor (om de används)',
    text: `Ja, jag vill gärna få reklammeddelanden från Miele AB och Miele & Cie. KG ("Miele") som är anpassade till mina personliga intressen via e-post, SMS, post och via Miele-appar och webbsidor (om de används) med information om produkter, erbjudanden och nyheter från Mieles produktsortiment och om Miele-event samt kundundersökningar, begäran om produktbetyg och recensioner samt recept. För detta ändamål kan Miele använda mina kontaktuppgifter (namn, e-postadress, mobiltelefonnummer och postadress) och utforma kommunikationen baserat på mina köp, tjänster, händelsehistorik, klick- och öppningsbeteende för nyhetsbrev samt kundvärde, vilket beskrivs i detalj i vår integritetspolicy . Jag kan när som helst återkalla mitt samtycke utan att ange skäl med verkan för framtiden (t.ex. genom att skicka ett informellt meddelande till contact{'@'}miele-support.se, de kontaktuppgifter som anges under Miele AB eller genom att klicka på länken för avregistrering i e-postmeddelanden).`,
    link: {
      title: "integritetspolicy",
      ref: "https://www.miele.se/c/integritetspolicy-14.htm"
    }
  },
  levelTwo: {
    text: "Utöver mitt grundläggande samtycke samtycker jag till att Miele även får behandla data från användningen av Miele-appen och mina besök på Mieles webbplatser (www.miele.se), inklusive användarbeteende på Mieles webbplatser efter klick på länkade nyhetsbrev, för att komplettera min användarprofil för personlig reklamkommunikation, förutsatt att mitt separata samtycke i appen eller på webbplatsen frigör databehandlingen. Jag kan när som helst återkalla mitt samtycke utan att ange skäl med verkan för framtiden. Ytterligare information finns i Mieles dataskyddspolicy.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Utöver mitt grundläggande samtycke samtycker jag till att Miele även får behandla data från mina anslutna Miele-produkter (data om produkternasanvändning och status) för att komplettera min användarprofil för personlig reklam. Mer information om behandlingen av produktdata hittar jag i sekretesspolicyn för Miele{'@'}Home-systemet. Jag kan när som helst återkalla mitt samtycke utan att ange skäl med verkan för framtiden. Ytterligare information finns i Mieles dataskyddspolicy.",
    link: {
      title: "Miele{'@'}Home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ja, jag godkänner användarvillkoren.",
    link: {
      title: "Se användarvillkoren*",
      ref: "https://www.miele.se/c/anvandarvillkor-304.htm"
    }
  }
}, mh = {
  headline: "Miele Club",
  why: {
    title: "Medlemskap utan kostnad - Exklusiva erbjudanden för medlemmar.",
    reasons: [
      "Välkomstgåva 10 % rabatt",
      "Födelsedagsöverraskning",
      "Exklusiva erbjudanden",
      "Inbjudningar till event & upplevelser "
    ]
  },
  birthDateTitle: "Får vi skicka en födelsedagspresent till dig?",
  birthDateLabel: "Födelsedatum (frivilligt)",
  birthDateValidation: {
    requirementMsg: "Ange datumformat DD/MM/ÅÅÅÅ",
    errorMsg: "Ogiltigt datum"
  },
  joinClubLabel: "Ja, jag vill gå med i Miele Club.",
  termsAndCondition: {
    description: "Jag godkänner Miele Club {termsAndConditionLink} och har tagit del av {privacyLink} gällande Miele Club.",
    termsAndConditionLink: {
      title: "medlems- och användarvillkor",
      ref: "https://www.miele.se/c/allmanna-villkor-13.htm"
    },
    privacyLink: {
      title: "integritetspolicyn",
      ref: "https://www.miele.se/c/integritetspolicy-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Ja, jag vill få klubbkommunikation från Miele AB (”Miele”) som har skräddarsytts utifrån mina personliga intressen via e-post och post",
    description: "Ja, jag vill få klubbkommunikation från Miele AB (”Miele”) som har skräddarsytts utifrån mina personliga intressen via e-post och post med specialerbjudanden, information, inbjudan till evenemang samt kundundersökningar om våra produkter och tjänster. För detta ändamål kan Miele använda mina kontaktuppgifter (namn, e-postadress och postadress) och utforma kommunikation baserat på mitt köpbeteende, mina interaktioner med nyhetsbrev samt mitt kundvärde, vilket beskrivs mer i detalj i {privacyLink}. Jag kan när som helst återkalla mitt samtycke med framtida verkan (t. ex. genom att skicka ett informellt meddelande till info{'@'}miele.se, eller genom att använda kontaktuppgifterna under Miele AB eller genom att klicka på avregistreringslänken i e-postmeddelanden). Den avtalsenliga {termsAndConditionLink} förblir opåverkad tills medlemskapet avslutas. ",
    privacyLink: {
      title: "integritetspolicyn för vår kundklubb",
      href: "https://www.miele.se/c/integritetspolicy-14.htm"
    },
    termsAndConditionLink: {
      title: "kommunikationen från kundklubben",
      href: "https://www.miele.se/c/allmanna-villkor-13.htm"
    },
    supportEmail: "info{'@'}miele.se"
  },
  selectAllConsents: {
    description: "För att gå med i Miele-klubben måste du acceptera alla villkor *"
  }
}, ph = "visa hela texten", hh = "dölja hela texten", gh = {
  auth: th,
  changeEmailScene: ih,
  changePasswordScene: nh,
  errors: ah,
  forgotPassword: sh,
  login: oh,
  modal: rh,
  passwordStrength: lh,
  passwordHelper: ch,
  register: dh,
  "marketing-consent": {
    title: "Marknadsföringspreferenser",
    description: "Markera nedan för exklusiva erbjudanden, nyheter, evenemang och hur du får ut det mesta av din apparat.",
    submit: "Spara",
    newsletter: {
      text: "Jag godkänner att Miele AB (“Miele”) skickar information om produkter och nyheter från Mieles sortiment och om Miele-evenemang samt kundundersökningar, produktomdömen och betyg och recept till mig via e-post, Mieles appar och sms. För att göra detta får Miele behandla de kontaktuppgifter som jag har angett (titel, namn, e-postadress, mobiltelefonnummer och postnummer) och de Miele-produkter som jag har köpt hittills och kommer att köpa i framtiden samt de intressen som jag har angett.",
      link: {
        title: "Se dataskyddspolicy",
        ref: ""
      }
    },
    personalisation: {
      text: "Jag samtycker till att Miele får behandla information om de tjänster jag har använt och teknikeruppdrag jag har utfört, samt event som jag har deltagit i, i syfte att förbättra personaliseringen.",
      link: {
        title: "Se dataskyddspolicy",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Utöver den utökade personaliseringen samtycker jag till att Miele även kan behandla data från användningen av Miele-appen och mina besök på Mieles webbplatser (www.miele.co.uk) för att komplettera min användarprofil, förutsatt att jag har gett separat samtycke ",
      link: {
        title: "Se dataskyddspolicy",
        ref: ""
      }
    },
    highlightedText: {
      text: "Jag kan när som helst återkalla mitt samtycke utan att ange skäl med verkan för framtiden.  ",
      link: {
        title: "dataskyddspolicy.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ja, jag godkänner användarvillkoren.",
      link: {
        title: "Se användarvillkoren*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: uh,
  mieleClub: mh,
  readMore: ph,
  readLess: hh
}, vh = {
  waitMessage: "Skoraj tam. "
}, fh = {
  buttonLabel: "Shrani",
  buttonLabelClose: "Zapri",
  confirmEmailMessage: "Potrdite svoj e-poštni naslov",
  copy: "Če želite posodobiti svoj e-poštni naslov, dodajte novega spodaj:",
  errorMessageCopy: "Nekaj ​​je šlo narobe. Poskusite znova ",
  errorMessageHeadline: "Napaka",
  headline: "Podrobnosti profila",
  inputEmailConfirmPlaceholder: "Potrdite Svoj Elektronski Naslov",
  inputEmailPlaceholder: "E-poštni naslov",
  invalidEmailMessage: "E-poštni naslov ni veljaven!",
  rememberMeLabel: "Zapomni si me",
  successMessageCopy: "Vaš e-poštni naslov je bil uspešno posodobljen.",
  successMessageHeadline: "E-poštni naslov posodobljen"
}, kh = {
  closeButtonLabel: "Zapri",
  confirmPasswordLabel: "Potrdi geslo",
  currentPasswordLabel: "Trenutno geslo",
  newPasswordLabel: "novo geslo",
  passwordMismatchError: "Geslo se ne ujema",
  passwordUpdateErrorTitle: "Napaka",
  passwordUpdateSuccessTitle: "Geslo posodobljeno",
  samePasswordError: "To geslo je bilo že uporabljeno, prosimo, pošljite novo geslo",
  subtitle: "Za spremembo gesla izpolnite spodnja polja:",
  submitButtonLabel: "Oddaj",
  successfulChangeLabel: "Vaše geslo je bilo uspešno posodobljeno",
  title: "Sprememba gesla"
}, bh = {
  invalidEmail: "Napačen e-poštni naslov",
  invalidPassword: "Napačno geslo",
  sap_206002: "Vaš račun čaka na preverjanje, vam trenutno ne moremo dovoliti nadaljevanja.  Prosim stopite v stik z nami za več informacij",
  sap_206006: "Videti je, da e-poštni naslov, ki ste ga poslali, čaka na preverjanje",
  sap_400003: "Ta e-poštni naslov že obstaja, uporabite drug e-poštni naslov.",
  sap_400028: "Poslani e-poštni naslov čaka na preverjanje",
  sap_400050: "Oprostite, trenutno ne moremo potrditi vaših poverilnic.",
  sap_400097: "Videti je, da do naših storitev dostopate iz nevarnega/nepodprtega brskalnika. Prosim poizkusite ponovno z drugim brskalnikom",
  sap_401030: "To geslo je bilo že uporabljeno, prosimo, vnesite novo geslo",
  sap_403005: "Nimamo računa, povezanega s tem e-poštnim naslovom, preverite svojo e-pošto in poskusite znova",
  sap_403011: "Seja se je iztekla. Ponovno naložite brskalnik in se ponovno prijavite. ",
  sap_403012: "Seja se je iztekla. Ponovno naložite brskalnik in se ponovno prijavite.",
  sap_403013: "Oprostite, trenutno ne moremo potrditi vaših poverilnic.",
  sap_403035: "Oprostite, trenutno ne moremo potrditi vaših poverilnic.",
  sap_403041: "Nimamo računa, povezanega s tem e-poštnim naslovom, preverite svojo e-pošto in poskusite znova",
  sap_403042: "Kombinacija e-pošte in gesla ni veljavna. Preverite e-pošto, povezano z računom, ali izberite pozabljeno geslo, če ga želite ponastaviti.",
  sap_403043: "Kombinacija e-pošte in gesla ni veljavna. Preverite e-pošto, povezano z računom, ali izberite pozabljeno geslo, če ga želite ponastaviti.",
  sap_403047: "Kombinacija e-pošte in gesla ni veljavna. Preverite e-pošto, povezano z računom, ali izberite pozabljeno geslo, če ga želite ponastaviti.",
  sap_403100: "Zahteva za posodobitev gesla je bila nedavno zahtevana, prosimo počakajte, dokler zahteva ne bo obdelana",
  sap_403025: "Povezava za ponastavitev gesla je neveljavna, ponovno pošljite zahtevo za pozabljeno geslo, da prejmete novo povezavo za ponastavitev.",
  sapErrorTitle: "Napaka pri obdelavi zahteve",
  sessionExpired: "Seja je potekla",
  tooWeakPassword: "Geslo mora vsebovati vsaj {minLength} znakov in {minCharGroups} od naslednjega: velika črka, mala črka, številka, poseben simbol | Geslo mora vsebovati vsaj {minLength} znakov",
  unexpectedDescription: "Če se težava ponovi, se obrnite na nas prek kontaktnega obrazca in navedite podrobnosti.",
  unexpectedTitle: "Prišlo je do nepričakovane napake",
  unknownDescription: "Prišlo je do nepričakovane napake. ",
  unknownTitle: "Ojoj!"
}, wh = {
  subtitle: "Nastavite novo geslo.",
  title: "Ste pozabili geslo?"
}, yh = {
  headMetaDescription: "Stran za prijavo stranke",
  headTitle: "Prijavite se s svojim e-poštnim naslovom in geslom:",
  subtitle: "Prijavite se ali ustvarite račun, da dobite vse funkcije Miele.",
  title: "Prijavite se v svoj račun",
  error: {
    invalidEmailPasswordDescription: "Kombinacija e-poštnega naslova in gesla ni veljavna.",
    invalidEmailPasswordTitle: "Neveljavne poverilnice",
    missingConcentTitle: "Račun čaka na registracijo",
    noAccountDescription: "S tem e-poštnim naslovom ni povezan noben račun.",
    noAccountTitle: "Ni registriranega računa"
  },
  extraConsentScene: {
    continue: "Nadaljuj",
    privacyStatementCheckboxLabel: "Upošteval sem {0}.",
    privacyStatementName: "izjava o zasebnosti",
    privacyStatementTitle: "Naš pravilnik o zasebnosti se je spremenil",
    termsOfUseCheckboxLabel: "Strinjam se z {0}.",
    termsOfUseName: "pogoji uporabe",
    termsOfUseTitle: "Naši pogoji uporabe so se spremenili",
    title: "Dokončanje profila"
  },
  forgotPasswordScene: {
    backButtonLabel: "Nazaj na prijavo",
    submitButtonLabel: "Oddaj",
    successDescription: "Prosimo, preverite svojo e-pošto, kmalu boste prejeli podatke o vašem računu, da začnete s postopkom ponastavitve gesla.",
    successTitle: "Vaša zahteva je bila prejeta.",
    title: "Za ponastavitev gesla vnesite svoj e-poštni naslov:"
  },
  loginModalScene: {
    copy: "Prijavite se ali ustvarite račun, da dobite vse funkcije Miele.",
    title: "Prijavite se v svoj račun"
  },
  loginScene: {
    emailInputLabel: "E-pošta",
    forgotPwdButtonLabel: "Pozabil sem geslo",
    invalidEmailMessage: "E-pošta ni veljavna!",
    loginButtonLabel: "Vpiši se",
    passwordInputLabel: "Geslo",
    rememberMeLabel: "Zapomni si me",
    title: "Prijavite se s svojim e-poštnim naslovom in geslom:"
  }
}, Mh = {
  accessibility: {
    close: "Zapri"
  }
}, zh = {
  tooShort: "Prekratko",
  medium: "Srednje",
  strong: "Močno",
  tooWeak: "Prešibko",
  veryStrong: "Zelo močno",
  weak: "Šibko"
}, jh = {
  showPasswordText: "Prikaži",
  hidePasswordText: "Skrij"
}, _h = {
  registerButtonLabel: "registracija",
  registerTitle: "Nimate računa?",
  whyRegister: {
    list: [
      "Dostop do ekskluzivnih ugodnosti Miele Kluba",
      "Registrirajte naprave, sledite naročilom, dostopajte do priročnikov",
      "Prejemajte prilagojene ponudbe in promocije",
      "Oglejte si vsa vaša naročila, garancije, dogodke in storitve"
    ],
    title: "Zakaj se registrirati?"
  },
  closeButtonLabel: "Zapri",
  passwordMismatchError: "Gesli se ne ujemata",
  passwordUpdateErrorTitle: "Napaka pri posodobitvi gesla",
  passwordUpdateSuccessTitle: "Geslo posodobljeno",
  successfulChangeLabel: "Vaše geslo je bilo uspešno posodobljeno"
}, Sh = {
  title: "Tržnenjske preference",
  description: "Spodaj označite za ekskluzivne ponudbe, novice, dogodke in kako kar najbolje izkoristiti vaš aparat.",
  submit: "Shrani",
  levelOne: {
    shortText: "Da, želim, da mi Miele d.o.o. in Miele & Cie. KG („Miele“) po elektronski in navadni pošti, s sporočili SMS in prek aplikacij ter spletnih strani Miele (če jih uporabljam) pošiljata oglasna sporočila, prilagojena mojim osebnim interesom,",
    text: "Da, želim, da mi Miele d.o.o. in Miele & Cie. KG („Miele“) po elektronski in navadni pošti, s sporočili SMS in prek aplikacij ter spletnih strani Miele (če jih uporabljam) pošiljata oglasna sporočila, prilagojena mojim osebnim interesom, z informacijami o Mielejevih izdelkih, ponudbah in novostih ter dogodkih, anketah za kupce, prošnjah za ocene in mnenjih o izdelkih ter receptih. V ta namen lahko Miele uporabi moje kontaktne podatke (naziv, ime, e-poštni naslov, številko mobilnega telefona in poštni naslov) in oblikuje sporočila na podlagi zgodovine mojih nakupov, udeležbe na dogodkih in uporabe servisnih storitev, mojega vedenja pri klikanju in odpiranju novic ter moje vrednosti stranke, kot je podrobneje opisano v naših informacijah o varstvu podatkov. Svoje soglasje lahko kadar koli prekličem z veljavnostjo za naprej (npr. tako, da pošljem neformalno sporočilo na naslov info{'@'}miele.si, na kontaktne podatke, navedene v pravnem obvestilu, ali s klikom na povezavo za odjavo v e-poštnih sporočilih).",
    link: {
      title: "Varstvo podatkov",
      ref: "https://www.miele.si/c/varstvo-podatkov-14.htm"
    }
  },
  levelTwo: {
    text: "Poleg mojega osnovnega soglasja se strinjam, da lahko Miele obdeluje tudi podatke iz uporabe aplikacije Miele in mojega obiska spletnih strani Miele (www.miele.si), vključno z vedenjem na spletnih straneh Miele, do katerih pridem s klikanjem v novicah Miele, za dopolnitev mojega uporabniškega profila za prilagojeno oglaševalsko komunikacijo, če moja ločena privolitev v aplikaciji ali na spletni strani dovoli obdelavo podatkov. Svoje soglasje lahko kadar koli prekličem z veljavnostjo za naprej. Dodatne podrobnosti so navedene v Politiki zasebnosti.",
    link: {
      title: "Varstvo podatkov",
      ref: "https://www.miele.si/c/varstvo-podatkov-14.htm"
    }
  },
  levelThree: {
    text: "Poleg mojega osnovnega soglasja se strinjam, da lahko Miele obdeluje podatke o mojih aparatih Miele, povezanih v omrežje (podatki o uporabi in stanju aparatov), da dopolni moj uporabniški profil za prilagojeno oglaševanje. Dodatne informacije o obdelavi podatkov o aparatih najdete v pravilniku o zasebnosti za sistem Miele{'@'}home. Svoje soglasje lahko kadar koli prekličem z veljavnostjo za naprej. Dodatne informacije so na voljo v varstvo podatkov.",
    link: {
      title: "Politika zasebnosti za sistem Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Da, strinjam se s pogoji uporabe.",
    link: {
      title: "Oglejte si pogoje uporabe*",
      ref: "https://www.miele.si/c/pogoji-uporabe-304.htm"
    }
  }
}, Ch = {
  headline: "Miele klub",
  birthDateTitle: "Vam lahko pošljemo darilo za rojstni dan?",
  birthDateLabel: "Vaš rojstni datum (neobvezno)",
  why: {
    title: "Članstvo",
    reasons: [
      "Rojstnodnevno presenečenje",
      "Ekskluzivne ponudbe in akcije",
      "Darilo dobrodošlice",
      "VIP ponudbe in",
      "izkušnje",
      "Privlačni prihranki",
      "Klubske novice"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Prosimo, da vnesete ta datumski format: DD/MM/LLLL",
    errorMsg: "Napačen datum"
  },
  joinClubLabel: "Da, želim se pridružiti Miele klubu.",
  termsAndCondition: {
    description: "Strinjam se s {termsAndConditionLink} Miele kluba in potrjujem {privacyLink} informacije o Miele klubu.",
    termsAndConditionLink: {
      title: "Pogoji",
      ref: "https://www.miele.si/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Varstvo podatkov",
      ref: "https://www.miele.si/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Da, želim prejemati promocijsko komunikacijo kluba Miele, prilagojeno mojim osebnim interesom, po e-pošti in pošti",
    description: "Da, želim postati član Miele kluba in prejemati sporočila Miele kluba (darilo dobrodošlice, rojstnodnevno presenečenje, sprememba statusa nadgradnje, novice Miele kluba) po e-pošti.",
    privacyLink: {
      title: "Varstvo podatkov kluba Miele",
      href: "https://www.miele.si/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Komunikacija kluba",
      href: "https://www.miele.si/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.si"
  },
  selectAllConsents: {
    description: "Če želite postati član Miele kluba, morate sprejeti vse pogoje *"
  }
}, Lh = "pokaži celotno izjavo", Eh = "skrij celotno izjavo", Ph = {
  auth: vh,
  changeEmailScene: fh,
  changePasswordScene: kh,
  errors: bh,
  forgotPassword: wh,
  login: yh,
  modal: Mh,
  passwordStrength: zh,
  passwordHelper: jh,
  register: _h,
  "marketing-consent": {
    title: "Tržnenjske preference",
    description: "Spodaj označite za ekskluzivne ponudbe, novice, dogodke in kako kar najbolje izkoristiti vaš aparat.",
    submit: "Shrani",
    newsletter: {
      text: 'Strinjam se, da mi lahko Miele trgovina in servis d.o.o. ("Miele") pošilja informacije o izdelkih in novostih iz nabora izdelkov Miele in o dogodkih Miele ter ankete strank in recepte po e-pošti, aplikacijah Miele in SMS-ih ter da lahko Miele obdeluje kontaktne podatke, ki sem jih posredoval (naziv, ime, e-poštni naslov, številko mobilnega telefona in poštno številko) in izdelke Miele, ki sem jih kupil do sedaj in jih bom kupil v prihodnosti, ter interese, ki sem jih navedel v ta namen . Nadalje se strinjam, da lahko Miele obdela potrdila o prejemu in branju, prejete prek glasila, in informacije o povezavah, na katere sem kliknil, ter o mojem povezanem vedenju uporabnika na povezani spletni strani za namene personalizacije. Enako velja za potisna sporočila v aplikaciji, v kolikor se uporabljajo aplikacije Miele. ',
      link: {
        title: "Oglejte si politiko varstva podatkov",
        ref: ""
      }
    },
    personalisation: {
      text: "Strinjam se, da lahko Miele obdeluje podatke o storitvah, ki sem jih uporabil, in tehničnih nalogah, ki sem jih opravil, ter dogodkih, ki sem se jih udeležil, za namen izboljšane personalizacije.",
      link: {
        title: "Oglejte si politiko varstva podatkov",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Poleg razširjene personalizacije se strinjam, da lahko Miele obdeluje tudi podatke iz uporabe aplikacije Miele in mojih obiskov spletnih strani Miele (www.miele.si) za dopolnitev mojega uporabniškega profila, pod pogojem, da sem posebej privolil v to. ",
      link: {
        title: "Oglejte si politiko varstva podatkov",
        ref: ""
      }
    },
    highlightedText: {
      text: "Svoje soglasje lahko kadar koli prekličem brez navedbe razlogov z učinkom za naprej.  ",
      link: {
        title: "politiko varstva podatkov.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Da, strinjam se s pogoji uporabe.",
      link: {
        title: "Oglejte si pogoje uporabe*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: Sh,
  mieleClub: Ch,
  readMore: Lh,
  readLess: Eh
}, Th = {
  waitMessage: "Majdnem kész. "
}, Ah = {
  buttonLabel: "Mentés",
  buttonLabelClose: "Bezárás",
  confirmEmailMessage: "Erősítse meg e-mail címét",
  copy: "E-mail címének frissítéséhez adja hozzá az újat alább:",
  errorMessageCopy: "Hiba történt. Próbálja meg újra.",
  errorMessageHeadline: "Hiba",
  headline: "Profil részletei",
  inputEmailConfirmPlaceholder: "Erősítse meg az e-mail címét",
  inputEmailPlaceholder: "Email cím",
  invalidEmailMessage: "Az e-mail cím nem érvényes!",
  rememberMeLabel: "Emlékezz rám",
  successMessageCopy: "E-mail címe sikeresen frissítve.",
  successMessageHeadline: "E-mail cím frissítve"
}, xh = {
  closeButtonLabel: "Bezárás",
  confirmPasswordLabel: "Jelszó megerősítése",
  currentPasswordLabel: "Jelenlegi jelszó",
  newPasswordLabel: "Új jelszó",
  passwordMismatchError: "Jelszó nem egyezik",
  passwordUpdateErrorTitle: "Hiba",
  passwordUpdateSuccessTitle: "Jelszó frissítve",
  samePasswordError: "Ezt a jelszót korábban már használták, kérjük, adjon meg új jelszót",
  subtitle: "Jelszava megváltoztatásához töltse ki az alábbi mezőket:",
  submitButtonLabel: "Küldés",
  successfulChangeLabel: "Jelszava sikeresen frissítve",
  title: "Jelszó változtatás"
}, Ih = {
  invalidEmail: "Helytelen e-mail",
  invalidPassword: "Rossz jelszó",
  sap_206002: "Fiókja ellenőrzésre vár, de sajnos  jelenleg nem tudjuk folytatni. További részletekért vegye fel velünk a kapcsolatot.",
  sap_206006: "Úgy tűnik, hogy a beküldött e-mail cím ellenőrzésre vár",
  sap_400003: "Ez az e-mail cím már létezik, kérjük, használjon másik e-mail címet.",
  sap_400028: "A beküldött e-mail cím ellenőrzésre vár",
  sap_400050: "Sajnos jelenleg nem tudjuk ellenőrizni a hitelesítő adatait.",
  sap_400097: "Úgy tűnik, nem biztonságos/nem támogatott böngészőből éri el szolgáltatásainkat. Kérjük, próbálja meg újra egy másik böngészővel",
  sap_401030: "Ezt a jelszót korábban már használták, kérjük, adjon meg új jelszót",
  sap_403005: "Ehhez az e-mail címhez nincs társítva fiók, kérjük, ellenőrizze e-mailjét, és próbálja újra",
  sap_403011: "A munkamenet ideje lejárt. Kérjük, töltse be újra a böngészőt, és jelentkezzen be újra.",
  sap_403012: "A munkamenet ideje lejárt. Kérjük, töltse be újra a böngészőt, és jelentkezzen be újra. ",
  sap_403013: "Sajnos jelenleg nem tudjuk ellenőrizni a hitelesítő adatait.",
  sap_403035: "Sajnos jelenleg nem tudjuk ellenőrizni a hitelesítő adatait.",
  sap_403041: "Ehhez az e-mail címhez nincs társítva fiók, kérjük, ellenőrizze e-mailjét, és próbálja újra",
  sap_403042: "Az e-mail és jelszó kombináció nem érvényes. Kérjük, ellenőrizze a fiókhoz tartozó e-mailt, vagy válassza az elfelejtett jelszót, ha vissza szeretné állítani azt.",
  sap_403043: "Az e-mail és jelszó kombináció nem érvényes. Kérjük, ellenőrizze a fiókhoz tartozó e-mailt, vagy válassza az elfelejtett jelszót, ha vissza szeretné állítani azt.",
  sap_403047: "Az e-mail és jelszó kombináció nem érvényes. Kérjük, ellenőrizze a fiókhoz tartozó e-mailt, vagy válassza az elfelejtett jelszót, ha vissza szeretné állítani azt.",
  sap_403100: "A közelmúltban jelszófrissítési kérelmet nyújtottak be, kérjük, szíves türelmét kérjük a kérelem feldolgozásáig",
  sap_403025: "A jelszó visszaállítása link érvénytelen, kérjük, küldje el újra az elfelejtett jelszó kérelmét, hogy megkapja az új visszaállítási hivatkozást.",
  sapErrorTitle: "Hiba a kérelem feldolgozása során",
  sessionExpired: "A munkamenet ideje lejárt",
  tooWeakPassword: "A jelszónak legalább {minLength} karakterből és az alábbiak közül {minCharGroups} karakterből kell állnia: nagybetű, kisbetű, szám, speciális karakter | A jelszónak legalább {minLength} karakterből",
  unexpectedDescription: "Ha a probléma továbbra is fennáll, kérjük, vegye fel velünk a kapcsolatot a kapcsolatfelvételi űrlapon keresztül a részletekkel.",
  unexpectedTitle: "Váratlan hiba történt",
  unknownDescription: "Váratlan hiba történt. Kérjük, próbálja meg újra. ",
  unknownTitle: "Hoppá!"
}, Dh = {
  subtitle: "Állítsa be az új jelszavát.",
  title: "Elfelejtette a jelszavát?"
}, Nh = {
  headMetaDescription: "Ügyfél bejelentkező oldala",
  headTitle: "Jelentkezzen be e-mail címével és jelszavával:",
  subtitle: "Jelentkezzen be, vagy hozzon létre egy fiókot a Miele összes funkciójának eléréséhez.",
  title: "Jelentkezzen be a fiókjába",
  error: {
    invalidEmailPasswordDescription: "Az e-mail cím és a jelszó kombinációja nem érvényes.",
    invalidEmailPasswordTitle: "Érvénytelen hitelesítő adatok",
    missingConcentTitle: "Fiók regisztráció függőben",
    noAccountDescription: "Ehhez az e-mail címhez nincs fiók társítva.",
    noAccountTitle: "Nincs regisztrált fiók"
  },
  extraConsentScene: {
    continue: "Folytatás",
    privacyStatementCheckboxLabel: "Tudomásul vettem a következőt: {0}.",
    privacyStatementName: "Adatvédelmi nyilatkozat",
    privacyStatementTitle: "Adatvédelmi szabályzatunk megváltozott",
    termsOfUseCheckboxLabel: "Elfogadom a következőt: {0}.",
    termsOfUseName: "Felhasználási feltételek",
    termsOfUseTitle: "Felhasználási feltételeink megváltoztak",
    title: "Profil kitöltése"
  },
  forgotPasswordScene: {
    backButtonLabel: "Vissza a bejelentkezéshez",
    submitButtonLabel: "Beküldés",
    successDescription: "Kérjük, ellenőrizze e-mailjeit, hamarosan megkapja a fiókjához tartozó információkat a jelszó-visszaállítási folyamat megkezdéséhez.",
    successTitle: "Kérését megkaptuk.",
    title: "Kérjük, adja meg e-mail címét a jelszó visszaállításához:"
  },
  loginModalScene: {
    copy: "Jelentkezzen be, vagy hozzon létre egy fiókot a Miele összes funkciójának eléréséhez.",
    title: "Jelentkezzen be a fiókjába"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Elfelejtettem a jelszavam",
    invalidEmailMessage: "Az e-mail cím nem érvényes!",
    loginButtonLabel: "Belépés",
    passwordInputLabel: "Jelszó",
    rememberMeLabel: "Emlékezz rám",
    title: "Jelentkezzen be e-mail címével és jelszavával:"
  }
}, Oh = {
  accessibility: {
    close: "Bezárás"
  }
}, Uh = {
  tooShort: "Túl rövid",
  medium: "Közepes",
  strong: "Erős",
  tooWeak: "Túl gyenge",
  veryStrong: "Nagyon erős",
  weak: "Gyenge"
}, $h = {
  showPasswordText: "Megjelenít",
  hidePasswordText: "Elrejt"
}, Bh = {
  registerButtonLabel: "Regisztráció",
  registerTitle: "Nincs fiókja?",
  whyRegister: {
    list: [
      "Hozzáférés a Miele Club exkluzív előnyeihez",
      "Készülékek regisztrálása, rendelések nyomon követése, használati útmutatók elérése",
      "Kapjon személyre szabott ajánlatokat és promóciókat",
      "Tekintse meg az összes megrendelését, garanciáját, eseményét és szolgáltatását"
    ],
    title: "Miért regisztráljon?"
  },
  closeButtonLabel: "Bezárás",
  passwordMismatchError: "A jelszavak nem egyeznek",
  passwordUpdateErrorTitle: "Jelszó frissítési hiba",
  passwordUpdateSuccessTitle: "Jelszó frissítve",
  successfulChangeLabel: "Jelszava sikeresen frissítve"
}, Rh = {
  title: "Marketingbeállítások",
  description: "Jelölje be alább az exkluzív ajánlatokat, híreket, eseményeket és azt, hogyan hozhatja ki a legtöbbet készülékéből.",
  submit: "Mentés",
  levelOne: {
    shortText: 'Igen, szeretném, ha a  Miele Kft. és a Miele & Cie. KG ("Miele") e-mailben, SMS-ben, postai úton és a Miele alkalmazásokon keresztül (ha használom) marketing célú kereskedelmi kommunikációt küldjön a részemre',
    text: `Igen, szeretném, ha a  Miele Kft. és a Miele & Cie. KG ("Miele") e-mailben, SMS-ben, postai úton és a Miele alkalmazásokon keresztül (ha használom) marketing célú kereskedelmi kommunikációt küldjön a részemre. Ennek érdekében hozzájárulok, hogy a Miele a termékeiről, ajánlatairól és újdonságairól, rendezvényeiről, receptekről tájékoztatást küldjön, valamint megkeressen vásárlói elégedettség felmérésekkel, termékértékelési kérésekkel kapcsolatban. Hozzájárulok, hogy a Miele ebből a célból az általam megadott elérhetőségeimet (megszólítás, név, e-mail cím, mobiltelefonszám és postacím) kezelje és a kommunikációt a vásárlási és szolgáltatási előzményeim, eseménytörténetem, hírlevél kattintási és megnyitási szokásaim, valamint az ügyfélértékem alapján alakítsa, ahogy azt részletesen ismertetjük az adatkezelési tájékoztatóban. Hozzájárulásomat a jövőre vonatkozóan bármikor indokolás nélkül visszavonhatom a (info{'@'}miele.hu címre küldött üzenettel, az adatkezelési tájékoztatóban megadott elérhetőségeken vagy a kapott kommunikációban található leiratkozási linkre kattintva).`,
    link: {
      title: "adatkezelési tájékoztatóban",
      ref: "https://www.miele.hu/c/adatvedelem-14.htm"
    }
  },
  levelTwo: {
    text: "Alapszintű hozzájárulásomon túlmenően hozzájárulok ahhoz, hogy a Miele alkalmazás használata során keletkező  és a Miele weboldalon  (www.miele.hu) tett látogatásaimból származó adatokat (beleértve a kereskedelmi kommunikációban kapott linkre kattintva elérhető Miele weboldalon való felhasználói szokásaimat)a felhasználói profilom kiegészítés során személyre szabott marketing kommunikáció céljából a Miele kezelje, feltéve, hogy külön hozzájárulásom az alkalmazásban vagy a Miele weboldalon lehetővé teszi az adatkezelést. Hozzájárulásomat a jövőre vonatkozóan bármikor indokolás nélkül visszavonhatom. További részletek az adatkezelési tájékoztatóban.",
    link: {
      title: "Adatvédelem",
      ref: "https://www.miele.hu/c/adatvedelem-14.htm"
    }
  },
  levelThree: {
    text: "Alapszintű hozzájárulásomon túlmenően hozzájárulok ahhoz, hogy a Miele kezelje a hálózatba kapcsolt Miele készülékeim adatait (a készülékek használatára és állapotára vonatkozó adatok), hogy kiegészítse felhasználói profilomat a személyre szabott marketing kommunikáció céljából. A készülékadatok kezeléséről  további információkat a Miele{'@'}Home rendszer adatvédelmi szabályzatában találok.",
    link: {
      title: "Miele{'@'}Home rendszer",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Igen, elfogadom a Felhasználási feltételeket.",
    link: {
      title: "Felhasználási feltételeket",
      ref: "https://www.miele.hu/c/aszf-13.htm"
    }
  }
}, Fh = {
  headline: "Miele Club",
  birthDateTitle: "Küldhetünk születésnapi ajándékot?",
  birthDateLabel: "Your date of birth (optional)",
  why: {
    title: "Tagság",
    reasons: [
      "Születésnapi meglepetés"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Használja a köv. formátumot:  HH/NN/ÉÉÉÉ",
    errorMsg: "Érvénytelen dátum"
  },
  joinClubLabel: "Igen, szeretnék csatlakozni a Miele Clubhoz.",
  termsAndCondition: {
    description: "A Miele Club tagságával ön elfogadja a Miele Club feltételeit.",
    termsAndConditionLink: {
      title: "Általános Szerződési Feltételek",
      ref: "https://www.miele.hu/c/adatvedelem-14.htm"
    },
    privacyLink: {
      title: "Adatvédelem",
      ref: "https://www.miele.hu/c/adatvedelem-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Igen, szeretnék személyes érdeklődési körömre szabott Miele Club promóciós közleményeket kapni e-mailben és postai úton",
    description: "Igen, szeretnék Miele Club tag lenni, és szeretnék e-mailben kapni  Miele Club kommunikációt (üdvözlő ajándék, születésnapi meglepetés, Miele Club hírek).",
    privacyLink: {
      title: "Miele Club adatvédelem",
      href: "https://www.miele.hu/c/adatvedelem-14.htm"
    },
    termsAndConditionLink: {
      title: "Klubkommunikáció",
      href: "https://www.miele.hu/c/adatvedelem-14.htm"
    },
    supportEmail: "info{'@'}miele.hu"
  },
  selectAllConsents: {
    description: "A Miele Klubhoz való csatlakozáshoz el kell fogadnia az összes feltételt *"
  }
}, Vh = "teljes nyilatkozat megjelenítése", qh = "teljes nyilatkozat elrejtése", Gh = {
  auth: Th,
  changeEmailScene: Ah,
  changePasswordScene: xh,
  errors: Ih,
  forgotPassword: Dh,
  login: Nh,
  modal: Oh,
  passwordStrength: Uh,
  passwordHelper: $h,
  register: Bh,
  "marketing-consent": {
    title: "Marketingbeállítások",
    description: "Jelölje be alább az exkluzív ajánlatokat, híreket, eseményeket és azt, hogyan hozhatja ki a legtöbbet készülékéből.",
    submit: "Mentés",
    newsletter: {
      text: 'Hozzájárulok ahhoz, hogy a Miele Co Ltd. ("Miele") információkat küldjön nekem a Miele termékeiről és innovációiról, valamint a Miele rendezvényeiről,  vásárlói felmérésekről és receptekről e-mailben, a Miele alkalmazásokban és SMS-ben, valamint hogy a Miele kezelheti az általam megadott elérhetőségeket (cím, név, e-mail cím, mobiltelefonszám és irányítószám), és az eddig vásárolt és a jövőben vásárolni kívánt Miele termékeket, valamint az e célból megjelölt érdeklődési köröket. Hozzájárulok továbbá ahhoz, hogy a Miele személyre szabás céljából feldolgozza a hírlevélen keresztül kapott átvételi és olvasási visszaigazolásokat, valamint az általam kattintott linkekre vonatkozó információkat és a kapcsolódó felhasználói magatartásomat a hivatkozott weboldalon. Ugyanez vonatkozik az alkalmazáson belüli push üzenetekre is a Miele alkalmazások használata esetén.',
      link: {
        title: "Lásd az Adatvédelmi szabályzatot",
        ref: ""
      }
    },
    personalisation: {
      text: "Hozzájárulok ahhoz, hogy a Miele a fokozott személyre szabás érdekében feldolgozzon információkat az általam igénybe vett szolgáltatásokról és az általam kért technikusi megbízásokról, valamint azokról az eseményekről, amelyeken részt vettem.",
      link: {
        title: "Lásd az Adatvédelmi szabályzatot",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "A kiterjesztett személyre szabás mellett hozzájárulok ahhoz, hogy a Miele a Miele alkalmazás használatából és a Miele weboldalain (www.miele.hu) tett látogatásaimból származó adatokat is kezeljen felhasználói profilom kiegészítése céljából, feltéve, hogy ehhez külön hozzájárultam. ",
      link: {
        title: "Lásd az Adatvédelmi szabályzatot",
        ref: ""
      }
    },
    highlightedText: {
      text: "Hozzájárulásomat a jövőre vonatkozó indoklás nélkül bármikor visszavonhatom. Ha többet szeretne megtudni arról, hogy a Miele hogyan kezeli az ön adatait, kérjük, olvassa el a Miele ",
      link: {
        title: "Adatvédelmi szabályzatát.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Igen, elfogadom a Felhasználási feltételeket.",
      link: {
        title: "Lásd a Felhasználási feltételeket*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: Rh,
  mieleClub: Fh,
  readMore: Vh,
  readLess: qh
}, Kh = {
  waitMessage: "Nearly there. Hang tight ..."
}, Hh = {
  buttonLabel: "Save",
  buttonLabelClose: "Close",
  confirmEmailMessage: "Confirm your e-mail adress",
  copy: "To update your email address, please add the new one below:",
  errorMessageCopy: "Something went wrong. Try again.",
  errorMessageHeadline: "Error",
  headline: "Profile Details",
  inputEmailConfirmPlaceholder: "Confirm your e-mail address",
  inputEmailPlaceholder: "E-mail address",
  invalidEmailMessage: "E-Mail not valid!",
  rememberMeLabel: "Remember me",
  successMessageCopy: "Your email address was successfully updated.",
  successMessageHeadline: "E-mail address updated"
}, Wh = {
  closeButtonLabel: "Close",
  confirmPasswordLabel: "Confirm Password",
  currentPasswordLabel: "Current Password",
  newPasswordLabel: "New Password",
  passwordMismatchError: "Password does not match",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Password updated",
  samePasswordError: "This password was used previously, please submit a new password",
  subtitle: "To change your password, please fill in the fields below:",
  submitButtonLabel: "Submit",
  successfulChangeLabel: "Your password has been successfully updated",
  title: "Password Change"
}, Jh = {
  invalidEmail: "Incorrect Email",
  invalidPassword: "Wrong password",
  sap_206002: "Your account is pending verification, I'm afraid we can't let you proceed at the moment. Please contact us for more details.",
  sap_206006: "Looks like the email address you submitted is pending verification",
  sap_400003: "This email already exists, please use a different email address.",
  sap_400028: "The email address submitted  is pending verification",
  sap_400050: "Sorry, we're unable to validate your credentials at this moment.",
  sap_400097: "Looks like you are accessing our services fom an insecure/unsupported browser. Please try again with another browswer",
  sap_401030: "This password was used previously, please submit a new password",
  sap_403005: "We do not have an account associated with this email address, please check your email and try again",
  sap_403011: "Session expired. Please reload the browser and sign-in again.",
  sap_403012: "Session expired. Please reload the browser and sign-in again.",
  sap_403013: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403035: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403041: "We do not have an account associated with this email address, please check your email and try again",
  sap_403042: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403043: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403047: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403100: "A request for password update is recently requested, please bare with us until the request is processed",
  sap_403025: "Reset password link invalid, please send forgot password request again to receive new reset link.",
  sapErrorTitle: "Error Processing Request",
  sessionExpired: "Session expired",
  tooWeakPassword: "Password must contain at least {minLength} characters and {minCharGroups} of the following: uppercase letter, lowercase letter, number, special symbol | Password must contain at least {minLength} characters",
  unexpectedDescription: "If the issue persists please get in touch with us via the contact form with details.",
  unexpectedTitle: "An unexpected error occured",
  unknownDescription: "Unexpected error ocurred. Please try again.",
  unknownTitle: "Uh Oh!"
}, Zh = {
  subtitle: "Set your new password.",
  title: "Forgot your password?"
}, Yh = {
  headMetaDescription: "Customer login page",
  headTitle: "Log in with your email and password:",
  subtitle: "Login or create an account to get all the Miele features.",
  title: "Login to your account",
  error: {
    invalidEmailPasswordDescription: "The combination of email address and password is not valid.",
    invalidEmailPasswordTitle: "Invalid credentials",
    missingConcentTitle: "Account Pending Registration",
    noAccountDescription: "There is no account associated to this email address.",
    noAccountTitle: "No account registered"
  },
  extraConsentScene: {
    continue: "Continue",
    privacyStatementCheckboxLabel: "I have taken note of the {0}.",
    privacyStatementName: "privacy statement",
    privacyStatementTitle: "Our Privacy Policy has changed",
    termsOfUseCheckboxLabel: "I agree to the {0}.",
    termsOfUseName: "terms of use",
    termsOfUseTitle: "Our Terms of Use have changed",
    title: "Profile completion"
  },
  forgotPasswordScene: {
    backButtonLabel: "Back to Login",
    submitButtonLabel: "Submit",
    successDescription: "Please check your e-mail, you will receive soon the information on your account to start with the password reset process.",
    successTitle: "Your request has been received.",
    title: "Please enter your email address to reset your password:"
  },
  loginModalScene: {
    copy: "Login or create an account to get all the Miele features.",
    title: "Login to your account"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Forgot my password",
    invalidEmailMessage: "E-Mail not valid!",
    loginButtonLabel: "Login",
    passwordInputLabel: "Password",
    rememberMeLabel: "Remember me",
    title: "Log in with your email and password:"
  }
}, Xh = {
  accessibility: {
    close: "Close"
  }
}, Qh = {
  tooShort: "Too Short",
  medium: "Medium",
  strong: "Strong",
  tooWeak: "Too Weak",
  veryStrong: "Very Strong",
  weak: "Weak"
}, eg = {
  showPasswordText: "Show",
  hidePasswordText: "Hide"
}, tg = {
  registerButtonLabel: "register",
  registerTitle: "Don't have an account?",
  whyRegister: {
    list: [
      "Access to exclusive benefits from Miele Club",
      "Register appliances, track orders, access manuals",
      "Receive personalized offers and promotions",
      "See all your orders, warranties, events and services"
    ],
    title: "Why register?"
  },
  closeButtonLabel: "Close",
  passwordMismatchError: "The passwords do not match",
  passwordUpdateErrorTitle: "Password update error",
  passwordUpdateSuccessTitle: "Password updated",
  successfulChangeLabel: "Your password has been successfully updated"
}, ig = {
  title: "Marketing Preferences",
  description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
  submit: "Save",
  levelOne: {
    shortText: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps',
    text: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps and SMS and that Miele may process the contact details I have provided (title, name, email address, mobile phone number and postcode) and the Miele products I have purchased to date and will purchase in the future as well as the interests I have indicated for this purpose. I further agree that Miele may also process receipt and read confirmations received via the newsletter and information about the links I have clicked on as well as my related user behaviour on the linked website for the purpose of personalisation. The same applies to in-app push messages, insofar as the Miele apps are used.',
    link: {
      title: "See data protection policy",
      ref: "#"
    }
  },
  levelTwo: {
    text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
    link: {
      title: "See data protection policy",
      ref: "#"
    }
  },
  levelThree: {
    text: "In addition to the extended personalisation, I agree that Miele may also process data from the use of the Miele app and my visits to the Miele websites (www.miele.co.uk) to supplement my user profile, provided that I have separately consented to the processing of this data.",
    link: {
      title: "See data protection policy",
      ref: "#"
    }
  },
  highlightedText: {
    text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
    link: {
      title: "data protection policy.",
      ref: "#"
    }
  },
  termsOfUse: {
    text: "Yes, I agree to the terms of use.",
    link: {
      title: "See Terms of Use*",
      ref: "#"
    }
  }
}, ng = {
  headline: "Miele Club",
  birthDateTitle: "Would you like to receive a birthday surprise?",
  birthDateLabel: "Your date of birth (optional)",
  why: {
    title: "Free membership - Exclusive offers for members.",
    reasons: [
      "£ 10 Welcome voucher",
      "Birthday surprise",
      "Special sale offers",
      "Invites to exclusive events & experiences"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Please enter this date format: DD/MM/YYYY",
    errorMsg: "Incorrect date"
  },
  joinClubLabel: "Yes, I would like to join the Miele Club.",
  termsAndCondition: {
    description: "I consent to the Miele Club {termsAndConditionLink} and acknowledge the {privacyLink} information regarding the Miele Club.",
    termsAndConditionLink: {
      title: "Terms and Conditions",
      ref: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Data privacy",
      ref: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Yes, I would like to receive Miele Club promotional communication, tailored to my personal interests, via email and in the post",
    description: "Yes, I would like to receive Miele Club promotional communication, tailored to my personal interests, via email and in the post including special offers, information, invitations to events and customer surveys about Miele products and services. For this purpose, Miele can use my contact information (title, name, e-mail and postal address) and adapt the communication on the basis of my purchase and newsletter behavior, as well as my customer value, as described in more detail in our {privacyLink}. I may revoke my consent with effect for the future at any time (for example, by sending an email to info{'@'}miele.co.uk, getting in touch via the contact details provided in the legal notice or clicking the unsubscribe link in e-mails). The contractual Miele Club communications {termsAndConditionLink} are not affected by this unless I terminate my membership.",
    privacyLink: {
      title: "Miele Club data privacy",
      href: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Club communication",
      href: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.co.uk"
  },
  selectAllConsents: {
    description: "To join the Miele Club, you must agree to all the terms and conditions *"
  }
}, ag = "show full statement", sg = "hide full statement", og = {
  auth: Kh,
  changeEmailScene: Hh,
  changePasswordScene: Wh,
  errors: Jh,
  forgotPassword: Zh,
  login: Yh,
  modal: Xh,
  passwordStrength: Qh,
  passwordHelper: eg,
  register: tg,
  "marketing-consent": {
    title: "Marketing Preferences",
    description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
    submit: "Save",
    newsletter: {
      text: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps and SMS and that Miele may process the contact details I have provided (title, name, email address, mobile phone number and postcode) and the Miele products I have purchased to date and will purchase in the future as well as the interests I have indicated for this purpose. I further agree that Miele may also process receipt and read confirmations received via the newsletter and information about the links I have clicked on as well as my related user behaviour on the linked website for the purpose of personalisation. The same applies to in-app push messages, insofar as the Miele apps are used.',
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    personalisation: {
      text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "In addition to the extended personalisation, I agree that Miele may also process data from the use of the Miele app and my visits to the Miele websites (www.miele.co.uk) to supplement my user profile, provided that I have separately consented to the processing of this data.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    highlightedText: {
      text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
      link: {
        title: "data protection policy.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Yes, I agree to the terms of use.",
      link: {
        title: "See Terms of Use*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: ig,
  mieleClub: ng,
  readMore: ag,
  readLess: sg
}, rg = {
  waitMessage: "Nearly there. Hang tight ..."
}, lg = {
  buttonLabel: "Save",
  buttonLabelClose: "Close",
  confirmEmailMessage: "Confirm your e-mail adress",
  copy: "To update your email address, please add the new one below:",
  errorMessageCopy: "Something went wrong. Try again.",
  errorMessageHeadline: "Error",
  headline: "Profile Details",
  inputEmailConfirmPlaceholder: "Confirm your e-mail address",
  inputEmailPlaceholder: "E-mail address",
  invalidEmailMessage: "E-Mail not valid!",
  rememberMeLabel: "Remember me",
  successMessageCopy: "Your email address was successfully updated.",
  successMessageHeadline: "E-mail address updated"
}, cg = {
  closeButtonLabel: "Close",
  confirmPasswordLabel: "Confirm Password",
  currentPasswordLabel: "Current Password",
  newPasswordLabel: "New Password",
  passwordMismatchError: "Password does not match",
  passwordUpdateErrorTitle: "Error",
  passwordUpdateSuccessTitle: "Password updated",
  samePasswordError: "This password was used previously, please submit a new password",
  subtitle: "To change your password, please fill in the fields below:",
  submitButtonLabel: "Submit",
  successfulChangeLabel: "Your password has been successfully updated",
  title: "Password Change"
}, dg = {
  invalidEmail: "Incorrect Email",
  invalidPassword: "Wrong password",
  sap_206002: "Your account is pending verification, I'm afraid we can't let you proceed at the moment. Please contact us for more details.",
  sap_206006: "Looks like the email address you submitted is pending verification",
  sap_400003: "This email already exists, please use a different email address.",
  sap_400028: "The email address submitted  is pending verification",
  sap_400050: "Sorry, we're unable to validate your credentials at this moment.",
  sap_400097: "Looks like you are accessing our services fom an insecure/unsupported browser. Please try again with another browswer",
  sap_401030: "This password was used previously, please submit a new password",
  sap_403005: "We do not have an account associated with this email address, please check your email and try again",
  sap_403011: "Session expired. Please reload the browser and sign-in again.",
  sap_403012: "Session expired. Please reload the browser and sign-in again.",
  sap_403013: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403035: "Sorry, we're unable to validate your credentials at this moment.",
  sap_403041: "We do not have an account associated with this email address, please check your email and try again",
  sap_403042: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403043: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403047: "Email & Password combination is not valid. Please check the email associated with the account or choose forgot password if you'd like to reset it.",
  sap_403100: "A request for password update is recently requested, please bare with us until the request is processed",
  sap_403025: "Reset password link invalid, please send forgot password request again to receive new reset link.",
  sapErrorTitle: "Error Processing Request",
  sessionExpired: "Session expired",
  tooWeakPassword: "Password must contain at least {minLength} characters and {minCharGroups} of the following: uppercase letter, lowercase letter, number, special symbol | Password must contain at least {minLength} characters",
  unexpectedDescription: "If the issue persists please get in touch with us via the contact form with details.",
  unexpectedTitle: "An unexpected error occured",
  unknownDescription: "Unexpected error ocurred. Please try again.",
  unknownTitle: "Uh Oh!"
}, ug = {
  subtitle: "Set your new password.",
  title: "Forgot your password?"
}, mg = {
  headMetaDescription: "Customer login page",
  headTitle: "Log in with your email and password:",
  subtitle: "Login or create an account to get all the Miele features.",
  title: "Login to your account",
  error: {
    invalidEmailPasswordDescription: "The combination of email address and password is not valid.",
    invalidEmailPasswordTitle: "Invalid credentials",
    missingConcentTitle: "Account Pending Registration",
    noAccountDescription: "There is no account associated to this email address.",
    noAccountTitle: "No account registered"
  },
  extraConsentScene: {
    continue: "Continue",
    privacyStatementCheckboxLabel: "I have taken note of the {0}.",
    privacyStatementName: "privacy statement",
    privacyStatementTitle: "Our Privacy Policy has changed",
    termsOfUseCheckboxLabel: "I agree to the {0}.",
    termsOfUseName: "terms of use",
    termsOfUseTitle: "Our Terms of Use have changed",
    title: "Profile completion"
  },
  forgotPasswordScene: {
    backButtonLabel: "Back to Login",
    submitButtonLabel: "Submit",
    successDescription: "Please check your e-mail, you will receive soon the information on your account to start with the password reset process.",
    successTitle: "Your request has been received.",
    title: "Please enter your email address to reset your password:"
  },
  loginModalScene: {
    copy: "Login or create an account to get all the Miele features.",
    title: "Login to your account"
  },
  loginScene: {
    emailInputLabel: "Email",
    forgotPwdButtonLabel: "Forgot my password",
    invalidEmailMessage: "E-Mail not valid!",
    loginButtonLabel: "Login",
    passwordInputLabel: "Password",
    rememberMeLabel: "Remember me",
    title: "Log in with your email and password:"
  }
}, pg = {
  accessibility: {
    close: "Close"
  }
}, hg = {
  tooShort: "Too Short",
  medium: "Medium",
  strong: "Strong",
  tooWeak: "Too Weak",
  veryStrong: "Very Strong",
  weak: "Weak"
}, gg = {
  showPasswordText: "Show",
  hidePasswordText: "Hide"
}, vg = {
  registerButtonLabel: "register",
  registerTitle: "Don't have an account?",
  whyRegister: {
    list: [
      "Access to exclusive benefits from Miele Club",
      "Register appliances, track orders, access manuals",
      "Receive personalized offers and promotions",
      "See all your orders, warranties, events and services"
    ],
    title: "Why register?"
  },
  closeButtonLabel: "Close",
  passwordMismatchError: "The passwords do not match",
  passwordUpdateErrorTitle: "Password update error",
  passwordUpdateSuccessTitle: "Password updated",
  successfulChangeLabel: "Your password has been successfully updated"
}, fg = {
  title: "Marketing Preferences",
  description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
  submit: "Save",
  levelOne: {
    shortText: 'Yes, I would like to receive promotional communications from Miele Ireland Ltd and Miele & Cie. KG ("Miele") tailored to my personal interests by email, text message, post or via the Miele apps and websites (if used)',
    text: `Yes, I would like to receive promotional communications from Miele Ireland Ltd and Miele & Cie. KG ("Miele") tailored to my personal interests by email, text message, post or via the Miele apps and websites (if used) with information on products, offers and innovations from the Miele product range and on Miele events as well as customer surveys, product rating and review requests and recipes. For this purpose, Miele may use my contact information (title, name, email address, mobile phone number and postal address) and design the communication based on my purchase, service, event history, newsletter click and open behavior as well as customer value, as described in detail in our privacy policy. I can revoke my consent at any time without giving reasons with effect for the future (e.g. by sending an informal message to contact{'@'}miele-support.ie, the contact details given in the imprint or by clicking on the unsubscribe link in emails).`,
    link: {
      title: "Privacy policy",
      ref: "https://www.miele.ie/c/data-protection-14.htm"
    }
  },
  levelTwo: {
    text: "In addition to my basic consent, I agree that Miele may also process data from the use of the Miele app and my visits to Miele websites (www.miele.ie), including user behavior on the Miele websites after linked newsletter clicks, to supplement my user profile for personalized advertising communications, provided that my separate consent in the app or on the website releases the data processing. I can revoke my consent at any time without giving reasons with effect for the future. Further details in Miele’s data protection policy.",
    link: {
      title: "Data protection policy",
      ref: "https://www.miele.ie/c/data-protection-14.htm"
    }
  },
  levelThree: {
    text: "In addition to my basic consent, I agree that Miele may also process data from my connected Miele appliances (data on appliance usage and status) to supplement my user profile for personalized advertising. I can find more information about the processing of device data in the privacy policy about the Miele{'@'}Home system. I can revoke my consent at any time without giving reasons with effect for the future. Further details in Miele’s data protection policy.",
    link: {
      title: "Miele{'@'}Home-System",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Yes, I agree to the terms of use.",
    link: {
      title: "See Terms of Use*",
      ref: "https://www.miele.ie/c/terms-of-use-304.htm"
    }
  }
}, kg = {
  headline: "Miele Club",
  birthDateTitle: "Can we send you a birthday gift?",
  birthDateLabel: "Birthday (optional)",
  why: {
    title: "Membership",
    reasons: [
      "Birthday surprise",
      "Exclusive offers and campaigns",
      "Welcome gift",
      "VIP offers and experiences",
      "Attractive savings",
      "Club news"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Use format like MM/DD/YYYY",
    errorMsg: "Invalid date"
  },
  joinClubLabel: "Yes, I want to join the Miele club.",
  termsAndCondition: {
    description: "I consent to the Miele Club {termsAndConditionLink} and acknowledge the {privacyLink} information regarding the Miele Club.",
    termsAndConditionLink: {
      title: "Terms and Conditions",
      ref: "https://www.miele.ie/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Data privacy",
      ref: "https://www.miele.ie/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Yes, I would like to receive Miele Club promotional communication, tailored to my personal interests, via email and in the post",
    description: "Yes, I would like to receive Miele Club promotional communication, tailored to my personal interests, via email and in the post including special offers, information, invitations to events and customer surveys about Miele products and services. For this purpose, Miele can use my contact information (title, name, e-mail and postal address) and adapt the communication on the basis of my purchase and newsletter behavior, as well as my customer value, as described in more detail in our {privacyLink}. I may revoke my consent with effect for the future at any time (for example, by sending an email to info{'@'}miele.ie, getting in touch via the contact details provided in the legal notice or clicking the unsubscribe link in e-mails). The contractual Miele Club communications {termsAndConditionLink} are not affected by this unless I terminate my membership.",
    privacyLink: {
      title: "Miele Club data privacy",
      href: "https://www.miele.ie/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Club communication",
      href: "https://www.miele.ie/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.ie"
  },
  selectAllConsents: {
    description: "To join the Miele Club, you must agree to all the terms and conditions *"
  }
}, bg = "show full statement", wg = "hide full statement", yg = {
  auth: rg,
  changeEmailScene: lg,
  changePasswordScene: cg,
  errors: dg,
  forgotPassword: ug,
  login: mg,
  modal: pg,
  passwordStrength: hg,
  passwordHelper: gg,
  register: vg,
  "marketing-consent": {
    title: "Marketing Preferences",
    description: "Tick below for exclusive offers, news, events, and how to get the most from your appliance.",
    submit: "Save",
    newsletter: {
      text: 'I agree that Miele Co Ltd. ("Miele") may send me information on products and innovations from the Miele product range and on Miele events as well as customer surveys and recipes via email, the Miele apps and SMS and that Miele may process the contact details I have provided (title, name, email address, mobile phone number and postcode) and the Miele products I have purchased to date and will purchase in the future as well as the interests I have indicated for this purpose. I further agree that Miele may also process receipt and read confirmations received via the newsletter and information about the links I have clicked on as well as my related user behaviour on the linked website for the purpose of personalisation. The same applies to in-app push messages, insofar as the Miele apps are used.',
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    personalisation: {
      text: "I agree that Miele may process information about the services I have used and technician assignments I have carried out, as well as events I have attended, for the purpose of enhanced personalisation.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    extendedPersonalisation: {
      text: "In addition to the extended personalisation, I agree that Miele may also process data from the use of the Miele app and my visits to the Miele websites (www.miele.co.uk) to supplement my user profile, provided that I have separately consented to the processing of this data.",
      link: {
        title: "See data protection policy",
        ref: "#"
      }
    },
    highlightedText: {
      text: "I can revoke my consent at any time without giving reasons with effect for the future. For more information on how Miele handles your data, please refer to Miele's ",
      link: {
        title: "data protection policy.",
        ref: "#"
      }
    },
    termsOfUse: {
      text: "Yes, I agree to the terms of use.",
      link: {
        title: "See Terms of Use*",
        ref: "#"
      }
    }
  },
  multiLevelMarketingConsent: fg,
  mieleClub: kg,
  readMore: bg,
  readLess: wg
}, Mg = {
  waitMessage: "Η αναμονή σχεδόν τελείωσε. "
}, zg = {
  buttonLabel: "Αποθήκευση",
  buttonLabelClose: "Κλείσιμο",
  confirmEmailMessage: "Επιβεβαιώστε τη διεύθυνση e-mail σας",
  copy: "Για να ενημερώσετε τη διεύθυνση email σας, προσθέστε τη νέα διεύθυνση παρακάτω:",
  errorMessageCopy: "Κάτι πήγε στραβά. Προσπαθήστε ξανά ",
  errorMessageHeadline: "Σφάλμα",
  headline: "Στοιχεία προφίλ",
  inputEmailConfirmPlaceholder: "Επιβεβαιώστε τη διεύθυνση ηλεκτρονικού ταχυδρομείου σας",
  inputEmailPlaceholder: "Διεύθυνση ηλεκτρονικού ταχυδρομείου",
  invalidEmailMessage: "Το e-mail δεν ισχύει!",
  rememberMeLabel: "Θυμήσου με",
  successMessageCopy: "Η διεύθυνση email σας ενημερώθηκε με επιτυχία.",
  successMessageHeadline: "Η διεύθυνση ηλεκτρονικού ταχυδρομείου ενημερώθηκε"
}, jg = {
  closeButtonLabel: "Κλείσιμο",
  confirmPasswordLabel: "Επιβεβαίωση Κωδικού",
  currentPasswordLabel: "Τρέχων κωδικός πρόσβασης",
  newPasswordLabel: "Νέος Κωδικός",
  passwordMismatchError: "Ο κωδικός δεν ταιριάζει",
  passwordUpdateErrorTitle: "Λάθος",
  passwordUpdateSuccessTitle: "Ο κωδικός ενημερώθηκε",
  samePasswordError: "Αυτός ο κωδικός πρόσβασης χρησιμοποιήθηκε στο παρελθόν, υποβάλετε έναν νέο κωδικό πρόσβασης",
  subtitle: "Για να αλλάξετε τον κωδικό πρόσβασής σας, συμπληρώστε τα παρακάτω πεδία:",
  submitButtonLabel: "Υποβολή",
  successfulChangeLabel: "Ο κωδικός πρόσβασής σας ενημερώθηκε με επιτυχία",
  title: "Αλλαγή κωδικού"
}, _g = {
  invalidEmail: "Λάθος email",
  invalidPassword: "Λάθος κωδικός",
  sap_206002: "Ο λογαριασμός σας δεν έχει επαληθευτεί, δυστυχώς δεν μπορούμε να σας επιτρέψουμε να συνεχίσετε αυτήν τη στιγμή. ",
  sap_206006: "Φαίνεται ότι η διεύθυνση ηλεκτρονικού ταχυδρομείου που υποβάλατε δεν έχει επαληθευτεί",
  sap_400003: "Αυτό το email υπάρχει ήδη, χρησιμοποιήστε διαφορετική διεύθυνση email.",
  sap_400028: "Η διεύθυνση ηλεκτρονικού ταχυδρομείου που υποβλήθηκε δεν έχει επαληθευτεί",
  sap_400050: "Λυπούμαστε, δεν μπορούμε να επικυρώσουμε τα στοιχεία του λογαριασμού σας αυτήν τη στιγμή.",
  sap_400097: "Φαίνεται ότι προσπαθέιτε να χρησιμοποιήσετε τις υπηρεσίες μας από ένα μη ασφαλές/μη υποστηριζόμενο πρόγραμμα περιήγησης. ",
  sap_401030: "Αυτός ο κωδικός πρόσβασης χρησιμοποιήθηκε στο παρελθόν, υποβάλετε έναν νέο κωδικό πρόσβασης",
  sap_403005: "Δεν έχουμε λογαριασμό που να σχετίζεται με αυτήν τη διεύθυνση email, ελέγξτε το email σας και δοκιμάστε ξανά",
  sap_403011: "Η συνεδρία έληξε. Παρακαλούμε επαναφορτώστε το πρόγραμμα περιήγησης και συνδεθείτε ξανά. ",
  sap_403012: "Η συνεδρία έληξε. Παρακαλούμε επαναφορτώστε το πρόγραμμα περιήγησης και συνδεθείτε ξανά.",
  sap_403013: "Λυπούμαστε, δεν μπορούμε να επικυρώσουμε τα στοιχεία του λογαριασμού σας αυτήν τη στιγμή.",
  sap_403035: "Λυπούμαστε, δεν μπορούμε να επικυρώσουμε τα στοιχεία του λογαριασμού σας αυτήν τη στιγμή.",
  sap_403041: "Δεν έχουμε λογαριασμό που να σχετίζεται με αυτήν τη διεύθυνση email, ελέγξτε το email σας και δοκιμάστε ξανά",
  sap_403042: "Ο συνδυασμός email & κωδικού πρόσβασης δεν είναι έγκυρος. Ελέγξτε το email που σχετίζεται με τον λογαριασμό ή επιλέξτε ξέχασα τον κωδικό πρόσβασης εάν θέλετε να τον επαναφέρετε.",
  sap_403043: "Ο συνδυασμός email & κωδικού πρόσβασης δεν είναι έγκυρος. Ελέγξτε το email που σχετίζεται με τον λογαριασμό ή επιλέξτε ξέχασα τον κωδικό πρόσβασης εάν θέλετε να τον επαναφέρετε.",
  sap_403047: "Ο συνδυασμός email & κωδικού πρόσβασης δεν είναι έγκυρος. Ελέγξτε το email που σχετίζεται με τον λογαριασμό ή επιλέξτε ξέχασα τον κωδικό πρόσβασης εάν θέλετε να τον επαναφέρετε.",
  sap_403100: "Πρόσφατα ζητήθηκε αίτημα ενημέρωσης κωδικού πρόσβασης, παρακαλούμε περιμένετε μέχρι να διεκπεραιωθεί το αίτημα",
  sap_403025: "Μη έγκυρος σύνδεσμος επαναφοράς κωδικού πρόσβασης. Στείλτε ξανά αίτημα για τον ξεχασμένο κωδικό πρόσβασης για να λάβετε νέο σύνδεσμο επαναφοράς.",
  sapErrorTitle: "Σφάλμα κατά την επεξεργασία του αιτήματος",
  sessionExpired: "Η συνεδρία έληξε",
  tooWeakPassword: "Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον {minLength} χαρακτήρες και {minCharGroups} από τα ακόλουθα: κεφαλαίο γράμμα, πεζό γράμμα, αριθμό, ειδικό σύμβολο | Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον {minLength} χαρακτήρες",
  unexpectedDescription: "Εάν το πρόβλημα επιμένει, επικοινωνήστε μαζί μας μέσω της φόρμας επικοινωνίας.",
  unexpectedTitle: "Παρουσιάστηκε σφάλμα",
  unknownDescription: "Παρουσιάστηκε μη αναμενόμενο σφάλμα. Παρακαλούμε προσπαθήστε ξανά. ",
  unknownTitle: "Ωχ!"
}, Sg = {
  subtitle: "Ορίστε τον νέο σας κωδικό πρόσβασης.",
  title: "Ξεχάσατε τον κωδικό σας;"
}, Cg = {
  headMetaDescription: "Σύνδεση ",
  headTitle: "Συνδεθείτε με το email και τον κωδικό πρόσβασής σας:",
  subtitle: "Συνδεθείτε ή δημιουργήστε έναν λογαριασμό για να αποκτήσετε όλες τις δυνατότητες της Miele.",
  title: "Συνδεθείτε στο λογαριασμό σας",
  error: {
    invalidEmailPasswordDescription: "Ο συνδυασμός διεύθυνσης email και κωδικού πρόσβασης δεν είναι έγκυρος.",
    invalidEmailPasswordTitle: "Μη έγκυρα στοιχέια λογαριασμού",
    missingConcentTitle: "Εκκρεμεί η δημιουργία λογαριασμού",
    noAccountDescription: "Δεν υπάρχει λογαριασμός που να σχετίζεται με αυτήν τη διεύθυνση email.",
    noAccountTitle: "Δεν έχει καταχωρηθεί λογαριασμός"
  },
  extraConsentScene: {
    continue: "Συνέχεια",
    privacyStatementCheckboxLabel: "Έχω λάβει υπόψη το {0}.",
    privacyStatementName: "Δήλωση προστασίας προσωπικών δεδομένων",
    privacyStatementTitle: "Η Πολιτική Απορρήτου μας έχει αλλάξει",
    termsOfUseCheckboxLabel: "Συμφωνώ με το {0}.",
    termsOfUseName: "όροι χρήσης",
    termsOfUseTitle: "Οι Όροι Χρήσης μας έχουν αλλάξει",
    title: "Ολοκλήρωση προφίλ"
  },
  forgotPasswordScene: {
    backButtonLabel: "Επιστροφή στην σελίδα εισόδου",
    submitButtonLabel: "Υποβολή",
    successDescription: "Ελέγξτε το e-mail σας, σύντομα θα λάβετε τις πληροφορίες στον λογαριασμό σας για να ξεκινήσετε τη διαδικασία επαναφοράς κωδικού πρόσβασης.",
    successTitle: "Το αίτημά σας έχει ληφθεί.",
    title: "Εισαγάγετε τη διεύθυνση email σας για να επαναφέρετε τον κωδικό πρόσβασής σας:"
  },
  loginModalScene: {
    copy: "Συνδεθείτε ή δημιουργήστε έναν λογαριασμό για να αποκτήσετε όλες τις δυνατότητες της Miele.",
    title: "Συνδεθείτε στο λογαριασμό σας"
  },
  loginScene: {
    emailInputLabel: "ΗΛΕΚΤΡΟΝΙΚΗ ΔΙΕΥΘΥΝΣΗ",
    forgotPwdButtonLabel: "Ξεχασα τον κωδικο μου",
    invalidEmailMessage: "Το e-mail δεν ισχύει!",
    loginButtonLabel: "Σύνδεση",
    passwordInputLabel: "Κωδικός πρόσβασης",
    rememberMeLabel: "Θυμήσου με",
    title: "Συνδεθείτε με το email και τον κωδικό πρόσβασής σας:"
  }
}, Lg = {
  accessibility: {
    close: "Κλείσιμο"
  }
}, Eg = {
  tooShort: "Πολύ σύντομο",
  medium: "Μέτριο",
  strong: "Ισχυρός",
  tooWeak: "Πολύ αδύναμος",
  veryStrong: "Πολύ δυνατός",
  weak: "Αδύναμος"
}, Pg = {
  showPasswordText: "Προβολή",
  hidePasswordText: "Απόκρυψη"
}, Tg = {
  registerButtonLabel: "ΕΓΓΡΑΦΗ",
  registerTitle: "Δεν έχετε λογαριασμό;",
  whyRegister: {
    list: [
      "Αποκτήστε πρόσβαση στα αποκλειστικά προνόμια του Miele Club",
      "Εγγραφή συσκευών, παρακολούθηση παραγγελιών, πρόσβαση σε οδηγίες χρήσης",
      "Λάβετε εξατομικευμένες προσφορές και προωθήσεις",
      "Δείτε όλες τις παραγγελίες, τις εγγυήσεις, τις εκδηλώσεις και τις υπηρεσίες σας"
    ],
    title: "Γιατί να εγγραφείτε;"
  },
  closeButtonLabel: "Κλείσιμο",
  passwordMismatchError: "Οι κωδικοί δεν ταιριάζουν",
  passwordUpdateErrorTitle: "Σφάλμα ενημέρωσης κωδικού πρόσβασης",
  passwordUpdateSuccessTitle: "Ο κωδικός ενημερώθηκε",
  successfulChangeLabel: "Ο κωδικός πρόσβασής σας ενημερώθηκε με επιτυχία"
}, Ag = {
  title: "Προτιμήσεις διαφημίσεων",
  description: "Επιλέξτε παρακάτω για αποκλειστικές προσφορές, νέα, εκδηλώσεις και πώς να αξιοποιήσετε στο έπακρο τη συσκευή σας.",
  submit: "Αποθηκεύσετε",
  levelOne: {
    shortText: 'Ναι, θα ήθελα να λαμβάνω διαφημιστική επικοινωνία προσαρμοσμένη στα προσωπικά μου ενδιαφέροντα από την Miele Hellas Ε.Π.Ε και την Miele & Cie. KG ("Miele") μέσω e-mail, γραπτού μηνύματος, ταχυδρομείου και μέσω των εφαρμογών Miele και της ιστοσελίδας (αν χρησιμοποιούνται)',
    text: `Ναι, θα ήθελα να λαμβάνω διαφημιστική επικοινωνία προσαρμοσμένη στα προσωπικά μου ενδιαφέροντα από την Miele Hellas Ε.Π.Ε και την Miele & Cie. KG ("Miele") μέσω e-mail, γραπτού μηνύματος, ταχυδρομείου και μέσω των εφαρμογών Miele και της ιστοσελίδας (αν χρησιμοποιούνται) με πληροφορίες για προϊόντα, προσφορές, καινοτομίες από τη σειρά προϊόντων της Miele και για εκδηλώσεις της Miele, καθώς και για έρευνες πελατών, αιτήσεις αξιολόγησης και κριτικής προϊόντων και συνταγές. Για το σκοπό αυτό, η Miele μπορεί να χρησιμοποιήσει τα στοιχεία επικοινωνίας μου (τίτλος, όνομα, διεύθυνση ηλεκτρονικού ταχυδρομείου, αριθμός κινητού τηλεφώνου και ταχυδρομική διεύθυνση) και να σχεδιάσει την επικοινωνία με βάση το ιστορικό αγορών, υπηρεσιών, τη συμμετοχή σε εκδηλώσεις, τη συμπεριφορά μου ως προς το κλικ και το άνοιγμα του newsletter και την αξία ως πελάτη, όπως περιγράφεται λεπτομερέστερα στις πληροφορίες μας για την προστασία δεδομένων. Μπορώ να ανακαλέσω τη συγκατάθεσή μου, χωρίς να απαιτείται αιτιολόγηση, με ισχύ για το μέλλον (π.χ. στέλνοντας ένα ανεπίσημο μήνυμα στο info{'@'}miele.gr, στα στοιχεία επικοινωνίας που αναφέρονται στη νομική σημείωση ή κάνοντας κλικ στον σύνδεσμο διαγραφής στα μηνύματα ηλεκτρονικού ταχυδρομείου).`,
    link: {
      title: "Πολιτική Απορρήτου",
      ref: "https://www.miele.gr/c/prostasia-dedomenwn-14.htm"
    }
  },
  levelTwo: {
    text: "Εκτός από τη βασική μου συγκατάθεση, συμφωνώ ότι η Miele μπορεί επίσης να επεξεργάζεται δεδομένα από τη χρήση της εφαρμογής Miele και τις επισκέψεις μου στις ιστοσελίδες της Miele (http://www.miele.gr ), συμπεριλαμβανομένης της συμπεριφοράς του χρήστη που συνδέεται με τα κλικ στο newsletter στις ιστοσελίδες της Miele που συνδέονται εκεί, για να συμπληρώσει το προφίλ χρήστη μου για εξατομικευμένη διαφημιστική επικοινωνία, υπό την προϋπόθεση ότι η ξεχωριστή συγκατάθεσή μου στην εφαρμογή ή στην ιστοσελίδα αποδεσμεύει την επεξεργασία δεδομένων. Μπορώ να ανακαλέσω τη συναίνεση μου ανά πάσα στιγμή χωρίς αιτιολόγηση για το μέλλον. Περισσότερες λεπτομέρειες στην πολιτική απορρήτου.",
    link: {
      title: "Πολιτική προστασίας δεδομένων",
      ref: "https://www.miele.gr/c/prostasia-dedomenwn-14.htm"
    }
  },
  levelThree: {
    text: "Εκτός από τη βασική μου συγκατάθεση, συμφωνώ ότι η Miele μπορεί να επεξεργάζεται δεδομένα από τις συνδεδεμένες συσκευές Miele (δεδομένα σχετικά με τη χρήση και την κατάσταση της συσκευής) για να συμπληρώσει το προφίλ χρήστη μου για εξατομικευμένη διαφήμιση. Μπορώ να βρω περισσότερες πληροφορίες σχετικά με την επεξεργασία των δεδομένων των συσκευών στην πολιτική απορρήτου για το σύστημα Miele{'@'}Home. Μπορώ να ανακαλέσω τη συγκατάθεσή μου ανά πάσα στιγμή για το μέλλον. Περισσότερες λεπτομέρειες στην πολιτική απορρήτου.",
    link: {
      title: "Πολιτική απορρήτου για το σύστημα Miele{'@'}Home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4/DataProtection/Privacy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ναι, συμφωνώ με τους όρους χρήσης.",
    link: {
      title: "Δείτε τους Όρους Χρήσης*",
      ref: "https://www.miele.gr/c/oroi-xrhshs-13.htm"
    }
  }
}, xg = {
  headline: "Miele Club",
  birthDateTitle: "Θα θέλατε να λάβετε μια έκπληξη για τα γενέθλιά σας;",
  birthDateLabel: "Ημερομηνία γέννησης (προαιρετικό)",
  why: {
    title: "Δωρεάν συνδρομή - Αποκλειστικές προσφορές για μέλη.",
    reasons: [
      "10% όφελος καλωσορίσματος",
      "Έκπληξη για τα γενέθλια σας",
      "Ειδικές προσφορές",
      "Προσκλήσεις σε αποκλειστικές εκδηλώσεις & εμπειρίες"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Παρακαλώ εισαγάγετε την ημερομηνία σε αυτήν τη μορφή: ΗΗ/ΜΜ/ΕΕΕΕ",
    errorMsg: "Λανθασμένη ημερομηνία"
  },
  joinClubLabel: "Ναι, θα ήθελα να γίνω μέλος του Miele Club.",
  termsAndCondition: {
    description: "Συναινώ στους {termsAndConditionLink} του Miele Club και αναγνωρίζω τις πληροφορίες {privacyLink} του Miele Club.",
    termsAndConditionLink: {
      title: "Όροι και Προϋποθέσεις",
      ref: "https://www.miele.gr/c/oroi-xrhshs-13.htm"
    },
    privacyLink: {
      title: "Προστασία Δεδομένων",
      ref: "https://www.miele.gr/c/prostasia-dedomenwn-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Ναι, θα ήθελα να λαμβάνω επικοινωνίες μάρκετινγκ για το Miele Club που είναι προσαρμοσμένες στα προσωπικά μου ενδιαφέροντα από την Miele Hellas («Miele») μέσω e-mail και ταχυδρομείο",
    description: "Ναι, θα ήθελα να λαμβάνω επικοινωνίες για το Miele Club που είναι προσαρμοσμένες στα προσωπικά μου ενδιαφέροντα από την Miele Hellas («Miele») μέσω e-mail και ταχυδρομείου συμπεριλαμβανομένων ειδικών προσφορών, πληροφοριών, προσκλήσεων για εκδηλώσεις και ερευνών πελατών σχετικά με τα προϊόντα και τις υπηρεσίες μας. Για να το κάνει αυτό, η Miele μπορεί να χρησιμοποιήσει τα στοιχεία επικοινωνίας μου (τίτλος, όνομα, διεύθυνση ηλεκτρονικού ταχυδρομείου και ταχυδρομική διεύθυνση) και να εξατομικεύσει τις επικοινωνίες με βάση την αγοραστική μου συμπεριφορά, τον τρόπο με τον οποίο αλληλεπιδρώ με το newsletter και την κατάστασή μου ως πελάτη, όπως περιγράφεται λεπτομερέστερα στην {privacyLink}. Μπορώ να ανακαλέσω τη συγκατάθεσή μου με ισχύ για το μέλλον ανά πάσα στιγμή (για παράδειγμα, στέλνοντας μήνυμα ηλεκτρονικού ταχυδρομείου στη διεύθυνση info{'@'}miele.gr, επικοινωνώντας με τα στοιχεία επικοινωνίας που παρέχονται στη νομική ειδοποίηση ή κάνοντας κλικ στον σύνδεσμο διαγραφής στα μηνύματα ηλεκτρονικού ταχυδρομείου). Οι  {termsAndConditionLink} δεν επηρεάζονται από το παρόν, εκτός εάν τερματίσω τη συνδρομή μου.",
    privacyLink: {
      title: "Πολιτική απορρήτου του Miele Club ",
      href: "https://www.miele.gr/c/prostasia-dedomenwn-14.htm"
    },
    termsAndConditionLink: {
      title: "Επικοινωνίες προς τα μέλη του Miele Club",
      href: "https://www.miele.gr/c/oroi-xrhshs-13.htm"
    },
    supportEmail: "info{'@'}miele.gr"
  },
  selectAllConsents: {
    description: "Για να γίνετε μέλος του Miele Club, πρέπει να συμφωνήσετε με όλους τους όρους και προϋποθέσεις *"
  }
}, Ig = {
  auth: Mg,
  changeEmailScene: zg,
  changePasswordScene: jg,
  errors: _g,
  forgotPassword: Sg,
  login: Cg,
  modal: Lg,
  passwordStrength: Eg,
  passwordHelper: Pg,
  register: Tg,
  "marketing-consent": {
    title: "Προτιμήσεις διαφημίσεων",
    description: "Επιλέξτε παρακάτω για αποκλειστικές προσφορές, νέα, εκδηλώσεις και πώς να αξιοποιήσετε στο έπακρο τη συσκευή σας.",
    submit: "Αποθηκεύσετε",
    newsletter: {
      text: 'Συμφωνώ ότι η Miele Co Ltd. ("Miele") μπορεί να μου στέλνει πληροφορίες για προϊόντα και καινοτομίες από τη γκάμα προϊόντων Miele και για εκδηλώσεις της Miele, καθώς και για έρευνες πελατών και συνταγές μέσω ηλεκτρονικού ταχυδρομείου, των εφαρμογών Miele και SMS και ότι η Miele μπορεί να επεξεργάζεται τα στοιχεία επικοινωνίας που έχω παράσχει (τίτλος, όνομα, διεύθυνση ηλεκτρονικού ταχυδρομείου, αριθμός κινητού τηλεφώνου και ταχυδρομικός κώδικας) και τα προϊόντα Miele που έχω αγοράσει μέχρι σήμερα και θα αγοράσω στο μέλλον, καθώς και τα ενδιαφέροντα που έχω δηλώσει για το σκοπό αυτό. Συμφωνώ περαιτέρω ότι η Miele μπορεί επίσης να επεξεργάζεται τις επιβεβαιώσεις παραλαβής και ανάγνωσης που λαμβάνει μέσω του ενημερωτικού δελτίου και τις πληροφορίες σχετικά με τους συνδέσμους στους οποίους έχω κάνει κλικ, καθώς και τη σχετική συμπεριφορά μου ως χρήστης στον συνδεδεμένο ιστότοπο με σκοπό την εξατομίκευση. Το ίδιο ισχύει και για τα push μηνύματα εντός της εφαρμογής, εφόσον χρησιμοποιούνται οι εφαρμογές της Miele.',
      link: {
        title: "Δείτε την πολιτική προστασίας δεδομένων",
        ref: ""
      }
    },
    personalisation: {
      text: "Συμφωνώ ότι η Miele μπορεί να επεξεργάζεται πληροφορίες σχετικά με τις υπηρεσίες που έχω χρησιμοποιήσει και τις αναθέσεις τεχνικών που έχω πραγματοποιήσει, καθώς και εκδηλώσεις στις οποίες έχω παρακολουθήσει, με σκοπό τη βελτιωμένη εξατομίκευση.",
      link: {
        title: "Δείτε την πολιτική προστασίας δεδομένων",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Εκτός από την εκτεταμένη εξατομίκευση, συμφωνώ ότι η Miele μπορεί επίσης να επεξεργάζεται δεδομένα από τη χρήση της εφαρμογής Miele και τις επισκέψεις μου στους ιστότοπους της Miele (www.miele.gr) για τη συμπλήρωση του προφίλ χρήστη μου, εφόσον έχω δώσει ξεχωριστά τη συγκατάθεσή μου για την επεξεργασία αυτών των δεδομένων. ",
      link: {
        title: "Δείτε την πολιτική προστασίας δεδομένων",
        ref: ""
      }
    },
    highlightedText: {
      text: "Μπορώ να ανακαλέσω τη συγκατάθεσή μου ανά πάσα στιγμή χωρίς να αναφέρω λόγους με ισχύ για το μέλλον.  ",
      link: {
        title: "πολιτική προστασίας δεδομένων.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ναι, συμφωνώ με τους όρους χρήσης.",
      link: {
        title: "Δείτε τους Όρους Χρήσης*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: Ag,
  mieleClub: xg
}, Dg = {
  waitMessage: "Už ste skoro tam. "
}, Ng = {
  buttonLabel: "Uložiť",
  buttonLabelClose: "Zavrieť",
  confirmEmailMessage: "Potvrďte svoju e-mailovú adresu",
  copy: "Ak chcete aktualizovať svoju e-mailovú adresu, pridajte novú nižšie:",
  errorMessageCopy: "Niečo sa pokazilo. ",
  errorMessageHeadline: "Chyba",
  headline: "Podrobnosti profilu",
  inputEmailConfirmPlaceholder: "Potvrďte svoju e-mailovú adresu",
  inputEmailPlaceholder: "Emailová adresa",
  invalidEmailMessage: "E-mail je neplatný!",
  rememberMeLabel: "Zapamätovať",
  successMessageCopy: "Vaša e-mailová adresa bola úspešne aktualizovaná.",
  successMessageHeadline: "E-mailová adresa bola aktualizovaná"
}, Og = {
  closeButtonLabel: "Zavrieť",
  confirmPasswordLabel: "Potvrďte heslo",
  currentPasswordLabel: "Aktuálne heslo",
  newPasswordLabel: "Nové heslo",
  passwordMismatchError: "Heslo sa nezhoduje",
  passwordUpdateErrorTitle: "Chyba",
  passwordUpdateSuccessTitle: "Heslo bolo aktualizované",
  samePasswordError: "Toto heslo sa už používalo, zadajte nové heslo",
  subtitle: "Ak chcete zmeniť svoje heslo, vyplňte nižšie uvedené polia: ",
  submitButtonLabel: "Potvrdiť",
  successfulChangeLabel: "Vaše heslo bolo úspešne aktualizované",
  title: "Zmena hesla"
}, Ug = {
  invalidEmail: "Nespravny email",
  invalidPassword: "Zlé heslo",
  sap_206002: "Váš účet čaká na overenie. Kontaktujte nás pre bližšie informácie. ",
  sap_206006: "Zdá sa, že e-mailová adresa, ktorú ste odoslali, čaká na overenie",
  sap_400003: "Tento e-mail už existuje, použite inú e-mailovú adresu.",
  sap_400028: "Odoslaná e-mailová adresa čaká na overenie",
  sap_400050: "Ľutujeme, momentálne nemôžeme overiť vaše prihlasovacie údaje.",
  sap_400097: "Zdá sa, že k našim službám pristupujete z nezabezpečeného/nepodporovaného prehliadača. ",
  sap_401030: "Toto heslo sa už používalo, zadajte nové heslo",
  sap_403005: "K tejto e-mailovej adrese nemáme priradený účet, skontrolujte svoj e-mail a skúste to znova",
  sap_403011: "Platnosť relácie vypršala. Znova načítajte prehliadač a znova sa prihláste.",
  sap_403012: "Platnosť relácie vypršala. Znova načítajte prehliadač a znova sa prihláste. ",
  sap_403013: "Ľutujeme, momentálne nemôžeme overiť vaše prihlasovacie údaje.",
  sap_403035: "Ľutujeme, momentálne nemôžeme overiť vaše prihlasovacie údaje.",
  sap_403041: "K tejto e-mailovej adrese nemáme priradený účet, skontrolujte svoj e-mail a skúste to znova",
  sap_403042: "Kombinácia emailu a hesla nie je správna. Skontrolujte, či zadávate pri prihlasovaní správny email, alebo zažiadajte o obnovenie hesla.",
  sap_403043: "Kombinácia emailu a hesla nie je správna. Skontrolujte, či zadávate pri prihlasovaní správny email, alebo zažiadajte o obnovenie hesla.",
  sap_403047: "Kombinácia emailu a hesla nie je správna. Skontrolujte, či zadávate pri prihlasovaní správny email, alebo zažiadajte o obnovenie hesla.",
  sap_403100: "Žiadosť o aktualizáciu hesla bola nedávno vyžiadaná, prosíme o strpenie, kým nebude žiadosť spracovaná",
  sap_403025: "Odkaz na obnovenie hesla je neplatný, pošlite žiadosť o zabudnuté heslo znova, aby ste dostali nový odkaz na obnovenie.",
  sapErrorTitle: "Chyba pri spracovaní požiadavky",
  sessionExpired: "Platnosť relácie vypršala",
  tooWeakPassword: "Heslo musí obsahovať aspoň {minLength} znakov a {minCharGroups} z nasledujúcich znakov: veľké písmeno, malé písmeno, číslo, špeciálny symbol | Heslo musí obsahovať aspoň {minLength} znakov",
  unexpectedDescription: "Ak problém pretrváva, kontaktujte nás prostredníctvom kontaktného formulára s podrobnosťami.",
  unexpectedTitle: "Vyskytla sa neočakávaná chyba",
  unknownDescription: "Vyskytla sa neočakávaná chyba. Skúste to prosím neskôr. ",
  unknownTitle: "Niečo sa nepodarilo."
}, $g = {
  subtitle: "Nastavte si nové heslo.",
  title: "Zabudli ste heslo?"
}, Bg = {
  headMetaDescription: "Prihlasovacia stránka zákazníka",
  headTitle: "Prihláste sa svojím emailom a heslom:",
  subtitle: "Prihláste sa alebo si vytvorte účet a získajte všetky výhody Miele.",
  title: "Prihláste sa do svojho účtu",
  error: {
    invalidEmailPasswordDescription: "Kombinácia e-mailovej adresy a hesla nie je platná.",
    invalidEmailPasswordTitle: "Neplatné prihlasovacie údaje",
    missingConcentTitle: "Účet čaká na registráciu",
    noAccountDescription: "K tejto e-mailovej adrese nie je priradený žiadny účet.",
    noAccountTitle: "Nie je zaregistrovaný žiadny účet"
  },
  extraConsentScene: {
    continue: "Pokračovať",
    privacyStatementCheckboxLabel: "Beriem na vedomie {0}.",
    privacyStatementName: "Vyhlásenie o ochrane súkromia",
    privacyStatementTitle: "Naše zásady ochrany osobných údajov sa zmenili",
    termsOfUseCheckboxLabel: "Súhlasím s {0}.",
    termsOfUseName: "Podmienky používania",
    termsOfUseTitle: "Naše podmienky používania sa zmenili",
    title: "Finalizácia profilu"
  },
  forgotPasswordScene: {
    backButtonLabel: "Späť na prihlásenie",
    submitButtonLabel: "Potvrdiť",
    successDescription: "Skontrolujte svoj e-mail, čoskoro dostanete informácie k procesu obnovenia hesla.",
    successTitle: "Vaša žiadosť bola prijatá.",
    title: "Ak chcete obnoviť heslo, zadajte svoju e-mailovú adresu:"
  },
  loginModalScene: {
    copy: "Prihláste sa alebo si vytvorte účet a získajte všetky funkcie Miele.",
    title: "Prihláste sa do svojho účtu"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Zabudol som heslo",
    invalidEmailMessage: "E-mail je neplatný!",
    loginButtonLabel: "Prihlásiť sa",
    passwordInputLabel: "Heslo",
    rememberMeLabel: "Zapamätovať",
    title: "Prihláste sa svojím emailom a heslom:"
  }
}, Rg = {
  accessibility: {
    close: "Zavrieť"
  }
}, Fg = {
  tooShort: "Príliš krátke",
  medium: "Stredné",
  strong: "Silné",
  tooWeak: "Príliš slabé",
  veryStrong: "Veľmi silné",
  weak: "Silné"
}, Vg = {
  showPasswordText: "Zobraziť",
  hidePasswordText: "Skryť"
}, qg = {
  registerButtonLabel: "Registrovať",
  registerTitle: "Nemáte účet?",
  whyRegister: {
    list: [
      "Registrácia spotrebičov, sledovanie objednávok, prístup k manuálom",
      "Dostávajte informácie o aktuálnych ponukách a akciách",
      "Pozrite si všetky svoje objednávky, záruky, udalosti a služby"
    ],
    title: "Prečo sa registrovať?"
  },
  closeButtonLabel: "Zavrieť",
  passwordMismatchError: "heslá sa nezhodujú",
  passwordUpdateErrorTitle: "Chyba aktualizácie hesla",
  passwordUpdateSuccessTitle: "Heslo bolo aktualizované",
  successfulChangeLabel: "Vaše heslo bolo úspešne aktualizované"
}, Gg = {
  title: "Marketingové preferencie",
  description: "Zaškrtnutím nižšie získate exkluzívne ponuky, novinky, udalosti a spôsob, ako zo svojho spotrebiča vyťažiť maximum.",
  submit: "Uložiť",
  levelOne: {
    shortText: 'Áno, chcem dostávať od spoločností Miele s.r.o. a Miele & Cie. KG ("Miele") reklamné oznámenia prispôsobené mojim osobným záujmom prostredníctvom e-mailu, SMS, pošty, webovej stránky a aplikácií Miele (ak ich používam)',
    text: `Áno, chcem dostávať od spoločností Miele s.r.o. a Miele & Cie. KG ("Miele") reklamné oznámenia prispôsobené mojim osobným záujmom prostredníctvom e-mailu, SMS, pošty, webovej stránky a aplikácií Miele (ak ich používam) s informáciami o výrobkoch, ponukách a inováciách zo sortimentu Miele a o podujatiach Miele, ako aj o zákazníckych prieskumoch, požiadavkách na hodnotenie a recenzie výrobkov a o receptoch. Na tento účel môže spoločnosť Miele použiť moje kontaktné údaje (titul, meno, e-mailovú adresu, číslo mobilného telefónu a poštovú adresu) a navrhnúť komunikáciu na základe histórie mojich nákupov, udalostí a služieb, môjho správania pri klikaní a otváraní newsletteru a mojich zákazníckych hodnotení, ako je podrobnejšie popísané v našich informáciách o ochrane údajov. Svoj súhlas môžem kedykoľvek do budúcnosti odvolať (napr. zaslaním neformálnej správy na e-mail info{'@'}miele.sk, kontaktnými údajmi uvedenými v právnom upozornení alebo kliknutím na odkaz na odhlásenie v e-mailoch).`,
    link: {
      title: "Ochrana osobných údajov",
      ref: "https://www.miele.sk/c/ochrana-osobnych-udajov-14.htm"
    }
  },
  levelTwo: {
    text: "Okrem môjho základného súhlasu súhlasím s tým, že spoločnosť Miele môže spracúvať aj údaje z používania aplikácie Miele a z mojich návštev webových stránok Miele (www.miele.sk) vrátane správania používateľa súvisiaceho s kliknutiami na newsletter na prepojených webových stránkach Miele na doplnenie môjho používateľského profilu na účely personalizovanej reklamnej komunikácie, a to za predpokladu, že môj samostatný súhlas v aplikácii alebo na webovej stránke uvoľní spracovanie údajov. Svoj súhlas môžem kedykoľvek do budúcnosti odvolať. Ďalšie podrobnosti nájdete na odkaze Ochrana osobných údajov.",
    link: {
      title: "Ochrana osobných údajov",
      ref: "https://www.miele.sk/c/ochrana-osobnych-udajov-14.htm"
    }
  },
  levelThree: {
    text: "Okrem môjho základného súhlasu súhlasím s tým, že spoločnosť Miele môže spracúvať údaje z mojich sieťových spotrebičov Miele (údaje o používaní a stave spotrebičov) na doplnenie môjho používateľského profilu na účely personalizovanej reklamy. Ďalšie informácie o spracovaní údajov spotrebičov nájdem v zásadách ochrany osobných údajov pre systém Miele{'@'}Home. Svoj súhlas môžem kedykoľvek do budúcnosti odvolať. Ďalšie informácie nájdete na odkaze Ochrana osobných údajov.",
    link: {
      title: "Miele{'@'}Home-System",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Áno, súhlasím s podmienkami používania.",
    link: {
      title: "Pozrite si podmienky používania",
      ref: "https://www.miele.sk/c/podmienky-pouzivania-304.htm"
    }
  }
}, Kg = {
  headline: "",
  why: {
    title: "",
    reasons: ""
  },
  birthDateTitle: "",
  birthDateValidation: {
    requirementMsg: "",
    errorMsg: ""
  },
  joinClubLabel: "",
  termsAndCondition: {
    description: "",
    termsAndConditionLink: {
      title: "Podmienky používania",
      ref: "https://www.miele.sk/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Ochrana osobných údajov",
      ref: "https://www.miele.sk/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    description: "",
    shortDescription: "Áno, chcem dostávať propagačnú komunikáciu Miele Club, prispôsobenú mojim osobným záujmom, prostredníctvom e-mailu a pošty",
    privacyLink: {
      title: "Ochrana osobných údajov Miele Club",
      href: "https://www.miele.sk/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Komunikácia Club",
      href: "https://www.miele.sk/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.sk"
  },
  selectAllConsents: {
    description: "Aby ste sa stali členom Miele Klubu, musíte prijať všetky podmienky *"
  },
  birthDateLabel: "Váš dátum narodenia (nepovinné)"
}, Hg = "zobraziť celé vyhlásenie", Wg = "skryť celé vyhlásenie", Jg = {
  auth: Dg,
  changeEmailScene: Ng,
  changePasswordScene: Og,
  errors: Ug,
  forgotPassword: $g,
  login: Bg,
  modal: Rg,
  passwordStrength: Fg,
  passwordHelper: Vg,
  register: qg,
  "marketing-consent": {
    title: "Marketingové preferencie",
    description: "Zaškrtnutím nižšie získate exkluzívne ponuky, novinky, udalosti a spôsob, ako zo svojho spotrebiča vyťažiť maximum.",
    submit: "Uložiť",
    newsletter: {
      text: 'Súhlasím s tým, že Miele s.r.o ("Miele") mi môže posielať informácie o produktoch a inováciách z produktového radu Miele, podujatiach Miele, ako aj zákaznícke prieskumy a recepty prostredníctvom e-mailu, aplikácií Miele a SMS a že Miele môže spracovať kontaktné údaje, ktoré som uviedol (titul, meno, e-mailová adresa, číslo mobilného telefónu a PSČ) a produkty Miele, ktoré som si doteraz zakúpil a kúpim v budúcnosti, ako aj záujmy, ktoré som na tento účel uviedol. Ďalej súhlasím s tým, že Miele môže za účelom personalizácie spracovávať aj potvrdenia o prijatí a prečítaní potvrdení doručených prostredníctvom newsletteru a informácie o odkazoch, na ktoré som klikol, ako aj o mojom správaní používateľov na prepojenej webovej stránke. To isté platí pre push správy v aplikácii, pokiaľ sa používajú v aplikácii Miele.',
      link: {
        title: "Viď. zásady ochrany údajov",
        ref: ""
      }
    },
    personalisation: {
      text: "Súhlasím s tým, že Miele môže spracovávať informácie o službách, ktoré som využil, a o úlohách technikov, ktoré som vykonal, ako aj o podujatiach, ktorých som sa zúčastnil, za účelom vylepšenej personalizácie.",
      link: {
        title: "Viď. zásady ochrany údajov",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Okrem rozšírenej personalizácie súhlasím s tým, že Miele môže na doplnenie môjho používateľského profilu spracúvať aj údaje z používania aplikácie Miele a mojich návštev na webových stránkach Miele (www.miele.co.uk), ak som s tým osobitne súhlasil. ",
      link: {
        title: "Viď. Zásady ochrany údajov",
        ref: ""
      }
    },
    highlightedText: {
      text: "Svoj súhlas môžem kedykoľvek odvolať bez uvedenia dôvodov s účinnosťou do budúcnosti.  ",
      link: {
        title: "Zásady ochrany údajov",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Áno, súhlasím s podmienkami používania.",
      link: {
        title: "Viď. Podmienky používania*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: Gg,
  mieleClub: Kg,
  readMore: Hg,
  readLess: Wg
}, Zg = {
  waitMessage: "Už jste skoro tam. "
}, Yg = {
  buttonLabel: "Uložit",
  buttonLabelClose: "Zavřít",
  confirmEmailMessage: "Potvrďte svou e-mailovou adresu",
  copy: "Chcete-li aktualizovat svou e-mailovou adresu, přidejte novou níže:",
  errorMessageCopy: "Něco se pokazilo. ",
  errorMessageHeadline: "Chyba",
  headline: "Podrobnosti profilu",
  inputEmailConfirmPlaceholder: "Potvrďte svou e-mailovou adresu",
  inputEmailPlaceholder: "E-mailová adresa",
  invalidEmailMessage: "E-mail není platný!",
  rememberMeLabel: "Zapamatovat",
  successMessageCopy: "Vaše e-mailová adresa byla úspěšně aktualizována.",
  successMessageHeadline: "E-mailová adresa byla aktualizována"
}, Xg = {
  closeButtonLabel: "Zavřít",
  confirmPasswordLabel: "Potvrďte heslo",
  currentPasswordLabel: "Aktuální heslo",
  newPasswordLabel: "Nové heslo",
  passwordMismatchError: "Heslo se neshoduje",
  passwordUpdateErrorTitle: "Chyba",
  passwordUpdateSuccessTitle: "Heslo aktualizováno",
  samePasswordError: "Toto heslo bylo použito již dříve, zadejte prosím nové heslo",
  subtitle: "Chcete-li změnit heslo, vyplňte níže uvedená pole:",
  submitButtonLabel: "Potvrdit",
  successfulChangeLabel: "Vaše heslo bylo úspěšně aktualizováno",
  title: "Změna hesla"
}, Qg = {
  invalidEmail: "Nesprávný e-mail",
  invalidPassword: "Špatné heslo",
  sap_206002: "Váš účet čeká na ověření. Kontaktujte nás pro bližší informace. ",
  sap_206006: "Zdá se, že vámi odeslaná e-mailová adresa čeká na ověření",
  sap_400003: "Tento e-mail již existuje, použijte prosím jinou e-mailovou adresu.",
  sap_400028: "Odeslaná e-mailová adresa čeká na ověření",
  sap_400050: "Omlouváme se, v tuto chvíli nejsme schopni ověřit vaše přihlašovací údaje.",
  sap_400097: "Zdá se, že k našim službám přistupujete z nezabezpečeného/nepodporovaného prohlížeče. ",
  sap_401030: "Toto heslo bylo použito již dříve, zadejte prosím nové heslo",
  sap_403005: "K této e-mailové adrese nemáme přidružený účet, zkontrolujte svůj e-mail a zkuste to znovu",
  sap_403011: "Relace vypršela. Znovu načtěte prohlížeč a opět se přihlaste. ",
  sap_403012: "Relace vypršela. Znovu načtěte prohlížeč a opět se přihlaste.",
  sap_403013: "Omlouváme se, v tuto chvíli nejsme schopni ověřit vaše přihlašovací údaje.",
  sap_403035: "Omlouváme se, v tuto chvíli nejsme schopni ověřit vaše přihlašovací údaje.",
  sap_403041: "K této e-mailové adrese nemáme přidružený účet, zkontrolujte svůj e-mail a zkuste to znovu",
  sap_403042: "Kombinace e-mailu a hesla není správná. Zkontrolujte prosím, zda zadáváte správný e-mail nebo vyberte možnost pro zapomenuté heslo.",
  sap_403043: "Kombinace e-mailu a hesla není správná. Zkontrolujte prosím, zda zadáváte správný e-mail nebo vyberte možnost pro zapomenuté heslo.",
  sap_403047: "Kombinace e-mailu a hesla není správná. Zkontrolujte prosím, zda zadáváte správný e-mail nebo vyberte možnost pro zapomenuté heslo.",
  sap_403100: "Žádost o aktualizaci hesla byla nedávno vyžádána, prosíme o strpení, dokud nebude žádost zpracována",
  sap_403025: "Odkaz pro resetování hesla je neplatný, zašlete prosím žádost o zapomenuté heslo znovu, abyste obdrželi nový odkaz pro resetování.",
  sapErrorTitle: "Chyba při zpracování požadavku",
  sessionExpired: "Relace vypršela",
  tooWeakPassword: "Heslo musí obsahovat alespoň {minLength} znaků a {minCharGroups} z následujících: velké písmeno, malé písmeno, číslo, speciální symbol | Heslo musí obsahovat alespoň {minLength} znaků",
  unexpectedDescription: "Pokud problém přetrvává, sdělte nám prosím podrobnosti prostřednictvím kontaktního formuláře.",
  unexpectedTitle: "Došlo k neočekávané chybě",
  unknownDescription: "Došlo k neočekávané chybě. ",
  unknownTitle: "Něco je špatně."
}, ev = {
  subtitle: "Nastavte si nové heslo.",
  title: "Zapomněli jste heslo?"
}, tv = {
  headMetaDescription: "Přihlašovací stránka zákazníka",
  headTitle: "Přihlaste se pomocí svého e-mailu a hesla:",
  subtitle: "Přihlaste se nebo si vytvořte účet a získejte všechny výhody Miele.",
  title: "Přihlaste se ke svému účtu",
  error: {
    invalidEmailPasswordDescription: "Kombinace e-mailové adresy a hesla není platná.",
    invalidEmailPasswordTitle: "Neplatné přihlašovací údaje",
    missingConcentTitle: "Účet čeká na registraci",
    noAccountDescription: "K této e-mailové adrese není přidružen žádný účet.",
    noAccountTitle: "Není registrován žádný účet"
  },
  extraConsentScene: {
    continue: "Pokračovat",
    privacyStatementCheckboxLabel: "Beru na vědomí {0}.",
    privacyStatementName: "Prohlášení o ochraně soukromí",
    privacyStatementTitle: "Naše zásady ochrany osobních údajů se změnily",
    termsOfUseCheckboxLabel: "Souhlasím s {0}.",
    termsOfUseName: "Podmínky používání",
    termsOfUseTitle: "Naše podmínky používání se změnily",
    title: "Finalizace profilu"
  },
  forgotPasswordScene: {
    backButtonLabel: "Zpět k přihlášení",
    submitButtonLabel: "Potvrdit",
    successDescription: "Zkontrolujte prosím svůj e-mail, brzy obdržíte informace na svůj účet, abyste mohli začít s procesem resetování hesla.",
    successTitle: "Vaše žádost byla přijata.",
    title: "Pro resetování hesla zadejte svou e-mailovou adresu:"
  },
  loginModalScene: {
    copy: "Přihlaste se nebo si vytvořte účet a získejte všechny funkce Miele.",
    title: "Přihlaste se ke svému účtu"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Zapomněl jsem heslo",
    invalidEmailMessage: "E-mail není platný!",
    loginButtonLabel: "Přihlásit se",
    passwordInputLabel: "Heslo",
    rememberMeLabel: "Zapamatovat",
    title: "Přihlaste se pomocí svého e-mailu a hesla:"
  }
}, iv = {
  accessibility: {
    close: "Zavřít"
  }
}, nv = {
  tooShort: "Příliš krátké",
  medium: "Střední",
  strong: "Silné",
  tooWeak: "Příliš slabé",
  veryStrong: "Velmi silné",
  weak: "Slabé"
}, av = {
  showPasswordText: "Zobrazit",
  hidePasswordText: "Skrýt"
}, sv = {
  registerButtonLabel: "Registrovat",
  registerTitle: "Nemáte účet?",
  whyRegister: {
    list: [
      "Získejte přístup k exkluzivním výhodám klubu Miele",
      "Registrace spotřebičů, sledování objednávek, přístup k návodům",
      "Získejte individuální nabídky a akce",
      "Podívejte se na všechny své objednávky, záruky, události a služby"
    ],
    title: "Proč se registrovat?"
  },
  closeButtonLabel: "Zavřít",
  passwordMismatchError: "Hesla se neshodují",
  passwordUpdateErrorTitle: "Chyba aktualizace hesla",
  passwordUpdateSuccessTitle: "Heslo aktualizováno",
  successfulChangeLabel: "Vaše heslo bylo úspěšně aktualizováno"
}, ov = {
  title: "Marketingové preference",
  description: "Zaškrtnutím níže získáte exkluzivní nabídky, novinky, události a způsob, jak ze svého spotřebiče vytěžit maximum.",
  submit: "Uložit",
  levelOne: {
    shortText: 'Ano, chci dostávat marketingová sdělení od společností Miele, spol. s r.o.a Miele & Cie. KG ("Miele") přizpůsobená mým osobním zájmům prostřednictvím e-mailu, textových zpráv, webové stránky, pošty a aplikací Miele (pokud je používám)',
    text: `Ano, chci dostávat marketingová sdělení od společností Miele, spol. s r.o.a Miele & Cie. KG ("Miele") přizpůsobená mým osobním zájmům prostřednictvím e-mailu, textových zpráv, webové stránky, pošty a aplikací Miele (pokud je používám) s informacemi o výrobcích, nabídkách a novinkách ze sortimentu Miele a o akcích Miele, jakož i o průzkumech mezi zákazníky, žádostech o hodnocení a recenze výrobků a receptech. K tomuto účelu může Miele použít mé kontaktní údaje (titul, jméno, e-mailovou adresu, číslo mobilního telefonu a poštovní adresu) a navrhnout komunikaci na základě mých nákupů, služeb, historie událostí, chování při kliknutí na newsletter a jeho otevření, jakož i hodnoty zákazníka, jak je podrobně popsáno v našich zásadách ochrany osobních údajů. Svůj souhlas mohu kdykoli odvolat bez udání důvodu s účinností do budoucna (např. zasláním neformální zprávy na adresu info{'@'}miele.cz, kontaktními údaji uvedenými v tiráži nebo kliknutím na odhlašovací odkaz v e-mailech).`,
    link: {
      title: "Zásadách ochrany osobních údajů",
      ref: "https://www.miele.cz/c/ochrana-osobnich-udaju-14.htm"
    }
  },
  levelTwo: {
    text: "Kromě mého základního souhlasu souhlasím s tím, že společnost Miele může zpracovávat také údaje z používání aplikace Miele a z mých návštěv webových stránek Miele (www.miele.cz ), včetně chování uživatele na webových stránkách Miele po kliknutí na propojený newsletter, za účelem doplnění mého uživatelského profilu pro personalizovaná reklamní sdělení, pokud můj samostatný souhlas v aplikaci nebo na webové stránce povoluje zpracování údajů. Svůj souhlas mohu kdykoli odvolat bez udání důvodů s účinností do budoucna. Další podrobnosti najdete v zásadách ochrany osobních údajů společnosti Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Kromě mého základního souhlasu souhlasím s tím, že společnost Miele může zpracovávat také údaje z mých připojených spotřebičů Miele (údaje o používání a stavu spotřebičů) za účelem doplnění mého uživatelského profilu pro personalizovanou reklamu. Další informace o zpracování údajů o přístrojích naleznu v zásadách ochrany osobních údajů o systému Miele{'@'}Home. Svůj souhlas mohu kdykoli odvolat bez udání důvodů s účinností do budoucna. Další podrobnosti najdete v zásadách ochrany osobních údajů společnosti Miele.",
    link: {
      title: "Miele{'@'}Home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Svůj souhlas mohu kdykoli bez udání důvodů odvolat s účinkem do budoucna.  ",
    link: {
      title: "Zásady ochrany údajů",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Ano, souhlasím s podmínkami použití.",
    link: {
      title: "Viz Podmínky použití*",
      ref: ""
    }
  }
}, rv = {
  headline: "Miele Club",
  birthDateTitle: "Chtěli byste dostat narozeninové překvapení?",
  birthDateLabel: "Vaše datum narození (volitelné)",
  why: {
    title: "Bezplatné členství – Exkluzivní nabídky pro členy.",
    reasons: [
      "Uvítací voucher",
      "Narozeninové překvapení",
      "Speciální nabídky",
      "Pozvánky na exkluzivní akce a zážitky"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Zadejte prosím tento formát data: DD/MM/RRRR",
    errorMsg: "Nesprávné datum"
  },
  joinClubLabel: "Ano, rád bych se stal členem Miele Club.",
  termsAndCondition: {
    description: "Souhlasím s podmínkami klubu Miele {termsAndConditionLink} a beru na vědomí {privacyLink} informace týkající se klubu Miele.",
    termsAndConditionLink: {
      title: "Podmínky užívání",
      ref: "https://www.miele.cz/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Ochrana dat",
      ref: "https://www.miele.cz/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Ano, rád(a) bych dostával(a) propagační komunikaci klubu Miele, přizpůsobenou mým osobním zájmům, e-mailem a poštou",
    description: "Ano, rád(a) bych dostával(a) propagační komunikaci klubu Miele, přizpůsobenou mým osobním zájmům, e-mailem a poštou zahrnující speciální nabídky, informace, pozvánky na akce a zákaznické průzkumy o produktech a službách Miele. Za tímto účelem může Miele použít mé kontaktní údaje (tituly, jméno, e-mailovou a poštovní adresu) a upravit komunikaci na základě mého nákupního a newsletterového chování i mé zákaznícké hodnoty, jak je podrobněji popsáno v našich {privacyLink}. Svůj souhlas mohu kdykoli odvolat s účinností do budoucna (například zasláním e-mailu na info{'@'}miele.cz, kontaktováním prostřednictvím kontaktních údajů uvedených v právním oznámení nebo kliknutím na odkaz pro odhlášení v e-mailech). Smluvní komunikace klubu Miele {termsAndConditionLink} tím nejsou ovlivněny, pokud neukončím své členství.",
    privacyLink: {
      title: "Ochrana dat klubu Miele",
      href: "https://www.miele.cz/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Komunikace klubu",
      href: "https://www.miele.cz/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.cz"
  },
  selectAllConsents: {
    description: "Pro vstup do Miele Clubu musíte souhlasit se všemi podmínkami *"
  }
}, lv = "vis hele erklæringen", cv = "vis mindre", dv = {
  auth: Zg,
  changeEmailScene: Yg,
  changePasswordScene: Xg,
  errors: Qg,
  forgotPassword: ev,
  login: tv,
  modal: iv,
  passwordStrength: nv,
  passwordHelper: av,
  register: sv,
  "marketing-consent": {
    title: "Marketingové preference",
    description: "Zaškrtnutím níže získáte exkluzivní nabídky, novinky, události a způsob, jak ze svého spotřebiče vytěžit maximum.",
    submit: "Uložit",
    newsletter: {
      text: 'Souhlasím s tím, že mi Miele, spol. s r.o. ("Miele") může zasílat informace o produktech, novinkách a akcích Miele, jakož i zákaznické průzkumy a recepty prostřednictvím e-mailu, aplikace Miele a SMS a že Miele může zpracovávat kontaktní údaje, které jsem uvedl (titul, jméno, e-mailová adresa, číslo mobilního telefonu a PSČ) a produkty Miele, které jsem dosud zakoupil a zakoupím v budoucnu, jakož i zájmy, které jsem pro tento účel uvedl. Dále souhlasím s tím, že Miele může za účelem personalizace zpracovávat také potvrzení o přijetí a přečtení přijatá prostřednictvím newsletteru a informace o odkazech, na které jsem klikl, a také o mém souvisejícím uživatelském chování na odkazovaném webu. Totéž platí pro push notifikace v aplikaci Miele.',
      link: {
        title: "Viz zásady ochrany dat",
        ref: ""
      }
    },
    personalisation: {
      text: "Souhlasím s tím, že Miele může zpracovávat informace o službách, které jsem využil, a úkolech techniků, které jsem provedl, a také o akcích, kterých jsem se zúčastnil, za účelem lepší personalizace.",
      link: {
        title: "Viz zásady ochrany dat",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Kromě rozšířené personalizace souhlasím s tím, že Miele může také zpracovávat údaje z používání aplikace Miele a mých návštěv na webových stránkách Miele (www.miele.cz) za účelem doplnění mého uživatelského profilu, pokud jsem k tomu dal samostatný souhlas. ",
      link: {
        title: "Viz zásady ochrany dat",
        ref: ""
      }
    },
    highlightedText: {
      text: "Svůj souhlas mohu kdykoli bez udání důvodů odvolat s účinkem do budoucna.  ",
      link: {
        title: "Zásady ochrany údajů",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Ano, souhlasím s podmínkami použití.",
      link: {
        title: "Viz Podmínky použití*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: ov,
  mieleClub: rv,
  readMore: lv,
  readLess: cv
}, uv = {
  waitMessage: "Aproape acolo. "
}, mv = {
  buttonLabel: "Salvați",
  buttonLabelClose: "Închide",
  confirmEmailMessage: "Confirmați-vă adresa de e-mail",
  copy: "Pentru a vă actualiza adresa de e-mail, adăugați-o pe cea nouă mai jos:",
  errorMessageCopy: "Ceva nu a mers bine. ",
  errorMessageHeadline: "Eroare",
  headline: "Detalii profil",
  inputEmailConfirmPlaceholder: "Confirmați adresa dumneavoastră de email",
  inputEmailPlaceholder: "Adresa de e-mail",
  invalidEmailMessage: "E-mail nu este valabil!",
  rememberMeLabel: "Ține-mă minte",
  successMessageCopy: "Adresa dvs. de e-mail a fost actualizată cu succes.",
  successMessageHeadline: "Adresă de e-mail actualizată"
}, pv = {
  closeButtonLabel: "Închide",
  confirmPasswordLabel: "Confirmă parola",
  currentPasswordLabel: "Parola actuală",
  newPasswordLabel: "Parolă nouă",
  passwordMismatchError: "Parola nu se potriveste",
  passwordUpdateErrorTitle: "Eroare",
  passwordUpdateSuccessTitle: "Parolă actualizată",
  samePasswordError: "Această parolă a fost folosită anterior, vă rugăm să trimiteți o nouă parolă",
  subtitle: "Pentru a vă schimba parola, vă rugăm să completați câmpurile de mai jos:",
  submitButtonLabel: "Trimite",
  successfulChangeLabel: "Parola dvs. a fost actualizată cu succes",
  title: "Schimbarea parolei"
}, hv = {
  invalidEmail: "email incorect",
  invalidPassword: "Parola greşită",
  sap_206002: "Contul dvs. este în așteptarea verificării, nu vă putem lăsa să continuați în acest moment. ",
  sap_206006: "Se pare că adresa de e-mail pe care ați trimis-o este în așteptarea verificării",
  sap_400003: "Acest e-mail există deja, vă rugăm să utilizați o altă adresă de e-mail.",
  sap_400028: "Adresa de e-mail trimisă este în așteptarea verificării",
  sap_400050: "Ne pare rău, nu putem să vă validăm acreditările în acest moment.",
  sap_400097: "Se pare că accesați serviciile noastre dintr-un browser nesigur/neacceptat. Vă rugăm să încercaţi din nou pe un alt browser. ",
  sap_401030: "Această parolă a fost folosită anterior, vă rugăm să trimiteți o nouă parolă",
  sap_403005: "Nu avem un cont asociat cu această adresă de e-mail, vă rugăm să vă verificați e-mailul și să încercați din nou",
  sap_403011: "Sesiunea a expirat. Vă rugăm să reîncărcați browserul și să vă conectați din nou. ",
  sap_403012: "Sesiunea a expirat. Vă rugăm să reîncărcați browserul și să vă conectați din nou.",
  sap_403013: "Ne pare rău, nu putem să vă validăm acreditările în acest moment.",
  sap_403035: "Ne pare rău, nu putem să vă validăm acreditările în acest moment.",
  sap_403041: "Nu avem un cont asociat cu această adresă de e-mail, vă rugăm să vă verificați e-mailul și să încercați din nou",
  sap_403042: "Combinația de e-mail și parolă nu este validă. Verificați adresa de e-mail asociată contului sau alegeți parola uitată dacă doriți să o resetați.",
  sap_403043: "Combinația de e-mail și parolă nu este validă. Verificați adresa de e-mail asociată contului sau alegeți parola uitată dacă doriți să o resetați.",
  sap_403047: "Combinația de e-mail și parolă nu este validă. Verificați adresa de e-mail asociată contului sau alegeți parola uitată dacă doriți să o resetați.",
  sap_403100: "Recent a fost solicitată actualizarea parolei, vă rugăm să asteptaţi până când cererea este procesată",
  sap_403025: "Linkul de resetare a parolei este invalid, vă rugăm să trimiteți din nou cererea de resetare a parolei pentru a primi un nou link de resetare.",
  sapErrorTitle: "Eroare la procesarea cererii",
  sessionExpired: "Sesiunea a expirat",
  tooWeakPassword: "Parola trebuie să conțină cel puțin {minLength} caractere și {minCharGroups} dintre următoarele: literă mare, literă mică, număr, simbol special | Parola trebuie să conțină cel puțin {minLength} caractere",
  unexpectedDescription: "Dacă problema persistă, vă rugăm să ne contactați prin formularul de contact cu detalii.",
  unexpectedTitle: "A apărut o eroare neașteptată",
  unknownDescription: "A apărut o eroare neașteptată. Vă rugăm să încercaţi din nou. ",
  unknownTitle: "Uh Oh!"
}, gv = {
  subtitle: "Setează-ți noua parolă.",
  title: "Ați uitat parola?"
}, vv = {
  headMetaDescription: "Pagina de conectare a clientului",
  headTitle: "Conectați-vă cu adresa dvs. de e-mail și parola:",
  subtitle: "Conectați-vă sau creaţi un cont pentru a beneficia de toate funcțiile Miele.",
  title: "conectați-vă la contul dvs.",
  error: {
    invalidEmailPasswordDescription: "Combinația dintre adresa de e-mail și parola nu este validă.",
    invalidEmailPasswordTitle: "Acreditări nevalide",
    missingConcentTitle: "Cont în așteptarea înregistrării",
    noAccountDescription: "Nu există niciun cont asociat acestei adrese de e-mail.",
    noAccountTitle: "Niciun cont înregistrat"
  },
  extraConsentScene: {
    continue: "Continua",
    privacyStatementCheckboxLabel: "Am luat notă de {0}.",
    privacyStatementName: "Declarație de confidențialitate",
    privacyStatementTitle: "Politica noastră de confidențialitate s-a schimbat",
    termsOfUseCheckboxLabel: "Sunt de acord cu {0}.",
    termsOfUseName: "termeni de utilizare",
    termsOfUseTitle: "Termenii noștri de utilizare s-au modificat",
    title: "Finalizarea profilului"
  },
  forgotPasswordScene: {
    backButtonLabel: "Înapoi la autentificare",
    submitButtonLabel: "Trimite",
    successDescription: "Vă rugăm să vă verificați e-mailul, veți primi în curând informațiile despre contul dvs. pentru a începe procesul de resetare a parolei.",
    successTitle: "Cererea dvs. a fost primită.",
    title: "Vă rugăm să introduceți adresa de e-mail pentru a vă reseta parola:"
  },
  loginModalScene: {
    copy: "Conectați-vă sau creaţi un cont pentru a beneficia de toate funcțiile Miele.",
    title: "conectați-vă la contul dvs."
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Mi-am uitat parola",
    invalidEmailMessage: "E-mail nu este valabil!",
    loginButtonLabel: "Log in",
    passwordInputLabel: "Parola",
    rememberMeLabel: "Ține-mă minte",
    title: "Conectați-vă cu adresa dvs. de e-mail și parola:"
  }
}, fv = {
  accessibility: {
    close: "Închide"
  }
}, kv = {
  tooShort: "Prea scurtă",
  medium: "Mediu",
  strong: "Puternic",
  tooWeak: "Prea slab",
  veryStrong: "Foarte puternic",
  weak: "Slab"
}, bv = {
  showPasswordText: "Arată",
  hidePasswordText: "Ascunde"
}, wv = {
  registerButtonLabel: "Înregistrează-te",
  registerTitle: "Nu aveţi un cont?",
  whyRegister: {
    list: [
      "Acces la beneficiile exclusive Miele Club",
      "Înregistrați aparatele, urmăriți comenzile, accesați manuale",
      "Primiți oferte și promoții personalizate",
      "Vedeți toate comenzile, garanțiile, evenimentele și serviciile dvs"
    ],
    title: "De ce să te înregistrezi?"
  },
  closeButtonLabel: "Închide",
  passwordMismatchError: "parola nu se potriveste",
  passwordUpdateErrorTitle: "Eroare de actualizare a parolei",
  passwordUpdateSuccessTitle: "Parolă actualizată",
  successfulChangeLabel: "Parola dvs. a fost actualizată cu succes"
}, yv = {
  title: "Preferințe de marketing",
  description: "Bifați mai jos pentru oferte exclusive, noutăţi, evenimente și cum să profitați la maximum de aparatul dvs.",
  submit: "Salvați",
  levelOne: {
    shortText: 'Da, aș dori să primesc comunicări promoționale de la Miele Appliances S.R.L. și Miele & Cie. KG ("Miele") adaptate intereselor mele personale prin e-mail, mesaj text, poștă și prin aplicațiile și site-urile web Miele (dacă sunt utilizate)',
    text: `Da, aș dori să primesc comunicări promoționale de la Miele Appliances S.R.L. și Miele & Cie. KG ("Miele") adaptate intereselor mele personale prin e-mail, mesaj text, poștă și prin aplicațiile și site-urile web Miele (dacă sunt utilizate) cu informații despre produse, oferte și inovații din gama de produse Miele și despre evenimentele Miele, precum și cu sondaje de opinie pentru clienți, solicitări de evaluare și recenzii ale produselor, și rețete. În acest scop, Miele poate utiliza informațiile mele de contact (titlu, nume, adresă de e-mail, număr de telefon mobil și adresă poștală) și poate concepe comunicarea în funcție de achiziția mea, servicii, istoricul evenimentelor, comportamentul de click și deschidere a newsletter-ului, precum și a valoriii pentru client, așa cum este descris în detaliu în politica noastră de confidențialitate. Îmi pot revoca consimțământul în orice moment, fără a oferi motive, cu efect pentru viitor (de exemplu, prin trimiterea unui mesaj informal la news{'@'}miele.ro, la datele de contact indicate în subsolul paginii sau făcând click pe link-ul de dezabonare din e-mailuri).`,
    link: {
      title: "Protecția datelor",
      ref: "https://www.miele.ro/c/protectia-datelor-14.htm"
    }
  },
  levelTwo: {
    text: "În plus față de consimțământul meu de bază, sunt de acord că Miele poate, de asemenea, să prelucreze date din utilizarea aplicației Miele și din vizitele mele pe site-urile Miele (www.miele.ro), inclusiv comportamentul utilizatorului pe site-urile Miele după clickurile pe newsletter-ul legat, pentru a completa profilul meu de utilizator pentru comunicări publicitare personalizate, cu condiția ca consimțământul meu separat în aplicație sau pe site să autorizeze prelucrarea datelor. Îmi pot revoca consimțământul în orice moment, fără a oferi motive, cu efect pentru viitor. Mai multe detalii în politica de protecție a datelor a Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: " În plus față de consimțământul meu de bază, sunt de acord că Miele poate, de asemenea, să prelucreze date de la aparatele mele Miele conectate (date privind utilizarea și starea aparatului) pentru a completa profilul meu de utilizator pentru publicitate personalizată. Pot găsi mai multe informații despre prelucrarea datelor aparatelor în politica de confidențialitate privind sistemul Miele{'@'}Home. Îmi pot revoca consimțământul în orice moment, fără a da motive, cu efect pentru viitor. Mai multe detalii în politica de protecție a datelor a Miele.",
    link: {
      title: "Miele{'@'}Home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "Îmi pot revoca consimțământul în orice moment, fără a oferi motive cu efect pentru viitor. Pentru mai multe informații despre modul în care Miele gestionează datele dvs., consultați  ",
    link: {
      title: "politica de protectie a datelor.",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Da, sunt de acord cu termenii de utilizare.",
    link: {
      title: "Consultați Termenii de utilizare*",
      ref: ""
    }
  }
}, Mv = {
  headline: "Miele Club",
  why: {
    title: "Membru",
    reasons: "Surpriză cu ocazia zilei de naștereOferte și campanii exclusive"
  },
  birthDateTitle: "Vă putem trimite un cadou de ziua de naștere?",
  birthDateValidation: {
    requirementMsg: "Utilizați un format precum LL/ZZ/AAAA",
    errorMsg: "Dată invalidă"
  },
  joinClubLabel: "Da, vreau să mă alătur clubului Miele.",
  termsAndCondition: {
    description: "Devenind membru al Clubului Miele, sunteți de acord cu termenii și condițiile Clubului Miele.",
    termsAndConditionLink: {
      title: "Termenii și condițiile",
      ref: "https://www.miele.ro/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Protecția datelor cu caracter personal",
      ref: "https://www.miele.ro/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    description: "Da, vreau să devin membru al Clubului Miele și să primesc comunicări din Clubul Miele (cadou de bun venit, surpriză de ziua de naștere, reformulare a statutului de membru, știri despre Clubul Miele) prin e-mail.",
    shortDescription: "Da, aș dori să primesc comunicări promoționale de la Clubul Miele, adaptate intereselor mele personale, prin e-mail și poștă",
    privacyLink: {
      title: "Protecția datelor Clubului Miele",
      href: "https://www.miele.ro/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Comunicare Club",
      href: "https://www.miele.ro/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.ro"
  },
  selectAllConsents: {
    description: "Pentru a deveni membru al Clubului Miele, trebuie să acceptați toți termenii și condițiile *"
  },
  birthDateLabel: "Data ta de naștere (opțional)"
}, zv = "arată declarația completă", jv = "ascunde declarația completă", _v = {
  auth: uv,
  changeEmailScene: mv,
  changePasswordScene: pv,
  errors: hv,
  forgotPassword: gv,
  login: vv,
  modal: fv,
  passwordStrength: kv,
  passwordHelper: bv,
  register: wv,
  "marketing-consent": {
    title: "Preferințe de marketing",
    description: "Bifați mai jos pentru oferte exclusive, noutăţi, evenimente și cum să profitați la maximum de aparatul dvs.",
    submit: "Salvați",
    newsletter: {
      text: 'Sunt de acord ca Miele Co Ltd. ("Miele") să îmi trimită informaţii despre produse şi despre inovaţiile din gama de produse Miele, despre evenimente, despre sondaje şi reţete pe adresa de e-mail, aplicaţiile Miele şi prin SMS, şi că Miele poate procesa datele de contact pe care le-am furnizat (titlu, nume, adresa de e-mail, număr de telefon mobil și cod poștal) și produsele Miele pe care le-am achiziționat până în prezent și pe care le voi achiziționa în viitor, precum și interesele pe care le-am indicat în acest scop. De asemenea, sunt de acord că Miele poate procesa primirea și confirmările primite prin newsletter și informații despre linkurile pe care am făcut click, precum și despre comportamentul meu de utilizator al site-ul web în scopul personalizării serviciilor.  Același lucru este valabil și pentru mesajele push din aplicație, în măsura în care sunt utilizate aplicațiile Miele.',
      link: {
        title: "Consultați politica de protecție a datelor",
        ref: ""
      }
    },
    personalisation: {
      text: "Sunt de acord ca Miele să prelucreze informații despre serviciile pe care le-am folosit și despre asistenţa tehnicienilor de care am beneficiat, precum și despre evenimentele la care am participat, în scopul îmbunătăţirii serviciilor",
      link: {
        title: "Consultați politica de protecție a datelor",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Pe lângă personalizarea extinsă, sunt de acord că Miele poate prelucra și date din utilizarea aplicației Miele și vizitele mele pe site-ul web Miele (www.miele.ro) pentru a-mi suplimenta profilul de utilizator, cu condiția să fiu de acord separat. ",
      link: {
        title: "Consultați politica de protecție a datelor",
        ref: ""
      }
    },
    highlightedText: {
      text: "Îmi pot revoca consimțământul în orice moment, fără a oferi motive cu efect pentru viitor. Pentru mai multe informații despre modul în care Miele gestionează datele dvs., consultați  ",
      link: {
        title: "politica de protectie a datelor.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Da, sunt de acord cu termenii de utilizare.",
      link: {
        title: "Consultați Termenii de utilizare.",
        ref: "https://www.miele.ro/c/termeni-si-conditii-generale-13.htm"
      }
    }
  },
  multiLevelMarketingConsent: yv,
  mieleClub: Mv,
  readMore: zv,
  readLess: jv
}, Sv = {
  waitMessage: "Još samo malo... "
}, Cv = {
  buttonLabel: "Pohraniti",
  buttonLabelClose: "Zatvoriti",
  confirmEmailMessage: "Potvrdite svoju e-mail adresu",
  copy: "Da biste ažurirali svoju adresu e-pošte, molimo dodajte novu u nastavku:",
  errorMessageCopy: "Nešto je pošlo po zlu. Molimo pokušajte ponovno. ",
  errorMessageHeadline: "Greška",
  headline: "Pojedinosti o profilu",
  inputEmailConfirmPlaceholder: "Potvrdite svoju adresu e-pošte",
  inputEmailPlaceholder: "Adresa e-pošte",
  invalidEmailMessage: "E-pošta nije valjana!",
  rememberMeLabel: "Zapamti me",
  successMessageCopy: "Vaša adresa e-pošte je uspješno ažurirana.",
  successMessageHeadline: "Adresa e-pošte ažurirana"
}, Lv = {
  closeButtonLabel: "Zatvoriti",
  confirmPasswordLabel: "Potvrditi zaporku",
  currentPasswordLabel: "Trenutna zaporka",
  newPasswordLabel: "Nova zaporka",
  passwordMismatchError: "Zaporka se ne podudara",
  passwordUpdateErrorTitle: "Greška",
  passwordUpdateSuccessTitle: "Zaporka ažurirana",
  samePasswordError: "Ova zaporka je već korištena ranije, molimo pošaljite novu zaporku",
  subtitle: "Za promjenu zaporke molimo ispunite polja niže:",
  submitButtonLabel: "Podnijeti",
  successfulChangeLabel: "Vaša zaporka je uspješno ažurirana",
  title: "Promjena zaporke"
}, Ev = {
  invalidEmail: "Netočna e-pošta",
  invalidPassword: "Pogrešna zaporka",
  sap_206002: "Vaš račun čeka potvrdu, na žalost trenutno ne možete nastaviti. ",
  sap_206006: "Čini se da adresa e-pošte koju ste poslali čeka potvrdu",
  sap_400003: "Ova adresa e-pošte već postoji, molimo upotrijebite drugu adresu e-pošte.",
  sap_400028: "Poslana adresa e-pošte čeka potvrdu",
  sap_400050: "Nažalost, trenutno ne možemo potvrditi Vaše vjerodajnice.",
  sap_400097: "Čini se da našim uslugama pristupate iz nesigurnog/nepodržanog preglednika. ",
  sap_401030: "Ova zaporka je već korištena ranije, molimo pošaljite novu zaporku",
  sap_403005: "Nemamo račun povezan s ovom adresom e-pošte, provjerite svoju e-poštu i pokušajte ponovno",
  sap_403011: "Vrijeme isteklo. Molimo ponovno učitajte preglednik i ponovno se prijavite.",
  sap_403012: "Vrijeme isteklo. Molimo ponovno učitajte preglednik i ponovno se prijavite.",
  sap_403013: "Ispričavamo se, trenutno ne možemo potvrditi Vaše vjerodajnice.",
  sap_403035: "Ispričavamo se, trenutno ne možemo potvrditi Vaše vjerodajnice.",
  sap_403041: "Nemamo račun povezan s ovom adresom e-pošte, molimo provjerite svoju e-poštu i pokušajte ponovno",
  sap_403042: 'Kombinacija e-pošte i zaporke nije važeća. Provjerite e-poštu povezanu s računom ili odaberite "Zaboravili ste zaporku" ako je želite poništiti.',
  sap_403043: 'Kombinacija e-pošte i zaporke nije važeća. Provjerite e-poštu povezanu s računom ili odaberite "Zaboravili ste zaporku" ako je želite poništiti.',
  sap_403047: 'Kombinacija e-pošte i zaporke nije važeća. Provjerite e-poštu povezanu s računom ili odaberite "Zaboravili ste zaporku" ako je želite poništiti.',
  sap_403100: "Nedavno je zatražen zahtjev za ažuriranje zaporke, molimo za strpljenje dok se zahtjev ne obradi",
  sap_403025: "Veza za poništavanje lozinke nije važeća, pošaljite ponovno zahtjev za zaboravljenu lozinku kako biste primili novu vezu za poništavanje.",
  sapErrorTitle: "Greška u obradi zahtjeva",
  sessionExpired: "Vrijeme isteklo",
  tooWeakPassword: "Zaporka mora sadržavati najmanje {minLength} znakova i {minCharGroups} od sljedećeg: veliko slovo, malo slovo, broj, poseban simbol | Zaporka mora sadržavati najmanje {minLength} znakova",
  unexpectedDescription: "Ako problem potraje, kontaktirajte nas putem obrasca za kontakt s detaljima.",
  unexpectedTitle: "Došlo je do neočekivane greške",
  unknownDescription: "Došlo je do neočekivane greške. ",
  unknownTitle: "Uh oh!"
}, Pv = {
  subtitle: "Postavite novu zaporku.",
  title: "Zaboravili ste zaporku?"
}, Tv = {
  headMetaDescription: "Stranica za prijavu korisnika",
  headTitle: "Prijavite se svojom e-poštom i zaporkom:",
  subtitle: "Prijavite se ili izradite račun kako biste dobili sve Miele značajke.",
  title: "Prijavite se na svoj račun",
  error: {
    invalidEmailPasswordDescription: "Kombinacija adrese e-pošte i zaporke nije važeća.",
    invalidEmailPasswordTitle: "Nevažeće vjerodajnice",
    missingConcentTitle: "Račun na čekanju za registraciju",
    noAccountDescription: "Ne postoji račun povezan s ovom adresom e-pošte.",
    noAccountTitle: "Nema registriranog računa"
  },
  extraConsentScene: {
    continue: "Nastaviti",
    privacyStatementCheckboxLabel: "Primljeno na znanje {0}.",
    privacyStatementName: "Izjava o privatnosti",
    privacyStatementTitle: "Naša Pravila o privatnosti su promijenjena",
    termsOfUseCheckboxLabel: "Slažem se s {0}.",
    termsOfUseName: "Uvjeti korištenja",
    termsOfUseTitle: "Naši Uvjeti korištenja su promijenjeni",
    title: "Završetak profila"
  },
  forgotPasswordScene: {
    backButtonLabel: "Natrag na prijavu",
    submitButtonLabel: "Podnijeti",
    successDescription: "Provjerite svoju e-poštu, uskoro ćete dobiti informacije o svom računu kako biste započeli s postupkom ponovnog postavljanja zaporke.",
    successTitle: "Vaš zahtjev je zaprimljen.",
    title: "Molimo unesite svoju adresu e-pošte za poništavanje zaporke:"
  },
  loginModalScene: {
    copy: "Prijavite se ili izradite račun kako biste dobili sve Miele značajke.",
    title: "Prijavite se na svoj račun"
  },
  loginScene: {
    emailInputLabel: "E-pošta",
    forgotPwdButtonLabel: "Zaboravila/o sam lozinku",
    invalidEmailMessage: "E-pošta nije valjana!",
    loginButtonLabel: "Prijava",
    passwordInputLabel: "Zaporka",
    rememberMeLabel: "Zapamti me",
    title: "Prijavite se sa svojom e-poštom i zaporkom:"
  }
}, Av = {
  accessibility: {
    close: "Zatvoriti"
  }
}, xv = {
  tooShort: "Prekratka",
  medium: "Srednja",
  strong: "Jaka",
  tooWeak: "Preslaba",
  veryStrong: "Vrlo jaka",
  weak: "Slaba"
}, Iv = {
  showPasswordText: "Prikazati",
  hidePasswordText: "Sakriti"
}, Dv = {
  registerButtonLabel: "Registracija",
  registerTitle: "Nemate račun?",
  whyRegister: {
    list: [
      "Pristup ekskluzivnim pogodnostima Miele Cluba",
      "Registrirajte uređaje, pratite narudžbe, pristupite priručnicima",
      "Primajte prilagođene ponude i promocije",
      "Pogledajte sve svoje narudžbe, jamstva, događaje i usluge"
    ],
    title: "Zašto se registrirati?"
  },
  closeButtonLabel: "Zatvoriti",
  passwordMismatchError: "Zaporke se ne podudaraju",
  passwordUpdateErrorTitle: "Pogreška ažuriranja zaporke",
  passwordUpdateSuccessTitle: "Zaporka ažurirana",
  successfulChangeLabel: "Vaša zaporka je uspješno ažurirana"
}, Nv = {
  title: "Marketinške postavke",
  description: "Označite niže za ekskluzivne ponude, novosti, događaje i kako najbolje iskoristiti svoj uređaj.",
  submit: "Pohraniti",
  levelOne: {
    shortText: "Da, želim da mi Miele d.o.o. i Miele & Cie. KG („Miele“) šalju reklamne poruke prilagođene mojim osobnim interesima putem e-pošte, obične pošte, SMS-a i putem Miele aplikacija i internetskih stranica (ako ih koristim),",
    text: "Da, želim da mi Miele d.o.o. i Miele & Cie. KG („Miele“) šalju reklamne poruke prilagođene mojim osobnim interesima putem e-pošte, obične pošte, SMS-a i putem Miele aplikacija i internetskih stranica (ako ih koristim), s informacijama o Miele proizvodima, ponudama i novostima, kao i događajima, anketama kupaca, zahtjevima za ocjenama i mišljenjima o proizvodima i receptima. U tu svrhu Miele može koristiti moje kontakt podatke (titulu, ime, adresu e-pošte, broj mobitela i poštansku adresu) i prilagođavati poruke na temelju moje povijesti kupnje, posjećivanja događaja i korištenja usluge, mog ponašanja pri klikanju i otvaranju te moje vrijednosti za kupca, kako je detaljnije opisano u našim informacijama o zaštiti podataka. Svoju privolu mogu opozvati u bilo kojem trenutku s učinkom za budućnost (npr. slanjem neformalne poruke na info{'@'}miele.hr, na kontakt podatke navedene u pravnoj obavijesti ili klikom na poveznicu za odjavu u e-porukama).",
    link: {
      title: "Zaštita podataka",
      ref: "https://www.miele.hr/c/zastita-podataka-14.htm"
    }
  },
  levelTwo: {
    text: "Uz moj osnovni pristanak, slažem se da Miele također može koristiti podatke iz korištenja Miele aplikacije i mojih posjeta Miele internetskim stranicama (www.miele.hr), uključujući ponašanje korisnika na temelju otvaranja poveznica sadržanih u newsletterima na Miele internetske stranice, za dopunu mog korisničkog profila za personaliziranu oglašivačku komunikaciju, pod uvjetom da moja posebna suglasnost u aplikaciji ili na internetskoj stranici omogućuje obradu podataka. Svoj pristanak možete opozvati bilo kada u budućnosti. Više detalja u politici o zaštiti podataka.",
    link: {
      title: "Zaštita podataka.",
      ref: "https://www.miele.hr/c/zastita-podataka-14.htm"
    }
  },
  levelThree: {
    text: "Uz moj osnovni pristanak, slažem se da Miele može obrađivati podatke s mojih povezanih Miele uređaja (podatke o korištenju i statusu uređaja) za dopunu mog korisničkog profila za personalizirano oglašavanje. Dodatne informacije o obradi podataka uređaja mogu se pronaći u izjavi o zaštiti podataka o sustavu Miele{'@'}Home. Svoj pristanak možete opozvati bilo kada s budućim učinkom. Više detalja u politici o zaštiti podataka.",
    link: {
      title: "Zaštita podataka Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Da, slažem se s uvjetima korištenja.",
    link: {
      title: "Pogledajte uvjete korištenja*",
      ref: "https://www.miele.hr/c/uvjeti-koristenja-304.htm"
    }
  }
}, Ov = {
  headline: "Miele klub",
  birthDateTitle: "Možemo li vam poslati rođendanski poklon?",
  birthDateLabel: "Your date of birth (optional)",
  why: {
    title: "Članstvo",
    reasons: [
      "Rođendansko iznenađenje"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Koristite format poput MM/DD/GGGG",
    errorMsg: "Nevažeći datum"
  },
  joinClubLabel: "Da, želim se pridružiti Miele klubu.",
  termsAndCondition: {
    description: "Pristajem na Miele Club {termsAndConditionLink} i potvrđujem {privacyLink} informacije u vezi s Miele Clubom.",
    termsAndConditionLink: {
      title: "Odredbe i uvjeti",
      ref: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Data privacy",
      ref: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Da, želio bih primati promotivnu komunikaciju Miele Cluba, prilagođenu mojim osobnim interesima, putem e-pošte i poštom",
    description: "Da, želio bih primati promotivnu komunikaciju Miele Cluba, prilagođenu mojim osobnim interesima, putem e-pošte i poštom uključujući posebne ponude, informacije, pozivnice na događaje i ankete kupaca o Miele proizvodima i uslugama. U tu svrhu Miele može koristiti moje podatke za kontakt (titula, ime, e-mail i poštanska adresa) i prilagoditi komunikaciju na temelju mog ponašanja pri kupnji i slanju biltena, kao i moje vrijednosti za kupca, kao što je detaljnije opisano u našem {privacyLink}. Svoj pristanak mogu opozvati s učinkom za budućnost u bilo kojem trenutku (na primjer, slanjem e-pošte na info{'@'}miele.co.uk, stupanjem u kontakt putem podataka za kontakt navedenih u pravnoj obavijesti ili klikom na odjavu link u e-porukama). Ovo ne utječe na ugovornu komunikaciju Miele Cluba {termsAndConditionLink} osim ako ne raskinem svoje članstvo.",
    privacyLink: {
      title: "Privatnost podataka Miele Cluba",
      href: "https://www.miele.co.uk/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Klubska komunikacija",
      href: "https://www.miele.co.uk/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.co.uk"
  },
  selectAllConsents: {
    description: "Da biste se pridružili Miele klubu, morate prihvatiti sve uvjete i odredbe *"
  }
}, Uv = "pokazati punu izjavu", $v = "sakrij punu izjavu", Bv = {
  auth: Sv,
  changeEmailScene: Cv,
  changePasswordScene: Lv,
  errors: Ev,
  forgotPassword: Pv,
  login: Tv,
  modal: Av,
  passwordStrength: xv,
  passwordHelper: Iv,
  register: Dv,
  "marketing-consent": {
    title: "Marketinške postavke",
    description: "Označite niže za ekskluzivne ponude, novosti, događaje i kako najbolje iskoristiti svoj uređaj.",
    submit: "Pohraniti",
    newsletter: {
      text: 'Slažem se da mi Miele Co Ltd. ("Miele") može slati informacije o proizvodima i inovacijama iz asortimana Miele proizvoda i o Miele događajima, kao i ankete kupaca i recepte putem e-pošte, Miele aplikacija i SMS-a te da Miele može obraditi podatke za kontakt koje sam dala/o (titula, ime, adresa e-pošte, broj mobilnog telefona i poštanski broj) i Miele proizvode koje sam do sada kupila/o i koje ću kupiti u budućnosti, kao i interese koje sam navela/o u tu svrhu. Nadalje, slažem se da Miele također može obrađivati potvrde o primitku i čitanju primljene putem newsletter-a i informacije o poveznicama na koje sam kliknula/o, kao i moje povezano korisničko ponašanje na povezanoj internetskoj stranici u svrhu personalizacije. Isto vrijedi i za push poruke unutar aplikacije, ukoliko se koriste Miele aplikacije.',
      link: {
        title: "Pogledajte politiku zaštite podataka",
        ref: ""
      }
    },
    personalisation: {
      text: "Slažem se da Miele može obrađivati ​​informacije o uslugama koje sam koristila/o i tehničkim zadacima koje sam izvršila/o, kao i o događajima kojima sam prisustvovala/o, u svrhu poboljšane personalizacije.",
      link: {
        title: "Pogledajte politiku zaštite podataka",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Pored proširene personalizacije, suglasna/an sam da Miele također može obrađivati ​​podatke iz korištenja Miele aplikacije i mojih posjeta Miele internetskim stranicama (www.miele.hr) kako bi dopunio moj korisnički profil, pod uvjetom da sam zasebno pristao na obradu navedenih podataka",
      link: {
        title: "Pogledajte politiku zaštite podataka",
        ref: ""
      }
    },
    highlightedText: {
      text: "Svoj pristanak mogu opozvati u bilo kojem trenutku bez navođenja razloga s učinkom za budućnost.  ",
      link: {
        title: "politika zaštite podataka.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Da, slažem se s uvjetima korištenja.",
      link: {
        title: "Pogledajte uvjete korištenja*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: Nv,
  mieleClub: Ov,
  readMore: Uv,
  readLess: $v
}, Rv = {
  waitMessage: "Już prawie! Poczekaj jeszcze chwilę... "
}, Fv = {
  buttonLabel: "Zapisz",
  buttonLabelClose: "Zamknij",
  confirmEmailMessage: "Potwierdź swój adres e-mail",
  copy: "Aby zaktualizować swój adres e-mail, dodaj nowy poniżej:",
  errorMessageCopy: "Coś poszło nie tak. ",
  errorMessageHeadline: "Błąd",
  headline: "szczegóły profilu",
  inputEmailConfirmPlaceholder: "Potwierdź adres e-mail",
  inputEmailPlaceholder: "Adres e-mail",
  invalidEmailMessage: "Adres e-mail jest nieprawidłowy!",
  rememberMeLabel: "Zapamiętaj mnie",
  successMessageCopy: "Twój adres e-mail został pomyślnie zaktualizowany.",
  successMessageHeadline: "Adres e-mail zaktualizowany"
}, Vv = {
  closeButtonLabel: "Zamknij",
  confirmPasswordLabel: "Potwierdź hasło",
  currentPasswordLabel: "Aktualne hasło",
  newPasswordLabel: "nowe hasło",
  passwordMismatchError: "Hasło nie pasuje",
  passwordUpdateErrorTitle: "Błąd",
  passwordUpdateSuccessTitle: "Hasło zostało zaktualizowane",
  samePasswordError: "To hasło było już używane. Prosimy o podanie nowego hasła",
  subtitle: "Aby zmienić hasło prosimy o wypełnienie poniższych pól:",
  submitButtonLabel: "Wyślij",
  successfulChangeLabel: "Twoje hasło zostało pomyślnie zaktualizowane",
  title: "Zmiana hasła"
}, qv = {
  invalidEmail: "nieprawidłowy email",
  invalidPassword: "Złe hasło",
  sap_206002: "Twoje konto oczekuje na weryfikację. W tej chwili nie możemy pozwolić Ci kontynuować. ",
  sap_206006: "Wygląda na to, że przesłany adres e-mail oczekuje na weryfikację",
  sap_400003: "Ten adres e-mail już istnieje. Użyj innego adresu e-mail.",
  sap_400028: "Podany adres e-mail oczekuje na weryfikację",
  sap_400050: "Przepraszamy, w tej chwili nie możemy zweryfikować Twoich danych uwierzytelniających.",
  sap_400097: "Wygląda na to, że uzyskujesz dostęp do naszych usług za pomocą niezabezpieczonej/nieobsługiwanej przeglądarki. ",
  sap_401030: "To hasło było już używane. Prosimy o podanie nowego hasła",
  sap_403005: "Nie mamy konta powiązanego z tym adresem e-mail. Sprawdź pocztę i spróbuj ponownie",
  sap_403011: "Sesja wygasła. Odśwież przeglądarkę i zaloguj się ponownie. ",
  sap_403012: "Sesja wygasła. Odśwież przeglądarkę i zaloguj się ponownie. ",
  sap_403013: "Przepraszamy, w tej chwili nie możemy zweryfikować Twoich danych uwierzytelniających.",
  sap_403035: "Przepraszamy, w tej chwili nie możemy zweryfikować Twoich danych uwierzytelniających.",
  sap_403041: "Nie mamy konta powiązanego z tym adresem e-mail. Sprawdź pocztę i spróbuj ponownie",
  sap_403042: "Kombinacja adresu e-mail i hasła jest nieprawidłowa. Sprawdź adres e-mail powiązany z kontem lub wybierz opcję zapomniałem hasła, jeśli chcesz je zresetować.",
  sap_403043: "Kombinacja adresu e-mail i hasła jest nieprawidłowa. Sprawdź adres e-mail powiązany z kontem lub wybierz opcję zapomniałem hasła, jeśli chcesz je zresetować.",
  sap_403047: "Kombinacja adresu e-mail i hasła jest nieprawidłowa. Sprawdź adres e-mail powiązany z kontem lub wybierz opcję zapomniałem hasła, jeśli chcesz je zresetować.",
  sap_403100: "Niedawno złożono prośbę o aktualizację hasła. Prosimy o pozostanie z nami do czasu przetworzenia wniosku",
  sap_403025: "Link do resetowania hasła jest nieprawidłowy. Prosimy o ponowne wysłanie prośby o zapomniane hasło, aby otrzymać nowy link do resetowania hasła.",
  sapErrorTitle: "Błąd przetwarzania żądania",
  sessionExpired: "Sesja wygasła",
  tooWeakPassword: "Hasło musi zawierać co najmniej {minLength} znaków i {minCharGroups} z następujących elementów: duża litera, mała litera, cyfra, symbol specjalny | Hasło musi zawierać co najmniej {minLength} znaków",
  unexpectedDescription: "Jeśli problem będzie się powtarzał, skontaktuj się z nami za pośrednictwem formularza kontaktowego.",
  unexpectedTitle: "Wystąpił nieoczekiwany błąd",
  unknownDescription: "Wystąpił nieoczekiwany błąd. ",
  unknownTitle: "O o!"
}, Gv = {
  subtitle: "Ustaw nowe hasło.",
  title: "Nie pamiętasz hasła?"
}, Kv = {
  headMetaDescription: "Strona logowania dla klientów",
  headTitle: "Zaloguj się podając swój adres e-mail i hasło:",
  subtitle: "Zaloguj się lub utwórz konto, aby uzyskać dostęp do wszystkich funkcji Miele.",
  title: "Zaloguj się na swoje konto",
  error: {
    invalidEmailPasswordDescription: "Kombinacja adresu e-mail i hasła jest nieprawidłowa.",
    invalidEmailPasswordTitle: "Nieprawidłowe dane uwierzytelniające",
    missingConcentTitle: "Konto oczekuje na rejestrację",
    noAccountDescription: "Z tym adresem e-mail nie jest powiązane żadne konto.",
    noAccountTitle: "Brak zarejestrowanego konta"
  },
  extraConsentScene: {
    continue: "Kontynuować",
    privacyStatementCheckboxLabel: "Potwierdzam zapoznanie się z {0}.",
    privacyStatementName: "oświadczenie o ochronie prywatności",
    privacyStatementTitle: "Nasza Polityka Prywatności uległa zmianie",
    termsOfUseCheckboxLabel: "Zgadzam się z {0}.",
    termsOfUseName: "Warunki korzystania",
    termsOfUseTitle: "Nasze Warunki korzystania uległy zmianie",
    title: "Uzupełnianie profilu"
  },
  forgotPasswordScene: {
    backButtonLabel: "Powrót do strony logowania",
    submitButtonLabel: "Wyślij",
    successDescription: "Sprawdź swoją skrzynkę e-mail, wkrótce otrzymasz informację o swoim koncie, aby rozpocząć proces resetowania hasła.",
    successTitle: "Twoje zgłoszenie zostało odebrane.",
    title: "Wpisz swój adres e-mail, aby zresetować hasło:"
  },
  loginModalScene: {
    copy: "Zaloguj się lub utwórz konto, aby uzyskać dostęp do wszystkich funkcji Miele.",
    title: "Zaloguj się na swoje konto"
  },
  loginScene: {
    emailInputLabel: "E-mail",
    forgotPwdButtonLabel: "Nie pamiętam hasła",
    invalidEmailMessage: "Adres e-mail jest nieprawidłowy!",
    loginButtonLabel: "Zaloguj sie",
    passwordInputLabel: "Hasło",
    rememberMeLabel: "Zapamiętaj mnie",
    title: "Zaloguj się podając swój adres e-mail i hasło:"
  }
}, Hv = {
  accessibility: {
    close: "Zamknij"
  }
}, Wv = {
  tooShort: "Za krótkie",
  medium: "Średnie",
  strong: "Mocne",
  tooWeak: "Zbyt słabe",
  veryStrong: "Bardzo silne",
  weak: "Słabe"
}, Jv = {
  showPasswordText: "Pokaż",
  hidePasswordText: "Ukryj"
}, Zv = {
  registerButtonLabel: "rejestracja",
  registerTitle: "Nie masz konta?",
  whyRegister: {
    list: [
      "Dostęp do ekskluzywnych korzyści Klubu Miele",
      "Zarejestruj urządzenia, śledź zamówienia, uzyskaj dostęp do instrukcji",
      "Otrzymuj spersonalizowane oferty i promocje",
      "Zobacz wszystkie swoje zamówienia, gwarancje, wydarzenia i usługi"
    ],
    title: "Dlaczego warto się zarejestrować?"
  },
  closeButtonLabel: "Zamknij",
  passwordMismatchError: "Hasła się nie zgadzają",
  passwordUpdateErrorTitle: "Wystąpił błąd podczas aktualizacji hasła",
  passwordUpdateSuccessTitle: "Hasło zaktualizowane",
  successfulChangeLabel: "Twoje hasło zostało pomyślnie zaktualizowane"
}, Yv = {
  title: "Preferencje marketingowe",
  description: 'Nasza obietnica jakości "Zawsze lepiej" dotyczy również konta klienta Miele. Polegaj na odpowiedzialnej obsłudze swoich danych osobowych i uzyskaj dostęp do wszystkich informacji o swoich transakcjach w dowolnym momencie. Do zalogowania wystarczy adres e-mail i hasło. Interesują Cię najnowsze produkty Miele, chciałbyś wziąć udział w ekskluzywnych wydarzeniach Miele lub uwielbiasz gotować? Newsletter Miele dostarcza przydatnej wiedzy ze świata Miele. Aby jeszcze lepiej dopasować treść do Twoich potrzeb, stosujemy personalizację. Chcesz lepiej poznać świat Miele? Z naszymi zaawansowanymi możliwościami personalizacji to możliwe.',
  submit: "Zapisz",
  levelOne: {
    shortText: 'Tak, chcę otrzymywać wiadomości promocyjne od Miele Sp z o.o. i Miele & Cie. KG  ("Miele") dostosowane do moich osobistych zainteresowań pocztą elektroniczną, SMS-em, pocztą tradycyjną i za pośrednictwem aplikacji Miele oraz strony internetowej Miele (jeśli jest używana)',
    text: `Tak, chcę otrzymywać wiadomości promocyjne od Miele Sp z o.o. i Miele & Cie. KG  ("Miele") dostosowane do moich osobistych zainteresowań pocztą elektroniczną, SMS-em, pocztą tradycyjną i za pośrednictwem aplikacji Miele oraz strony internetowej Miele (jeśli jest używana) przez informacje o produktach, ofertach i innowacjach z asortymentu Miele oraz o wydarzeniach Miele, a także  przez ankiety klientów, prośby o ocenę i recenzje produktów oraz przepisy kulinarne. W tym celu Miele może wykorzystywać moje dane kontaktowe (tytuł, imię i nazwisko, adres e-mail, numer telefonu komórkowego i adres pocztowy) i opracowywać komunikację na podstawie moich zakupów, usług, historii wydarzeń, kliknięć i otwarć newslettera, a także wartości  klienta, jak opisano szczegółowo w naszej polityce prywatności. Mogę odwołać swoją zgodę w dowolnym momencie bez podawania przyczyn ze skutkiem na przyszłość (np. wysyłając nieformalną wiadomość na adres info{'@'}miele.pl, dane kontaktowe podane w stopce redakcyjnej lub klikając łącze rezygnacji z subskrypcji w wiadomościach e-mail).`,
    link: {
      title: "Polityka prywatności",
      ref: "https://www.miele.pl/c/polityka-prywatnosci-12.htm"
    }
  },
  levelTwo: {
    text: "Oprócz mojej podstawowej zgody, wyrażam zgodę na przetwarzanie przez Miele danych pochodzących z korzystania z aplikacji Miele i moich wizyt na stronach internetowych Miele (www.miele.pl), w tym zachowania użytkownika na stronach internetowych Miele po kliknięciu w linki z newslettera, w celu uzupełnienia mojego profilu użytkownika na potrzeby spersonalizowanej komunikacji reklamowej, pod warunkiem, że moja oddzielna zgoda w aplikacji lub na stronie internetowej zezwala na przetwarzanie danych. Mogę odwołać swoją zgodę w dowolnym momencie bez podania przyczyny ze skutkiem na przyszłość. Dalsze szczegóły w polityce ochrony danych Miele.",
    link: {
      title: "",
      ref: ""
    }
  },
  levelThree: {
    text: "Oprócz mojej podstawowej zgody, wyrażam zgodę na przetwarzanie przez Miele danych z moich podłączonych urządzeń Miele (dane dotyczące użytkowania i statusu urządzenia) w celu uzupełnienia mojego profilu użytkownika na potrzeby spersonalizowanej reklamy. Więcej informacji na temat przetwarzania danych urządzeń można znaleźć w polityce prywatności systemu Miele{'@'}Home. Mogę odwołać swoją zgodę w dowolnym momencie bez podania przyczyny ze skutkiem na przyszłość. Dalsze szczegóły w polityce ochrony danych Miele.",
    link: {
      title: "Miele{'@'}Home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "W każdej chwili mogę odwołać wyrażoną zgodę bez podania przyczyny ze skutkiem na przyszłość.  ",
    link: {
      title: "polityka ochrony danych.",
      ref: "https://www.miele.pl/c/ochrona-danych-14.htm"
    }
  },
  termsOfUse: {
    text: "Tak, zgadzam się z warunkami użytkowania.",
    link: {
      title: "Zobacz Warunki korzystania*",
      ref: "https://www.miele.pl/c/ochrona-danych-14.htm"
    }
  }
}, Xv = {
  headline: "Miele Club",
  why: {
    title: "Bezpłatne członkostwo - Ekskluzywne oferty dla klubowiczów.",
    reasons: [
      "Prezent powitalny po zarejestrowaniu urządzeń",
      "Urodzinowa niespodzianka",
      "Dostęp do specjalnych ofert",
      "Wyjątkowe eventy"
    ]
  },
  birthDateTitle: "Chcesz otrzymać urodzinową niespodziankę?",
  birthDateLabel: "Twoja data urodzenia (opcjonalnie)",
  birthDateValidation: {
    requirementMsg: "Wprowadź datę w tym formacie: DD/MM/RRRR",
    errorMsg: "nieprawidłowa data"
  },
  joinClubLabel: "Tak, chcę dołączyć do Miele Club.",
  termsAndCondition: {
    description: "Wyrażam zgodę na {termsAndConditionLink} Miele Club i akceptuję {privacyLink} informacje dotyczące Miele Club.",
    termsAndConditionLink: {
      title: "Ogólne-warunki-handlowe",
      ref: "https://www.miele.pl/c/ogolne-warunki-handlowe-13.htm"
    },
    privacyLink: {
      title: "Oświadczenie o ochronie danych",
      ref: "https://www.miele.pl/c/ochrona-danych-14.htm"
    }
  },
  newsletter: {
    description: "Tak, chcę otrzymywać od spółki Miele Sp. z o.o. („Miele“) za pośrednictwem poczty elektronicznej i tradycyjnej komunikację promocyjną Miele Club, dostosowaną do moich osobistych zainteresowań, w tym oferty specjalne, informacje, zaproszenia na wydarzenia i ankiety dotyczące produktów i usług Miele. W tym celu Miele może wykorzystywać moje dane kontaktowe (tytuł, imię i nazwisko, adres e-mail i adres pocztowy) i dostosowywać komunikację na podstawie moich zakupów i zachowań związanych z newsletterem, a także mojej wartości dla klienta, jak opisano bardziej szczegółowo w naszym {privacyLink}. W każdej chwili mogę odwołać swoją zgodę ze skutkiem na przyszłość (na przykład wysyłając wiadomość e-mail na adres info{'@'}miele.pl, kontaktując się za pośrednictwem danych kontaktowych podanych w nocie prawnej lub klikając link rezygnacji z subskrypcji w wiadomościach e-mail). Nie ma to wpływu na umowną komunikację Miele Club {termsAndConditionLink}, chyba że wypowiem członkostwo.",
    shortDescription: "Tak, chcę otrzymywać od spółki Miele Sp. z o.o. („Miele“) za pośrednictwem poczty elektronicznej i tradycyjnej komunikację promocyjną Miele Club, dostosowaną do moich osobistych zainteresowań",
    privacyLink: {
      title: "ochronie danych w ramach klubu",
      href: "https://www.miele.pl/c/ochrona-danych-14.htm"
    },
    termsAndConditionLink: {
      title: "(Miele Club Ogólne-warunki-handlowe)",
      href: "https://www.miele.pl/c/ogolne-warunki-handlowe-13.htm"
    },
    supportEmail: "info{'@'}miele.pl"
  },
  selectAllConsents: {
    description: "Aby dołączyć do Klubu Miele, musisz zaakceptować wszystkie warunki *"
  }
}, Qv = "pokaż pełne oświadczenie", ef = "Pokaż mniej", tf = {
  auth: Rv,
  changeEmailScene: Fv,
  changePasswordScene: Vv,
  errors: qv,
  forgotPassword: Gv,
  login: Kv,
  modal: Hv,
  passwordStrength: Wv,
  passwordHelper: Jv,
  register: Zv,
  "marketing-consent": {
    title: "Preferencje marketingowe",
    description: "Zaznacz, aby poznać ekskluzywne oferty, aktualności, wydarzenia i dowiedzieć się, jak w pełni wykorzystać możliwości swojego urządzenia.",
    submit: "Zapisz",
    newsletter: {
      text: 'Wyrażam zgodę na przesyłanie mi przez Miele Sp. z o.o. ("Miele") informacji o produktach i nowościach związanych z asortymentem Miele oraz o wydarzeniach Miele, a także ankiet dla klientów, zaproszeń do oceny i recenzji zakupionych produktów, przepisów za pośrednictwem poczty elektronicznej, aplikacji Miele i wiadomości SMS oraz na przetwarzanie przez Miele podanych przeze mnie danych kontaktowych (forma grzecznościowa, imię i nazwisko, adres e-mail, numer telefonu komórkowego i kod pocztowy) oraz produktów Miele, zakupionych do tej pory i w przyszłości, a także wskazanych przeze mnie zainteresowań. Ponadto wyrażam zgodę na przetwarzanie przez Miele potwierdzeń odbioru i odczytu otrzymanych za pośrednictwem newslettera oraz informacji o klikniętych przeze mnie łączach i powiązanych z tym zachowaniach na powiązanych stronach internetowych w celach personalizacyjnych. To samo dotyczy powiadomień push w aplikacjach, o ile używane są aplikacje Miele.',
      link: {
        title: "Pozostałe informacje",
        ref: "https://www.miele.pl/c/ochrona-danych-14.htm"
      }
    },
    personalisation: {
      text: "Wyrażam zgodę na przetwarzanie przez Miele informacji o usługach, z których korzystałem, wykonanych przeze mnie zadaniach technicznych, a także wydarzeniach, w których brałem udział, w celu większej personalizacji.",
      link: {
        title: "Zobacz politykę ochrony danych",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Oprócz rozszerzonej personalizacji zgadzam się, na przetwarzanie przez Miele danych pochodzących z korzystania z aplikacji Miele i moich wizyt na stronach internetowych Miele (www.miele.pl) w celu uzupełnienia mojego profilu użytkownika, pod warunkiem, że osobno wyraziłem zgodę na przetwarzanie tych danych. ",
      link: {
        title: "Zobacz politykę ochrony danych",
        ref: ""
      }
    },
    highlightedText: {
      text: "W każdej chwili mogę odwołać wyrażoną zgodę bez podania przyczyny ze skutkiem na przyszłość.  ",
      link: {
        title: "polityka ochrony danych.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Tak, zgadzam się z warunkami użytkowania.",
      link: {
        title: "Zobacz Warunki korzystania",
        ref: "https://www.miele.pl/c/warunki-korzystania-304.htm"
      }
    }
  },
  multiLevelMarketingConsent: Yv,
  mieleClub: Xv,
  readMore: Qv,
  readLess: ef
}, nf = {
  waitMessage: "Skoraj tam. "
}, af = {
  buttonLabel: "Shrani",
  buttonLabelClose: "Zapri",
  confirmEmailMessage: "Potrdite svoj e-poštni naslov",
  copy: "Če želite posodobiti svoj e-poštni naslov, dodajte novega spodaj:",
  errorMessageCopy: "Nekaj ​​je šlo narobe. Poskusite znova ",
  errorMessageHeadline: "Napaka",
  headline: "Podrobnosti profila",
  inputEmailConfirmPlaceholder: "Potrdite Svoj Elektronski Naslov",
  inputEmailPlaceholder: "E-poštni naslov",
  invalidEmailMessage: "E-poštni naslov ni veljaven!",
  rememberMeLabel: "Zapomni si me",
  successMessageCopy: "Vaš e-poštni naslov je bil uspešno posodobljen.",
  successMessageHeadline: "E-poštni naslov posodobljen"
}, sf = {
  closeButtonLabel: "Zapri",
  confirmPasswordLabel: "Potrdi geslo",
  currentPasswordLabel: "Trenutno geslo",
  newPasswordLabel: "novo geslo",
  passwordMismatchError: "Geslo se ne ujema",
  passwordUpdateErrorTitle: "Napaka",
  passwordUpdateSuccessTitle: "Geslo posodobljeno",
  samePasswordError: "To geslo je bilo že uporabljeno, prosimo, pošljite novo geslo",
  subtitle: "Za spremembo gesla izpolnite spodnja polja:",
  submitButtonLabel: "Oddaj",
  successfulChangeLabel: "Vaše geslo je bilo uspešno posodobljeno",
  title: "Sprememba gesla"
}, of = {
  invalidEmail: "Napačen e-poštni naslov",
  invalidPassword: "Napačno geslo",
  sap_206002: "Vaš račun čaka na preverjanje, vam trenutno ne moremo dovoliti nadaljevanja.  Prosim stopite v stik z nami za več informacij",
  sap_206006: "Videti je, da e-poštni naslov, ki ste ga poslali, čaka na preverjanje",
  sap_400003: "Ta e-poštni naslov že obstaja, uporabite drug e-poštni naslov.",
  sap_400028: "Poslani e-poštni naslov čaka na preverjanje",
  sap_400050: "Oprostite, trenutno ne moremo potrditi vaših poverilnic.",
  sap_400097: "Videti je, da do naših storitev dostopate iz nevarnega/nepodprtega brskalnika. Prosim poizkusite ponovno z drugim brskalnikom",
  sap_401030: "To geslo je bilo že uporabljeno, prosimo, vnesite novo geslo",
  sap_403005: "Nimamo računa, povezanega s tem e-poštnim naslovom, preverite svojo e-pošto in poskusite znova",
  sap_403011: "Seja se je iztekla. Ponovno naložite brskalnik in se ponovno prijavite. ",
  sap_403012: "Seja se je iztekla. Ponovno naložite brskalnik in se ponovno prijavite.",
  sap_403013: "Oprostite, trenutno ne moremo potrditi vaših poverilnic.",
  sap_403035: "Oprostite, trenutno ne moremo potrditi vaših poverilnic.",
  sap_403041: "Nimamo računa, povezanega s tem e-poštnim naslovom, preverite svojo e-pošto in poskusite znova",
  sap_403042: "Kombinacija e-pošte in gesla ni veljavna. Preverite e-pošto, povezano z računom, ali izberite pozabljeno geslo, če ga želite ponastaviti.",
  sap_403043: "Kombinacija e-pošte in gesla ni veljavna. Preverite e-pošto, povezano z računom, ali izberite pozabljeno geslo, če ga želite ponastaviti.",
  sap_403047: "Kombinacija e-pošte in gesla ni veljavna. Preverite e-pošto, povezano z računom, ali izberite pozabljeno geslo, če ga želite ponastaviti.",
  sap_403100: "Zahteva za posodobitev gesla je bila nedavno zahtevana, prosimo počakajte, dokler zahteva ne bo obdelana",
  sap_403025: "Povezava za ponastavitev gesla je neveljavna, ponovno pošljite zahtevo za pozabljeno geslo, da prejmete novo povezavo za ponastavitev.",
  sapErrorTitle: "Napaka pri obdelavi zahteve",
  sessionExpired: "Seja je potekla",
  tooWeakPassword: "Geslo mora vsebovati vsaj {minLength} znakov in {minCharGroups} od naslednjega: velika črka, mala črka, številka, poseben simbol | Geslo mora vsebovati vsaj {minLength} znakov",
  unexpectedDescription: "Če se težava ponovi, se obrnite na nas prek kontaktnega obrazca in navedite podrobnosti.",
  unexpectedTitle: "Prišlo je do nepričakovane napake",
  unknownDescription: "Prišlo je do nepričakovane napake. ",
  unknownTitle: "Ojoj!"
}, rf = {
  subtitle: "Nastavite novo geslo.",
  title: "Ste pozabili geslo?"
}, lf = {
  headMetaDescription: "Stran za prijavo stranke",
  headTitle: "Prijavite se s svojim e-poštnim naslovom in geslom:",
  subtitle: "Prijavite se ali ustvarite račun, da dobite vse funkcije Miele.",
  title: "Prijavite se v svoj račun",
  error: {
    invalidEmailPasswordDescription: "Kombinacija e-poštnega naslova in gesla ni veljavna.",
    invalidEmailPasswordTitle: "Neveljavne poverilnice",
    missingConcentTitle: "Račun čaka na registracijo",
    noAccountDescription: "S tem e-poštnim naslovom ni povezan noben račun.",
    noAccountTitle: "Ni registriranega računa"
  },
  extraConsentScene: {
    continue: "Nadaljuj",
    privacyStatementCheckboxLabel: "Upošteval sem {0}.",
    privacyStatementName: "izjava o zasebnosti",
    privacyStatementTitle: "Naš pravilnik o zasebnosti se je spremenil",
    termsOfUseCheckboxLabel: "Strinjam se z {0}.",
    termsOfUseName: "pogoji uporabe",
    termsOfUseTitle: "Naši pogoji uporabe so se spremenili",
    title: "Dokončanje profila"
  },
  forgotPasswordScene: {
    backButtonLabel: "Nazaj na prijavo",
    submitButtonLabel: "Oddaj",
    successDescription: "Prosimo, preverite svojo e-pošto, kmalu boste prejeli podatke o vašem računu, da začnete s postopkom ponastavitve gesla.",
    successTitle: "Vaša zahteva je bila prejeta.",
    title: "Za ponastavitev gesla vnesite svoj e-poštni naslov:"
  },
  loginModalScene: {
    copy: "Prijavite se ali ustvarite račun, da dobite vse funkcije Miele.",
    title: "Prijavite se v svoj račun"
  },
  loginScene: {
    emailInputLabel: "E-pošta",
    forgotPwdButtonLabel: "Pozabil sem geslo",
    invalidEmailMessage: "E-pošta ni veljavna!",
    loginButtonLabel: "Vpiši se",
    passwordInputLabel: "Geslo",
    rememberMeLabel: "Zapomni si me",
    title: "Prijavite se s svojim e-poštnim naslovom in geslom:"
  }
}, cf = {
  accessibility: {
    close: "Zapri"
  }
}, df = {
  tooShort: "Prekratko",
  medium: "Srednje",
  strong: "Močno",
  tooWeak: "Prešibko",
  veryStrong: "Zelo močno",
  weak: "Šibko"
}, uf = {
  showPasswordText: "Prikaži",
  hidePasswordText: "Skrij"
}, mf = {
  registerButtonLabel: "registracija",
  registerTitle: "Nimate računa?",
  whyRegister: {
    list: [
      "Dostop do ekskluzivnih ugodnosti Miele Kluba",
      "Registrirajte naprave, sledite naročilom, dostopajte do priročnikov",
      "Prejemajte prilagojene ponudbe in promocije",
      "Oglejte si vsa vaša naročila, garancije, dogodke in storitve"
    ],
    title: "Zakaj se registrirati?"
  },
  closeButtonLabel: "Zapri",
  passwordMismatchError: "Gesli se ne ujemata",
  passwordUpdateErrorTitle: "Napaka pri posodobitvi gesla",
  passwordUpdateSuccessTitle: "Geslo posodobljeno",
  successfulChangeLabel: "Vaše geslo je bilo uspešno posodobljeno"
}, pf = {
  title: "Tržnenjske preference",
  description: "Spodaj označite za ekskluzivne ponudbe, novice, dogodke in kako kar najbolje izkoristiti vaš aparat.",
  submit: "Shrani",
  levelOne: {
    shortText: "Da, želim, da mi Miele d.o.o. in Miele & Cie. KG („Miele“) po elektronski in navadni pošti, s sporočili SMS in prek aplikacij ter spletnih strani Miele (če jih uporabljam) pošiljata oglasna sporočila, prilagojena mojim osebnim interesom,",
    text: "Da, želim, da mi Miele d.o.o. in Miele & Cie. KG („Miele“) po elektronski in navadni pošti, s sporočili SMS in prek aplikacij ter spletnih strani Miele (če jih uporabljam) pošiljata oglasna sporočila, prilagojena mojim osebnim interesom, z informacijami o Mielejevih izdelkih, ponudbah in novostih ter dogodkih, anketah za kupce, prošnjah za ocene in mnenjih o izdelkih ter receptih. V ta namen lahko Miele uporabi moje kontaktne podatke (naziv, ime, e-poštni naslov, številko mobilnega telefona in poštni naslov) in oblikuje sporočila na podlagi zgodovine mojih nakupov, udeležbe na dogodkih in uporabe servisnih storitev, mojega vedenja pri klikanju in odpiranju novic ter moje vrednosti stranke, kot je podrobneje opisano v naših informacijah o varstvu podatkov. Svoje soglasje lahko kadar koli prekličem z veljavnostjo za naprej (npr. tako, da pošljem neformalno sporočilo na naslov info{'@'}miele.si, na kontaktne podatke, navedene v pravnem obvestilu, ali s klikom na povezavo za odjavo v e-poštnih sporočilih).",
    link: {
      title: "Varstvo podatkov",
      ref: "https://www.miele.si/c/varstvo-podatkov-14.htm"
    }
  },
  levelTwo: {
    text: "Poleg mojega osnovnega soglasja se strinjam, da lahko Miele obdeluje tudi podatke iz uporabe aplikacije Miele in mojega obiska spletnih strani Miele (www.miele.si), vključno z vedenjem na spletnih straneh Miele, do katerih pridem s klikanjem v novicah Miele, za dopolnitev mojega uporabniškega profila za prilagojeno oglaševalsko komunikacijo, če moja ločena privolitev v aplikaciji ali na spletni strani dovoli obdelavo podatkov. Svoje soglasje lahko kadar koli prekličem z veljavnostjo za naprej. Dodatne podrobnosti so navedene v Politiki zasebnosti.",
    link: {
      title: "Varstvo podatkov",
      ref: "https://www.miele.si/c/varstvo-podatkov-14.htm"
    }
  },
  levelThree: {
    text: "Poleg mojega osnovnega soglasja se strinjam, da lahko Miele obdeluje podatke o mojih aparatih Miele, povezanih v omrežje (podatki o uporabi in stanju aparatov), da dopolni moj uporabniški profil za prilagojeno oglaševanje. Dodatne informacije o obdelavi podatkov o aparatih najdete v pravilniku o zasebnosti za sistem Miele{'@'}home. Svoje soglasje lahko kadar koli prekličem z veljavnostjo za naprej. Dodatne informacije so na voljo v varstvo podatkov.",
    link: {
      title: "Politika zasebnosti za sistem Miele{'@'}home",
      ref: "https://www.miele.com/appfiles/production/mieleatmobile/ConsentManagement/V4.11/LandingPages/Countries/PrivacyPolicy.html"
    }
  },
  highlightedText: {
    text: "",
    link: {
      title: "",
      ref: ""
    }
  },
  termsOfUse: {
    text: "Da, strinjam se s pogoji uporabe.",
    link: {
      title: "Oglejte si pogoje uporabe*",
      ref: "https://www.miele.si/c/pogoji-uporabe-304.htm"
    }
  }
}, hf = {
  headline: "Miele klub",
  birthDateTitle: "Vam lahko pošljemo darilo za rojstni dan?",
  birthDateLabel: "Vaš rojstni datum (neobvezno)",
  why: {
    title: "Članstvo",
    reasons: [
      "Rojstnodnevno presenečenje",
      "Ekskluzivne ponudbe in akcije",
      "Darilo dobrodošlice",
      "VIP ponudbe in",
      "izkušnje",
      "Privlačni prihranki",
      "Klubske novice"
    ]
  },
  birthDateValidation: {
    requirementMsg: "Prosimo, da vnesete ta datumski format: DD/MM/LLLL",
    errorMsg: "Napačen datum"
  },
  joinClubLabel: "Da, želim se pridružiti Miele klubu.",
  termsAndCondition: {
    description: "Strinjam se s {termsAndConditionLink} Miele kluba in potrjujem {privacyLink} informacije o Miele klubu.",
    termsAndConditionLink: {
      title: "Pogoji",
      ref: "https://www.miele.si/c/general-terms-conditions-13.htm"
    },
    privacyLink: {
      title: "Varstvo podatkov",
      ref: "https://www.miele.si/c/privacy-notice-14.htm"
    }
  },
  newsletter: {
    shortDescription: "Da, želim prejemati promocijsko komunikacijo kluba Miele, prilagojeno mojim osebnim interesom, po e-pošti in pošti",
    description: "Da, želim postati član Miele kluba in prejemati sporočila Miele kluba (darilo dobrodošlice, rojstnodnevno presenečenje, sprememba statusa nadgradnje, novice Miele kluba) po e-pošti.",
    privacyLink: {
      title: "Varstvo podatkov kluba Miele",
      href: "https://www.miele.si/c/privacy-notice-14.htm"
    },
    termsAndConditionLink: {
      title: "Komunikacija kluba",
      href: "https://www.miele.si/c/general-terms-conditions-13.htm"
    },
    supportEmail: "info{'@'}miele.si"
  },
  selectAllConsents: {
    description: "Če želite postati član Miele kluba, morate sprejeti vse pogoje *"
  }
}, gf = "pokaži celotno izjavo", vf = "skrij celotno izjavo", ff = {
  auth: nf,
  changeEmailScene: af,
  changePasswordScene: sf,
  errors: of,
  forgotPassword: rf,
  login: lf,
  modal: cf,
  passwordStrength: df,
  passwordHelper: uf,
  register: mf,
  "marketing-consent": {
    title: "Tržnenjske preference",
    description: "Spodaj označite za ekskluzivne ponudbe, novice, dogodke in kako kar najbolje izkoristiti vaš aparat.",
    submit: "Shrani",
    newsletter: {
      text: 'Strinjam se, da mi lahko Miele trgovina in servis d.o.o. ("Miele") pošilja informacije o izdelkih in novostih iz nabora izdelkov Miele in o dogodkih Miele ter ankete strank in recepte po e-pošti, aplikacijah Miele in SMS-ih ter da lahko Miele obdeluje kontaktne podatke, ki sem jih posredoval (naziv, ime, e-poštni naslov, številko mobilnega telefona in poštno številko) in izdelke Miele, ki sem jih kupil do sedaj in jih bom kupil v prihodnosti, ter interese, ki sem jih navedel v ta namen . Nadalje se strinjam, da lahko Miele obdela potrdila o prejemu in branju, prejete prek glasila, in informacije o povezavah, na katere sem kliknil, ter o mojem povezanem vedenju uporabnika na povezani spletni strani za namene personalizacije. Enako velja za potisna sporočila v aplikaciji, v kolikor se uporabljajo aplikacije Miele. ',
      link: {
        title: "Oglejte si politiko varstva podatkov",
        ref: ""
      }
    },
    personalisation: {
      text: "Strinjam se, da lahko Miele obdeluje podatke o storitvah, ki sem jih uporabil, in tehničnih nalogah, ki sem jih opravil, ter dogodkih, ki sem se jih udeležil, za namen izboljšane personalizacije.",
      link: {
        title: "Oglejte si politiko varstva podatkov",
        ref: ""
      }
    },
    extendedPersonalisation: {
      text: "Poleg razširjene personalizacije se strinjam, da lahko Miele obdeluje tudi podatke iz uporabe aplikacije Miele in mojih obiskov spletnih strani Miele (www.miele.si) za dopolnitev mojega uporabniškega profila, pod pogojem, da sem posebej privolil v to. ",
      link: {
        title: "Oglejte si politiko varstva podatkov",
        ref: ""
      }
    },
    highlightedText: {
      text: "Svoje soglasje lahko kadar koli prekličem brez navedbe razlogov z učinkom za naprej.  ",
      link: {
        title: "politiko varstva podatkov.",
        ref: ""
      }
    },
    termsOfUse: {
      text: "Da, strinjam se s pogoji uporabe.",
      link: {
        title: "Oglejte si pogoje uporabe*",
        ref: ""
      }
    }
  },
  multiLevelMarketingConsent: pf,
  mieleClub: hf,
  readMore: gf,
  readLess: vf
}, li = J();
function pe() {
  li.value || (li.value = Ai({
    locale: "en-US",
    messages: {
      "da-DK": jl,
      "de-AT": $l,
      "de-CH": ec,
      "de-DE": gc,
      "de-LU": Pc,
      "en-GB": Gc,
      "en-SG": od,
      "en-US": yd,
      "es-ES": Nd,
      "fi-FI": mu,
      "fr-FR": Cu,
      "fr-BE": Fu,
      "fr-CH": nm,
      "fr-LU": km,
      "it-IT": xm,
      "it-CH": Wm,
      "nl-NL": cp,
      "nl-BE": jp,
      "no-NO": $p,
      "pt-PT": eh,
      "sv-SE": gh,
      "sl-SI": Ph,
      "hu-HU": Gh,
      "ga-IE": og,
      "en-IE": yg,
      "el-GR": Ig,
      "sk-SK": Jg,
      "cs-CZ": dv,
      "ro-RO": _v,
      "pl-PL": tf,
      "hr-HR": Bv,
      "si-SL": ff,
      "es-MX": Yd
    }
  }));
  const { t: e, tm: t, rt: i, te: n } = li.value;
  return { ct: e, ctm: t, crt: i, cte: n, i18n: li.value };
}
class ze extends Error {
  constructor(i, n, a, s, o = !1) {
    const l = pe().ct, u = i || l("errors.unknownTitle");
    super(u);
    ot(this, "cause");
    ot(this, "details");
    ot(this, "data");
    ot(this, "code");
    ot(this, "isDismissible");
    Error.captureStackTrace && Error.captureStackTrace(this, ze), this.name = "GenericError", this.cause = a, this.details = n || l("errors.unknownDescription"), this.data = s, this.isDismissible = o, this.code = void 0;
  }
}
class gt extends ze {
  constructor(t, i, n) {
    super(t, i, n), this.name = "AccountsApiError";
  }
}
const kf = (e = "Error on account login.") => {
  const t = new Error(e);
  return t.name = "AccountLoginError", t;
};
class ys extends ze {
  constructor(t, i, n) {
    const s = pe().ct;
    super(t || s("errors.sessionExpired"), i, n), this.name = "HybrisSessionExpiredError";
  }
}
class Cn extends ze {
  constructor(t, i, n) {
    const s = pe().ct;
    super(
      t || s("login.error.invalidEmailPasswordTitle"),
      i || s("login.error.invalidEmailPasswordDescription"),
      n
    ), this.name = "InvalidEmailPasswordError";
  }
}
class Ln extends ze {
  constructor(t, i, n) {
    super(t, i, n), this.name = "InvalidLoginError";
  }
}
class En extends ze {
  constructor(t, i, n) {
    super(t, i, n), this.name = "InvalidSessionError";
  }
}
class xi extends ze {
  constructor(t, i, n, a) {
    const o = pe().ct;
    super(t || o("login.error.missingConcentTitle"), i, n, a), this.name = "MissingConsentError";
  }
}
class bf extends ze {
  constructor(t, i, n) {
    const s = pe().ct;
    super(t || s("login.error.noAccountTitle"), i || s("login.error.noAccountDescription"), n), this.name = "NoAccountError";
  }
}
const wf = [
  206002,
  206006,
  400003,
  400028,
  400050,
  400097,
  401030,
  403005,
  403011,
  403012,
  403013,
  403035,
  403041,
  403042,
  403043,
  403047,
  403100,
  403025
], vt = (e) => e && wf.includes(e);
class ft extends ze {
  constructor(t) {
    const n = pe().ct, a = t ? n(`errors.sap_${t}`) : void 0;
    super(n("errors.sapErrorTitle"), a), this.name = "SapError", this.code = t;
  }
}
class Pn extends ze {
  constructor(t, i, n) {
    super(t || "Invalid session grant", i, n), this.name = "SessionInvalidGrantError";
  }
}
class ye extends ze {
  constructor(t, i, n) {
    const s = pe().ct;
    super(t || s("errors.unexpectedTitle"), i || s("errors.unexpectedDescription"), n), this.name = "UnexpectedError";
  }
}
class Tn extends ze {
  constructor(t, i, n) {
    const s = pe().ct;
    super(t || s("errors.unknownTitle"), i || s("errors.unknownDescription"), n), this.name = "UnknownError";
  }
}
const zy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountLoginError: kf,
  AccountsApiError: gt,
  GenericError: ze,
  HybrisSessionExpiredError: ys,
  InvalidEmailPasswordError: Cn,
  InvalidLoginError: Ln,
  InvalidSessionError: En,
  MissingConsentError: xi,
  NoAccountError: bf,
  SapError: ft,
  SessionInvalidGrantError: Pn,
  UnexpectedError: ye,
  UnknownError: Tn,
  isSapErrorHandled: vt
}, Symbol.toStringTag, { value: "Module" })), Ms = "MIELE_LOGIN_TOGGLE", zs = "MIELE_CHANGE_PASSWORD_TOGGLE", js = "MIELE_FORGOT_PASSWORD_TOGGLE", _s = "MIELE_CHANGE_EMAIL_TOGGLE", Ss = "MIELE_CONSENT_TOGGLE", Cs = "MIELE_NEWSLETTER_CONSENT_TOGGLE", Ls = "MIELE_CLUB_CONSENT_TOGGLE", yf = "MIELE_NINJA_LOGOUT", jy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CHANGE_EMAIL_TOGGLE: _s,
  CHANGE_PASSWORD_TOGGLE: zs,
  CONSENT_TOGGLE: Ss,
  FORGOT_PASSWORD_TOGGLE: js,
  LOGIN_TOGGLE: Ms,
  MIELE_CLUB_CONSENT_TOGGLE: Ls,
  NEWSLETTER_CONSENT_TOGGLE: Cs,
  NINJA_LOGOUT: yf
}, Symbol.toStringTag, { value: "Module" })), Mf = [
  { countryCode: "be", languages: ["nl", "fr"] },
  { countryCode: "ch", languages: ["de", "fr", "it"] },
  { countryCode: "ca", languages: ["en", "fr"] },
  { countryCode: "lu", languages: ["fr", "de"] }
], Ii = {
  global: "miele.com",
  dk: "miele.dk",
  uk: "miele.co.uk",
  us: "mieleusa.com",
  nl: "miele.nl",
  be: "miele.be",
  lu: "miele.lu",
  fi: "miele.fi",
  no: "miele.no",
  se: "miele.se",
  pl: "miele.pl",
  ch: "miele.ch",
  gr: "miele.gr",
  fr: "miele.fr",
  es: "miele.es",
  pt: "miele.pt",
  ie: "miele.ie",
  za: "miele.co.za",
  at: "miele.at",
  de: "miele.de",
  au: "miele.com.au",
  nz: "miele.co.nz",
  jp: "miele.co.jp",
  ae: "miele.ae",
  hk: "miele.hk",
  cn: "miele.cn",
  hr: "miele.hr",
  sl: "miele.sl",
  cz: "miele.cz",
  sk: "miele.sk",
  my: "miele.my",
  sg: "miele.sg",
  kr: "miele.co.kr",
  lt: "miele.lt",
  lv: "miele.lv",
  ee: "miele.ee",
  it: "miele.it",
  ca: "miele.ca",
  bg: "miele.bg",
  hu: "miele.hu",
  mx: "miele.com.mx",
  cl: "miele.cl",
  ro: "miele.ro",
  ru: "miele.ru",
  ua: "miele.ua",
  kz: "miele.kz",
  rs: "miele.rs",
  tr: "miele.tr",
  in: "miele.in",
  th: "miele.co.th",
  br: "mielebrasil.com.br",
  si: "miele.si"
}, zf = (e) => {
  const t = e == null ? void 0 : e.split("/")[3], i = An(e), n = Di(i);
  return n != null && n.languages.includes(t) ? t : (n == null ? void 0 : n.languages[0]) || void 0;
}, _y = (e) => {
  const t = An(e), i = Di(t);
  return (i == null ? void 0 : i.languages[0]) || void 0;
}, An = (e) => {
  try {
    const t = new URL(e).host, i = Object.entries(Ii).find(([n, a]) => t.includes(a));
    return i == null ? void 0 : i[0];
  } catch (t) {
    if (t.message.includes("Invalid URL:"))
      return;
    throw t;
  }
}, Di = (e) => Mf.find((t) => t.countryCode === (e == null ? void 0 : e.toLowerCase())), jf = (e, t) => {
  const i = Di(e);
  return !!(i != null && i.languages.includes(t == null ? void 0 : t.toLowerCase()));
}, xn = (e) => {
  const t = An(e);
  return !!Di(t);
}, lt = (e, t) => {
  let i = e.startsWith("/") ? e : `/${e}`;
  const n = (t == null ? void 0 : t.domain) || window.location.href;
  return xn(n) && (i = `/${(t == null ? void 0 : t.language) || zf(n) || ""}${i}`), i;
}, _f = (e) => {
  var i;
  const t = e || window.location.pathname;
  return (i = /\/([a-z]{2})(?:\/|$)/.exec(t)) == null ? void 0 : i[1];
}, Sy = (e) => {
  const t = e.startsWith("/") ? e : `/${e}`, i = _f();
  return i ? `/${i}${t}` : t;
}, Sf = (e = 61) => Array.from({ length: e }, () => window.Math.random().toString(36)[2]).join(""), Cy = (e, t, i) => {
  var s, o;
  const n = (s = e.value) == null ? void 0 : s["general.country"].toUpperCase();
  if (jf(n, i)) {
    const r = (o = e.value) == null ? void 0 : o["general.language"];
    console.debug(`Switching language: ${r}-${n} > ${i}-${n}`), t(`${i}-${n}`);
  } else
    console.debug(`"${i}" is not a valid language for this domain (${n}). Ignoring locale change request.`);
}, Cf = (e) => {
  const t = e == null ? void 0 : e["general.language"], i = e == null ? void 0 : e["general.country"];
  return `${t}-${i}`;
}, Lf = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, Ef = (e) => Lf.test(e);
var Je = /* @__PURE__ */ ((e) => (e[e.TooShort = -1] = "TooShort", e[e.TooWeak = 0] = "TooWeak", e[e.Weak = 1] = "Weak", e[e.Medium = 2] = "Medium", e[e.Strong = 3] = "Strong", e[e.VeryStrong = 4] = "VeryStrong", e))(Je || {});
const Pf = 12, Tf = 14, Ly = (e) => Ef(e) ? e.length >= Tf ? 4 : e.length >= Pf ? 3 : 1 : 0, Af = /[A-Z]/, xf = /[a-z]/, If = /[0-9]/, Df = /[^\w\s]/, Nf = (e) => {
  let t = 0;
  return Af.test(e) && t++, xf.test(e) && t++, If.test(e) && t++, Df.test(e) && t++, t;
}, Es = (e, t = 8, i = 0) => {
  if (e.length < t)
    return -1;
  const n = Nf(e);
  return i > 0 && n < i ? 0 : n <= 1 ? 1 : n === 2 ? 2 : n === 3 ? 3 : n >= 4 ? 4 : 0;
}, Of = (e) => e.reduce((t, i) => {
  const [n, ...a] = i.split(".");
  return t[n] || (t[n] = []), t[n].push(a.join(".")), t;
}, {}), Uf = /(@.*@|(\.@)|(@\.)|^\.|\.$|\.\.|\s)/i, $f = /^[^\s@]+@[^\s@]+\.[a-z0-9]{2,}$/i, Ut = (e) => Uf.test(e) ? !1 : $f.test(e), Bf = (e) => {
  const t = [];
  for (const i in e) {
    const n = encodeURIComponent(i), a = e[i], s = typeof a == "object" ? JSON.stringify(Object.assign({}, a)) : a, o = encodeURIComponent(s);
    t.push(n + "=" + o);
  }
  return t.join("&");
}, ba = (...e) => e.map((t, i) => {
  let n = t.trim();
  for (; n.endsWith("/"); )
    n = n.slice(0, -1);
  if (i > 0)
    for (; n.startsWith("/"); )
      n = n.slice(1);
  return n;
}).filter((t) => t.length).join("/");
async function Rf(e) {
  const t = new TextEncoder().encode(e);
  let i;
  globalThis.window ? (console.debug("sha256b64: hashing with browser ..."), i = await window.crypto.subtle.digest("SHA-256", t)) : (console.debug("sha256b64: hashing with node ..."), i = (await import("./__vite-browser-external-2447137e.js")).createHash("sha256").update(t).digest());
  const n = new Uint8Array(i);
  let a = btoa(String.fromCharCode(...n)).replace(/\+/g, "-").replace(/\//g, "_");
  for (; a.endsWith("="); )
    a = a.slice(0, -1);
  return a;
}
async function Ff(e) {
  var a;
  const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", i = new Uint8Array(e);
  if (typeof window < "u" && ((a = window.crypto) != null && a.getRandomValues))
    window.crypto.getRandomValues(i);
  else {
    const { webcrypto: s } = await import("./__vite-browser-external-2447137e.js");
    s.getRandomValues(i);
  }
  let n = "";
  for (let s = 0; s < e; s++)
    n += t.charAt(i[s] % t.length);
  return n;
}
const wa = (e) => {
  try {
    return new URL(e).hostname;
  } catch {
    return null;
  }
}, Vf = (e) => {
  try {
    return new URL(e).pathname;
  } catch {
    return null;
  }
}, Vi = (e) => typeof e == "string" ? e === "true" : !!e;
/*! js-cookie v3.0.5 | MIT */
function ci(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t];
    for (var n in i)
      e[n] = i[n];
  }
  return e;
}
var qf = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function un(e, t) {
  function i(a, s, o) {
    if (!(typeof document > "u")) {
      o = ci({}, t, o), typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)), o.expires && (o.expires = o.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var r = "";
      for (var l in o)
        o[l] && (r += "; " + l, o[l] !== !0 && (r += "=" + o[l].split(";")[0]));
      return document.cookie = a + "=" + e.write(s, a) + r;
    }
  }
  function n(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var s = document.cookie ? document.cookie.split("; ") : [], o = {}, r = 0; r < s.length; r++) {
        var l = s[r].split("="), u = l.slice(1).join("=");
        try {
          var c = decodeURIComponent(l[0]);
          if (o[c] = e.read(u, c), a === c)
            break;
        } catch {
        }
      }
      return a ? o[a] : o;
    }
  }
  return Object.create(
    {
      set: i,
      get: n,
      remove: function(a, s) {
        i(
          a,
          "",
          ci({}, s, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return un(this.converter, ci({}, this.attributes, a));
      },
      withConverter: function(a) {
        return un(ci({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var qi = un(qf, { path: "/" });
function mn(e) {
  const t = e.startsWith("http://") || e.startsWith("https://") ? e : `https://${e}`, i = new URL(t).hostname, n = i.split("."), a = Object.values(Ii).map((s) => {
    const o = s.split(".");
    return o.length > 2 ? o.slice(-2).join(".") : "";
  }).filter(Boolean);
  for (const s of a)
    if (i.endsWith(`.${s}`))
      return `${n[n.length - 3]}.${s}`;
  return n.slice(-2).join(".");
}
const Gf = () => {
  if (globalThis.window) {
    const e = Object.values(Ii), t = mn(window.location.hostname), i = e.find((n) => t === n);
    return i || (console.warn(
      `Could not determine domain from page hostname=${window == null ? void 0 : window.location.hostname}. Defaulting to window.location.hostname`
    ), window.location.hostname);
  }
  return null;
}, Et = (e, t) => {
  const i = Gf(), n = i === "localhost" ? i : `.${i}`, a = "strict", s = !0, o = { opts: t };
  return { set: (c, m) => {
    m && (o.opts = m);
    const d = typeof c == "string" ? c : JSON.stringify(c);
    return qi.set(e, d, { domain: n, sameSite: a, secure: s, ...o.opts });
  }, get: () => {
    const c = qi.get(e);
    try {
      return JSON.parse(c);
    } catch (m) {
      return m instanceof SyntaxError || console.error(m), c;
    }
  }, remove: () => qi.remove(e, { domain: n, sameSite: a, secure: s, ...o.opts }) };
}, Kf = (e) => e.startsWith("glt_") || e.startsWith("gig_");
function Ps() {
  document.cookie.split(";").map((t) => t.split("=")[0].trim()).filter(Kf).forEach((t) => Et(t).remove());
}
function Hf(e) {
  try {
    return e ? JSON.parse(e) : null;
  } catch {
    return null;
  }
}
const Gi = "miele_auth_redirect", ya = 36e5, Wf = "miele_force_auth_proxy", Ma = "miele_code_verifier", Ki = J(void 0), Xe = () => ({
  globalsState: Ki,
  loadSessionGlobals: () => {
    const i = sessionStorage.getItem("miele_globals");
    Ki.value = i ? JSON.parse(i) : void 0;
  },
  setGlobals: (i) => {
    Ki.value = i;
  }
}), Jf = (e) => {
  const t = decodeURIComponent(e);
  return /<script[^>]*>[^<]*<\/script[^>]*>|javascript:|data:text\/html/i.test(t);
};
function Hi(e) {
  if (Jf(e))
    return !1;
  const t = mn(window.location.hostname), i = new URL(e, window.location.origin), n = mn(i.hostname);
  return n === t ? !0 : Object.values(Ii).some((s) => s === n);
}
function Zf(e) {
  return `/${e.split("/").slice(2).join("/")}`;
}
function za(e) {
  return xn(e.toString()) ? Zf(e.pathname) : e.pathname;
}
function Wi(e, t) {
  const i = decodeURIComponent(e), n = decodeURIComponent(t), a = za(new URL(i, window.location.origin));
  return za(new URL(n, window.location.origin)) === a;
}
const ja = ["login.microsoftonline.com"], Yf = ["/e/newpassword", "/login/newpassword"];
function In() {
  const { globalsState: e } = Xe();
  e.value && e.value["module.auth.baseUrl"] && ja.push(wa(e.value["module.auth.baseUrl"]));
  const t = (o) => {
    sessionStorage.setItem(Gi, o);
  }, i = () => {
    sessionStorage.removeItem(Gi);
  }, n = () => {
    const o = sessionStorage.getItem(Gi);
    return o && Hi(o) && !Wi(o, window.location.toString()) ? o : null;
  };
  return { saveRedirectTarget: () => {
    const o = window.location.toString(), l = new URLSearchParams(window.location.search).get("target_url");
    if (l && Hi(l) && !Wi(l, o)) {
      t(decodeURIComponent(l));
      return;
    }
    const u = document.referrer, c = wa(u), m = Vf(u);
    if (c && u !== window.location.href) {
      if (ja.includes(c) || Yf.includes(m))
        return;
      if (Hi(u) && !Wi(l, o)) {
        t(u);
        return;
      }
    }
    i();
  }, redirectToTarget: () => {
    var m;
    const { globalsState: o } = Xe(), r = n(), l = xn(window.location.href) ? (m = o.value) == null ? void 0 : m["general.language"] : "", u = `${window.location.origin}/${l}`, c = r || u;
    i(), window.location.assign(c);
  }, storeRedirect: t, retrieveRedirect: n, clearRedirect: i };
}
const Ey = "miele-session", Xf = "miele_host", di = "miele_sessionData", Ts = "miele_regToken", Qf = "miele_authCode", Py = "miele_jwt", ek = "miele_DANGER_ZONE", Dn = () => {
  const e = Et(Ts);
  return { set: (n, a) => {
    var s, o, r, l;
    (n != null && n.regToken || (s = n.sessionInfo) != null && s.cookieValue) && (e.set((n == null ? void 0 : n.regToken) || ((o = n.sessionInfo) == null ? void 0 : o.cookieValue), {
      expires: a ? new Date(Date.now() + ya) : void 0,
      maxAge: a ? `${ya}` : void 0
    }), (r = n.sessionInfo) != null && r.cookieName && Et((l = n.sessionInfo) == null ? void 0 : l.cookieName).set(n.sessionInfo.cookieValue));
  }, get: () => e != null && e.get() ? e.get() : (console.warn("No session token cookie found"), null), remove: e.remove };
}, Ni = () => {
  const e = Dn(), t = {
    remember: !1
  }, i = (o, r) => {
    t.remember = r || !1, e.set(o, r);
    const l = {
      UID: o == null ? void 0 : o.UID,
      preferences: o == null ? void 0 : o.preferences
    };
    localStorage.setItem(di, JSON.stringify(l));
  }, n = () => {
    const o = localStorage.getItem(di) || sessionStorage.getItem(di);
    if (o) {
      const r = JSON.parse(o);
      return s() || e.set(r, t.remember), r;
    }
    return null;
  }, a = () => {
    localStorage.removeItem(di);
  }, s = () => e == null ? void 0 : e.get();
  return { set: i, get: n, remove: a, getCdcToken: s };
}, tk = (e, t) => {
  const i = e[t];
  return i ? typeof i == "function" ? i() : Promise.resolve(i) : new Promise((n, a) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(a.bind(null, new Error("Unknown variable dynamic import: " + t)));
  });
}, me = async (e, t, i) => {
  if (e) {
    console.debug("Returning mocked json:", t);
    const { default: n } = await tk(/* @__PURE__ */ Object.assign({ "../mocks/accounts.getAccountInfo.ts": () => import("./accounts.getAccountInfo-daa5f0a7.js"), "../mocks/accounts.getPasswordPolicies.ts": () => import("./accounts.getPasswordPolicies-cbffd8da.js"), "../mocks/accounts.getSchema.ts": () => import("./accounts.getSchema-cf160c28.js"), "../mocks/accounts.login.missing-consent.ts": () => import("./accounts.login.missing-consent-1ceeb468.js"), "../mocks/accounts.login.ts": () => import("./accounts.login-8b7bdf12.js"), "../mocks/accounts.logout.ts": () => import("./accounts.logout-ca9acf65.js"), "../mocks/accounts.resetPassword.ts": () => import("./accounts.resetPassword-26e2c546.js"), "../mocks/accounts.resetPasswordWithResetToken.ts": () => import("./accounts.resetPasswordWithResetToken-69c282b9.js"), "../mocks/accounts.setAccountInfo.ts": () => import("./accounts.setAccountInfo-a81e02f2.js"), "../mocks/cdc.verifySession.ts": () => import("./cdc.verifySession-9d1a6552.js"), "../mocks/experience.email.ts": () => import("./experience.email-c5fbeec2.js"), "../mocks/experience.userInfo.ts": () => import("./experience.userInfo-2dbb35b3.js"), "../mocks/globals-mock.ts": () => import("./globals-mock-2bed6c6d.js"), "../mocks/hybris.csrf.ts": () => import("./hybris.csrf-9768cfa3.js"), "../mocks/hybris.login.ts": () => import("./hybris.login-22c48e84.js"), "../mocks/hybris.logout.ts": () => import("./hybris.logout-fa8d5e51.js"), "../mocks/hybris.session.ts": () => import("./hybris.session-1897913c.js"), "../mocks/session-data-mocks.ts": () => import("./session-data-mocks-b34ec4c1.js") }), `../mocks/${t}.ts`);
    return { json: n, resp: { ok: !0 } };
  }
  return i();
}, _a = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE"
}, Ie = {
  login: "/accounts.login",
  resetPassword: "/accounts.resetPassword",
  logout: "/accounts.logout",
  getPasswordPolicies: "/accounts.getPolicies",
  isEmailAvailable: "/accounts.isAvailableLoginID",
  registrationToken: "/accounts.initRegistration",
  register: "/accounts.register",
  finalizeRegistration: "/accounts.finalizeRegistration",
  getConsents: "/accounts.getConsentsStatements",
  setConsents: "/accounts.setConsentsStatements",
  setAccountInfoLegacy: "/accounts.setAccountInfo",
  unsubscribe: "/accounts.unsubscribe",
  getSchema: "/accounts.getSchema",
  // XAPI migrated
  getAccountInfo: "cdc/accounts.getAccountInfo",
  setAccountInfo: "cdc/accounts.setAccountInfo",
  verifySession: "cdc/accounts.session.verify"
}, Ji = {
  create: "session/token",
  status: "session",
  logout: "session/logout"
}, ui = {
  getUserInfo(e) {
    return `occ/miele-${e}/user`;
  },
  getMieleClubUrl(e) {
    return `occ/miele-${e}/miele-club`;
  },
  getEmailUrl(e) {
    return `occ/miele-${e}/email`;
  },
  getGlobalSettingsUrl(e) {
    return `occ/miele-${e}/global-settings`;
  }
}, Zi = {
  account: "newsletter-preferences/account",
  setLiteAccountInfo: "newsletter-preferences/setLiteAccountInfo",
  setFullAccountInfo: "newsletter-preferences/setFullAccountInfo"
}, Qt = {
  csrf: "/e/csrf",
  authenticationStatus: "/e/authentication/status",
  gigyaRaasLogin: "/e/gigyaraas/login",
  logout: "/e/logout",
  completeRegistration: "/e/account/complete-registration"
}, ik = {
  oidc: "/oidc/op/v1.0"
}, Ty = "https://stg.cdn.api.miele.com/api-connector", Rt = {
  login: "/login",
  auth: "/login/auth"
}, Ay = {
  authVerifier: "umf-verifier"
};
var nk = /* @__PURE__ */ ((e) => (e.USER = "user", e))(nk || {});
const Sa = Object.freeze({
  ignoreUnknown: !1,
  respectType: !1,
  respectFunctionNames: !1,
  respectFunctionProperties: !1,
  unorderedObjects: !0,
  unorderedArrays: !1,
  unorderedSets: !1,
  excludeKeys: void 0,
  excludeValues: void 0,
  replacer: void 0
});
function ak(e, t) {
  t ? t = { ...Sa, ...t } : t = Sa;
  const i = As(t);
  return i.dispatch(e), i.toString();
}
const sk = Object.freeze([
  "prototype",
  "__proto__",
  "constructor"
]);
function As(e) {
  let t = "", i = /* @__PURE__ */ new Map();
  const n = (a) => {
    t += a;
  };
  return {
    toString() {
      return t;
    },
    getContext() {
      return i;
    },
    dispatch(a) {
      return e.replacer && (a = e.replacer(a)), this[a === null ? "null" : typeof a](a);
    },
    object(a) {
      if (a && typeof a.toJSON == "function")
        return this.object(a.toJSON());
      const s = Object.prototype.toString.call(a);
      let o = "";
      const r = s.length;
      r < 10 ? o = "unknown:[" + s + "]" : o = s.slice(8, r - 1), o = o.toLowerCase();
      let l = null;
      if ((l = i.get(a)) === void 0)
        i.set(a, i.size);
      else
        return this.dispatch("[CIRCULAR:" + l + "]");
      if (typeof Buffer < "u" && Buffer.isBuffer && Buffer.isBuffer(a))
        return n("buffer:"), n(a.toString("utf8"));
      if (o !== "object" && o !== "function" && o !== "asyncfunction")
        this[o] ? this[o](a) : e.ignoreUnknown || this.unkown(a, o);
      else {
        let u = Object.keys(a);
        e.unorderedObjects && (u = u.sort());
        let c = [];
        e.respectType !== !1 && !Ca(a) && (c = sk), e.excludeKeys && (u = u.filter((d) => !e.excludeKeys(d)), c = c.filter((d) => !e.excludeKeys(d))), n("object:" + (u.length + c.length) + ":");
        const m = (d) => {
          this.dispatch(d), n(":"), e.excludeValues || this.dispatch(a[d]), n(",");
        };
        for (const d of u)
          m(d);
        for (const d of c)
          m(d);
      }
    },
    array(a, s) {
      if (s = s === void 0 ? e.unorderedArrays !== !1 : s, n("array:" + a.length + ":"), !s || a.length <= 1) {
        for (const l of a)
          this.dispatch(l);
        return;
      }
      const o = /* @__PURE__ */ new Map(), r = a.map((l) => {
        const u = As(e);
        u.dispatch(l);
        for (const [c, m] of u.getContext())
          o.set(c, m);
        return u.toString();
      });
      return i = o, r.sort(), this.array(r, !1);
    },
    date(a) {
      return n("date:" + a.toJSON());
    },
    symbol(a) {
      return n("symbol:" + a.toString());
    },
    unkown(a, s) {
      if (n(s), !!a && (n(":"), a && typeof a.entries == "function"))
        return this.array(
          Array.from(a.entries()),
          !0
          /* ordered */
        );
    },
    error(a) {
      return n("error:" + a.toString());
    },
    boolean(a) {
      return n("bool:" + a);
    },
    string(a) {
      n("string:" + a.length + ":"), n(a);
    },
    function(a) {
      n("fn:"), Ca(a) ? this.dispatch("[native]") : this.dispatch(a.toString()), e.respectFunctionNames !== !1 && this.dispatch("function-name:" + String(a.name)), e.respectFunctionProperties && this.object(a);
    },
    number(a) {
      return n("number:" + a);
    },
    xml(a) {
      return n("xml:" + a.toString());
    },
    null() {
      return n("Null");
    },
    undefined() {
      return n("Undefined");
    },
    regexp(a) {
      return n("regex:" + a.toString());
    },
    uint8array(a) {
      return n("uint8array:"), this.dispatch(Array.prototype.slice.call(a));
    },
    uint8clampedarray(a) {
      return n("uint8clampedarray:"), this.dispatch(Array.prototype.slice.call(a));
    },
    int8array(a) {
      return n("int8array:"), this.dispatch(Array.prototype.slice.call(a));
    },
    uint16array(a) {
      return n("uint16array:"), this.dispatch(Array.prototype.slice.call(a));
    },
    int16array(a) {
      return n("int16array:"), this.dispatch(Array.prototype.slice.call(a));
    },
    uint32array(a) {
      return n("uint32array:"), this.dispatch(Array.prototype.slice.call(a));
    },
    int32array(a) {
      return n("int32array:"), this.dispatch(Array.prototype.slice.call(a));
    },
    float32array(a) {
      return n("float32array:"), this.dispatch(Array.prototype.slice.call(a));
    },
    float64array(a) {
      return n("float64array:"), this.dispatch(Array.prototype.slice.call(a));
    },
    arraybuffer(a) {
      return n("arraybuffer:"), this.dispatch(new Uint8Array(a));
    },
    url(a) {
      return n("url:" + a.toString());
    },
    map(a) {
      n("map:");
      const s = [...a];
      return this.array(s, e.unorderedSets !== !1);
    },
    set(a) {
      n("set:");
      const s = [...a];
      return this.array(s, e.unorderedSets !== !1);
    },
    file(a) {
      return n("file:"), this.dispatch([a.name, a.size, a.type, a.lastModfied]);
    },
    blob() {
      if (e.ignoreUnknown)
        return n("[blob]");
      throw new Error(
        `Hashing Blob objects is currently not supported
Use "options.replacer" or "options.ignoreUnknown"
`
      );
    },
    domwindow() {
      return n("domwindow");
    },
    bigint(a) {
      return n("bigint:" + a.toString());
    },
    /* Node.js standard native objects */
    process() {
      return n("process");
    },
    timer() {
      return n("timer");
    },
    pipe() {
      return n("pipe");
    },
    tcp() {
      return n("tcp");
    },
    udp() {
      return n("udp");
    },
    tty() {
      return n("tty");
    },
    statwatcher() {
      return n("statwatcher");
    },
    securecontext() {
      return n("securecontext");
    },
    connection() {
      return n("connection");
    },
    zlib() {
      return n("zlib");
    },
    context() {
      return n("context");
    },
    nodescript() {
      return n("nodescript");
    },
    httpparser() {
      return n("httpparser");
    },
    dataview() {
      return n("dataview");
    },
    signal() {
      return n("signal");
    },
    fsevent() {
      return n("fsevent");
    },
    tlswrap() {
      return n("tlswrap");
    }
  };
}
const xs = "[native code] }", ok = xs.length;
function Ca(e) {
  return typeof e != "function" ? !1 : Function.prototype.toString.call(e).slice(-ok) === xs;
}
class ut {
  constructor(t, i) {
    t = this.words = t || [], this.sigBytes = i === void 0 ? t.length * 4 : i;
  }
  toString(t) {
    return (t || rk).stringify(this);
  }
  concat(t) {
    if (this.clamp(), this.sigBytes % 4)
      for (let i = 0; i < t.sigBytes; i++) {
        const n = t.words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
        this.words[this.sigBytes + i >>> 2] |= n << 24 - (this.sigBytes + i) % 4 * 8;
      }
    else
      for (let i = 0; i < t.sigBytes; i += 4)
        this.words[this.sigBytes + i >>> 2] = t.words[i >>> 2];
    return this.sigBytes += t.sigBytes, this;
  }
  clamp() {
    this.words[this.sigBytes >>> 2] &= 4294967295 << 32 - this.sigBytes % 4 * 8, this.words.length = Math.ceil(this.sigBytes / 4);
  }
  clone() {
    return new ut([...this.words]);
  }
}
const rk = {
  stringify(e) {
    const t = [];
    for (let i = 0; i < e.sigBytes; i++) {
      const n = e.words[i >>> 2] >>> 24 - i % 4 * 8 & 255;
      t.push((n >>> 4).toString(16), (n & 15).toString(16));
    }
    return t.join("");
  }
}, lk = {
  stringify(e) {
    const t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", i = [];
    for (let n = 0; n < e.sigBytes; n += 3) {
      const a = e.words[n >>> 2] >>> 24 - n % 4 * 8 & 255, s = e.words[n + 1 >>> 2] >>> 24 - (n + 1) % 4 * 8 & 255, o = e.words[n + 2 >>> 2] >>> 24 - (n + 2) % 4 * 8 & 255, r = a << 16 | s << 8 | o;
      for (let l = 0; l < 4 && n * 8 + l * 6 < e.sigBytes * 8; l++)
        i.push(t.charAt(r >>> 6 * (3 - l) & 63));
    }
    return i.join("");
  }
}, ck = {
  parse(e) {
    const t = e.length, i = [];
    for (let n = 0; n < t; n++)
      i[n >>> 2] |= (e.charCodeAt(n) & 255) << 24 - n % 4 * 8;
    return new ut(i, t);
  }
}, dk = {
  parse(e) {
    return ck.parse(unescape(encodeURIComponent(e)));
  }
};
class uk {
  constructor() {
    this._data = new ut(), this._nDataBytes = 0, this._minBufferSize = 0, this.blockSize = 512 / 32;
  }
  reset() {
    this._data = new ut(), this._nDataBytes = 0;
  }
  _append(t) {
    typeof t == "string" && (t = dk.parse(t)), this._data.concat(t), this._nDataBytes += t.sigBytes;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _doProcessBlock(t, i) {
  }
  _process(t) {
    let i, n = this._data.sigBytes / (this.blockSize * 4);
    t ? n = Math.ceil(n) : n = Math.max((n | 0) - this._minBufferSize, 0);
    const a = n * this.blockSize, s = Math.min(a * 4, this._data.sigBytes);
    if (a) {
      for (let o = 0; o < a; o += this.blockSize)
        this._doProcessBlock(this._data.words, o);
      i = this._data.words.splice(0, a), this._data.sigBytes -= s;
    }
    return new ut(i, s);
  }
}
class mk extends uk {
  update(t) {
    return this._append(t), this._process(), this;
  }
  finalize(t) {
    t && this._append(t);
  }
}
const La = [
  1779033703,
  -1150833019,
  1013904242,
  -1521486534,
  1359893119,
  -1694144372,
  528734635,
  1541459225
], pk = [
  1116352408,
  1899447441,
  -1245643825,
  -373957723,
  961987163,
  1508970993,
  -1841331548,
  -1424204075,
  -670586216,
  310598401,
  607225278,
  1426881987,
  1925078388,
  -2132889090,
  -1680079193,
  -1046744716,
  -459576895,
  -272742522,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  -1740746414,
  -1473132947,
  -1341970488,
  -1084653625,
  -958395405,
  -710438585,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  -2117940946,
  -1838011259,
  -1564481375,
  -1474664885,
  -1035236496,
  -949202525,
  -778901479,
  -694614492,
  -200395387,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  -2067236844,
  -1933114872,
  -1866530822,
  -1538233109,
  -1090935817,
  -965641998
], jt = [];
class hk extends mk {
  constructor() {
    super(...arguments), this._hash = new ut([...La]);
  }
  reset() {
    super.reset(), this._hash = new ut([...La]);
  }
  _doProcessBlock(t, i) {
    const n = this._hash.words;
    let a = n[0], s = n[1], o = n[2], r = n[3], l = n[4], u = n[5], c = n[6], m = n[7];
    for (let d = 0; d < 64; d++) {
      if (d < 16)
        jt[d] = t[i + d] | 0;
      else {
        const g = jt[d - 15], w = (g << 25 | g >>> 7) ^ (g << 14 | g >>> 18) ^ g >>> 3, L = jt[d - 2], _ = (L << 15 | L >>> 17) ^ (L << 13 | L >>> 19) ^ L >>> 10;
        jt[d] = w + jt[d - 7] + _ + jt[d - 16];
      }
      const b = l & u ^ ~l & c, f = a & s ^ a & o ^ s & o, k = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22), M = (l << 26 | l >>> 6) ^ (l << 21 | l >>> 11) ^ (l << 7 | l >>> 25), j = m + M + b + pk[d] + jt[d], y = k + f;
      m = c, c = u, u = l, l = r + j | 0, r = o, o = s, s = a, a = j + y | 0;
    }
    n[0] = n[0] + a | 0, n[1] = n[1] + s | 0, n[2] = n[2] + o | 0, n[3] = n[3] + r | 0, n[4] = n[4] + l | 0, n[5] = n[5] + u | 0, n[6] = n[6] + c | 0, n[7] = n[7] + m | 0;
  }
  finalize(t) {
    super.finalize(t);
    const i = this._nDataBytes * 8, n = this._data.sigBytes * 8;
    return this._data.words[n >>> 5] |= 128 << 24 - n % 32, this._data.words[(n + 64 >>> 9 << 4) + 14] = Math.floor(
      i / 4294967296
    ), this._data.words[(n + 64 >>> 9 << 4) + 15] = i, this._data.sigBytes = this._data.words.length * 4, this._process(), this._hash;
  }
}
function gk(e) {
  return new hk().finalize(e).toString(lk);
}
function vk(e, t = {}) {
  const i = typeof e == "string" ? e : ak(e, t);
  return gk(i).slice(0, 10);
}
function ai(e) {
  const { host: t, path: i, defaultOptions: n, defaultHeaders: a } = e, o = (() => {
    const d = ba(t, i);
    return d.startsWith("http") ? d : `/${d}`;
  })(), r = (d, b = {}) => {
    const f = new URLSearchParams({
      ...b
    }).toString(), k = ba(o, d);
    return f ? `${k}?${f}` : k;
  }, l = (d = {}) => {
    const { headers: b, ...f } = d;
    return {
      headers: {
        ...a,
        ...b
      },
      ...n,
      ...f
    };
  };
  return {
    baseUrl: o,
    buildRequestUrl: r,
    buildRequestOptions: l,
    fetchPostJson: (d, b, f, k) => fetch(r(d, b), {
      ...l({ ...k, method: _a.POST, body: JSON.stringify(f) })
    }),
    fetchPost: (d, b, f, k) => fetch(r(d, b), {
      ...l({ ...k, method: _a.POST, body: Bf(f) })
    }),
    fetchGet: (d, b, f) => fetch(r(d, b), {
      ...l({ ...f, key: vk([d, b]) })
    })
  };
}
const kt = () => {
  var g, w, L, _, E, T;
  const e = qt(), { globalsState: t } = Xe(), i = ((g = t.value) == null ? void 0 : g["module.cdc.baseUrl"]) || "", n = ((w = t.value) == null ? void 0 : w["module.cdc.ApiKey"]) || "", a = ((L = t.value) == null ? void 0 : L["module.cdc.clientId"]) || "", s = (E = (_ = t.value) == null ? void 0 : _["general.domain"]) == null ? void 0 : E.replace(/\/$/, ""), o = (T = e.value) != null && T.localLogin ? new URL(Rt.auth, `http://${s}`).toString() : `https://${s}${Rt.auth}`, r = ai({
    host: i,
    path: "/",
    defaultHeaders: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    }
  });
  return {
    login: (C, O, B) => {
      var x;
      return me(
        (x = e.value) == null ? void 0 : x.isMocked,
        "accounts.login",
        () => r.fetchPost(Ie.login, void 0, {
          ApiKey: n,
          sessionExpiration: B,
          loginID: C,
          password: O,
          include: "missing-required-fields,preferences",
          includeUserInfo: !0,
          httpStatusCodes: !0
        }).then(async (z) => {
          const A = await z.json();
          return { resp: z, json: A };
        })
      );
    },
    logout: ({
      sessionData: C
    }) => {
      var O;
      return me(
        (O = e.value) == null ? void 0 : O.isMocked,
        "accounts.logout",
        () => r.fetchPost(Ie.logout, void 0, {
          ApiKey: n,
          UID: C.UID,
          httpStatusCodes: !0
        }).then(async (B) => {
          const x = await B.json();
          return { resp: B, json: x };
        })
      );
    },
    emailValidation: (C) => r.fetchPost(Ie.isEmailAvailable, void 0, {
      ApiKey: n,
      loginID: C
    }).then(async (O) => {
      const B = await O.json();
      return { ...O, json: B };
    }),
    getPasswordPolicies: (C) => {
      var O;
      return me(
        (O = e.value) == null ? void 0 : O.isMocked,
        "accounts.getPasswordPolicies",
        () => r.fetchPost(Ie.getPasswordPolicies, void 0, {
          ApiKey: n,
          sections: C.join(","),
          filter: "full",
          httpStatusCodes: !0
        }).then(async (B) => {
          const x = await B.json();
          return { resp: B, json: x };
        })
      );
    },
    resetPassword: (C) => {
      var O;
      return me(
        (O = e.value) == null ? void 0 : O.isMocked,
        "accounts.resetPassword",
        () => r.fetchPost(Ie.resetPassword, void 0, {
          ApiKey: n,
          email: C,
          loginID: C,
          httpStatusCodes: !0
        }).then(async (B) => {
          try {
            const x = await B.json();
            return { resp: B, json: x };
          } catch {
            return { resp: B, json: {} };
          }
        })
      );
    },
    resetPasswordWithResetToken: ({ passwordResetToken: C, newPassword: O }) => {
      var B;
      return me(
        (B = e.value) == null ? void 0 : B.isMocked,
        "accounts.resetPasswordWithResetToken",
        () => r.fetchPost(Ie.resetPassword, void 0, {
          ApiKey: n,
          passwordResetToken: C,
          newPassword: O,
          httpStatusCodes: !0
        }).then(async (x) => {
          try {
            const z = await x.json();
            return { resp: x, json: z };
          } catch {
            return { resp: x, json: {} };
          }
        })
      );
    },
    setAccountInfo: (C) => {
      var B;
      const O = Nn();
      return me(
        (B = e.value) == null ? void 0 : B.isMocked,
        "accounts.setAccountInfo",
        () => r.fetchPost(Ie.setAccountInfoLegacy, void 0, {
          ApiKey: n,
          login_token: O.get(),
          httpStatusCodes: !0,
          ...C
        }).then(async (x) => {
          try {
            const z = await x.json();
            return { resp: x, json: z };
          } catch {
            return { resp: x, json: {} };
          }
        })
      );
    },
    authorize: async (C) => {
      var A;
      console.debug("CDC authorize ...");
      const O = await Ff(60), B = await Rf(O);
      sessionStorage.setItem(Ma, O);
      const x = {
        response_type: "code",
        // 'code', 'token', 'id_token'
        client_id: a,
        redirect_uri: (C == null ? void 0 : C.redirectUri) || o,
        scope: "openid customer_data bpdata shop",
        state: Sf(),
        code_challenge: B,
        code_challenge_method: "S256"
        // e.g., 'S256', 'plain'
        // nonce: 'NONCE_VALUE', // Should be generated dynamically
        // prompt: 'PROMPT_VALUE', // e.g., 'none', 'login', 'consent'
        // response_mode: 'RESPONSE_MODE', // e.g., 'query', 'fragment', 'form_post'
      }, z = Ea(x, n, i, "/authorize");
      (A = e.value) != null && A.isMocked ? (console.debug("MOCK", "Skipping authorize URL:", z), console.debug("MOCK", "Navigating to:", (location.pathname + "/auth?code=123456abc").replace("//", "/")), location.href = (location.pathname + "/auth?code=123456abc").replace("//", "/")) : location.href = z;
    },
    getToken: ({ authorizationCode: C, redirectUri: O = o }) => {
      var B;
      return me(
        (B = e.value) == null ? void 0 : B.isMocked,
        "accounts.login",
        () => r.fetchPost(Ea({}, n, "", "/token"), void 0, {
          code: C,
          grant_type: "authorization_code",
          redirect_uri: O,
          client_id: a,
          code_verifier: sessionStorage.getItem(Ma)
        }).then(async (x) => {
          try {
            const z = await x.json();
            return { resp: x, json: z };
          } catch {
            return { resp: x, json: {} };
          }
        })
      );
    },
    unsubscribe: ({ channelToken: C, subscriptionID: O }) => {
      var B;
      return me(
        (B = e.value) == null ? void 0 : B.isMocked,
        "accounts.unsubscribe",
        () => r.fetchPost(Ie.unsubscribe, void 0, {
          ApiKey: n,
          channelToken: C,
          subscriptionID: O,
          httpStatusCodes: !0
        }).then(async (x) => {
          try {
            const z = await x.json();
            return { resp: x, json: z };
          } catch (z) {
            return console.error(z), { resp: x, json: {} };
          }
        })
      );
    },
    getSchema: () => {
      var C;
      return me(
        (C = e.value) == null ? void 0 : C.isMocked,
        "accounts.getSchema",
        () => r.fetchPost(Ie.getSchema, void 0, {
          ApiKey: n,
          httpStatusCodes: !0
        }).then(async (O) => {
          try {
            const B = await O.json();
            return { resp: O, json: B };
          } catch (B) {
            return console.error(B), { resp: O, json: {} };
          }
        })
      );
    }
  };
};
function Ea(e, t, i, n) {
  const a = `${i}${ik.oidc}/${t}${n}`, s = Object.keys(e).map((o) => `${encodeURIComponent(o)}=${encodeURIComponent(e[o])}`).join("&");
  return `${a}?${s}`;
}
const fk = process.env.NUXT_PUBLIC_LOCAL_LOGIN, kk = process.env.NUXT_PUBLIC_REQUEST_CONTEXT_FORCE_HOST, mt = () => {
  var b;
  const { globalsState: e } = Xe(), t = qt(), i = ai({
    host: ((b = e.value) == null ? void 0 : b["general.experienceApi"]) || "",
    path: "/",
    defaultHeaders: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      ...fk && { "x-forwarded-host": kk }
    }
  });
  return {
    createSession: async (f) => {
      const k = await i.fetchPostJson(
        Ji.create,
        void 0,
        {
          regToken: f.refresh_token,
          mieleJWT: f.access_token
        },
        {
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "include"
        }
      );
      try {
        const M = await k.json();
        return { resp: k, json: M };
      } catch (M) {
        return console.error(M), { resp: k, json: {} };
      }
    },
    validateSession: async () => {
      const f = await i.fetchGet(Ji.status, void 0, {
        credentials: "include"
      });
      try {
        const k = await f.json();
        return { resp: f, json: k };
      } catch (k) {
        return console.error(k), { resp: f, json: {} };
      }
    },
    logoutSession: async () => {
      const f = await i.fetchGet(Ji.logout, void 0, {
        credentials: "include"
      });
      try {
        const k = await f.json();
        return { resp: f, json: k };
      } catch (k) {
        return console.error(k), { resp: f, json: {} };
      }
    },
    getUserInfo: async () => {
      var f;
      return me((f = t.value) == null ? void 0 : f.isMocked, "experience.userInfo", async () => {
        var M;
        const k = await i.fetchGet(
          ui.getUserInfo(e.value["general.country"]),
          {
            fields: "FULL",
            lang: `${e.value["general.language"]}_${e.value["general.country"].toUpperCase()}`
          },
          {
            headers: {
              ApiKey: ((M = e.value) == null ? void 0 : M["module.eComApi.ApiKey"]) || ""
            }
          }
        );
        try {
          const j = await k.json();
          return { resp: k, json: j };
        } catch (j) {
          return console.error(j), { resp: k };
        }
      });
    },
    getGlobalSettings: async () => {
      var f;
      return me((f = t.value) == null ? void 0 : f.isMocked, "experience.globalSettings", async () => {
        var M;
        const k = await i.fetchGet(ui.getGlobalSettingsUrl(e.value["general.country"]), void 0, {
          headers: {
            ApiKey: ((M = e.value) == null ? void 0 : M["module.eComApi.ApiKey"]) || ""
          }
        });
        try {
          const j = await k.json();
          return { resp: k, json: j };
        } catch (j) {
          return console.error(j), { resp: k };
        }
      });
    },
    setMieleClub: async (f) => {
      var k;
      return me((k = t.value) == null ? void 0 : k.isMocked, "experience.mieleClub", async () => {
        var j;
        const M = await i.fetchPost(
          ui.getMieleClubUrl(e.value["general.country"]),
          { isMieleClubMember: f },
          {},
          {
            headers: {
              ApiKey: ((j = e.value) == null ? void 0 : j["module.eComApi.ApiKey"]) || ""
            }
          }
        );
        try {
          const y = await M.json();
          return { resp: M, json: y };
        } catch (y) {
          return console.error(y), { resp: M };
        }
      });
    },
    setEmail: async (f) => {
      var k;
      return me((k = t.value) == null ? void 0 : k.isMocked, "experience.email", async () => {
        var j;
        const M = await i.fetchPostJson(
          ui.getEmailUrl(e.value["general.country"]),
          {},
          { newEmail: f },
          {
            headers: {
              "Content-Type": "application/json",
              ApiKey: ((j = e.value) == null ? void 0 : j["module.eComApi.ApiKey"]) || ""
            }
          }
        );
        try {
          const y = await M.json();
          return { resp: M, json: y };
        } catch (y) {
          return console.error(y), { resp: M };
        }
      });
    },
    getNewsletterAccount: (f) => {
      var k;
      return me((k = t.value) == null ? void 0 : k.isMocked, "experience.newsletterPreferences.account", async () => {
        const M = await i.fetchGet(Zi.account, {
          uid: f
        });
        try {
          const j = await M.json();
          return { resp: M, json: j };
        } catch (j) {
          return console.error(j), { resp: M };
        }
      });
    },
    setNewsletterLiteAccountInfo: (f) => {
      var k;
      return me(
        (k = t.value) == null ? void 0 : k.isMocked,
        "experience.newsletterPreferences.setLiteAccountInfo",
        async () => {
          const M = await i.fetchPostJson(
            Zi.setLiteAccountInfo,
            {},
            { ...f },
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          );
          try {
            const j = await M.json();
            return { resp: M, json: j };
          } catch (j) {
            return console.error(j), { resp: M };
          }
        }
      );
    },
    setNewsletterFullAccountInfo: (f) => {
      var k;
      return me(
        (k = t.value) == null ? void 0 : k.isMocked,
        "experience.newsletterPreferences.setFullAccountInfo",
        async () => {
          const M = await i.fetchPostJson(
            Zi.setFullAccountInfo,
            {},
            { ...f },
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          );
          try {
            const j = await M.json();
            return { resp: M, json: j };
          } catch (j) {
            return console.error(j), { resp: M };
          }
        }
      );
    }
  };
}, Is = () => async (e, t) => {
  var r, l;
  console.warn("useAccountLogin is DEPRECATED and will be removed. You should use: useCdcService");
  const n = await mt().getGlobalSettings(), a = ((r = n == null ? void 0 : n.json) == null ? void 0 : r.cdcSessionDuration) || 3600, s = kt(), { json: o } = await s.login(e, t, a);
  if (o.statusCode !== 200)
    switch (o.statusCode) {
      case 206:
        let u = null;
        return (l = o.missingRequiredFields) != null && l.length && (u = new xi(void 0, void 0, void 0, o)), { json: o, error: u };
      case 403:
        throw new Cn();
      default:
        throw new Ln(o.errorMessage, o.errorDetails);
    }
  return { json: o, error: null };
}, Oi = () => Et(Qf), Nn = () => Et(Ts), xy = (e, t) => {
  var n;
  const i = Et(Xf);
  return i.get() || i.set(e.host || e[":authority"] || ((n = t.value) == null ? void 0 : n["general.domain"])), i;
}, bk = () => {
  var c, m, d, b, f;
  const e = qt(), { globalsState: t } = Xe(), i = ((c = t.value) == null ? void 0 : c["module.auth.baseUrl"]) || "", n = (d = (m = t.value) == null ? void 0 : m["general.domain"]) == null ? void 0 : d.replace(/\/$/, ""), a = ((f = (b = i == null ? void 0 : i.split("/")) == null ? void 0 : b.slice(-1)) == null ? void 0 : f.pop()) || "", s = `https://${n}${Rt.auth}`, o = ai({
    host: i,
    path: "/",
    defaultHeaders: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      Accept: "application/json"
    }
  });
  return { getToken: ({
    authorizationCode: k,
    org: M = a,
    grantType: j = "authorization_code",
    redirectUri: y = s
  }) => o.fetchPost("/token", void 0, {
    org: M,
    code: k,
    grant_type: j,
    redirect_uri: y
  }).then(async (g) => {
    const w = await g.json();
    return { resp: g, data: w };
  }), authorize: (k) => {
    var w;
    if ((w = e.value) != null && w.isMocked) {
      location.href = "/login/auth?code=mockingreallywell";
      return;
    }
    const {
      clientId: M = "XXX",
      responseType: j = "code",
      scope: y = "openid+email+profile+bpdata+zuora+mcs+shop+stock",
      redirectUri: g = s
      // redirectUri = 'https://oauth2-demo-qs.map.miele-iot.com/demo/oauth2/gb2', // whitelisted address for testing
    } = k || {};
    location.href = `${i}/authorize?client_id=${M}&response_type=${j}&scope=${y}&redirect_uri=${g}`;
  }, logout: ({ authorizationCode: k, org: M = a }) => {
    var j;
    return me(
      (j = e.value) == null ? void 0 : j.isMocked,
      "accounts.logout",
      () => o.fetchPost("/logout", void 0, void 0, {
        headers: {
          org: M,
          Authorization: `Bearer ${k}`
        }
      }).then(async (y) => {
        const g = await y.json();
        return { resp: y, json: g };
      })
    );
  } };
}, At = () => ({
  createSession: async (n) => {
    const { resp: a } = await mt().createSession(n);
    if (!a.ok)
      throw new ye("Unable to create session");
  },
  isSessionValid: async () => {
    var o;
    const { resp: n, json: a } = await mt().validateSession();
    if (!n.ok)
      throw new ye("Unable to validate session");
    const s = a;
    return ((o = s == null ? void 0 : s.auth) == null ? void 0 : o.authenticated) || !1;
  },
  logoutSession: async () => {
    const { resp: n } = await mt().logoutSession();
    if (!n.ok)
      throw new ye("Unable to logout of session");
  }
}), wk = () => {
  const { isSessionValid: e } = At(), t = bk(), i = J({
    access_token: null,
    token_type: null,
    expires_in: null,
    refresh_token: null
  }), n = () => {
    t.authorize();
  }, a = Nn();
  return { authorize: n, getJwtToken: async ({ authorizationCode: o }) => {
    if (!await e() || !i.value.access_token) {
      const l = await t.getToken({ authorizationCode: o }), { resp: u, data: c } = l;
      if (!u.ok) {
        const m = c;
        throw (m == null ? void 0 : m.error) === "invalid_grant" ? (console.warn("New session is required.", m == null ? void 0 : m.error_description), new Pn(m == null ? void 0 : m.error_description)) : Error(`Unhandled error getJwtToken: ${JSON.stringify(m)}`);
      }
      a.set(c.refresh_token), i.value = c;
    }
    return i.value;
  } };
}, yk = () => !!Et(ek).get(), Yi = J(void 0), qt = () => (Yi.value || (Yi.value = {
  isMocked: !1,
  isDangerZone: yk()
}), Yi), Mk = (e) => {
  var u;
  const t = qt(), { globalsState: i } = Xe(), n = e || ((u = i.value) == null ? void 0 : u["general.domain"]), a = ai({
    host: `https://${n}`,
    path: "/",
    defaultHeaders: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      Accept: "application/json"
    }
  }), s = async () => {
    var c;
    return me(
      (c = t.value) == null ? void 0 : c.isMocked,
      "hybris.csrf",
      () => a.fetchGet(lt(Qt.csrf)).then(async (m) => {
        const d = await m.json();
        return { resp: m, json: d };
      })
    );
  };
  return { login: async ({
    newUser: c,
    UIDSignature: m,
    signatureTimestamp: d,
    UID: b,
    profile: f,
    data: k,
    ...M
  }) => {
    var g;
    const j = {
      gigyaData: {
        eventName: "login",
        remember: !1,
        isGlobal: !0,
        fullEventName: Ie.login,
        loginMode: "standard",
        provider: "",
        source: "showScreenSet",
        // TODO: check if this is necessary
        newUser: c ?? M.isNewUser ?? !1,
        UIDSignature: m,
        signatureTimestamp: d,
        UID: b,
        profile: f,
        data: k
      }
    }, y = { headers: {} };
    try {
      const { json: w } = await s();
      y.headers.csrftoken = w.CSRFToken;
    } catch (w) {
      throw console.error(w), new ze("Unable to get csrf token.", void 0, w);
    }
    return me(
      (g = t.value) == null ? void 0 : g.isMocked,
      "hybris.login",
      () => a.fetchPost(lt(Qt.gigyaRaasLogin), void 0, j, y).then(async (w) => {
        const L = await w.json();
        return { resp: w, json: L };
      })
    );
  }, logout: () => {
    var c;
    return me(
      (c = t.value) == null ? void 0 : c.isMocked,
      "hybris.logout",
      () => a.fetchGet(lt(Qt.logout)).then(async (m) => ({ resp: m, json: {} }))
    );
  }, sessionStatus: (c) => {
    var m;
    return me(
      (m = t.value) == null ? void 0 : m.isMocked,
      "hybris.session",
      () => a.fetchGet(
        lt(Qt.authenticationStatus),
        void 0,
        c ? { headers: { cookie: c } } : void 0
      ).then(async (d) => ({ resp: d, json: {} }))
    );
  } };
}, On = (e) => {
  const t = Mk(e);
  return { login: async (s) => {
    const { resp: o, json: r } = await t.login(s);
    if (!o.ok)
      throw console.error("ERROR", "hybris login failed with status", o.status), Error("WebLoginError");
    return r;
  }, logout: async () => {
    const { resp: s } = await t.logout();
    if (!s.ok)
      throw console.error("ERROR", "hybris logout failed with status", s.status), Error("WebLoginError");
  }, sessionStatus: async (s) => {
    const { resp: o } = await t.sessionStatus(s);
    if (!o.ok)
      switch (o.status) {
        case 401:
          const r = new ys(o.statusText);
          throw r.code = 401, r;
        default:
          throw new ze(o.statusText);
      }
    if (new URL(o.url).pathname !== lt(Qt.authenticationStatus)) {
      const r = new ze("Unable to check session status.");
      throw r.code = 403, r;
    }
    return o.status;
  } };
}, zk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  useWebService: On
}, Symbol.toStringTag, { value: "Module" })), Un = () => {
  const { setIsLoggedIn: e, isLoggedIn: t } = $n(), i = () => {
    const a = Ni();
    console.debug("Removing session data from storage"), a.remove();
  };
  return { logout: async () => {
    const a = Dn(), s = Oi();
    console.debug("Initiating logout process");
    const { logoutSession: o } = At(), r = On();
    console.debug("Logging out from AuthProxy & remove JWT cookie via experience api"), await o(), console.debug("Logging out from Hybris"), await r.logout(), console.debug("Removing CDC session cookie"), a.remove(), console.debug("Removing auth code cookie"), s.remove(), i(), console.debug("Removing Gigya cookies"), Ps(), e(!1);
  }, isLoggedIn: t, clearSessionCache: i };
}, Pa = J(!1), $n = () => {
  const e = (i) => {
    console.debug(`User is logged ${i ? "in" : "out"}`), Pa.value = i;
  };
  return {
    isLoggedIn: () => Pa.value,
    setIsLoggedIn: e,
    checkSession: async (i = !1) => {
      const n = (await Promise.resolve().then(() => zk)).useWebService();
      try {
        return await n.sessionStatus(), e(!0), !0;
      } catch (a) {
        if (a.code === 401) {
          const { logout: s, clearSessionCache: o } = Un();
          i ? await s() : (o(), e(!1));
        } else
          throw a;
        return !1;
      }
    }
  };
}, Ft = "miele.marketingconsent.personalized.tracking.isConsentGranted", Ds = "miele.marketingconsent.personalized.general.isConsentGranted", jk = "miele.marketingconsent.personalized.iot.isConsentGranted", Ns = "terms.miele.statement.isConsentGranted", Os = "miele.general.newsletter.email.isSubscribed", Re = {
  login: "umf-login-form",
  register: "umf-register-form",
  registerDetails: "umf-register-details-form",
  changeEmail: "umf-change-email-form",
  changePassword: "umf-change-password-form",
  changeMarketingPreference: "umf-marketing-preference-form",
  newPassword: "umf-new-password-form",
  forgotPassword: "umf-forgot-password-form"
}, mi = {
  login: "login_event",
  register: "register_event",
  registerDetailsComplete: "full_registration_complete",
  formSubmit: "MieleBasic_FormSubmit",
  addressLookupClick: "search_address_click",
  addressLookupError: "lookup_address_error",
  selectAddressFromDropdown: "system_provided_address_click"
};
function Fe() {
  function e({ userInfo: o, loginSession: r }) {
    var u, c;
    const l = {
      event: mi.login,
      uid: r.UID,
      consent_status: Us(r),
      user: {
        account_type: ((u = o.customerType) == null ? void 0 : u.toLowerCase()) ?? "n/a",
        clubmember: o.clubMember ? "yes" : "no",
        loginStatus: "logged in",
        miele_club_level: (c = o.mieleClubUserGroup) == null ? void 0 : c.toLowerCase()
      }
    };
    return s().push(l);
  }
  function t({
    uid: o,
    consentFields: r,
    consentStatus: l
  }) {
    const u = r.map((m, d) => m ? `level ${d + 1}` : null).filter((m) => m !== null).join(","), c = {
      event: mi.register,
      uid: o,
      consent_status: l,
      user: {
        clubmember: "no",
        loginStatus: "logged in",
        marketing_consent_levels: u || "no"
      }
    };
    s().push(c);
  }
  function i(o, r) {
    var c;
    const l = Sk(o), u = {
      event: mi.registerDetailsComplete,
      uid: o.UID,
      consent_status: Ck(o),
      user: {
        account_type: (c = r.customerType) == null ? void 0 : c.toLowerCase(),
        clubmember: r.registerMieleClub ? "yes" : "no",
        loginStatus: "logged in",
        marketing_consent_levels: l,
        miele_club_level: r.registerMieleClub ? "member" : "none"
      }
    };
    return s().push(u);
  }
  const n = (o, r) => {
    const l = {
      event: mi.formSubmit,
      form: {
        identifier: o,
        form_submission_status: [void 0, null].includes(r) ? "ok" : `error:${r}`
      }
    };
    return s().push(l);
  }, a = (o, r) => {
    if (window === void 0)
      return;
    const l = {
      event: o
    };
    return r && (l.error_message = r), s().push(l);
  };
  function s() {
    return window != null && window.dataLayer || (window.dataLayer = []), window == null ? void 0 : window.dataLayer;
  }
  return {
    getDataLayer: s,
    pushLoginEvent: e,
    pushRegisterEvent: t,
    pushRegisterDetailsEvent: i,
    pushFormSubmitEvent: n,
    pushAddressEvent: a
  };
}
function _k(e) {
  var t, i, n, a, s, o, r, l;
  return [
    (s = (a = (n = (i = (t = e == null ? void 0 : e.preferences) == null ? void 0 : t.miele) == null ? void 0 : i.marketingconsent) == null ? void 0 : n.personalized) == null ? void 0 : a.tracking) == null ? void 0 : s.isConsentGranted,
    (r = (o = e == null ? void 0 : e.preferences) == null ? void 0 : o[$s(Ft)]) == null ? void 0 : r.isConsentGranted,
    (l = e == null ? void 0 : e.preferences) == null ? void 0 : l[Ft]
  ];
}
function Us(e) {
  var t, i, n, a, s, o, r, l;
  return (
    // TODO: check with CDC if this ⬇ can be standardized
    ((s = (a = (n = (i = (t = e == null ? void 0 : e.preferences) == null ? void 0 : t.miele) == null ? void 0 : i.marketingconsent) == null ? void 0 : n.personalized) == null ? void 0 : a.tracking) == null ? void 0 : s.isConsentGranted) ?? ((r = (o = e == null ? void 0 : e.preferences) == null ? void 0 : o[$s(Ft)]) == null ? void 0 : r.isConsentGranted) ?? ((l = e == null ? void 0 : e.preferences) == null ? void 0 : l[Ft]) ?? !1
  );
}
function Sk(e) {
  var t, i, n, a, s, o, r, l, u, c, m, d, b, f, k;
  return [
    (s = (a = (n = (i = (t = e == null ? void 0 : e.preferences) == null ? void 0 : t.miele) == null ? void 0 : i.marketingconsent) == null ? void 0 : n.personalized) == null ? void 0 : a.general) == null ? void 0 : s.isConsentGranted,
    (c = (u = (l = (r = (o = e == null ? void 0 : e.preferences) == null ? void 0 : o.miele) == null ? void 0 : r.marketingconsent) == null ? void 0 : l.personalized) == null ? void 0 : u.tracking) == null ? void 0 : c.isConsentGranted,
    (k = (f = (b = (d = (m = e == null ? void 0 : e.preferences) == null ? void 0 : m.miele) == null ? void 0 : d.marketingconsent) == null ? void 0 : b.personalized) == null ? void 0 : f.iot) == null ? void 0 : k.isConsentGranted
  ].map((M, j) => M ? `level ${j + 1}` : null).filter((M) => !!M).join(",");
}
function Ck(e) {
  var t, i, n, a, s, o, r, l, u, c, m, d, b, f, k;
  return ((s = (a = (n = (i = (t = e == null ? void 0 : e.preferences) == null ? void 0 : t.miele) == null ? void 0 : i.marketingconsent) == null ? void 0 : n.personalized) == null ? void 0 : a.general) == null ? void 0 : s.isConsentGranted) || ((c = (u = (l = (r = (o = e == null ? void 0 : e.preferences) == null ? void 0 : o.miele) == null ? void 0 : r.marketingconsent) == null ? void 0 : l.personalized) == null ? void 0 : u.tracking) == null ? void 0 : c.isConsentGranted) || ((k = (f = (b = (d = (m = e == null ? void 0 : e.preferences) == null ? void 0 : m.miele) == null ? void 0 : d.marketingconsent) == null ? void 0 : b.personalized) == null ? void 0 : f.iot) == null ? void 0 : k.isConsentGranted) || !1;
}
const $s = (e) => e.includes(".") ? e.substring(0, e.lastIndexOf(".")) : e, Lk = (e) => e.includes(".") ? e.substring(e.indexOf(".") + 1) : e, Bs = () => {
  const e = kt(), { isSessionValid: t } = At(), i = Nn(), n = J({
    access_token: null,
    token_type: null,
    expires_in: null,
    refresh_token: null
  });
  return { login: async (r, l) => {
    var b, f;
    const c = await mt().getGlobalSettings(), m = ((b = c == null ? void 0 : c.json) == null ? void 0 : b.cdcSessionDuration) || 3600, { json: d } = await e.login(r, l, m);
    if (d.statusCode !== 200)
      switch (d.statusCode) {
        case 206:
          let k = null;
          return (f = d.missingRequiredFields) != null && f.length && (k = new xi(void 0, void 0, void 0, d)), { json: d, error: k };
        case 403:
          throw new Cn();
        default:
          throw new Ln(d.errorMessage, d.errorDetails);
      }
    return { json: d, error: null };
  }, authorize: () => e.authorize(), getJwtToken: async ({ authorizationCode: r }) => {
    if (!await t() || !n.value.access_token) {
      const u = await e.getToken({ authorizationCode: r }), { resp: c, json: m } = u;
      if (!c.ok) {
        const d = m;
        throw (d == null ? void 0 : d.error) === "invalid_grant" ? (console.warn("New session is required.", d == null ? void 0 : d.error_description), new Pn(d == null ? void 0 : d.error_description)) : Error(`Unhandled error getJwtToken: ${JSON.stringify(d)}`);
      }
      i.set(m.refresh_token), n.value = m;
    }
    return n.value;
  } };
}, Rs = () => {
  const { setIsLoggedIn: e, isLoggedIn: t } = $n(), i = Is(), { redirectToTarget: n, storeRedirect: a } = In(), s = mt(), o = J(null);
  return { login: async ({ email: l, password: u, code: c, redirectUrl: m, isRemember: d }) => {
    const b = !!sessionStorage.getItem(Wf), f = Xe().globalsState.value["module.auth.authProxyDeprecated"], k = (
      // useConfig().value?.isDangerZone && // TODO: remove this check when feature is ready
      !b && // AuthProxy forced when "miele_force_auth_proxy" exist in session storage
      f
    ), { authorize: M, getJwtToken: j } = k ? Bs() : wk(), y = On(), g = Oi(), w = Ni(), { createSession: L } = At(), { logout: _ } = Un();
    if (o.value = null, m && a(m), l && u)
      try {
        await _();
        const { json: E, error: T } = await i(l, u);
        if (await y.login(E), w.set(E, d), T)
          throw T;
      } catch (E) {
        throw console.warn("An error ocurred when trying to login with CDC."), o.value = E, E;
      }
    else
      c && g.set(c);
    if (!g.get())
      await M();
    else {
      const E = w.get();
      if (E) {
        try {
          const T = await j({ authorizationCode: g.get() });
          await L(T);
        } catch (T) {
          if (T instanceof Error)
            switch (T.name) {
              case "SessionInvalidGrantError":
                await M();
                return;
              default:
                o.value = new Tn();
                return;
            }
          else
            throw T;
        } finally {
          g.remove();
        }
        if (e(!0), globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: T, pushLoginEvent: C } = Fe();
          try {
            const O = await s.getUserInfo();
            O.json && (Ek(), T(Re.login), C({ userInfo: O.json, loginSession: E }));
          } catch (O) {
            console.error("Error fetching user info: ", O);
          }
        }
        n();
      } else
        e(!1), location.href = lt(Rt.login);
    }
  }, error: o, isLoggedIn: t };
};
function Ek() {
  const e = new URL(globalThis.window.location.href);
  e.search = "", globalThis.window.history.pushState({}, document.title, e);
}
const Fs = (e) => {
  if (e.statusCode !== 200 || e.errorCode !== 0) {
    if (vt(e.errorCode))
      throw new ft(e.errorCode);
    switch (e.statusCode) {
      case 400:
      case 401:
      case 403:
        throw new ye();
      default:
        throw e.errorMessage ? new gt(e.errorMessage, e.errorDetails) : new ye();
    }
  }
  return e;
}, Pk = () => async (e) => {
  const { json: t } = await kt().resetPassword(e);
  return Fs(t);
}, Iy = () => async ({ passwordResetToken: e, newPassword: t }) => {
  const { json: i } = await kt().resetPasswordWithResetToken({ passwordResetToken: e, newPassword: t });
  return Fs(i);
}, Tk = () => {
  const e = Pk();
  return { forgotPassword: async (i) => await e(i) };
}, Ui = () => async () => {
  const { resp: e, json: t } = await Bn().verifySession();
  if (!e.ok)
    throw e.status === 401 || !t.active ? new En("Session is not valid") : new ye(t.message);
  return t;
}, Ak = () => ({ submitChangePassword: async (t, i) => {
  const n = si();
  return await Ui()(), await n({ password: t, newPassword: i });
} }), xk = () => async (e) => {
  const t = kt();
  await Ui()();
  const { json: n } = await t.getPasswordPolicies(e);
  if (n.statusCode !== 200 || n.errorCode !== 0) {
    if (vt(n.errorCode))
      throw new ft(n.errorCode);
    switch (n.statusCode) {
      case 400:
      case 401:
      case 403:
        throw new ye();
      default:
        throw n.errorMessage ? new gt(n.errorMessage, n.errorDetails) : new ye();
    }
  }
  return n;
}, Ta = {
  completeRegistrationUrl: "/registration/details",
  dashboardUrl: "/e/account/dashboard",
  loginUrl: "/login",
  registerUrl: "/registration",
  forgotPasswordUrl: "/login/forgotpassword",
  newPasswordUrl: "/login/newpassword"
}, Dy = () => ({ checkSessionAndRedirectOnInvalid: async (t) => {
  var o;
  if ((o = qt().value) != null && o.isMocked)
    return;
  const n = t ? Ta.loginUrl + "?target_url=" + t : Ta.loginUrl, { isSessionValid: a } = At();
  await a() || (location.href = n);
} }), Ik = (e) => {
  if (e.statusCode !== 200 || e.errorCode !== 0) {
    if (vt(e.errorCode))
      throw new ft(e.errorCode);
    switch (e.statusCode) {
      case 400:
      case 401:
      case 403:
        throw new ye();
      default:
        throw e.errorMessage ? new gt(e.errorMessage, e.errorDetails) : new ye();
    }
  }
  return e;
}, Ny = async (e) => {
  const { json: t } = await kt().unsubscribe(e);
  return Ik(t);
}, Oy = async () => {
  const e = kt(), { json: t } = await e.getSchema();
  if (t.statusCode !== 200 || t.errorCode !== 0) {
    if (vt(t.errorCode))
      throw new ft(t.errorCode);
    switch (t.statusCode) {
      case 400:
      case 401:
      case 403:
        throw new ye();
      default:
        throw t.errorMessage ? new gt(t.errorMessage, t.errorDetails) : new ye();
    }
  }
  return t;
}, Dk = () => {
  const e = () => {
    const i = Ni();
    console.debug("Removing session data from storage"), i.remove();
  };
  return { logout: async () => {
    const i = Dn(), n = Oi();
    console.debug("Initiating logout process");
    const { logoutSession: a } = At();
    console.debug("Logging out from AuthProxy & remove JWT cookie via experience api"), await a(), console.debug("Removing CDC session cookie"), i.remove(), console.debug("Removing auth code cookie"), n.remove(), e(), console.debug("Removing Gigya cookies"), Ps();
  }, clearSessionCache: e };
}, Vs = J(!1), Aa = (e) => {
  console.debug(`User is logged ${e ? "in" : "out"}`), Vs.value = e;
}, Uy = () => {
  const e = Is(), { redirectToTarget: t, storeRedirect: i } = In(), n = J(null);
  return { login: async ({ email: s, password: o, code: r, redirectUrl: l, isRemember: u }) => {
    const { authorize: c, getJwtToken: m } = Bs(), d = Oi(), b = Ni(), { createSession: f } = At(), { logout: k } = Dk();
    if (n.value = null, l && i(l), s && o)
      try {
        await k();
        const { json: M, error: j } = await e(s, o);
        if (console.log("useLoginWithoutHybrisSession -> login -> accountLogin -> json response", M), b.set(M, u), j)
          throw j;
      } catch (M) {
        throw console.warn("An error ocurred when trying to login with CDC."), n.value = M, M;
      }
    else
      r && d.set(r);
    if (!d.get())
      await c();
    else if (b.get()) {
      try {
        const j = await m({ authorizationCode: d.get() });
        await f(j);
      } catch (j) {
        if (j instanceof Error)
          if (j.name === "SessionInvalidGrantError") {
            await c();
            return;
          } else {
            n.value = new Tn();
            return;
          }
        else
          throw j;
      } finally {
        d.remove();
      }
      Aa(!0), t();
    } else
      Aa(!1), location.href = lt(Rt.login);
  }, error: n, isLoggedIn: Vs };
}, pn = "consentLevelOne", hn = "consentLevelTwo", gn = "consentLevelThree", qs = (e) => {
  const t = Hf(e), i = t !== null, n = (r) => t == null ? void 0 : t.some((l) => l[r]), a = (r, { consentLevelOne: l, consentLevelTwo: u, consentLevelThree: c }) => {
    const d = [
      [pn, l],
      [hn, u],
      [gn, c]
    ].map(([b, f]) => {
      var k, M, j;
      return (j = (M = (k = t == null ? void 0 : t.find((y) => y[b])) == null ? void 0 : k[b]) == null ? void 0 : M.map(
        (y) => y.startsWith(r) ? [Lk(y), l && f] : null
      )) == null ? void 0 : j.filter((y) => y !== null);
    }).filter((b) => b !== null && (b == null ? void 0 : b.length) > 0).flat();
    return Object.fromEntries(d);
  };
  return {
    getSubscriptionsFromCustomConsentConfig: ({
      consentLevelOne: r,
      consentLevelTwo: l,
      consentLevelThree: u
    }) => a("subscriptions.", { consentLevelOne: r, consentLevelTwo: l, consentLevelThree: u }),
    getPreferencesFromCustomConsentConfig: ({
      consentLevelOne: r,
      consentLevelTwo: l,
      consentLevelThree: u
    }) => a("preferences.", { consentLevelOne: r, consentLevelTwo: l, consentLevelThree: u }),
    hasCustomConsentConfig: i,
    customConsentConfig: t,
    hasConsentGroup: n
  };
}, Gs = () => async (e) => {
  await Ui()();
  const { json: i } = await Bn().getAccountInfo({ include: e });
  if (i.statusCode !== 200 || i.errorCode !== 0) {
    if (vt(i.errorCode))
      throw new ft(i.errorCode);
    switch (i.statusCode) {
      case 400:
      case 401:
      case 403:
        throw new ye();
      default:
        throw i.errorMessage ? new gt(i.errorMessage, i.errorDetails) : new ye();
    }
  }
  return i;
}, Bn = () => {
  var o, r;
  const e = qt(), { globalsState: t } = Xe(), i = ai({
    host: ((o = t.value) == null ? void 0 : o["general.experienceApi"]) || "",
    path: "/",
    defaultHeaders: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      apiKey: ((r = t.value) == null ? void 0 : r["module.eComApi.ApiKey"]) || ""
    }
  });
  return {
    getAccountInfo: ({ include: l }) => {
      var u;
      return me(
        (u = e.value) == null ? void 0 : u.isMocked,
        "accounts.getAccountInfo",
        () => i.fetchPost(
          Ie.getAccountInfo,
          void 0,
          {
            include: l == null ? void 0 : l.join(","),
            httpStatusCodes: !1
          },
          {
            credentials: "include"
          }
        ).then(async (c) => {
          const m = await c.json();
          return { resp: c, json: m };
        })
      );
    },
    setAccountInfo: (l) => {
      var u;
      return me(
        (u = e.value) == null ? void 0 : u.isMocked,
        "accounts.setAccountInfo",
        () => i.fetchPost(
          Ie.setAccountInfo,
          void 0,
          {
            httpStatusCodes: !1,
            ...l
          },
          {
            credentials: "include"
          }
        ).then(async (c) => {
          try {
            const m = await c.json();
            return { resp: c, json: m };
          } catch {
            return { resp: c, json: {} };
          }
        })
      );
    },
    verifySession: () => {
      var l;
      return me(
        (l = e.value) == null ? void 0 : l.isMocked,
        "cdc.verifySession",
        () => i.fetchPost(
          Ie.verifySession,
          void 0,
          {
            httpStatusCodes: !1
          },
          {
            credentials: "include"
          }
        ).then(async (u) => {
          const c = await u.json();
          return { resp: u, json: c };
        })
      );
    }
  };
}, si = () => async (e) => {
  await Ui()();
  const { json: i } = await Bn().setAccountInfo(e);
  if (i.statusCode !== 200 || i.errorCode !== 0) {
    if (vt(i.errorCode))
      throw new ft(i.errorCode);
    switch (i.statusCode) {
      case 400:
      case 401:
      case 403:
        throw new ye();
      default:
        throw i.errorMessage ? new gt(i.errorMessage, i.errorDetails) : new ye();
    }
  }
  return i;
}, Nk = { class: "umf-change-email" }, Ok = { class: "dcf-h2 umf-change-email__headline" }, Uk = { class: "dcf-copy umf-change-email__copy" }, $k = { class: "umf-change-email__form-wrapper" }, Bk = /* @__PURE__ */ fe({
  __name: "umf-change-email-scene",
  setup(e) {
    const { ct: t } = pe(), i = J({
      changeEmailSuccessful: !1,
      email: null,
      emailConfirmation: null,
      isFormReady: !0,
      error: null
    }), n = si(), { setEmail: a } = mt(), s = H(() => Ut(i.value.email)), o = H(() => i.value.email === i.value.emailConfirmation), r = H(() => i.value.email !== null && !s.value ? t("changeEmailScene.invalidEmailMessage") : null), l = H(() => i.value.emailConfirmation !== null && !o.value ? t("changeEmailScene.confirmEmailMessage") : null), u = H(() => i.value.changeEmailSuccessful && !i.value.email && !i.value.emailConfirmation), c = H(() => !s.value || !o.value || !i.value.isFormReady), m = async () => {
      i.value.isFormReady = !1, i.value.changeEmailSuccessful = !1;
      try {
        const b = i.value.email;
        if (await n({ profile: { email: b } }), await a(b), globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: f } = Fe();
          f(Re.changeEmail);
        }
        i.value.changeEmailSuccessful = !0, window.location.reload();
      } catch (b) {
        if (globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: f } = Fe();
          f(Re.changeEmail, b.name);
        }
        i.value.changeEmailSuccessful = !1, i.value.error = b, i.value.isFormReady = !0;
      }
    }, d = async () => {
      await m(), i.value.email = null, i.value.emailConfirmation = null;
    };
    return (b, f) => (K(), Q("div", Nk, [
      N("h2", Ok, V(p(t)("changeEmailScene.headline")), 1),
      N("p", Uk, V(p(t)("changeEmailScene.copy")), 1),
      N("form", {
        onSubmit: Qe(d, ["prevent"])
      }, [
        N("div", $k, [
          F(p(ct), {
            modelValue: i.value.email,
            "onUpdate:modelValue": f[0] || (f[0] = (k) => i.value.email = k),
            modelModifiers: { trim: !0 },
            label: p(t)("changeEmailScene.inputEmailPlaceholder"),
            "is-validated": p(Ut)(i.value.email),
            "is-required": "",
            autocomplete: "email",
            disabled: !i.value.isFormReady,
            "error-message": r.value
          }, null, 8, ["modelValue", "label", "is-validated", "disabled", "error-message"]),
          F(p(ct), {
            modelValue: i.value.emailConfirmation,
            "onUpdate:modelValue": f[1] || (f[1] = (k) => i.value.emailConfirmation = k),
            modelModifiers: { trim: !0 },
            label: p(t)("changeEmailScene.inputEmailConfirmPlaceholder"),
            "is-required": "",
            disabled: !i.value.isFormReady,
            "error-message": l.value
          }, null, 8, ["modelValue", "label", "disabled", "error-message"]),
          u.value ? (K(), xe(p(Si), {
            key: 0,
            headline: p(t)("changeEmailScene.successMessageHeadline"),
            description: p(t)("changeEmailScene.successMessageCopy"),
            variant: "SUCCESS",
            "has-close-button": !1
          }, null, 8, ["headline", "description"])) : ve("", !0),
          F(p(bt), {
            error: i.value.error
          }, null, 8, ["error"]),
          F(p(Be), {
            type: "submit",
            variant: "primary",
            "full-width": "",
            disabled: c.value
          }, {
            default: re(() => [
              Pe(V(p(t)("changeEmailScene.buttonLabel")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32)
    ]));
  }
});
const Ne = (e, t) => {
  const i = e.__vccOpts || e;
  for (const [n, a] of t)
    i[n] = a;
  return i;
}, Rk = /* @__PURE__ */ Ne(Bk, [["__scopeId", "data-v-20a36d7a"]]), Fk = { class: "umf-change-password" }, Vk = { class: "dcf-h2 umf-change-password_form-title" }, qk = { class: "dcf-h5 umf-change-password_form-subtitle" }, Gk = { class: "form-wrap" }, Kk = {
  key: 1,
  class: "success-display"
}, Hk = /* @__PURE__ */ fe({
  __name: "umf-change-password-scene",
  emits: ["onClose"],
  setup(e, { emit: t }) {
    const { ct: i } = pe(), { submitChangePassword: n } = Ak(), a = J(), s = J({
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      isChangeSuccessful: !1,
      errorMsg: "",
      minCharGroups: 3,
      minLength: 8,
      error: null
    }), o = H(() => !s.value.currentPassword || !s.value.newPassword || !s.value.confirmPassword || !r.value || !u.value || m.value || !c.value), r = H(() => {
      const j = s.value.confirmPassword === "";
      return s.value.newPassword === s.value.confirmPassword || j;
    }), l = H(() => Es(s.value.newPassword, s.value.minLength, s.value.minCharGroups)), u = H(() => l.value > Je.TooWeak), c = H(() => s.value.currentPassword !== "" && s.value.newPassword !== "" ? s.value.currentPassword !== s.value.newPassword : !0), m = H(() => {
      var j;
      return (j = a == null ? void 0 : a.value) == null ? void 0 : j.isLoading;
    }), d = t, b = async (j) => {
      try {
        if (await n(s.value.currentPassword, s.value.newPassword), globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: g } = Fe();
          g(Re.changePassword);
        }
        s.value.isChangeSuccessful = !0;
        const { logout: y } = Un();
        await y(), window.location.replace("/");
      } catch (y) {
        if (globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: g } = Fe();
          g(Re.changePassword, y.name);
        }
        j(), s.value.isChangeSuccessful = !1, s.value.error = y;
      }
    }, f = () => {
      a.value.isLoading = !0, b(a.value.resolveLoading);
    }, k = () => {
      d("onClose");
    }, M = async () => {
      try {
        const y = await xk()(["passwordComplexity"]);
        s.value.minCharGroups = y.passwordComplexity.minCharGroups, s.value.minLength = y.passwordComplexity.minLength;
      } catch (j) {
        s.value.error = j;
      }
    };
    return pt(() => {
      M();
    }), (j, y) => (K(), Q("div", Fk, [
      N("h2", Vk, V(p(i)("changePasswordScene.title")), 1),
      s.value.isChangeSuccessful ? (K(), Q("div", Kk, [
        F(p(Si), {
          "on-click": () => null,
          variant: "SUCCESS",
          headline: p(i)("changePasswordScene.passwordUpdateSuccessTitle"),
          description: p(i)("changePasswordScene.successfulChangeLabel")
        }, null, 8, ["headline", "description"]),
        F(p(Be), {
          variant: "primary",
          "full-width": "",
          onClick: k
        }, {
          default: re(() => [
            Pe(V(p(i)("changePasswordScene.closeButtonLabel")), 1)
          ]),
          _: 1
        })
      ])) : (K(), Q(Tt, { key: 0 }, [
        N("h5", qk, V(p(i)("changePasswordScene.subtitle")), 1),
        N("form", {
          onSubmit: Qe(f, ["prevent"])
        }, [
          N("div", Gk, [
            F(p(ct), {
              modelValue: s.value.currentPassword,
              "onUpdate:modelValue": y[0] || (y[0] = (g) => s.value.currentPassword = g),
              autocomplete: "current-password",
              label: p(i)("changePasswordScene.currentPasswordLabel"),
              "is-required": "",
              type: "password",
              "show-password-text": p(i)("passwordHelper.showPasswordText"),
              "hide-password-text": p(i)("passwordHelper.hidePasswordText")
            }, null, 8, ["modelValue", "label", "show-password-text", "hide-password-text"]),
            F(p(ct), {
              modelValue: s.value.newPassword,
              "onUpdate:modelValue": y[1] || (y[1] = (g) => s.value.newPassword = g),
              autocomplete: "new-password",
              label: p(i)("changePasswordScene.newPasswordLabel"),
              "is-required": "",
              type: "password",
              "error-message": c.value ? null : p(i)("changePasswordScene.samePasswordError"),
              "show-password-text": p(i)("passwordHelper.showPasswordText"),
              "hide-password-text": p(i)("passwordHelper.hidePasswordText")
            }, null, 8, ["modelValue", "label", "error-message", "show-password-text", "hide-password-text"]),
            so(F(p(hw), {
              password: s.value.newPassword,
              "min-length": s.value.minLength,
              "min-char-groups": s.value.minCharGroups
            }, null, 8, ["password", "min-length", "min-char-groups"]), [
              [oo, s.value.newPassword]
            ]),
            F(p(ct), {
              modelValue: s.value.confirmPassword,
              "onUpdate:modelValue": y[2] || (y[2] = (g) => s.value.confirmPassword = g),
              autocomplete: "confirm-password",
              label: p(i)("changePasswordScene.confirmPasswordLabel"),
              "is-required": "",
              type: "password",
              "error-message": r.value ? null : p(i)("changePasswordScene.passwordMismatchError"),
              "show-password-text": p(i)("passwordHelper.showPasswordText"),
              "hide-password-text": p(i)("passwordHelper.hidePasswordText")
            }, null, 8, ["modelValue", "label", "error-message", "show-password-text", "hide-password-text"]),
            F(p(bt), {
              error: s.value.error
            }, null, 8, ["error"]),
            F(p(Be), {
              ref_key: "submitChangeButtonRef",
              ref: a,
              variant: "primary",
              "full-width": "",
              disabled: o.value,
              "with-loading-state": "",
              type: "submit"
            }, {
              default: re(() => [
                Pe(V(p(i)("changePasswordScene.submitButtonLabel")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ], 32)
      ], 64))
    ]));
  }
});
const Wk = /* @__PURE__ */ Ne(Hk, [["__scopeId", "data-v-32e7e62c"]]);
var je = /* @__PURE__ */ ((e) => (e.dark = "dcf-ctx-dark", e.light = "dcf-ctx-light", e))(je || {}), de = /* @__PURE__ */ ((e) => (e.dark = "dark", e.light = "light", e))(de || {});
const Jk = () => async (e) => {
  const { json: t } = await kt().setAccountInfo(e);
  if (t.statusCode !== 200 || t.errorCode !== 0) {
    if (vt(t.errorCode))
      throw new ft(t.errorCode);
    switch (t.statusCode) {
      case 400:
      case 401:
      case 403:
        throw new ye();
      default:
        throw t.errorMessage ? new gt(t.errorMessage, t.errorDetails) : new ye();
    }
  }
  return t;
}, Zk = ["for", "innerHTML"], xa = /* @__PURE__ */ fe({
  __name: "umf-consent-scene-consent",
  props: {
    label: null,
    for: null,
    linkLabel: null,
    url: null
  },
  setup(e) {
    var a;
    const { ct: t } = pe(), i = e, n = (a = i.linkLabel) != null && a.length ? `<a href="${i.url}">${t(i.linkLabel)}</a>` : void 0;
    return (s, o) => (K(), Q("label", {
      tag: "label",
      for: i.for,
      innerHTML: p(t)(i.label, [p(n)])
    }, null, 8, Zk));
  }
}), Yk = { class: "dcf-h4 login-form-title" }, Xk = { key: 0 }, Qk = {
  key: 0,
  class: "umf-consent-scene__checkbox-group"
}, eb = { class: "dcf-h5" }, tb = { class: "umf-consent-scene__checkbox dcf-body-copy" }, ib = {
  key: 1,
  class: "umf-consent-scene__checkbox-group"
}, nb = { class: "dcf-h5" }, ab = { class: "umf-consent-scene__checkbox dcf-body-copy" }, sb = { class: "umf-consent-scene__cta" }, ob = /* @__PURE__ */ fe({
  __name: "umf-consent-scene",
  props: {
    context: { default: de.light },
    missingConsentFields: { default: void 0 },
    credentials: { default: void 0 }
  },
  setup(e) {
    const { ct: t } = pe(), i = e, n = Jk(), { login: a } = Rs(), s = J(!1), o = J(!1), r = J(!1), l = J(!1), u = J(null), c = J(), m = H(
      () => (r.value || s.value) && (l.value || o.value)
    ), d = (k) => {
      s.value = !!k.checked;
    }, b = (k) => {
      o.value = !!k.checked;
    }, f = async () => {
      try {
        await n({
          preferences: {
            "privacy.miele.statement.isConsentGranted": "true",
            "terms.miele.statement.isConsentGranted": "true"
          }
        }), await a(i.credentials || {});
      } catch (k) {
        u.value = k;
      }
    };
    return pt(async () => {
      var k, M;
      c.value = Of(
        i.missingConsentFields
      ), r.value = !((k = c.value.preferences) != null && k.includes(
        "privacy.miele.statement.isConsentGranted"
      )), l.value = !((M = c.value.preferences) != null && M.includes(
        "terms.miele.statement.isConsentGranted"
      ));
    }), (k, M) => (K(), Q("div", {
      class: et([
        "umf-consent-scene",
        {
          [p(je).dark]: i.context === p(de).dark,
          [p(je).light]: i.context === p(de).light
        }
      ])
    }, [
      N("h2", Yk, V(p(t)("login.extraConsentScene.title")), 1),
      N("form", {
        onSubmit: Qe(f, ["prevent"])
      }, [
        c.value ? (K(), Q("div", Xk, [
          r.value ? ve("", !0) : (K(), Q("div", Qk, [
            N("h5", eb, V(p(t)("login.extraConsentScene.privacyStatementTitle")), 1),
            N("div", tb, [
              F(p($e), {
                id: "privacy",
                label: "",
                context: i.context,
                checked: s.value,
                "onUpdate:CheckboxValue": d
              }, null, 8, ["context", "checked"]),
              F(xa, {
                label: "login.extraConsentScene.privacyStatementCheckboxLabel",
                "link-label": "login.extraConsentScene.privacyStatementName",
                url: "/c/datenschutz-14.htm",
                for: "privacy"
              })
            ])
          ])),
          l.value ? ve("", !0) : (K(), Q("div", ib, [
            N("h5", nb, V(p(t)("login.extraConsentScene.termsOfUseTitle")), 1),
            N("div", ab, [
              F(p($e), {
                id: "terms",
                label: "",
                context: i.context,
                checked: o.value,
                "onUpdate:CheckboxValue": b
              }, null, 8, ["context", "checked"]),
              F(xa, {
                label: "login.extraConsentScene.termsOfUseCheckboxLabel",
                "link-label": "login.extraConsentScene.termsOfUseName",
                url: "/c/nutzungsbedingungen-304.htm",
                for: "terms"
              })
            ])
          ]))
        ])) : ve("", !0),
        F(p(bt), { error: u.value }, null, 8, ["error"]),
        N("div", sb, [
          F(p(Be), {
            variant: "primary",
            "full-width": "",
            disabled: !m.value
          }, {
            default: re(() => [
              Pe(V(p(t)("login.extraConsentScene.continue")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32)
    ], 2));
  }
});
const rb = /* @__PURE__ */ Ne(ob, [["__scopeId", "data-v-424e7a96"]]);
const lb = {}, cb = { class: "umf-divider-container" };
function db(e, t) {
  return K(), Q("div", cb, t[0] || (t[0] = [
    N("div", { class: "umf-divider-line" }, null, -1)
  ]));
}
const $y = /* @__PURE__ */ Ne(lb, [["render", db], ["__scopeId", "data-v-beece808"]]), ub = {
  key: 0,
  class: "umf-error-handler"
}, bt = /* @__PURE__ */ fe({
  __name: "umf-error-handler",
  props: {
    error: { default: null }
  },
  setup(e) {
    const t = e, i = J({
      visibleError: null,
      isErrorDismissed: !0
    });
    vi(t, () => {
      t.error !== null && (t.error instanceof En ? location.href = lt(Rt.login) : (console.error("Error Handler <", t.error), i.value = {
        visibleError: t.error,
        isErrorDismissed: !1
      }));
    });
    const n = () => {
      i.value.isErrorDismissed = !0;
    };
    return (a, s) => i.value.visibleError && !i.value.isErrorDismissed ? (K(), Q("div", ub, [
      F(p(Si), {
        headline: i.value.visibleError.message,
        description: i.value.visibleError.details,
        variant: "ERROR",
        "has-close-button": i.value.visibleError.isDismissible,
        onOnClose: n
      }, null, 8, ["headline", "description", "has-close-button"])
    ])) : ve("", !0);
  }
});
var be = /* @__PURE__ */ ((e) => (e[e.ChangeEmail = 0] = "ChangeEmail", e[e.ChangePassword = 1] = "ChangePassword", e[e.ForgotPassword = 2] = "ForgotPassword", e[e.Login = 3] = "Login", e[e.Consent = 4] = "Consent", e[e.NewsletterConsent = 5] = "NewsletterConsent", e[e.MieleClubConsent = 6] = "MieleClubConsent", e))(be || {});
const mb = { class: "dcf-h4 forgotPassword-form-title" }, pb = { class: "form-wrap" }, hb = { class: "buttons-wrap" }, gb = {
  key: 1,
  class: "dcf-h5-child"
}, vb = /* @__PURE__ */ fe({
  __name: "umf-forgot-password-scene",
  props: {
    context: { default: de.light }
  },
  emits: ["onClose", "onChangeModal"],
  setup(e, { emit: t }) {
    const { ct: i } = pe(), n = e, a = t, { forgotPassword: s } = Tk(), o = J({
      email: null,
      isErrorDismissed: !1,
      resetSuccessful: !1,
      error: null
    }), r = H(() => Ut(o.value.email)), l = H(
      () => o.value.email !== null && !r.value ? i("errors.invalidEmail") : null
    ), u = async () => {
      await c();
    }, c = async () => {
      if (!l.value && o.value.email) {
        o.value.error = null;
        try {
          const d = await s(o.value.email);
          o.value.resetSuccessful = (d == null ? void 0 : d.statusCode) === 200;
        } catch (d) {
          o.value.error = d;
        }
      }
    }, m = () => {
      a("onChangeModal", be.Login);
    };
    return (d, b) => (K(), Q("div", {
      class: et([
        "forgotPassword-scene-content",
        {
          [p(je).dark]: n.context === p(de).dark,
          [p(je).light]: n.context === p(de).light
        }
      ])
    }, [
      N("h2", mb, V(o.value.resetSuccessful ? p(i)("login.forgotPasswordScene.successTitle") : p(i)("login.forgotPasswordScene.title")), 1),
      o.value.resetSuccessful ? ve("", !0) : (K(), Q("form", {
        key: 0,
        onSubmit: Qe(u, ["prevent"])
      }, [
        N("div", pb, [
          F(p(ct), {
            modelValue: o.value.email,
            "onUpdate:modelValue": b[0] || (b[0] = (f) => o.value.email = f),
            modelModifiers: { trim: !0 },
            label: p(i)("login.loginScene.emailInputLabel"),
            "is-validated": r.value,
            "is-required": "",
            autocomplete: "email",
            "error-message": l.value
          }, null, 8, ["modelValue", "label", "is-validated", "error-message"]),
          N("div", hb, [
            F(p(Be), {
              type: "submit",
              variant: "primary",
              "full-width": "",
              disabled: !o.value.email
            }, {
              default: re(() => [
                Pe(V(p(i)("login.forgotPasswordScene.submitButtonLabel")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            F(p(bt), {
              error: o.value.error
            }, null, 8, ["error"])
          ])
        ])
      ], 32)),
      o.value.resetSuccessful ? (K(), Q("p", gb, V(p(i)("login.forgotPasswordScene.successDescription")), 1)) : ve("", !0),
      F(p(Be), {
        class: "go-back-btn",
        variant: "tertiary",
        icon: "chevron-right",
        onClick: m
      }, {
        default: re(() => [
          Pe(V(p(i)("login.forgotPasswordScene.backButtonLabel")), 1)
        ]),
        _: 1
      })
    ], 2));
  }
});
const fb = /* @__PURE__ */ Ne(vb, [["__scopeId", "data-v-96f69cdc"]]), kb = { class: "umf-login-scene__form-wrapper" }, bb = { class: "buttons-wrap" }, wb = /* @__PURE__ */ fe({
  __name: "umf-login-scene",
  props: {
    context: { default: de.light },
    redirectUrl: { default: "" },
    onForgotPasswordClick: { type: Function, default: () => {
    } },
    onExtraConsentRequired: { type: Function, default: () => {
    } }
  },
  setup(e) {
    const { ct: t } = pe(), { login: i } = Rs(), n = e, a = J({
      email: null,
      emailFormatError: null,
      isFormReady: !0,
      isRememberChecked: !1,
      password: "",
      error: null
    }), s = H(() => Ut(a.value.email)), o = async () => {
      l(), await r();
    }, r = async () => {
      const u = a.value.emailFormatError, c = a.value.email && a.value.password;
      if (!(u || !c)) {
        a.value.error = null;
        try {
          await i({
            email: a.value.email,
            password: a.value.password,
            redirectUrl: n.redirectUrl,
            isRemember: a.value.isRememberChecked
          });
        } catch (m) {
          if (m instanceof xi) {
            if (n.onExtraConsentRequired) {
              const { email: d, password: b } = a.value, { missingRequiredFields: f } = m.data;
              n.onExtraConsentRequired(f, { email: d, password: b });
            }
          } else
            a.value.error = m;
          if (globalThis != null && globalThis.window) {
            const { pushFormSubmitEvent: d } = Fe();
            d(Re.login, m.name);
          }
        }
      }
    }, l = () => {
      a.value.emailFormatError = Ut(a.value.email) ? null : t("errors.invalidEmail");
    };
    return (u, c) => (K(), Q("div", {
      class: et([
        "umf-login-scene",
        {
          [p(je).dark]: n.context === p(de).dark,
          [p(je).light]: n.context === p(de).light
        }
      ])
    }, [
      N("form", {
        onSubmit: Qe(o, ["prevent"])
      }, [
        N("div", kb, [
          F(p(ct), {
            modelValue: a.value.email,
            "onUpdate:modelValue": c[0] || (c[0] = (m) => a.value.email = m),
            modelModifiers: { trim: !0 },
            label: p(t)("login.loginScene.emailInputLabel"),
            "is-validated": p(Ut)(a.value.email),
            "is-required": "",
            autocomplete: "email",
            disabled: !a.value.isFormReady,
            "error-message": a.value.email != null && !s.value ? p(t)("login.loginScene.invalidEmailMessage") : null
          }, null, 8, ["modelValue", "label", "is-validated", "disabled", "error-message"]),
          F(p(ct), {
            modelValue: a.value.password,
            "onUpdate:modelValue": c[1] || (c[1] = (m) => a.value.password = m),
            label: p(t)("login.loginScene.passwordInputLabel"),
            "is-required": "",
            type: "password",
            autocomplete: "current-password",
            disabled: !a.value.isFormReady,
            "show-password-text": p(t)("passwordHelper.showPasswordText"),
            "hide-password-text": p(t)("passwordHelper.hidePasswordText")
          }, null, 8, ["modelValue", "label", "disabled", "show-password-text", "hide-password-text"]),
          N("div", bb, [
            F(p(Be), {
              variant: "primary",
              "full-width": "",
              disabled: !a.value.isFormReady || !a.value.email || !a.value.password
            }, {
              default: re(() => [
                Pe(V(p(t)("login.loginScene.loginButtonLabel")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]),
            F(p(bt), {
              error: a.value.error
            }, null, 8, ["error"]),
            F(p(Be), {
              class: "forgot-pwd-btn",
              variant: "tertiary",
              disabled: !a.value.isFormReady,
              icon: "chevron-right",
              onClick: e.onForgotPasswordClick
            }, {
              default: re(() => [
                Pe(V(p(t)("login.loginScene.forgotPwdButtonLabel")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ])
        ])
      ], 32)
    ], 2));
  }
});
const Ks = /* @__PURE__ */ Ne(wb, [["__scopeId", "data-v-4d44666f"]]), yb = { class: "dcf-h4 umf-login__headline" }, Mb = /* @__PURE__ */ fe({
  __name: "umf-login",
  props: {
    context: { default: de.light },
    onForgotPasswordClick: { type: Function, default: () => {
    } },
    onExtraConsentRequired: { type: Function, default: () => {
    } }
  },
  setup(e) {
    const { ct: t } = pe(), i = e;
    return (n, a) => (K(), Q("div", {
      class: et([
        "umf-login",
        {
          [p(je).dark]: i.context === p(de).dark,
          [p(je).light]: i.context === p(de).light
        }
      ])
    }, [
      N("h2", yb, V(p(t)("login.loginScene.title")), 1),
      F(Ks, {
        "on-forgot-password-click": e.onForgotPasswordClick,
        "on-extra-consent-required": e.onExtraConsentRequired
      }, null, 8, ["on-forgot-password-click", "on-extra-consent-required"])
    ], 2));
  }
});
const By = /* @__PURE__ */ Ne(Mb, [["__scopeId", "data-v-8322c143"]]), zb = { class: "umf-login-modal__wrapper" }, jb = { class: "dcf-h2 umf-login-modal__headline" }, _b = { class: "dcf-copy umf-login-modal__copy" }, Sb = /* @__PURE__ */ fe({
  __name: "umf-login-modal-scene",
  emits: ["onClose", "onChangeModal"],
  setup(e, { emit: t }) {
    const { ct: i } = pe(), n = J({
      redirectUrl: ""
    }), a = t, s = () => {
      a("onChangeModal", be.ForgotPassword);
    }, o = (r, l) => {
      a("onChangeModal", be.Consent, {
        consentState: {
          accountMissingConsentFields: r,
          credentials: l
        }
      });
    };
    return (r, l) => (K(), Q("div", zb, [
      N("h2", jb, V(p(i)("login.loginModalScene.title")), 1),
      N("p", _b, V(p(i)("login.loginModalScene.copy")), 1),
      F(p(Ks), {
        "redirect-url": n.value.redirectUrl,
        "on-forgot-password-click": s,
        "on-extra-consent-required": o
      }, null, 8, ["redirect-url"])
    ]));
  }
});
const Cb = /* @__PURE__ */ Ne(Sb, [["__scopeId", "data-v-246ac9f3"]]);
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Hs = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], yi = /* @__PURE__ */ Hs.join(","), Ws = typeof Element > "u", Pt = Ws ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Mi = !Ws && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, zi = function e(t, i) {
  var n;
  i === void 0 && (i = !0);
  var a = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "inert"), s = a === "" || a === "true", o = s || i && t && e(t.parentNode);
  return o;
}, Lb = function(t) {
  var i, n = t == null || (i = t.getAttribute) === null || i === void 0 ? void 0 : i.call(t, "contenteditable");
  return n === "" || n === "true";
}, Js = function(t, i, n) {
  if (zi(t))
    return [];
  var a = Array.prototype.slice.apply(t.querySelectorAll(yi));
  return i && Pt.call(t, yi) && a.unshift(t), a = a.filter(n), a;
}, Zs = function e(t, i, n) {
  for (var a = [], s = Array.from(t); s.length; ) {
    var o = s.shift();
    if (!zi(o, !1))
      if (o.tagName === "SLOT") {
        var r = o.assignedElements(), l = r.length ? r : o.children, u = e(l, !0, n);
        n.flatten ? a.push.apply(a, u) : a.push({
          scopeParent: o,
          candidates: u
        });
      } else {
        var c = Pt.call(o, yi);
        c && n.filter(o) && (i || !t.includes(o)) && a.push(o);
        var m = o.shadowRoot || // check for an undisclosed shadow
        typeof n.getShadowRoot == "function" && n.getShadowRoot(o), d = !zi(m, !1) && (!n.shadowRootFilter || n.shadowRootFilter(o));
        if (m && d) {
          var b = e(m === !0 ? o.children : m.children, !0, n);
          n.flatten ? a.push.apply(a, b) : a.push({
            scopeParent: o,
            candidates: b
          });
        } else
          s.unshift.apply(s, o.children);
      }
  }
  return a;
}, Ys = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, _t = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Lb(t)) && !Ys(t) ? 0 : t.tabIndex;
}, Eb = function(t, i) {
  var n = _t(t);
  return n < 0 && i && !Ys(t) ? 0 : n;
}, Pb = function(t, i) {
  return t.tabIndex === i.tabIndex ? t.documentOrder - i.documentOrder : t.tabIndex - i.tabIndex;
}, Xs = function(t) {
  return t.tagName === "INPUT";
}, Tb = function(t) {
  return Xs(t) && t.type === "hidden";
}, Ab = function(t) {
  var i = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
  return i;
}, xb = function(t, i) {
  for (var n = 0; n < t.length; n++)
    if (t[n].checked && t[n].form === i)
      return t[n];
}, Ib = function(t) {
  if (!t.name)
    return !0;
  var i = t.form || Mi(t), n = function(r) {
    return i.querySelectorAll('input[type="radio"][name="' + r + '"]');
  }, a;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    a = n(window.CSS.escape(t.name));
  else
    try {
      a = n(t.name);
    } catch (o) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
    }
  var s = xb(a, t.form);
  return !s || s === t;
}, Db = function(t) {
  return Xs(t) && t.type === "radio";
}, Nb = function(t) {
  return Db(t) && !Ib(t);
}, Ob = function(t) {
  var i, n = t && Mi(t), a = (i = n) === null || i === void 0 ? void 0 : i.host, s = !1;
  if (n && n !== t) {
    var o, r, l;
    for (s = !!((o = a) !== null && o !== void 0 && (r = o.ownerDocument) !== null && r !== void 0 && r.contains(a) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !s && a; ) {
      var u, c, m;
      n = Mi(a), a = (u = n) === null || u === void 0 ? void 0 : u.host, s = !!((c = a) !== null && c !== void 0 && (m = c.ownerDocument) !== null && m !== void 0 && m.contains(a));
    }
  }
  return s;
}, Ia = function(t) {
  var i = t.getBoundingClientRect(), n = i.width, a = i.height;
  return n === 0 && a === 0;
}, Ub = function(t, i) {
  var n = i.displayCheck, a = i.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var s = Pt.call(t, "details>summary:first-of-type"), o = s ? t.parentElement : t;
  if (Pt.call(o, "details:not([open]) *"))
    return !0;
  if (!n || n === "full" || n === "legacy-full") {
    if (typeof a == "function") {
      for (var r = t; t; ) {
        var l = t.parentElement, u = Mi(t);
        if (l && !l.shadowRoot && a(l) === !0)
          return Ia(t);
        t.assignedSlot ? t = t.assignedSlot : !l && u !== t.ownerDocument ? t = u.host : t = l;
      }
      t = r;
    }
    if (Ob(t))
      return !t.getClientRects().length;
    if (n !== "legacy-full")
      return !0;
  } else if (n === "non-zero-area")
    return Ia(t);
  return !1;
}, $b = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var i = t.parentElement; i; ) {
      if (i.tagName === "FIELDSET" && i.disabled) {
        for (var n = 0; n < i.children.length; n++) {
          var a = i.children.item(n);
          if (a.tagName === "LEGEND")
            return Pt.call(i, "fieldset[disabled] *") ? !0 : !a.contains(t);
        }
        return !0;
      }
      i = i.parentElement;
    }
  return !1;
}, ji = function(t, i) {
  return !(i.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  zi(i) || Tb(i) || Ub(i, t) || // For a details element with a summary, the summary element gets the focus
  Ab(i) || $b(i));
}, vn = function(t, i) {
  return !(Nb(i) || _t(i) < 0 || !ji(t, i));
}, Bb = function(t) {
  var i = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(i) || i >= 0);
}, Rb = function e(t) {
  var i = [], n = [];
  return t.forEach(function(a, s) {
    var o = !!a.scopeParent, r = o ? a.scopeParent : a, l = Eb(r, o), u = o ? e(a.candidates) : r;
    l === 0 ? o ? i.push.apply(i, u) : i.push(r) : n.push({
      documentOrder: s,
      tabIndex: l,
      item: a,
      isScope: o,
      content: u
    });
  }), n.sort(Pb).reduce(function(a, s) {
    return s.isScope ? a.push.apply(a, s.content) : a.push(s.content), a;
  }, []).concat(i);
}, Fb = function(t, i) {
  i = i || {};
  var n;
  return i.getShadowRoot ? n = Zs([t], i.includeContainer, {
    filter: vn.bind(null, i),
    flatten: !1,
    getShadowRoot: i.getShadowRoot,
    shadowRootFilter: Bb
  }) : n = Js(t, i.includeContainer, vn.bind(null, i)), Rb(n);
}, Vb = function(t, i) {
  i = i || {};
  var n;
  return i.getShadowRoot ? n = Zs([t], i.includeContainer, {
    filter: ji.bind(null, i),
    flatten: !0,
    getShadowRoot: i.getShadowRoot
  }) : n = Js(t, i.includeContainer, ji.bind(null, i)), n;
}, Dt = function(t, i) {
  if (i = i || {}, !t)
    throw new Error("No node provided");
  return Pt.call(t, yi) === !1 ? !1 : vn(i, t);
}, qb = /* @__PURE__ */ Hs.concat("iframe").join(","), Xi = function(t, i) {
  if (i = i || {}, !t)
    throw new Error("No node provided");
  return Pt.call(t, qb) === !1 ? !1 : ji(i, t);
};
/*!
* focus-trap 7.6.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function fn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var i = 0, n = Array(t); i < t; i++)
    n[i] = e[i];
  return n;
}
function Gb(e) {
  if (Array.isArray(e))
    return fn(e);
}
function Kb(e, t, i) {
  return (t = Yb(t)) in e ? Object.defineProperty(e, t, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = i, e;
}
function Hb(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Wb() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Da(e, t) {
  var i = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), i.push.apply(i, n);
  }
  return i;
}
function Na(e) {
  for (var t = 1; t < arguments.length; t++) {
    var i = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Da(Object(i), !0).forEach(function(n) {
      Kb(e, n, i[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : Da(Object(i)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(i, n));
    });
  }
  return e;
}
function Jb(e) {
  return Gb(e) || Hb(e) || Xb(e) || Wb();
}
function Zb(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var i = e[Symbol.toPrimitive];
  if (i !== void 0) {
    var n = i.call(e, t || "default");
    if (typeof n != "object")
      return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Yb(e) {
  var t = Zb(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function Xb(e, t) {
  if (e) {
    if (typeof e == "string")
      return fn(e, t);
    var i = {}.toString.call(e).slice(8, -1);
    return i === "Object" && e.constructor && (i = e.constructor.name), i === "Map" || i === "Set" ? Array.from(e) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? fn(e, t) : void 0;
  }
}
var Oa = {
  activateTrap: function(t, i) {
    if (t.length > 0) {
      var n = t[t.length - 1];
      n !== i && n._setPausedState(!0);
    }
    var a = t.indexOf(i);
    a === -1 || t.splice(a, 1), t.push(i);
  },
  deactivateTrap: function(t, i) {
    var n = t.indexOf(i);
    n !== -1 && t.splice(n, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, Qb = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, ew = function(t) {
  return (t == null ? void 0 : t.key) === "Escape" || (t == null ? void 0 : t.key) === "Esc" || (t == null ? void 0 : t.keyCode) === 27;
}, ei = function(t) {
  return (t == null ? void 0 : t.key) === "Tab" || (t == null ? void 0 : t.keyCode) === 9;
}, tw = function(t) {
  return ei(t) && !t.shiftKey;
}, iw = function(t) {
  return ei(t) && t.shiftKey;
}, Ua = function(t) {
  return setTimeout(t, 0);
}, Xt = function(t) {
  for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)
    n[a - 1] = arguments[a];
  return typeof t == "function" ? t.apply(void 0, n) : t;
}, pi = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, nw = [], aw = function(t, i) {
  var n = (i == null ? void 0 : i.document) || document, a = (i == null ? void 0 : i.trapStack) || nw, s = Na({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: tw,
    isKeyBackward: iw
  }, i), o = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, r, l = function(z, A, $) {
    return z && z[A] !== void 0 ? z[A] : s[$ || A];
  }, u = function(z, A) {
    var $ = typeof (A == null ? void 0 : A.composedPath) == "function" ? A.composedPath() : void 0;
    return o.containerGroups.findIndex(function(q) {
      var Z = q.container, X = q.tabbableNodes;
      return Z.contains(z) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      ($ == null ? void 0 : $.includes(Z)) || X.find(function(W) {
        return W === z;
      });
    });
  }, c = function(z) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, $ = A.hasFallback, q = $ === void 0 ? !1 : $, Z = A.params, X = Z === void 0 ? [] : Z, W = s[z];
    if (typeof W == "function" && (W = W.apply(void 0, Jb(X))), W === !0 && (W = void 0), !W) {
      if (W === void 0 || W === !1)
        return W;
      throw new Error("`".concat(z, "` was specified but was not a node, or did not return a node"));
    }
    var ae = W;
    if (typeof W == "string") {
      try {
        ae = n.querySelector(W);
      } catch (se) {
        throw new Error("`".concat(z, '` appears to be an invalid selector; error="').concat(se.message, '"'));
      }
      if (!ae && !q)
        throw new Error("`".concat(z, "` as selector refers to no known node"));
    }
    return ae;
  }, m = function() {
    var z = c("initialFocus", {
      hasFallback: !0
    });
    if (z === !1)
      return !1;
    if (z === void 0 || z && !Xi(z, s.tabbableOptions))
      if (u(n.activeElement) >= 0)
        z = n.activeElement;
      else {
        var A = o.tabbableGroups[0], $ = A && A.firstTabbableNode;
        z = $ || c("fallbackFocus");
      }
    else
      z === null && (z = c("fallbackFocus"));
    if (!z)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return z;
  }, d = function() {
    if (o.containerGroups = o.containers.map(function(z) {
      var A = Fb(z, s.tabbableOptions), $ = Vb(z, s.tabbableOptions), q = A.length > 0 ? A[0] : void 0, Z = A.length > 0 ? A[A.length - 1] : void 0, X = $.find(function(se) {
        return Dt(se);
      }), W = $.slice().reverse().find(function(se) {
        return Dt(se);
      }), ae = !!A.find(function(se) {
        return _t(se) > 0;
      });
      return {
        container: z,
        tabbableNodes: A,
        focusableNodes: $,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: ae,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: q,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: Z,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: X,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: W,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(he) {
          var Oe = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Ce = A.indexOf(he);
          return Ce < 0 ? Oe ? $.slice($.indexOf(he) + 1).find(function(Ve) {
            return Dt(Ve);
          }) : $.slice(0, $.indexOf(he)).reverse().find(function(Ve) {
            return Dt(Ve);
          }) : A[Ce + (Oe ? 1 : -1)];
        }
      };
    }), o.tabbableGroups = o.containerGroups.filter(function(z) {
      return z.tabbableNodes.length > 0;
    }), o.tabbableGroups.length <= 0 && !c("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (o.containerGroups.find(function(z) {
      return z.posTabIndexesFound;
    }) && o.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, b = function(z) {
    var A = z.activeElement;
    if (A)
      return A.shadowRoot && A.shadowRoot.activeElement !== null ? b(A.shadowRoot) : A;
  }, f = function(z) {
    if (z !== !1 && z !== b(document)) {
      if (!z || !z.focus) {
        f(m());
        return;
      }
      z.focus({
        preventScroll: !!s.preventScroll
      }), o.mostRecentlyFocusedNode = z, Qb(z) && z.select();
    }
  }, k = function(z) {
    var A = c("setReturnFocus", {
      params: [z]
    });
    return A || (A === !1 ? !1 : z);
  }, M = function(z) {
    var A = z.target, $ = z.event, q = z.isBackward, Z = q === void 0 ? !1 : q;
    A = A || pi($), d();
    var X = null;
    if (o.tabbableGroups.length > 0) {
      var W = u(A, $), ae = W >= 0 ? o.containerGroups[W] : void 0;
      if (W < 0)
        Z ? X = o.tabbableGroups[o.tabbableGroups.length - 1].lastTabbableNode : X = o.tabbableGroups[0].firstTabbableNode;
      else if (Z) {
        var se = o.tabbableGroups.findIndex(function(Ke) {
          var at = Ke.firstTabbableNode;
          return A === at;
        });
        if (se < 0 && (ae.container === A || Xi(A, s.tabbableOptions) && !Dt(A, s.tabbableOptions) && !ae.nextTabbableNode(A, !1)) && (se = W), se >= 0) {
          var he = se === 0 ? o.tabbableGroups.length - 1 : se - 1, Oe = o.tabbableGroups[he];
          X = _t(A) >= 0 ? Oe.lastTabbableNode : Oe.lastDomTabbableNode;
        } else
          ei($) || (X = ae.nextTabbableNode(A, !1));
      } else {
        var Ce = o.tabbableGroups.findIndex(function(Ke) {
          var at = Ke.lastTabbableNode;
          return A === at;
        });
        if (Ce < 0 && (ae.container === A || Xi(A, s.tabbableOptions) && !Dt(A, s.tabbableOptions) && !ae.nextTabbableNode(A)) && (Ce = W), Ce >= 0) {
          var Ve = Ce === o.tabbableGroups.length - 1 ? 0 : Ce + 1, nt = o.tabbableGroups[Ve];
          X = _t(A) >= 0 ? nt.firstTabbableNode : nt.firstDomTabbableNode;
        } else
          ei($) || (X = ae.nextTabbableNode(A));
      }
    } else
      X = c("fallbackFocus");
    return X;
  }, j = function(z) {
    var A = pi(z);
    if (!(u(A, z) >= 0)) {
      if (Xt(s.clickOutsideDeactivates, z)) {
        r.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: s.returnFocusOnDeactivate
        });
        return;
      }
      Xt(s.allowOutsideClick, z) || z.preventDefault();
    }
  }, y = function(z) {
    var A = pi(z), $ = u(A, z) >= 0;
    if ($ || A instanceof Document)
      $ && (o.mostRecentlyFocusedNode = A);
    else {
      z.stopImmediatePropagation();
      var q, Z = !0;
      if (o.mostRecentlyFocusedNode)
        if (_t(o.mostRecentlyFocusedNode) > 0) {
          var X = u(o.mostRecentlyFocusedNode), W = o.containerGroups[X].tabbableNodes;
          if (W.length > 0) {
            var ae = W.findIndex(function(se) {
              return se === o.mostRecentlyFocusedNode;
            });
            ae >= 0 && (s.isKeyForward(o.recentNavEvent) ? ae + 1 < W.length && (q = W[ae + 1], Z = !1) : ae - 1 >= 0 && (q = W[ae - 1], Z = !1));
          }
        } else
          o.containerGroups.some(function(se) {
            return se.tabbableNodes.some(function(he) {
              return _t(he) > 0;
            });
          }) || (Z = !1);
      else
        Z = !1;
      Z && (q = M({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: o.mostRecentlyFocusedNode,
        isBackward: s.isKeyBackward(o.recentNavEvent)
      })), f(q || o.mostRecentlyFocusedNode || m());
    }
    o.recentNavEvent = void 0;
  }, g = function(z) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    o.recentNavEvent = z;
    var $ = M({
      event: z,
      isBackward: A
    });
    $ && (ei(z) && z.preventDefault(), f($));
  }, w = function(z) {
    (s.isKeyForward(z) || s.isKeyBackward(z)) && g(z, s.isKeyBackward(z));
  }, L = function(z) {
    ew(z) && Xt(s.escapeDeactivates, z) !== !1 && (z.preventDefault(), r.deactivate());
  }, _ = function(z) {
    var A = pi(z);
    u(A, z) >= 0 || Xt(s.clickOutsideDeactivates, z) || Xt(s.allowOutsideClick, z) || (z.preventDefault(), z.stopImmediatePropagation());
  }, E = function() {
    if (o.active)
      return Oa.activateTrap(a, r), o.delayInitialFocusTimer = s.delayInitialFocus ? Ua(function() {
        f(m());
      }) : f(m()), n.addEventListener("focusin", y, !0), n.addEventListener("mousedown", j, {
        capture: !0,
        passive: !1
      }), n.addEventListener("touchstart", j, {
        capture: !0,
        passive: !1
      }), n.addEventListener("click", _, {
        capture: !0,
        passive: !1
      }), n.addEventListener("keydown", w, {
        capture: !0,
        passive: !1
      }), n.addEventListener("keydown", L), r;
  }, T = function() {
    if (o.active)
      return n.removeEventListener("focusin", y, !0), n.removeEventListener("mousedown", j, !0), n.removeEventListener("touchstart", j, !0), n.removeEventListener("click", _, !0), n.removeEventListener("keydown", w, !0), n.removeEventListener("keydown", L), r;
  }, C = function(z) {
    var A = z.some(function($) {
      var q = Array.from($.removedNodes);
      return q.some(function(Z) {
        return Z === o.mostRecentlyFocusedNode;
      });
    });
    A && f(m());
  }, O = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(C) : void 0, B = function() {
    O && (O.disconnect(), o.active && !o.paused && o.containers.map(function(z) {
      O.observe(z, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return r = {
    get active() {
      return o.active;
    },
    get paused() {
      return o.paused;
    },
    activate: function(z) {
      if (o.active)
        return this;
      var A = l(z, "onActivate"), $ = l(z, "onPostActivate"), q = l(z, "checkCanFocusTrap");
      q || d(), o.active = !0, o.paused = !1, o.nodeFocusedBeforeActivation = n.activeElement, A == null || A();
      var Z = function() {
        q && d(), E(), B(), $ == null || $();
      };
      return q ? (q(o.containers.concat()).then(Z, Z), this) : (Z(), this);
    },
    deactivate: function(z) {
      if (!o.active)
        return this;
      var A = Na({
        onDeactivate: s.onDeactivate,
        onPostDeactivate: s.onPostDeactivate,
        checkCanReturnFocus: s.checkCanReturnFocus
      }, z);
      clearTimeout(o.delayInitialFocusTimer), o.delayInitialFocusTimer = void 0, T(), o.active = !1, o.paused = !1, B(), Oa.deactivateTrap(a, r);
      var $ = l(A, "onDeactivate"), q = l(A, "onPostDeactivate"), Z = l(A, "checkCanReturnFocus"), X = l(A, "returnFocus", "returnFocusOnDeactivate");
      $ == null || $();
      var W = function() {
        Ua(function() {
          X && f(k(o.nodeFocusedBeforeActivation)), q == null || q();
        });
      };
      return X && Z ? (Z(k(o.nodeFocusedBeforeActivation)).then(W, W), this) : (W(), this);
    },
    pause: function(z) {
      return o.active ? (o.manuallyPaused = !0, this._setPausedState(!0, z)) : this;
    },
    unpause: function(z) {
      return o.active ? (o.manuallyPaused = !1, a[a.length - 1] !== this ? this : this._setPausedState(!1, z)) : this;
    },
    updateContainerElements: function(z) {
      var A = [].concat(z).filter(Boolean);
      return o.containers = A.map(function($) {
        return typeof $ == "string" ? n.querySelector($) : $;
      }), o.active && d(), B(), this;
    }
  }, Object.defineProperties(r, {
    _isManuallyPaused: {
      value: function() {
        return o.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(z, A) {
        if (o.paused === z)
          return this;
        if (o.paused = z, z) {
          var $ = l(A, "onPause"), q = l(A, "onPostPause");
          $ == null || $(), T(), B(), q == null || q();
        } else {
          var Z = l(A, "onUnpause"), X = l(A, "onPostUnpause");
          Z == null || Z(), d(), E(), B(), X == null || X();
        }
        return this;
      }
    }
  }), r.updateContainerElements(t), r;
};
/*!
  * focus-trap-vue v4.0.2
  * (c) 2023 Eduardo San Martin Morote
  * @license MIT
  */
const sw = {
  escapeDeactivates: {
    type: Boolean,
    default: !0
  },
  returnFocusOnDeactivate: {
    type: Boolean,
    default: !0
  },
  allowOutsideClick: {
    type: [Boolean, Function],
    default: !0
  },
  clickOutsideDeactivates: [Boolean, Function],
  initialFocus: [String, Function, Boolean],
  fallbackFocus: [String, Function],
  checkCanFocusTrap: Function,
  checkCanReturnFocus: Function,
  delayInitialFocus: {
    type: Boolean,
    default: !0
  },
  document: Object,
  preventScroll: Boolean,
  setReturnFocus: [Object, String, Boolean, Function],
  tabbableOptions: Object
}, ow = fe({
  props: Object.assign({
    active: {
      // TODO: could be options for activate but what about the options for deactivating?
      type: Boolean,
      default: !0
    }
  }, sw),
  emits: [
    "update:active",
    "activate",
    "postActivate",
    "deactivate",
    "postDeactivate"
  ],
  render() {
    return this.renderImpl();
  },
  setup(e, { slots: t, emit: i }) {
    let n;
    const a = J(null), s = H(() => {
      const r = a.value;
      return r && (r instanceof HTMLElement ? r : r.$el);
    });
    function o() {
      return n || (n = aw(s.value, {
        escapeDeactivates: e.escapeDeactivates,
        allowOutsideClick: e.allowOutsideClick,
        returnFocusOnDeactivate: e.returnFocusOnDeactivate,
        clickOutsideDeactivates: e.clickOutsideDeactivates,
        onActivate: () => {
          i("update:active", !0), i("activate");
        },
        onDeactivate: () => {
          i("update:active", !1), i("deactivate");
        },
        onPostActivate: () => i("postActivate"),
        onPostDeactivate: () => i("postDeactivate"),
        initialFocus: e.initialFocus,
        fallbackFocus: e.fallbackFocus,
        tabbableOptions: e.tabbableOptions,
        delayInitialFocus: e.delayInitialFocus,
        preventScroll: e.preventScroll
      }));
    }
    return pt(() => {
      vi(() => e.active, (r) => {
        r && s.value ? o().activate() : n && (n.deactivate(), (!s.value || s.value.nodeType === Node.COMMENT_NODE) && (n = null));
      }, { immediate: !0, flush: "post" });
    }), Ra(() => {
      n && n.deactivate(), n = null;
    }), {
      activate() {
        o().activate();
      },
      deactivate() {
        n && n.deactivate();
      },
      renderImpl() {
        if (!t.default)
          return null;
        const r = t.default().filter((u) => u.type !== ro);
        return !r || !r.length || r.length > 1 ? (console.error("[focus-trap-vue]: FocusTrap requires exactly one child."), r) : lo(r[0], { ref: a });
      }
    };
  }
}), rw = { class: "umf-modal-overlay" }, lw = /* @__PURE__ */ fe({
  __name: "umf-modal-overlay",
  props: {
    isOpen: { type: Boolean, default: !1 },
    size: { default: "sm" }
  },
  emits: ["close-modal"],
  setup(e, { emit: t }) {
    const { ct: i } = pe(), n = e, a = t, s = {
      close: i("modal.accessibility.close")
    }, o = J({
      isFocusTrapActive: !1
    }), r = () => {
      o.value.isFocusTrapActive = !1, a("close-modal");
    };
    return (l, u) => (K(), Q("div", rw, [
      F(p(ow), {
        active: o.value.isFocusTrapActive
      }, {
        default: re(() => [
          F(p(co), {
            name: "umf-modal",
            size: n.size,
            position: "center",
            "mobile-alignment": "full",
            "is-open": n.isOpen,
            "accessibility-labels": s,
            onClosed: u[0] || (u[0] = (c) => r()),
            onOpened: u[1] || (u[1] = (c) => o.value.isFocusTrapActive = !0)
          }, {
            default: re(() => [
              hi(l.$slots, "default")
            ]),
            _: 3
          }, 8, ["size", "is-open"])
        ]),
        _: 3
      }, 8, ["active"])
    ]));
  }
});
const _i = class _i {
  constructor() {
    ot(this, "subscribers");
    this.subscribers = {};
  }
  dispatch(t, i) {
    const n = this.subscribers[t];
    n !== void 0 && Object.keys(n).forEach((a) => n[a](i));
  }
  register(t, i) {
    const n = this.getNextId();
    return this.subscribers[t] || (this.subscribers[t] = {}), this.subscribers[t][n] = i, {
      unregister: () => {
        delete this.subscribers[t][n], Object.keys(this.subscribers[t]).length === 0 && delete this.subscribers[t];
      }
    };
  }
  getNextId() {
    return _i.nextId++;
  }
};
ot(_i, "nextId", 0);
let kn = _i;
const Ry = /* @__PURE__ */ fe({
  __name: "umf-modals-controller",
  props: {
    globals: null,
    featureToggleConfigs: null
  },
  setup(e) {
    const t = process.env.NUXT_PUBLIC_LOCAL_LOGIN;
    pe();
    const i = e, n = J({
      isOpen: !1,
      contents: null
    }), a = J({
      accountMissingConsentFields: void 0,
      credentials: void 0
    }), s = In(), { setGlobals: o } = Xe();
    o(i.globals);
    const r = H(
      () => {
        var y, g, w;
        return !!((w = (g = (y = i.featureToggleConfigs) == null ? void 0 : y.marketingconsent) == null ? void 0 : g.enableMultiLevelConsent) != null && w.enabled);
      }
    ), l = H(
      () => {
        var y, g, w;
        return !!((w = (g = (y = i.featureToggleConfigs) == null ? void 0 : y.marketingconsent) == null ? void 0 : g.hasSingleConsent) != null && w.enabled);
      }
    ), u = H(
      () => {
        var y, g, w;
        return ((w = (g = (y = i.featureToggleConfigs) == null ? void 0 : y.marketingconsent) == null ? void 0 : g.customMultiLevelConsent) == null ? void 0 : w.toString()) ?? null;
      }
    ), c = H(() => Vi(i.globals["module.cdc.SyncMieleClub"])), m = H(
      () => {
        var y, g;
        return Vi((g = (y = i.featureToggleConfigs) == null ? void 0 : y.mieleClub) == null ? void 0 : g.requireToSelectAllConsents);
      }
    ), d = H(
      () => {
        var y, g;
        return Vi((g = (y = i.featureToggleConfigs) == null ? void 0 : y.mieleClub) == null ? void 0 : g.toSyncSubscriptionOnCdc);
      }
    ), b = H(
      () => [be.NewsletterConsent, be.MieleClubConsent].includes(n.value.contents) ? "lg" : "sm"
    ), f = (y) => {
      n.value = {
        isOpen: !0,
        contents: y
      };
    }, k = () => {
      n.value = {
        isOpen: !1,
        contents: null
      };
    }, M = (y, g) => {
      j(g), n.value.contents = y;
    }, j = (y) => {
      y != null && y.consentState && (a.value = y.consentState);
    };
    return pt(async () => {
      if (window.EventBus = window.EventBus || new kn(), window.EventBus.register(_s, () => f(be.ChangeEmail)), window.EventBus.register(zs, () => f(be.ChangePassword)), window.EventBus.register(js, () => f(be.ForgotPassword)), window.EventBus.register(Ms, (y) => {
        y ? s.storeRedirect(y.targetUrl) : s.saveRedirectTarget(), f(be.Login);
      }), window.EventBus.register(Ss, (y) => {
        j({ consentState: y }), f(be.Consent);
      }), window.EventBus.register(Cs, () => f(be.NewsletterConsent)), window.EventBus.register(Ls, () => f(be.MieleClubConsent)), !t) {
        const { checkSession: y } = $n();
        await y();
      }
    }), (y, g) => (K(), xe(p(lw), {
      size: b.value,
      class: "umf-controller-modal",
      "is-open": n.value.isOpen,
      onCloseModal: k
    }, {
      default: re(() => [
        n.value.contents === p(be).Consent ? (K(), xe(p(rb), {
          key: 0,
          "missing-consent-fields": a.value.accountMissingConsentFields,
          credentials: a.value.credentials
        }, null, 8, ["missing-consent-fields", "credentials"])) : ve("", !0),
        n.value.contents === p(be).ChangeEmail ? (K(), xe(p(Rk), {
          key: 1,
          onOnClose: k
        })) : ve("", !0),
        n.value.contents === p(be).ChangePassword ? (K(), xe(p(Wk), {
          key: 2,
          onOnClose: k
        })) : ve("", !0),
        n.value.contents === p(be).ForgotPassword ? (K(), xe(p(fb), {
          key: 3,
          onOnChangeModal: M,
          onOnClose: k
        })) : ve("", !0),
        n.value.contents === p(be).Login ? (K(), xe(p(Cb), {
          key: 4,
          onOnChangeModal: M,
          onOnClose: k
        })) : ve("", !0),
        n.value.contents === p(be).NewsletterConsent && r.value ? (K(), xe(p(qw), {
          key: 5,
          "only-has-single-consent": l.value,
          "custom-multi-level-consent": u.value,
          onOnClose: k
        }, null, 8, ["only-has-single-consent", "custom-multi-level-consent"])) : n.value.contents === p(be).NewsletterConsent ? (K(), xe(p(Pw), {
          key: 6,
          onOnClose: k
        })) : ve("", !0),
        n.value.contents === p(be).MieleClubConsent ? (K(), xe(p(vy), {
          key: 7,
          "show-newsletter": c.value,
          "all-consents-required": m.value,
          "to-sync-miele-club-subscription-on-cdc": d.value,
          onOnChangeModal: M,
          onOnClose: k
        }, null, 8, ["show-newsletter", "all-consents-required", "to-sync-miele-club-subscription-on-cdc"])) : ve("", !0)
      ]),
      _: 1
    }, 8, ["size", "is-open"]));
  }
}), cw = { class: "umf-password-strength" }, dw = {
  class: "umf-password-strength__msg",
  "aria-live": "polite"
}, uw = { class: "umf-password-strength__meter" }, mw = {
  key: 0,
  class: "umf-password-strength__error"
}, pw = /* @__PURE__ */ fe({
  __name: "umf-password-strength",
  props: {
    password: { default: "" },
    minCharGroups: { default: 3 },
    minLength: { default: 8 },
    hideMessage: { type: Boolean, default: !1 }
  },
  setup(e) {
    const { ct: t } = pe(), i = e, n = H(() => i.minCharGroups <= 0 ? 2 : 1), a = H(() => Es(i.password, i.minLength, i.minCharGroups)), s = (o) => {
      switch (o) {
        case Je.TooShort:
          return t("passwordStrength.tooShort");
        case Je.TooWeak:
          return t("passwordStrength.tooWeak");
        case Je.Weak:
          return t("passwordStrength.weak");
        case Je.Medium:
          return t("passwordStrength.medium");
        case Je.Strong:
          return t("passwordStrength.strong");
        case Je.VeryStrong:
          return t("passwordStrength.veryStrong");
      }
    };
    return (o, r) => (K(), Q("div", cw, [
      N("span", dw, V(s(a.value)), 1),
      N("span", uw, [
        N("span", {
          class: et(`umf-password-strength__meter-strength_${a.value}`)
        }, null, 2)
      ]),
      !e.hideMessage && a.value <= p(Je).TooWeak ? (K(), Q("span", mw, V(p(t)("errors.tooWeakPassword", { minLength: i.minLength, minCharGroups: i.minCharGroups }, n.value)), 1)) : ve("", !0)
    ]));
  }
});
const hw = /* @__PURE__ */ Ne(pw, [["__scopeId", "data-v-53fdf548"]]), gw = { class: "dcf-h2 marketing-consent-scene-content__title" }, vw = { class: "marketing-consent-scene-content__description" }, fw = { class: "marketing-consent-scene-content__scroll-content" }, kw = { class: "marketing-consent-scene-content__input-field" }, bw = ["href"], ww = { class: "marketing-consent-scene-content__input-field" }, yw = ["href"], Mw = { class: "marketing-consent-scene-content__input-field" }, zw = ["href"], jw = { class: "marketing-consent-scene-content__highlighted" }, _w = ["href"], Sw = { class: "marketing-consent-scene-content__input-field" }, Cw = ["href"], Lw = { class: "marketing-consent-scene-content__button-area" }, Ew = /* @__PURE__ */ fe({
  __name: "umf-marketing-consent-scene",
  props: {
    context: { default: de.light }
  },
  emits: ["on-close"],
  setup(e, { emit: t }) {
    const { ct: i } = pe(), n = t, a = J({
      isNewsletterAccepted: !1,
      isPrivacyAccepted: !1,
      isExtendedPrivacyAccepted: !1,
      isAgreementAccepted: !1,
      error: null
    }), s = () => {
      n("on-close");
    };
    pt(async () => {
      var d, b, f, k, M, j, y, g, w, L, _, E, T, C, O, B, x, z, A;
      try {
        const q = await Gs()(["subscriptions", "preferences"]);
        a.value.isNewsletterAccepted = ((M = (k = (f = (b = (d = q.subscriptions) == null ? void 0 : d.miele) == null ? void 0 : b.general) == null ? void 0 : f.newsletter) == null ? void 0 : k.email) == null ? void 0 : M.isSubscribed) || !1, a.value.isPrivacyAccepted = ((L = (w = (g = (y = (j = q.preferences) == null ? void 0 : j.miele) == null ? void 0 : y.marketingconsent) == null ? void 0 : g.personalized) == null ? void 0 : w.general) == null ? void 0 : L.isConsentGranted) || !1, a.value.isExtendedPrivacyAccepted = ((O = (C = (T = (E = (_ = q.preferences) == null ? void 0 : _.miele) == null ? void 0 : E.marketingconsent) == null ? void 0 : T.personalized) == null ? void 0 : C.tracking) == null ? void 0 : O.isConsentGranted) || !1, a.value.isAgreementAccepted = ((A = (z = (x = (B = q.preferences) == null ? void 0 : B.terms) == null ? void 0 : x.miele) == null ? void 0 : z.statement) == null ? void 0 : A.isConsentGranted) || !1;
      } catch ($) {
        a.value.error = $;
      }
    });
    const o = e, r = (d) => a.value.isNewsletterAccepted = d.checked, l = (d) => a.value.isPrivacyAccepted = d.checked, u = (d) => a.value.isExtendedPrivacyAccepted = d.checked, c = (d) => {
      a.value.isAgreementAccepted = d.checked;
    }, m = async () => {
      try {
        const d = si(), b = {
          preferences: {
            [Ft]: a.value.isExtendedPrivacyAccepted,
            [Ds]: a.value.isPrivacyAccepted,
            [Ns]: a.value.isAgreementAccepted
          },
          subscriptions: {
            [Os]: a.value.isNewsletterAccepted
          }
        };
        if (await d(b), globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: f } = Fe();
          f(Re.changeMarketingPreference);
        }
        s();
      } catch (d) {
        if (globalThis != null && globalThis.window) {
          const { pushFormSubmitEvent: b } = Fe();
          b(Re.changeMarketingPreference, d.name);
        }
        a.value.error = d;
      }
    };
    return (d, b) => (K(), Q("div", {
      class: et([
        "marketing-consent-scene-content",
        {
          [p(je).dark]: o.context === p(de).dark,
          [p(je).light]: o.context === p(de).light
        }
      ])
    }, [
      N("h2", gw, V(p(i)("marketing-consent.title")), 1),
      N("p", vw, V(p(i)("marketing-consent.description")), 1),
      N("form", null, [
        N("div", fw, [
          N("div", kw, [
            F(p($e), {
              label: p(i)("marketing-consent.newsletter.text"),
              checked: a.value.isNewsletterAccepted,
              "onUpdate:CheckboxValue": r
            }, null, 8, ["label", "checked"]),
            N("a", {
              href: p(i)("marketing-consent.newsletter.link.ref"),
              class: "dcf-link"
            }, V(p(i)("marketing-consent.newsletter.link.title")), 9, bw)
          ]),
          N("div", ww, [
            F(p($e), {
              label: p(i)("marketing-consent.personalisation.text"),
              checked: a.value.isPrivacyAccepted,
              "onUpdate:CheckboxValue": l
            }, null, 8, ["label", "checked"]),
            N("a", {
              href: p(i)("marketing-consent.personalisation.link.ref"),
              class: "dcf-link"
            }, V(p(i)("marketing-consent.personalisation.link.title")), 9, yw)
          ]),
          N("div", Mw, [
            F(p($e), {
              label: p(i)("marketing-consent.extendedPersonalisation.text"),
              checked: a.value.isExtendedPrivacyAccepted,
              "onUpdate:CheckboxValue": u
            }, null, 8, ["label", "checked"]),
            N("a", {
              href: p(i)("marketing-consent.extendedPersonalisation.link.ref"),
              class: "dcf-link"
            }, V(p(i)("marketing-consent.extendedPersonalisation.link.title")), 9, zw)
          ]),
          N("p", jw, [
            Pe(V(p(i)("marketing-consent.highlightedText.text")) + " ", 1),
            N("a", {
              href: p(i)("marketing-consent.highlightedText.link.ref"),
              class: "dcf-link"
            }, V(p(i)("marketing-consent.highlightedText.link.title")), 9, _w)
          ])
        ]),
        N("div", Sw, [
          F(p($e), {
            label: p(i)("marketing-consent.termsOfUse.text"),
            checked: a.value.isAgreementAccepted,
            "onUpdate:CheckboxValue": c
          }, null, 8, ["label", "checked"]),
          N("a", {
            href: p(i)("marketing-consent.termsOfUse.link.ref"),
            class: "dcf-link"
          }, V(p(i)("marketing-consent.termsOfUse.link.title")), 9, Cw)
        ]),
        N("div", Lw, [
          F(p(Be), {
            type: "submit",
            class: "marketing-consent-scene-content__submit",
            variant: "primary",
            disabled: !a.value.isAgreementAccepted,
            "full-width": "",
            onClick: Qe(m, ["prevent"])
          }, {
            default: re(() => [
              Pe(V(p(i)("marketing-consent.submit")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        F(p(bt), {
          error: a.value.error
        }, null, 8, ["error"])
      ])
    ], 2));
  }
});
const Pw = /* @__PURE__ */ Ne(Ew, [["__scopeId", "data-v-ce675638"]]), Qi = (...e) => e.some((t) => !t.includes(!1));
function $a() {
  let e = !1, t = !1, i = !1, n = !1;
  const a = () => ({
    consentLevelOne: e,
    consentLevelTwo: t,
    consentLevelThree: i,
    isAgreementAccepted: n
  }), s = (c) => {
    var k, M, j, y, g, w, L, _, E, T, C, O, B, x, z, A, $, q, Z, X, W, ae, se, he;
    const m = ((g = (y = (j = (M = (k = c == null ? void 0 : c.subscriptions) == null ? void 0 : k.miele) == null ? void 0 : M.general) == null ? void 0 : j.newsletter) == null ? void 0 : y.email) == null ? void 0 : g.isSubscribed) || !1, d = ((T = (E = (_ = (L = (w = c == null ? void 0 : c.preferences) == null ? void 0 : w.miele) == null ? void 0 : L.marketingconsent) == null ? void 0 : _.personalized) == null ? void 0 : E.general) == null ? void 0 : T.isConsentGranted) || !1, b = ((z = (x = (B = (O = (C = c == null ? void 0 : c.preferences) == null ? void 0 : C.miele) == null ? void 0 : O.marketingconsent) == null ? void 0 : B.personalized) == null ? void 0 : x.tracking) == null ? void 0 : z.isConsentGranted) || !1, f = ((X = (Z = (q = ($ = (A = c == null ? void 0 : c.preferences) == null ? void 0 : A.miele) == null ? void 0 : $.marketingconsent) == null ? void 0 : q.personalized) == null ? void 0 : Z.iot) == null ? void 0 : X.isConsentGranted) || !1;
    n = ((he = (se = (ae = (W = c == null ? void 0 : c.preferences) == null ? void 0 : W.terms) == null ? void 0 : ae.miele) == null ? void 0 : se.statement) == null ? void 0 : he.isConsentGranted) || !1, e = Qi(
      [m, d, b],
      [m, d],
      [m, b],
      [m]
    ), t = e && Qi(
      [b],
      [m, d, b],
      [m, b]
    ), i = e && Qi([f]);
  }, o = (c) => ({
    preferences: {
      // consent personalized general
      [Ds]: c.consentLevelOne,
      // consent personalized tracking
      [Ft]: c.hasSingleConsent ? c.consentLevelOne : c.consentLevelTwo,
      // consent iot
      [jk]: c.consentLevelThree,
      // terms & services
      [Ns]: c.isAgreementAccepted
    },
    subscriptions: {
      // consent newsletter
      [Os]: c.consentLevelOne
    }
  }), r = async () => {
    const m = await Gs()(["subscriptions", "preferences"]);
    return s(m), a();
  }, l = (c) => {
    const m = si(), { hasCustomConsentConfig: d, getSubscriptionsFromCustomConsentConfig: b, getPreferencesFromCustomConsentConfig: f } = qs(c.customMultiLevelConsent);
    let k;
    if (d) {
      const { consentLevelOne: M, consentLevelTwo: j, consentLevelThree: y } = c, g = f({ consentLevelOne: M, consentLevelTwo: j, consentLevelThree: y }), w = b({
        consentLevelOne: M,
        consentLevelTwo: j,
        consentLevelThree: y
      });
      k = {
        preferences: g,
        subscriptions: w
      };
    } else
      k = o(c);
    return m(k);
  };
  return {
    fetchUserConsent: r,
    postUserConsent: async (c) => l(c).then(() => {
      if (globalThis != null && globalThis.window) {
        const { pushFormSubmitEvent: m } = Fe();
        m(Re.changeMarketingPreference);
      }
    }).catch((m) => {
      if (globalThis != null && globalThis.window) {
        const { pushFormSubmitEvent: d } = Fe();
        d(Re.changeMarketingPreference, m.name);
      }
      throw m;
    }),
    setMultiLevelConsent: s,
    getMultiLevelConsent: a
  };
}
const Tw = { class: "dcf-h2 marketing-consent-scene-content__title" }, Aw = { class: "marketing-consent-scene-content__description" }, xw = { class: "marketing-consent-scene-content__scroll-content" }, Iw = { class: "marketing-consent-scene-content__input-field" }, Dw = ["href"], Nw = {
  key: 0,
  class: "marketing-consent-scene-content__input-field"
}, Ow = ["href"], Uw = {
  key: 0,
  class: "marketing-consent-scene-content__input-field"
}, $w = ["href"], Bw = { class: "marketing-consent-scene-content__input-field" }, Rw = ["href"], Fw = { class: "marketing-consent-scene-content__button-area" }, Vw = /* @__PURE__ */ fe({
  __name: "umf-marketing-consent-multi-level-scene",
  props: {
    context: { default: de.light },
    onlyHasSingleConsent: { type: Boolean, default: !1 },
    customMultiLevelConsent: { default: null }
  },
  emits: ["on-close"],
  setup(e, { emit: t }) {
    const { ct: i } = pe(), n = t, a = J({
      consentLevelOne: !1,
      consentLevelTwo: !1,
      consentLevelThree: !1,
      isAgreementAccepted: !1,
      error: null,
      isSubmitting: !1,
      isLoading: !1
    }), s = e, { hasCustomConsentConfig: o, hasConsentGroup: r } = qs(s.customMultiLevelConsent), l = H(() => o ? r(pn) : !0), u = H(() => o ? r(hn) : !s.onlyHasSingleConsent), c = H(() => o ? r(gn) : !s.onlyHasSingleConsent), m = H(() => (u.value || c.value) && a.value.consentLevelOne), d = (g) => {
      a.value.consentLevelOne = g.checked, a.value.consentLevelOne || (a.value.consentLevelTwo = !1, a.value.consentLevelThree = !1);
    }, b = (g) => a.value.consentLevelTwo = g.checked, f = (g) => a.value.consentLevelThree = g.checked, k = (g) => {
      a.value.isAgreementAccepted = g.checked;
    }, M = async () => {
      try {
        a.value.isLoading = !0;
        const { fetchUserConsent: g } = $a(), { consentLevelOne: w, consentLevelTwo: L, consentLevelThree: _, isAgreementAccepted: E } = await g();
        o ? (a.value.consentLevelOne = r(pn) && w, a.value.consentLevelTwo = r(hn) && L, a.value.consentLevelThree = r(gn) && _) : (a.value.consentLevelOne = w, a.value.consentLevelTwo = !s.onlyHasSingleConsent && L, a.value.consentLevelThree = !s.onlyHasSingleConsent && _), a.value.isAgreementAccepted = E;
      } catch (g) {
        a.value.error = g;
      } finally {
        a.value.isLoading = !1;
      }
    }, j = async () => {
      try {
        a.value.isSubmitting = !0;
        const { postUserConsent: g } = $a();
        await g({
          consentLevelOne: a.value.consentLevelOne,
          consentLevelTwo: a.value.consentLevelTwo,
          consentLevelThree: a.value.consentLevelThree,
          isAgreementAccepted: a.value.isAgreementAccepted,
          hasSingleConsent: s.onlyHasSingleConsent,
          customMultiLevelConsent: s.customMultiLevelConsent
        }), y();
      } catch (g) {
        a.value.error = g;
      } finally {
        a.value.isSubmitting = !1;
      }
    }, y = () => n("on-close");
    return pt(() => {
      M();
    }), (g, w) => (K(), Q("div", {
      class: et([
        "marketing-consent-scene-content",
        {
          [p(je).dark]: s.context === p(de).dark,
          [p(je).light]: s.context === p(de).light
        }
      ])
    }, [
      N("h2", Tw, V(p(i)("multiLevelMarketingConsent.title")), 1),
      N("p", Aw, V(p(i)("multiLevelMarketingConsent.description")), 1),
      N("form", null, [
        N("div", xw, [
          N("div", Iw, [
            l.value ? (K(), xe(p($e), {
              key: 0,
              label: p(i)("multiLevelMarketingConsent.levelOne.text"),
              checked: a.value.consentLevelOne,
              "onUpdate:CheckboxValue": d
            }, null, 8, ["label", "checked"])) : ve("", !0),
            N("a", {
              href: p(i)("multiLevelMarketingConsent.levelOne.link.ref"),
              class: "dcf-link"
            }, V(p(i)("multiLevelMarketingConsent.levelOne.link.title")), 9, Dw)
          ]),
          m.value ? (K(), xe(Fn, { key: 0 }, {
            default: re(() => [
              u.value ? (K(), Q("div", Nw, [
                F(p($e), {
                  label: p(i)("multiLevelMarketingConsent.levelTwo.text"),
                  checked: a.value.consentLevelTwo,
                  "onUpdate:CheckboxValue": b
                }, null, 8, ["label", "checked"]),
                N("a", {
                  href: p(i)("multiLevelMarketingConsent.levelTwo.link.ref"),
                  class: "dcf-link"
                }, V(p(i)("multiLevelMarketingConsent.levelTwo.link.title")), 9, Ow)
              ])) : ve("", !0)
            ]),
            _: 1
          })) : ve("", !0),
          m.value ? (K(), xe(Fn, { key: 1 }, {
            default: re(() => [
              c.value ? (K(), Q("div", Uw, [
                F(p($e), {
                  label: p(i)("multiLevelMarketingConsent.levelThree.text"),
                  checked: a.value.consentLevelThree,
                  "onUpdate:CheckboxValue": f
                }, null, 8, ["label", "checked"]),
                N("a", {
                  href: p(i)("multiLevelMarketingConsent.levelThree.link.ref"),
                  class: "dcf-link"
                }, V(p(i)("multiLevelMarketingConsent.levelThree.link.title")), 9, $w)
              ])) : ve("", !0)
            ]),
            _: 1
          })) : ve("", !0)
        ]),
        N("div", Bw, [
          F(p($e), {
            label: p(i)("multiLevelMarketingConsent.termsOfUse.text"),
            checked: a.value.isAgreementAccepted,
            "onUpdate:CheckboxValue": k
          }, null, 8, ["label", "checked"]),
          N("a", {
            href: p(i)("multiLevelMarketingConsent.termsOfUse.link.ref"),
            class: "dcf-link"
          }, V(p(i)("multiLevelMarketingConsent.termsOfUse.link.title")), 9, Rw)
        ]),
        N("div", Fw, [
          F(p(Be), {
            type: "submit",
            class: "marketing-consent-scene-content__submit",
            variant: "primary",
            disabled: a.value.isLoading || a.value.isSubmitting || !a.value.isAgreementAccepted,
            icon: a.value.isSubmitting || a.value.isLoading ? "heartbeat-loader" : "",
            "full-width": "",
            onClick: Qe(j, ["prevent"])
          }, {
            default: re(() => [
              Pe(V(p(i)("multiLevelMarketingConsent.submit")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "icon"])
        ]),
        F(p(bt), {
          error: a.value.error
        }, null, 8, ["error"])
      ])
    ], 2));
  }
});
const qw = /* @__PURE__ */ Ne(Vw, [["__scopeId", "data-v-688e15b4"]]), Gw = (e) => {
  const t = Date.now(), i = (n, a) => {
    var s, o, r, l;
    (o = (s = window.gigya) == null ? void 0 : s.accounts) != null && o.showScreenSet ? n((l = (r = window.gigya) == null ? void 0 : r.accounts) == null ? void 0 : l.showScreenSet) : e && Date.now() - t >= e ? a(new Error("timeout")) : setTimeout(i.bind(void 0, n, a), 30);
  };
  return new Promise(i);
}, Kw = async (e) => {
  var t, i;
  try {
    await Gw(2e3), (i = (t = window.gigya) == null ? void 0 : t.accounts) != null && i.showScreenSet ? window.gigya.accounts.showScreenSet({
      screenSet: "Default-RegistrationLogin",
      startScreen: "gigya-register-screen-simple",
      onError: (n) => {
        e({ error: n });
      },
      onAfterSubmit: (n) => {
        e({ response: n });
      }
    }) : console.warn('Unable to display screenset. Make sure "window.gigya" library is loaded.');
  } catch (n) {
    console.warn("Something went wrong loading gigya library.", n);
  }
}, Hw = { class: "dcf-h4 umf-register-scene__headline" }, Ww = { class: "umf-register-scene__buttonWrapper" }, Jw = { class: "dcf-h5 umf-register-scene__list-headline" }, Zw = { class: "umf-register-scene__list" }, Fy = /* @__PURE__ */ fe({
  __name: "umf-register-scene",
  props: {
    context: { default: de.light },
    onRegisterComplete: { type: Function, default: void 0 },
    onRegisterError: { type: Function, default: void 0 },
    configState: null,
    useHead: { type: Function }
  },
  setup(e) {
    var m;
    const t = e, { ct: i, ctm: n, crt: a } = pe(), s = ((m = t.configState) == null ? void 0 : m["module.cdc.ApiKey"]) || "", o = H(() => new URLSearchParams(window == null ? void 0 : window.location.search).get("register") !== null), r = () => {
      Kw(({ error: d, response: b }) => {
        if (d && console.error(d), d && t.onRegisterError) {
          if (globalThis != null && globalThis.window) {
            const { pushFormSubmitEvent: f } = Fe();
            f(Re.register, d.eventName);
          }
          t.onRegisterError(d);
        } else if (t.onRegisterComplete) {
          if (globalThis != null && globalThis.window) {
            const { pushRegisterEvent: f, pushFormSubmitEvent: k } = Fe();
            k(Re.register), f({
              uid: b.response.UID,
              consentFields: _k(b.response),
              consentStatus: Us(b.response)
            });
          }
          t.onRegisterComplete(b);
        }
      });
    }, l = Cf(t.configState).replace("-", "_");
    let u = l.substring(l.length - 2), c = l.substring(0, l.length - 2) + u.toUpperCase();
    return t.useHead({
      script: [
        {
          src: `https://cdns.gigya.com/js/gigya.js?apikey=${s}&lang=${c}`,
          defer: !0
        }
      ]
    }), pt(() => {
      o.value && r();
    }), (d, b) => (K(), Q("div", {
      class: et([
        "umf-register-scene",
        {
          [p(je).dark]: t.context === p(de).dark,
          [p(je).light]: t.context === p(de).light
        }
      ])
    }, [
      N("h2", Hw, V(p(i)("register.registerTitle")), 1),
      N("div", Ww, [
        F(p(Be), {
          variant: "secondary",
          "full-width": "",
          onClick: r
        }, {
          default: re(() => [
            Pe(V(p(i)("register.registerButtonLabel")), 1)
          ]),
          _: 1
        })
      ]),
      N("div", null, [
        N("h3", Jw, V(p(i)("register.whyRegister.title")), 1),
        N("ul", Zw, [
          (K(!0), Q(Tt, null, Va(p(n)("register.whyRegister.list"), (f) => (K(), Q("li", {
            key: f,
            class: "umf-register-scene__list-item"
          }, [
            F(p(uo), {
              name: "checkmark",
              class: "umf-register-scene__list-icon"
            }),
            N("p", null, V(p(a)(f)), 1)
          ]))), 128))
        ])
      ])
    ], 2));
  }
});
const Yw = { class: "umf-read-more" }, Xw = { key: 0 }, Qw = /* @__PURE__ */ fe({
  __name: "umf-read-more",
  props: {
    readMoreText: null,
    readLessText: null
  },
  setup(e) {
    const { ct: t } = pe(), i = e.readMoreText || t("readMore"), n = e.readLessText || t("readLess"), a = J(!1), s = () => {
      a.value = !a.value;
    };
    return (o, r) => (K(), Q("div", Yw, [
      o.$slots["short-content"] ? (K(), Q("div", Xw, [
        a.value ? hi(o.$slots, "default", { key: 1 }, void 0, !0) : hi(o.$slots, "short-content", { key: 0 }, void 0, !0),
        r[0] || (r[0] = Pe("   ")),
        N("button", {
          class: "umf-read-more__button",
          type: "button",
          onClick: Qe(s, ["prevent"])
        }, V(a.value ? p(n) : p(i)), 1)
      ])) : hi(o.$slots, "default", { key: 1 }, void 0, !0)
    ]));
  }
});
const ey = /* @__PURE__ */ Ne(Qw, [["__scopeId", "data-v-90907899"]]), ty = { class: "miele-club-consent-scene__form" }, iy = { class: "miele-club-consent-scene__description" }, ny = { class: "miele-club-consent-scene__benefits" }, ay = { class: "miele-club-consent-scene__consent" }, sy = { class: "miele-club-consent-scene__membership" }, oy = { class: "miele-club-consent-scene__terms-condition" }, ry = ["href"], ly = ["href"], cy = { key: 0 }, dy = { class: "miele-club-consent-scene__newsletter" }, uy = ["href"], my = ["href"], py = ["href"], hy = "https://media.miele.com/images/2000021/200002108/20000210898.png?impolicy=gallery&imwidth=768", gy = /* @__PURE__ */ fe({
  __name: "umf-miele-club-consent-scene",
  props: {
    context: { default: de.light },
    showNewsletter: { type: Boolean, default: !0 },
    allConsentsRequired: { type: Boolean, default: !1 },
    toSyncMieleClubSubscriptionOnCdc: { type: Boolean, default: !1 }
  },
  emits: ["on-close"],
  setup(e, { emit: t }) {
    const { ct: i, ctm: n, crt: a, cte: s, i18n: o } = pe(), r = t, l = e, u = J(), c = J(!1), m = J(!1), d = J(!0), b = J(!1), f = J(!1), k = H(() => m.value || c.value || !b.value), M = (_) => {
      b.value = _.checked, _.checked || (f.value = !1);
    }, j = (_) => f.value = _.checked, y = async () => {
      const _ = si(), E = {
        preferences: {
          "miele.loyalty.membership.isConsentGranted": b.value
        }
      };
      return l.toSyncMieleClubSubscriptionOnCdc && (E.subscriptions = {
        "miele.loyalty.newsletter.email.isSubscribed": b.value
      }), f.value && (E.preferences["miele.loyalty.personalized.general.isConsentGranted"] = f.value), _(E);
    }, g = () => l.allConsentsRequired && (b.value || f.value) ? b.value && f.value : b.value, w = async () => {
      u.value = null;
      try {
        if (d.value = g(), !d.value)
          return;
        c.value = !0, await Promise.all([mt().setMieleClub(b.value), y()]), L(), window.location.reload();
      } catch (_) {
        u.value = _;
      } finally {
        c.value = !1;
      }
    }, L = () => r("on-close");
    return (_, E) => (K(), Q("div", {
      class: et([
        "miele-club-consent-scene",
        {
          [p(je).dark]: l.context === p(de).dark,
          [p(je).light]: l.context === p(de).light
        }
      ])
    }, [
      N("form", ty, [
        F(p(mo), null, {
          media: re(() => [
            N("img", {
              src: hy,
              alt: ""
            })
          ]),
          title: re(() => [
            Pe(V(p(i)("mieleClub.headline")), 1)
          ]),
          content: re(() => [
            N("div", iy, V(p(i)("mieleClub.why.title")), 1),
            N("ul", ny, [
              (K(!0), Q(Tt, null, Va(p(n)("mieleClub.why.reasons"), (T) => (K(), Q("li", {
                key: T,
                class: "miele-club-consent-scene__benefit"
              }, [
                N("div", null, V(p(a)(T)), 1)
              ]))), 128))
            ]),
            N("div", ay, [
              N("div", sy, [
                F(p($e), {
                  label: p(i)("mieleClub.joinClubLabel"),
                  checked: b.value,
                  "onUpdate:CheckboxValue": M
                }, null, 8, ["label", "checked"]),
                N("div", oy, [
                  F(p(Ba), {
                    keypath: "mieleClub.termsAndCondition.description",
                    i18n: p(o)
                  }, Bi({ _: 2 }, [
                    p(s)("mieleClub.termsAndCondition.termsAndConditionLink.ref") ? {
                      name: "termsAndConditionLink",
                      fn: re(() => [
                        N("a", {
                          class: "miele-club-consent-scene__link",
                          href: p(i)("mieleClub.termsAndCondition.termsAndConditionLink.ref"),
                          target: "_blank"
                        }, V(p(i)("mieleClub.termsAndCondition.termsAndConditionLink.title")), 9, ry)
                      ]),
                      key: "0"
                    } : void 0,
                    p(s)("mieleClub.termsAndCondition.privacyLink.ref") ? {
                      name: "privacyLink",
                      fn: re(() => [
                        N("a", {
                          class: "miele-club-consent-scene__link",
                          href: p(i)("mieleClub.termsAndCondition.privacyLink.ref"),
                          target: "_blank"
                        }, V(p(i)("mieleClub.termsAndCondition.privacyLink.title")), 9, ly)
                      ]),
                      key: "1"
                    } : void 0
                  ]), 1032, ["i18n"])
                ])
              ]),
              e.showNewsletter ? (K(), Q("div", cy, [
                N("label", dy, [
                  F(p($e), {
                    label: "",
                    disabled: !b.value,
                    checked: f.value,
                    "onUpdate:CheckboxValue": j
                  }, null, 8, ["disabled", "checked"]),
                  F(p(ey), null, Bi({
                    default: re(() => [
                      F(p(Ba), {
                        keypath: "mieleClub.newsletter.description",
                        i18n: p(o)
                      }, Bi({ _: 2 }, [
                        p(s)("mieleClub.newsletter.supportEmail") ? {
                          name: "supportEmail",
                          fn: re(() => [
                            N("a", {
                              class: "miele-club-consent-scene__link",
                              href: "mailto:" + p(i)("mieleClub.newsletter.supportEmail"),
                              target: "_blank"
                            }, V(p(i)("mieleClub.newsletter.supportEmail")), 9, uy)
                          ]),
                          key: "0"
                        } : void 0,
                        p(s)("mieleClub.newsletter.privacyLink.href") ? {
                          name: "privacyLink",
                          fn: re(() => [
                            N("a", {
                              class: "miele-club-consent-scene__link",
                              href: p(i)("mieleClub.newsletter.privacyLink.href"),
                              target: "_blank"
                            }, V(p(i)("mieleClub.newsletter.privacyLink.title")), 9, my)
                          ]),
                          key: "1"
                        } : void 0,
                        p(s)("mieleClub.newsletter.termsAndConditionLink.href") ? {
                          name: "termsAndConditionLink",
                          fn: re(() => [
                            N("a", {
                              class: "miele-club-consent-scene__link",
                              href: p(i)("mieleClub.newsletter.termsAndConditionLink.href"),
                              target: "_blank"
                            }, V(p(i)("mieleClub.newsletter.termsAndConditionLink.title")), 9, py)
                          ]),
                          key: "2"
                        } : void 0
                      ]), 1032, ["i18n"])
                    ]),
                    _: 2
                  }, [
                    p(s)("mieleClub.newsletter.shortDescription") ? {
                      name: "short-content",
                      fn: re(() => [
                        N("div", null, V(p(i)("mieleClub.newsletter.shortDescription")), 1)
                      ]),
                      key: "0"
                    } : void 0
                  ]), 1024)
                ])
              ])) : ve("", !0)
            ]),
            e.allConsentsRequired && !d.value ? (K(), xe(p(Si), {
              key: 0,
              headline: p(i)("mieleClub.selectAllConsents.description"),
              variant: "WARNING",
              class: "miele-club-consent-scene__msg-notification"
            }, null, 8, ["headline"])) : ve("", !0),
            F(p(bt), {
              error: u.value,
              class: "miele-club-consent-scene__msg-error"
            }, null, 8, ["error"]),
            F(p(Be), {
              type: "submit",
              variant: "primary",
              class: "miele-club-consent-scene__submit",
              disabled: k.value,
              icon: c.value || m.value ? "heartbeat-loader" : "",
              "full-width": "",
              onClick: Qe(w, ["prevent"])
            }, {
              default: re(() => [
                Pe(V(p(i)("multiLevelMarketingConsent.submit")), 1)
              ]),
              _: 1
            }, 8, ["disabled", "icon"])
          ]),
          _: 1
        })
      ])
    ], 2));
  }
});
const vy = /* @__PURE__ */ Ne(gy, [["__scopeId", "data-v-45f68809"]]);
function fy({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((n, a) => [...n, ...a.type === Tt ? a.children : [a]], []) : t.reduce((i, n) => {
    const a = e[n];
    return a && (i[n] = a()), i;
  }, {});
}
function ky() {
  return Tt;
}
const Ba = fe({
  props: {
    keypath: {
      type: String,
      required: !0
    },
    i18n: {
      type: Object,
      required: !0
    }
  },
  setup(e, t) {
    const { slots: i, attrs: n } = t, a = e.i18n;
    return () => {
      const s = Object.keys(i).filter((c) => c !== "_"), o = fy(t, s), r = Object.getOwnPropertySymbols(a).find(
        (c) => c.toString().includes("__translateVNode")
      ), l = a[r](e.keypath, o), u = ky();
      return bn(u, n, l);
    };
  }
});
var by = /* @__PURE__ */ ((e) => (e.APPLIANCE = "APPLIANCE", e.SERVICE = "SERVICE", e.MSC = "MSC", e))(by || {});
export {
  Ty as APIConnectorBaseURL,
  nk as API_URLS,
  Qf as AUTH_CODE_COOKIE,
  kf as AccountLoginError,
  Ie as AccountPaths,
  gt as AccountsApiError,
  jy as BusEvents,
  pn as CONSENT_LEVEL_ONE,
  gn as CONSENT_LEVEL_THREE,
  hn as CONSENT_LEVEL_TWO,
  ik as CdcPaths,
  je as ContextCssClasses,
  de as ContextOptions,
  ek as DANGER_ZONE,
  mi as EventNames,
  Re as FormSubmitIds,
  ze as GenericError,
  _a as HttpMethods,
  Qt as HybrisPaths,
  ys as HybrisSessionExpiredError,
  Cn as InvalidEmailPasswordError,
  Ln as InvalidLoginError,
  En as InvalidSessionError,
  Py as JWT_COOKIE,
  Ey as MIELE_SESSION_COOKIE,
  xi as MissingConsentError,
  Zi as NewsletterPreferencesPaths,
  bf as NoAccountError,
  ui as OccPaths,
  Je as PasswordStrength,
  by as ProductTypeCode,
  Ts as REG_TOKEN_COOKIE,
  di as SESSION_DATA_COOKIE,
  Xf as SESSION_HOST_COOKIE,
  ft as SapError,
  Pn as SessionInvalidGrantError,
  Ji as SessionPaths,
  Rk as UmfChangeEmailScene,
  Wk as UmfChangePasswordScene,
  rb as UmfConsentScene,
  $y as UmfDivider,
  bt as UmfErrorHandler,
  fb as UmfForgotPasswordScene,
  Ba as UmfI18nT,
  Ay as UmfKeys,
  By as UmfLogin,
  Cb as UmfLoginModalScene,
  Ks as UmfLoginScene,
  qw as UmfMarketingConsentMultiLevelScene,
  Pw as UmfMarketingConsentScene,
  vy as UmfMieleClubConsentScene,
  lw as UmfModalOverlay,
  Ry as UmfModalsController,
  hw as UmfPasswordStrength,
  Rt as UmfPaths,
  ey as UmfReadMore,
  Fy as UmfRegisterScene,
  ye as UnexpectedError,
  Tn as UnknownError,
  zy as errors,
  mt as experienceApi,
  Di as findMultiLangCountry,
  Ff as generateRandomString,
  Nf as getComplexityScore,
  _k as getConsentFields,
  Cf as getCurrentLocalLanguage,
  An as getDomainCountryCode,
  zf as getDomainLanguage,
  _y as getFallbackLanguage,
  _f as getLocaleFromCurrentUrl,
  Sf as getNonce,
  Ly as getPasswordStrength,
  Es as getPasswordStrengthForComplexity,
  $s as getPathWithoutLeaf,
  Lk as getPathWithoutRoot,
  mn as getRootDomain,
  Of as groupPathsByPathRoot,
  lt as handleMultilingualPrefix,
  wa as hostFromUrl,
  Ut as isEmailValid,
  xn as isMultiLingualDomain,
  Ef as isPasswordValid,
  vt as isSapErrorHandled,
  Us as isTrackingConsentEnabled,
  jf as isValidCountryLanguage,
  ba as joinPath,
  Bf as objectToUrlEncoded,
  Hf as parseCustomMultiLevelConsent,
  Vf as pathFromUrl,
  Sy as prefixUrlWithCurrentLocale,
  Ps as removeGigyaCookies,
  Cy as setNewLocale,
  Rf as sha256b64,
  Vi as toBoolean,
  Is as useAccountLogin,
  Ni as useAccountLoginSession,
  Oi as useAuthCode,
  wk as useAuthProxy,
  Bs as useCdcService,
  Ak as useChangePassword,
  Dy as useCheckSessionAndRedirectOnInvalid,
  qt as useConfig,
  qs as useCustomConsentConfig,
  Tk as useForgotPassword,
  Gs as useGetAccountInfo,
  xk as useGetPasswordPolicies,
  Oy as useGetSchema,
  Xe as useGlobals,
  At as useJwtSession,
  Rs as useLogin,
  Uy as useLoginWithoutHybrisSession,
  Un as useLogout,
  Dk as useLogoutWithoutHybrisSession,
  Ny as useNewsletterUnsubscribe,
  Nn as useRegToken,
  Pk as useResetPassword,
  Iy as useResetPasswordWithResetToken,
  $n as useSession,
  xy as useSessionHostCookie,
  Dn as useSessionTokenCookie,
  si as useSetAccountInfo,
  In as useSuccessRedirect,
  Fe as useTracking,
  pe as useTranslations,
  On as useWebService
};
